var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultsGraphTextureYellowSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 443.1 416.9",
    style: {
      enableBackground: "new 0 0 443.1 416.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#f0cc71;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.3,256.6l-0.2-0.1C170.1,256.6,170.2,256.7,170.3,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.5,257l-0.1-0.1L170.5,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.3,222.4C167.3,222.4,167.3,222.5,167.3,222.4c0,0.1,0,0.1,0,0.1C167.8,222.7,167.9,221.8,167.3,222.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.6,211.2C191.6,211.2,191.5,211.2,191.6,211.2c-0.1,0.2-0.1,0.1-0.1,0.1 C191.5,211.3,191.9,211.4,191.6,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107,132.1c0,0.1,0,0.1,0,0.1C106.9,132.4,107.3,132.3,107,132.1L107,132.1L107,132.1L107,132.1L107,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,52.8c-6.1,2.8,8.8,3.9,6.1-0.1C440.8,52.4,438.6,53.1,436.7,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.3,96.6c-6.5,10.3-0.2,9,2.6,0c4.6-2.7,3.7-0.6,5-7.3c-0.6-6.6-3,4.1-4,5.8 C355.9,95.3,354.1,95.1,353.3,96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.5,78.8c-0.9,1.6-0.5,5.8,1.8,3.9c0.7,12.3,3.6-3,2.6-7.4c-3.1-3-2,3.8-2.6,5.3 C347.8,79.9,348.4,77.5,346.5,78.8z M348.3,81.8L348.3,81.8L348.3,81.8L348.3,81.8L348.3,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425,146.4c1.1,0.2,2.9,0.5,3.3,1.5c6-1.7-8.4-7.3-9-5.4c-1.6,2,6.4,3.2,4.5,3.6c-1.5,0.1-4.1-2-4.7,0 C418.8,148.3,426.2,149.7,425,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.7,150.8c-4.8,0.4,7.1,6.9,8.5,6.1c2.1-2.4-6.6-3.9-7.9-6.3c3.8-1.1-5.4-10.5-4.2-5.5 C397,146.8,400.5,149.2,399.7,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.4,150.9c4.1,3,2.8-2.4-1.1-3.3c-6.2-3.3-0.2,3.7-6.5-2.5c-2.3,1.6,0.5,2.9,1.1,4.5c2.1,4.8,6.2,3,2-0.9 C407.1,148.8,409.1,150.3,410.4,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363,118.4c6.4,6.7,18,5.6,3.5,0c-4.6-3.2,0.2-2.2,0.4-4.7C365.6,111,361.6,116.5,363,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.5,44.6c-1.9-3.9-2.7,0.3-1.2,2.5c-2.9,0.5,0.9,6,1.9,7.4c3.3-0.5-0.4-3.2-0.1-4.7 C372.7,52.2,366.7,46.7,366.5,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.2,106.4c-0.9,4.3-4.2,8.7-0.7,12.6c4.5,0.5-0.2-3.7,0.8-5.5C346.8,111.6,350.6,102.5,346.2,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.5,5.8c-12.7,3.8-1.1,3.7,4.3,1.6C368.5,4.6,361.1,4.2,358.5,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,148.8c-0.5,2.3,8.3,4.1,4.4,0.4c-6.1-2.7,1.1-2.8-8.9-6.3C405.8,145.9,417,146,414.7,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.5,139.6c1.1,1.6,4.5,6,3.6,1.2c1.6,0.2,7.5,4.7,6.1,0.6C368.4,140.4,359.5,135.2,360.5,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.2,38.5c-0.7,1.9,3.2,6.8,4.1,3.4c0-1.8-4.7-3.8-1.1-5.4C422.6,35.5,407.5,30.9,407.2,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.5,75.1c-1.6,1.6,7.6,15.1,6.6,8.4C322.6,82,321,73.9,318.5,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396,156.9c-3.3-2-9-5.6-12.5-3.3c1.4,2,5.3,1.2,7.5,2.6C392.4,157.1,397.7,160.8,396,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,161.1c-3.1-2.1-6.7-3.7-8.8-6.7C331.9,156.5,348.1,167.5,345,161.1C345.1,161.1,345.1,161.1,345,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.3,29.8c-0.6,2.3,6.6,12.8,6.7,7.1C430.5,35.9,428.5,26.5,426.3,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,103.2c-5.6-2.7-4.2,1.2-0.1,2.5C443.1,105.7,442.9,103,443.1,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.8,61.3c-3-0.7,1.8,12.8,3.2,13.1C437.6,73.2,432.2,64.1,431.8,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.3,71.6c-2.2,12.5,7.5-10.5,0.3-7.3C371.9,66.6,372.7,69.4,371.3,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.1,15.8c-1.2-1.2-8-2.1-5.6,0.7c3.3,0.1,5.8,2.3,7.9,4.4C374.8,19.9,370.6,16.7,369.1,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.9,161.8c0.5,0.9,2,1.1,2,2.2c5.5-0.3-5-6.8-6.6-8.4C395.1,153.8,405,160.7,405.9,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.5,47.7c0.6-2.2-2.9-10.5-3.3-4.9c1.9,2.5-0.2,7.8,2.5,9C324.5,51.2,323.5,49,323.5,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412,57.2c2.1,6.6,5.2,8.3,1.9,0.3C419,48.3,412.9,49.6,412,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.3,50.4c2.9,6.8,2.5-5.5,3.1-7.5C340.1,42.1,341.7,47.9,341.3,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.8,11c-1.3-1.7-10.3,2.1-9.9,4.8c1.3,2.1,3.3-1.6,5.1-1.6C353.2,12.9,357.5,13.3,356.8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.3,23.6c-0.6-1.4-1.6-6.3-2.8-2.4c0.4,3,2.5,5.6,2.3,8.6C441.6,33.7,441.2,25.1,439.3,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376,43.8c-3.4,0.1,0.5,4.5-0.2,6.4c-0.7,1.9,2.2,7.1,3.1,3.2C377,50.5,377.9,46.6,376,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.8,140.9c-2.5-1-2.5-9-5.3-6.3C345.1,142.2,355.3,145.8,350.8,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.6,100.8c-19.8-3.9-2.5,7.7-7.5,0.8C380.9,101.2,388.7,104.3,386.6,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.1,147.1c1.6,1,10.2,2.9,6.1-0.7c-2.2,1-10.8-4.7-10.4-1.3C348.9,146,350.8,146.7,352.1,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.1,150.8c2.4,0.1,8.8,5.7,8.6,1C433.8,151.2,425.1,146.1,427.1,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,46.5c-0.7-1.9,1.3-9.3-2.3-7.1c0.1,2.7-1.1,7.9,1.6,9.2C328,48.8,327.4,47.3,327,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.2,34.6c-5.4-1.5-0.4,4.6,2.9,3.6c1.3-0.4,5.1-2.7,3.3-4.2C405.7,35.8,403.3,36.2,401.2,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.9,105.4c2,1.4,2.7,7.4,5.5,5.7C436.3,107.6,425,97.1,429.9,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.5,29c-0.8-1.5-4.1-4.2-3.6-0.8c1.5,1.5,9.2,9.2,9,4C368,31.6,365.6,30.9,364.5,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.2,46.5c-1.3-10.5-3.4,1.3-1.9,5.3C401,56.6,398.5,48.3,399.2,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.2,75.1c-5,7.5,7.2,0.7,0.2-8.8C433.1,66.9,440.6,73.2,437.2,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427,138.7c2.6,2.2,5.8-0.8,1.5-1.5c-1.5-1.2,3.6-0.9,4.4-1.8C436.2,131.7,420.9,135.5,427,138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,44.7c2.7,3.8,3.8-10.4,1.4-10.4c-2,1.2-0.2,7-1.4,9.9C440.3,44.1,440.3,44.4,440.3,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.7,0.3c-0.2,6.4,9.4,10.3,5.9,5.3C414.3,5.7,414.9-1.9,411.7,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.4,93c-5.9-3.6,1.4,6.4,3.2,7.8C425.8,100.5,419.1,94.8,418.4,93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.6,157.4c1.9,0.9,4,4.8,6.2,3.4C360.6,157.9,346.1,149.7,353.6,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.5,74.2c-2.8-2.9-0.3,3.8,0.8,4.7c0.3,3.3,9.4,1.4,6.3-0.9C389.9,79.8,387.4,77.9,386.5,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.4,42.6c0.5-2.2-5.7-4.4-5.2-1.5c3.6,1.3,3.7,4,4.8,7.3C409.1,49.2,406.4,44.1,406.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.2,94.4c-2.3-0.6-5.1-1-5.2-3.8c-1.7-1.7-1.5,3.5-0.4,4.2C431.4,97.3,441.4,98.5,435.2,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.8,51.5c-1.3,1.7-3.9,6.7,0,3.8C413.6,54.3,411.1,40,408.8,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.1,29.6c-2.6,5,1.6,3.4,2.4-0.3c0.7,0.6,0.7,2.7,2.1,2.9c2.5,1.1,0.1-7-2.1-3.4 C420.3,24.3,419.2,26.5,419.1,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.2,22.1c-1.3-1.8-6.2-5.7-7.4-2.5C354.5,20.9,365.5,28.3,360.2,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.6,113.2c1.6,2.6,3,5.8,2.7,8.8C339.7,124.5,329.6,106,330.6,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.4,48.7c0.8,2.4,0,5.7,1,7.8C350.4,58.6,348.1,43.9,345.4,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.7,115.6c-0.2,2.5,3.7,13.3,4.6,5.9C351.6,119.9,351.8,113.6,348.7,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4,151.9c3.3-6-4.2-1.6-3.1,5.4C333.5,161.3,332.6,153.5,333.4,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.5,61.1c-1.6-1.5-1.8-9.3-4.7-6.5c1.1,2.4,0.8,5,2.5,7.2C325.3,64.2,328.6,63.6,326.5,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.1,67.5c-1-1.9-0.9-4.1-1.3-6.1c-4.5-8.6-1,14.3,1.3,6.4C341.2,67.8,341.2,67.7,341.1,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.5,110.5c-7-2.2,2.2,4.5,4.4,5.9C394.5,116.1,387,111.1,385.5,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.9,79.1c-1.9,1.7,1.2,5.1,0.8,7.4C337,95,337.6,79.6,333.9,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.5,164.7c3.3-2.5-7.4-3.8-8.7-3.7c-1.3,2.7,3.3,2.3,4.9,3c-3.2,2.4,4.8,6.8,1.1,0.2 C359.7,164.5,360.3,164.7,361.5,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.9,57.9c-2.2,4.4,7-0.4,7.9-1.1C402.3,52.9,397,57.4,394.9,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.7,122.4c-2.6-1.1-3.8-3.9-5.3-6.1C336.4,115.2,347.8,128.3,347.7,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.9,16c-0.9-1.6-3.6-4.9-3.9-1.4C431.8,19.1,440.3,24,433.9,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.8,23.2c-6.2-1.4,5.5,8.5,6.8,4.4C379.6,26.5,373.1,24.8,371.8,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.6,95.8c-3.2,0.1-7.6,0.3-10.9,0.4C367,98.7,382,99,379.6,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.2,52.2c3.1,3.7,2.7-7,1.9-8.3C383.9,42.8,385.4,50.2,385.2,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.2,112.3c2.3,8.5,3.7-4,1.8-6C349.5,106.8,351.2,110.7,350.2,112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.5,107.5c3.2-1-1.2-4.4-0.1-6.5C412.1,89.3,407.1,104.6,411.5,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.2,31.1c0.3,0.5,0.7,1,0.9,1.6V30C442.7,30.3,441.9,30.5,442.2,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.8,159.1c1.7,1.1,8.2,5,5.9,0.5C431.8,158.1,423.8,154,427.8,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.8,79.6c-0.5,5.7,6.9,6.8,1.7,1C421.5,72.5,420.2,69.7,418.8,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.1,146.5c2,1.5,2.8,3.9,4,6C444.6,147,438.7,142.9,439.1,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369,85.9c-1.2,0.3-2.1,3.5-0.3,2.4c2.2-2.2,5.1,0,7.5,0.6C380,86.6,370.7,83.8,369,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.6,50.1c-0.8,0.9,1,12.1,3.2,8.2C392,55.9,392.8,50.3,389.6,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.3,17.4c-3.8,0.2-0.7,2,1,2.8c1.3,0.9,2.6,3.6,4.5,3.3C353.3,22.4,346.7,17.4,345.3,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.3,139.4c1-0.7-2.9-5.5-3.4-7.4c-1.2-2.7-4.3-0.1-1.7,1.2C392.9,134.8,393.4,140.8,396.3,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440,90.4c-1.5,2,1.4,4.5,3.2,5.1c-0.1-0.7,0.5-3.2-0.9-3.1C441.3,92.1,441.1,90.1,440,90.4L440,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.9,28.2c-5.2-0.1-3.6,3.9,0.7,2C349.8,30.3,347.9,25.9,341.9,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435,39.1c3.9,5.9,2.4-1.8,0.6-4.2C433.3,29.7,432.8,37.2,435,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.3,75.8c0.3,2.7-0.1,6.7,0.3,9C346,85.4,344.7,72.4,342.3,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.8,13.3c-6.1,3.5,10.5,12.2,3,4.8C403.1,17,403,14.3,401.8,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.3,132c2.4-0.3,1.8-2.3-0.4-1.8c-2.6-0.2-4.2-2.8-6.3-3.8C415.3,128.2,423.3,133,425.3,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.1,91.3c-2.9,0.3,0.5,1.9,1.6,2.1c2.6,0.6,3.8,3.4,6.3,4.1C388.9,96.6,378.8,91.1,377.1,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.5,79.2c1.6,4.2,5.4-7.1,4.2-7.9C367.1,70.2,366.7,77.3,365.5,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.7,98.7c-3,2.9,7,1,7.6,4.6C409.6,100,401.5,97.7,398.7,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.5,30.2c2.6-0.5,7.1,2.9,9.2,0.7C361,29.6,349.8,26.2,351.5,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,55.7c-0.6,2.2,1.9,10.3,4.2,6.2C320.1,60.9,321.5,53.1,318.2,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.2,89.1c-3.7,2.3-4.3,14.4-0.7,4.8C350.1,92.7,352.9,89.3,350.2,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.1,34.7c-1.5-1-7.5-4.4-7.1-0.6C354.7,34.5,362.5,39.4,360.1,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.4,159.4c7.5,5.4-0.7-5.3-3.8-5C340.8,156.5,345.3,158.1,346.4,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.5,67.6c-2.3,1.9-0.2,9.2,0.1,12.2C443.5,78.2,443.2,69.9,442.5,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.4,111.8c-1.4-1.4-2.2-7.6-4.6-5.6C413.9,108,419.2,118,419.4,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.7,71.4c-1.4-1.7-0.1-6.3-2.5-6.6C331.3,67.5,340.1,78.5,337.7,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.7,6.1c-5.6,1.4,5,4.2,6.9,2.5C347,5.2,340.5,7.4,338.7,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.1,156.9c-0.1-1.3-5.6-8.3-6.5-5.9c-0.4,2,3,3.1,3.7,4.8c0.2,1.3,2.4,3.5,2.7,1.1 C360,157,360,156.9,360.1,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.1,87.4c2.7,0.6,7.3,6.8,9,3.6C387.2,90.2,377.3,83.5,379.1,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.4,89.1c0.5,0.8,1.8,1.5,2.7,2C444,88.7,440.6,85.9,440.4,89.1C440.4,89,440.4,89,440.4,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328,88.1c0.3,2.2,0.9,8.4,4.3,7.2C332,94.1,329.3,83.7,328,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.1,65.9c-4-1.5-2.8,2.2,0.1,2.6c0.1,1.3-2.5,2.6-1,4.1C385.2,73.8,386.2,66.4,383.1,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.4,63.5c-0.1,2.4,5.2,2.5,2.6-0.1c0.1-1.9,0.9-5.7-1.6-6C351.6,58.1,353.2,61.8,352.4,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.7,16c4.5,10,11.9,4.6,0.2-0.5C396,15.7,395.8,15.8,395.7,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.3,72.9c0.8,4.5,4-3.5,3.4-5.2c0.2-1.8-3.5-3.2-2.8-0.7C364.5,68.5,362.3,71.1,362.3,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322,133.6c-4.2,4.3,4,3.4,2.4-5C321.7,123.4,323,132.4,322,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.3,107.1c-8.4-3.4-0.8,2.6,2.8,4.1C407.3,109.8,403,107.6,401.3,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.9,109.3c0-1-0.9-1.7-1.4-2.5c-5.1-5.2-2.3,1.3-0.3,3.6C318.4,116.1,321.2,113.3,319.9,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.3,105.4c-6.3-3.4,1.1,6,4.3,4.2C329.5,107.4,324.4,106.9,323.3,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.5,123.3c3.5-1.4-4.9-6.4-6.5-5.9C401.4,119.8,408.1,121.3,409.5,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368,0.2c0.2,2.7,3.8,0.2,5.2-0.2C373.2,0.1,367.6-0.3,368,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.2,69.4c0.3,3.1,4.4,1.6,6.4,2.3C401,70,390.2,67.6,389.2,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381,49.4c-2.6,4,7.2,11.3,4.5,6.3c-2.6-1-1.6-5.8-4.5-6.2C381.1,49.4,381.1,49.4,381,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.2,116.8c-1.1,3.7,10.5,10.3,5.6,5C327,121.1,324.5,114,323.2,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.6,143.5c-2.4,1.5,3.8,3.5,4.4,5.5c1,0.6,0.7,3.5,2.2,3C384.8,148.9,379.5,144.4,376.6,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.9,92.7c0.6,1.3,8.4,7.7,7.6,3.6C398.5,95.1,395,90.3,392.9,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328,34.7c2.1-5.7-8.7,2.1-5.4,4.2c1.7-1,3.5-3,5.3-4.2C327.9,34.8,327.9,34.8,328,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434,79.8c-5.3-1.2-10.1,12.9-4.5,5.2C430.4,82.8,435.1,82.4,434,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.4,161.1c2.2,0.5,7.6,4.6,8.5,1.3C389.9,161.9,377.9,156.6,382.4,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.6,88.6c1.6,2.6,2.4,5.5,3.7,8C409.5,96.7,404.5,85,402.6,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417,70.4c-4.2-2.3-4.6,15.3-2.2,8.7C414,75.7,417,73.4,417,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.4,59.8c-2.5-0.3-4.2-0.1-5.1-2.7C401.3,61.9,415.2,65,410.4,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,31c-1.2,0.5-3.6,0.7-2.2,2.6c2.4,0.3,5.2-1.3,7.7-1.6C352.7,31,346.2,29.7,345,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385,14c6.6-6.9-2.4-3.2-1.9-0.1C381.8,19.6,385.7,20,385,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.6,158.5c3.2-2.3-3.8-4.5-5.7-4.8C427.6,156.6,434.1,157.1,435.6,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.5,21.1c-1.2,0.9,0,3.3-2.2,2.5c-4.9,0.4,3.9,5,1.7,0.5C322.3,23.9,325.7,15.2,319.5,21.1z M318.9,23.8 L318.9,23.8L318.9,23.8L318.9,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.8,16.4c-3.5-4.6,0.1,9.5,2.5,6.6C423.7,21.4,420.6,18,419.8,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,65.2c-3.3-1.8,0.3,9.4,1.6,9.4C330.9,73.9,327.1,67.4,327,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.2,64.8c-5.2-1.5-1.5,2.3,0.9,3.3c0.6,1.6-1.2,3.1,0.6,4.1C413.8,71.4,413,65.2,410.2,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.1,54c0.3,2.5-0.2,6.4,2.5,7.7c2.6-0.7,0-2.3-0.2-3.7C371.2,56.3,371.6,51,369.1,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.7,73.5c0.3,3,3.1-0.5,3.2-2c0.4-1.7,3.5-2.7,3.1-4.3C355.1,66.6,352.5,71.2,351.7,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.4,85.3c-1.8,0-5.6-2.5-6.1,0C411.7,87.4,424.8,89.2,416.4,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,107.5c1.3,1.2,5.7,3.2,4.1-0.2C437.7,104.8,429.3,102.6,436.7,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.2,39.2c-0.9,3.7,3.4,2.4,2.6-0.7c0.6-1.4,2.6-2.3,3.1-3.9C321,32.5,315.8,37.8,316.2,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.8,3.7c-6.2-3.1,0,3.5,1.3,5.7C426.7,9.6,423.2,4.8,421.8,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.5,83.3c0.8,1.7,1.6,0,1.6-1.2c0.7-2.4,3.6-4.3,2.1-6.9C409.5,75.1,406.6,81.2,407.5,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381,19.3c-1.9,1,0.7,3.5,1.1,4.8C387.6,32.6,385,19.8,381,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.8,49.5c-2.6-1.5-6,7.1-2.8,7.3C337.7,55.7,337.8,51.5,338.8,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403,128.4c3.2,3,7.8,1.8,2.2-1.2C400.9,123.9,397.3,126.2,403,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423,154.7c-1.9-0.8-4.3-1.5-5.8-3C412.4,153.7,425.5,159.6,423,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.1,10.4c-1.9-2.5-7.1-4.4-3.1,0.1C416.8,14.7,423.1,13.8,416.1,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.3,115.4c-8.9-2.2-1.2,2.6,2.6,3.4C403.5,117.9,398.9,115.8,397.3,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.5,26c1.7,0.9,5.9,4.9,6.3,1.1c-1.7-0.7-11.2-6.3-6.5-1.1C393.3,25.9,393.4,26,393.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.2,27.5c3.9-1-4-6.2-5.7-5.7C342.3,24.6,347.7,25.6,349.2,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.5,154.8c2.7,0.1,7.4-8.4,2.5-7C342.7,150.9,335.3,152.7,338.5,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.5,31.2c-1.9,5.8,7.1-3.2,4.1-6C413.8,24.4,415.5,31.2,412.5,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4,41.7c-2.2-0.9-2.6,2.1-3.6,3.4C325.9,53.6,335.1,44.5,333.4,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.9,24.7c-2.6,1,1,4.8,0.8,6.8C435.8,36,432.8,24.2,430.9,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.7,120.6c6.4,1.5,2.7-2.7-1.1-2.8c-3.3,1.2,1.2,10.3,0.8,2.6C388.5,120.7,388.6,120.6,388.7,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.2,21.4c-0.3,0.4,1.9,8.1,2.7,7.2C443.3,27.3,443.2,18.5,440.2,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.5,15.9c-7.8,2.6,7.5,3.8,5.9-1.1C331,14.7,328.4,15.9,326.5,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.3,78.5c-2.4-5.6-2.2,5.1-1.7,6.8C331.8,87.4,330.2,80.3,330.3,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.9,24.1c-2.1,0-7.2-0.4-7.2,2.4c1.4,1.7,4-0.8,5.9-0.1C328.3,26.8,328.6,25.3,327.9,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.6,0.1c-3.8,3,5.4,1.5,6.1-0.2C342.5,0,336.6-0.4,336.6,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.2,30.8c0.1,2.3,4.8,0.5,6.3,0.9C400.3,31.2,387.7,28.5,385.2,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.5,89.5c-2.5,2.1,4.7,3.7,5.9,5.3C406.3,93.3,398.2,89.3,396.5,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333,19.4c-13.1-0.9-2.3,4.5,1.7,1.5V21C334.4,19.8,334.1,19.5,333,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.4,118.3c-1.8-4-12.5-9.6-4.4-2c1.4,0.6,2.7,4.3,4.2,2.3C331.2,118.6,331.3,118.5,331.4,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.8,18.7c-2.5,1.7,3.8,5.1,5.3,5.7C369.5,22.6,363.6,18.6,361.8,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.6,69.5c-3-9.7-1.9,1.4-2.6,3.9C344.8,76.2,346.7,71.2,345.6,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.3,28.8c-2,0.4-5.4,0-6.7,1.7C315.8,33.4,326.4,31.9,323.3,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.6,69.3c-1.3-0.9-6.9,10.5-2.6,7.9C359.3,74.9,362.6,71.2,361.6,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.5,85.2c-0.4,1.5-2.7,2.8-1.6,4.4c1,1.7,2.1-2.4,2.7-3.1c1-1.4,3-2,3.5-3.8 C438.5,79.2,434.3,84.1,433.5,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349,58.5c-1.4,7.6,4.1-0.6,2.6-4.1C348.8,52.9,349.3,56.9,349,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.3,86.1c0.3,1.5,0.8,6.4,3,4.3C356.7,87.5,352.9,77.5,353.3,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,125.9c-3.8,0.2-12.4,6.8-3.4,3C441.9,128.4,443.5,128.7,443.1,125.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.6,49.8c-3.7-9.8-1.8,4.2,1.3,5.5C431.5,54.7,426.8,51.7,426.6,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.2,55.4c0.1-1.8,0-6.1-2.5-3.5C324.8,55.9,328.8,63.3,328.2,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.4,65.7c-6.5,2.2,1.8,2.7,4.4,2.2C403.6,65.7,398.2,64.7,396.4,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.5,6.5c-3.7-7.2-2,1.8-1,4.4C397,14,395.4,8.2,394.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.1,90.6c2.4,0.4,5.1,4.5,7.2,3.1C427.8,91.8,418.1,86.2,420.1,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.3,50.7c1.4,5.1,3.9-4.5,1.8-6.2C316,43.8,318.6,49,317.3,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.6,96.2c-0.1,2.4-2.3,4.5-3.3,6.3C341.1,105.5,347,92.6,341.6,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.5,141.1c3.3-1.8-2.5-4.5-3.6-6.2C398.9,133.1,405.9,140.1,407.5,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.1,99.7c-2.7-0.3-2.6,3.4-4.3,4.5C334.5,110.8,347.9,104,346.1,99.7L346.1,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.1,5.8c-8.1,1.6,6.3,2.9,6.8,0C389.5,3.9,386,5.6,384.1,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.9,90.2c0.7,1.2,5,2.4,4,0c-2.2-0.8-3.1-2.9-4.2-4.9C318.6,84.5,321.1,89,321.9,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.5,32.5c-1-2.9-3.7-10.1-2.8-2.1C381.9,36.2,388.8,36.5,384.5,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.3,79.3c-4.1,4.5,5.8,0.6,2-6.6C337,72.8,340.2,77.9,338.3,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.6,139.2c1.8,1.2,3.3,6.9,5.5,5.7C388.6,142.7,379.3,133,382.6,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.7,99c-4.9,2.3,10.4,3.9,6.8,0.6C370.2,99.2,368,99,365.7,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.4,1c0.1,1.2,0.1,3.1,1.4,3.5C404.7,4.3,399.5-3.1,399.4,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.3,61.9c0.5-2.8-4.5-7.1-3-2c2.5,1.2,0.2,5.8,3.6,5.9C443.2,64.5,442.5,63.1,442.3,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.2,23.7c-2.1,0.4-8.7-4-5.1,1C338.8,25.7,345.8,27.4,342.2,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.4,21.7c0.1,2,3.8,7.1,5.7,4.6c0.3-1.6-1.8-1.9-2.7-3C354.5,22.5,352.7,18.7,352.4,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.1,12.7c-3.2,1,0.9,4,1,5.9C442.8,17.9,443.9,12.3,442.1,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.9,104.8c-0.9,0.6-3.6,3-1.7,3.8c1-2.4,8.6-3.8,5.9-6.4C365.4,102.5,364.6,104.1,362.9,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.9,4.8c-1.9,0.9-7.9,2.2-6.3,5C329.9,9.9,337.9,6.6,334.9,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.9,14.6c2.2,0.9,3.3,3.3,4.9,4.7C443.8,18.3,436,10.5,434.9,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.6,45.8c1.6,5.6,4.1-4.8,1.9-6.1C381.2,38.9,381.9,44.3,381.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.4,37.2c-4-2.8-6.8,0.1-2.8,1.2C371.8,40.9,376.9,39.7,371.4,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.9,32.3c1.7,2,2.5,4.6,3.6,6.8C386.4,38.3,378.7,27.5,378.9,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.4,34.2c-1.1,4.6,4.3-0.5,6.1-1c1.2-4.1-4.5,0.1-6,0.8C329.6,33.9,329.5,34,329.4,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.6,108.6c-6.3-0.9,1.8,3.5,3.7,4.6C396.6,111.9,391,109.3,389.6,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.2,135.8c4-1.1-6.1-8.7-5.4-4C415.7,132.9,417.4,134.7,419.2,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.5,95.1c-2.5,2.7,0.4,2.7,1.8,0.4c1.1-2.1,4.4,0.4,5-1.7C366.3,90.8,363.2,92.8,361.5,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.5,2.1c0.9,2.4,8.9-1.1,8.5-2.1C392.3-0.1,388,0.6,386.5,2.1C386.5,2,386.5,2.1,386.5,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.5,51.3c-4.5-7-2.1,2-0.2,4.8C357.9,56.9,356.5,52.3,355.5,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.1,130.8c-0.7,1.3,1,2.9,0.6,4.4C350.9,143.5,352.7,128.1,348.1,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.3,148.7c-0.7-0.9-1.8-2.2-2.5-3C360.2,141.2,375.4,161.4,369.3,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.3,32.7c-1.9,1.2-6.7,3.3-4.4,5.9C336.9,37.4,344.2,33.7,340.3,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.7,123.8c1.7,0.7,7.4,2.3,4.1-0.8C366,121.6,357.2,120,364.7,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.6,1.7c3.3,4,3.5-3.1-1.7-1.7C439.5,0.5,440,1.1,440.6,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.7,11.3c-7.1,2.2,8.4,2.7,8.7,0.8C368.1,10.3,364.4,12.2,361.7,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.5,152.9c1.9,1.3,1.9,4.5,3.5,5.6C353.5,155.3,343.1,147.7,346.5,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.3,107c-5-6.6-1.5,2.6,0,5.1C429.9,112.6,428.4,108.1,427.3,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.6,128.9c0.8-2.3-4.3-7.3-3.8-3.1c1.7,1.2,2.3,2.9,2.3,5C319,134.3,320.8,130.7,319.6,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.6,19.4c1.7,5,4.5,3.9,2-1c-0.4-1.1,0.6-4.1-1.5-3.3C409.4,16.1,409.5,18.1,409.6,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.1,17c1.1,2.9,5.4,3.8,2.9-0.2C415.1,13.3,410.9,11.4,414.1,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.4,57c-2.6,1.5,1.5,10.3,2.8,5.8C345.3,61.2,347.7,56.7,344.4,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.4,122.3c2-2.3-2.4-2.9-3.3-4.5C409.4,113,415,122.8,418.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.1,100.8c-1.4-0.7-6.2-5.8-6.8-3.3c0.8,1.6,6.5,6.9,7.1,3.4C325.3,101,325.2,100.9,325.1,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.1,147c2.2,0.4,4.9,6,6.3,4.6c1.9-2.2-7.3-8.3-6.4-4.6C344,146.9,344,147,344.1,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.5,148.9c2.4,0.1,3.1,6.2,5.4,3.9C441.2,145.4,431,147.9,436.5,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.8,4.8c-9.8-1.9-1.1,2.4,2.8,2.7C442.2,5.6,438.2,5.1,436.8,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.6,16.5c-5.3,0.5,3.4,3.7,4.8,4.7C343.8,19,338.5,16.7,336.6,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.6,70.1c0,5.2,5.3-3.6,4-5.1C349.8,62.2,349.1,68.7,347.6,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.5,163.8c0.2-0.5,0.8-1.3,0.2-1.7C394.1,154.8,396,160.8,404.5,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.1,43.1c-0.3-1.9-4-6-3.6-1.8C378.3,44.1,380.3,51.7,380.1,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.1,111.6c-1,2.1,3.4,6.2,5.3,6.3C420.5,116.4,414.2,112.4,413.1,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.7,106.4c-3.3,1.4,3.1,5.4,4.4,6.3C401.1,110.3,396.2,108,394.7,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.5,40.9c-0.9,1.9,3.1,9.4,4,4.9C435.2,44.7,434.6,39.1,432.5,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.4,42.2c-0.5-1.2-1.3-2.5-1.8-3.6c-3.7,0,0.9,4.9-0.1,7C431.5,47.1,432.2,43.6,431.4,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.5,85.6c-0.1,1.8,8.8,6,8,2.4C413,87.6,403.7,84.6,404.5,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.1,126.7c-1.2-1.2-4.3-6.4-4.3-2.1C342.6,127.4,350.3,131.1,347.1,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418,56.1c1.2,4.4,4-6.5,3.9-7.8C420.7,45.9,418.1,55,418,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.1,116.1c0.6,0.2,0.6,1.3,1.3,1c3.1-2.4-9-8-6.7-4C371.8,113.4,373.2,115.4,375.1,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.5,128.2c1.2,9.1,8.6,7.8,0.8-0.7C340.1,128,339.8,128,339.5,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.9,58.7c-3.3-6-3.4-0.3-0.8,2.6C438.3,65.4,437.6,61.5,434.9,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.6,61.5c-2.2-0.7-5,0.3-2.2,2.2c1.7,0,3.7,0.5,4.5,2.2C407,66.1,402.9,62,401.6,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.3,123.6c-0.9,1.3-1.8,5.7,0.8,3.5c1.3-1.5,2.3-10-1-6.5C337.6,121.7,338.2,122.6,337.3,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.2,139.2c3.3,0.4,1.5-5.4,0.5-6.7c-2.9-0.4-0.7,2.7-1,4.3C352.9,137.6,352.2,138.9,353.2,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.7,78c-0.6,1.4-4.4,6.3-1.5,6.7C361.5,84.6,365.7,75.1,361.7,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378,32.4c-1-1.5-5.4-2-3.6,0.5c2,0.6,3.4,2.2,3.9,4.2C380.8,37.8,379,33.4,378,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,131.5c2.9-1.5-3.3-5.1-4.7-6.2C354.2,126.9,359.6,130.7,361.3,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.1,122.3c1.8,1.2,2.4,4.7,4.3,4.8C364.3,125,353.8,116.3,357.1,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.7,70.2c-1.8,2.2,2.7,9.2,4.1,5.4c-1.3-1.2-3.8-2.9-2.8-5.2C382.4,68.1,379.4,68,378.7,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.6,133.4c1.3,1,3.7,7.1,5.2,4.7C377.6,136.3,370.2,128.6,371.6,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.5,38.2c-2.7,5,1.8,1.3,4,0C348.8,34.3,342.7,35.9,341.5,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.8,28.1c0.9,1.4,0.8,6.3,2.4,6C407.3,32.5,404.7,23.1,402.8,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.3,7.6c1.3,1.3,4.2,6.8,5.9,3.3C407,10,403.1,4.1,402.3,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,37.1c-3.3,0.5-3.9,4.3,0.2,2.4C355.1,40.5,354.6,35.9,350,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.5,112.1c5-0.8,7-4.3,0.5-2.2C359.9,111,357.6,116.3,363.5,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.7,45.2c-5.7-1.6,3.9,4,4.3,5.6C420.8,49,413.5,46.5,412.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.5,124.7c-0.5-4.4-12.3-4.3-3.8-1C405.9,124.5,407.2,126,408.5,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319,92c-6.3-2.5,0.3,3.3,2.6,4.3C325,95.5,320.2,92.7,319,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.7,155.5c0.1,2.8,11,10,5.1,3C374,157.9,372.6,154.4,370.7,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.3,98.3c-2,1.5,0.7,4,1,5.9C420.9,108.6,417.2,99.4,415.3,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.5,32.7c-1.4,0-4.3,0.5-3.2,2.5c1.8-0.1,3.8-0.6,5.6,0.4C398.4,34.8,394.2,32.5,392.5,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.5,88.1c2,0.4,6.8,3.2,7.8,0.7C392.9,87.8,383.1,85.5,385.5,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.2,163.9c2.1,0.6,5.7,3.8,7.3,2.3C386.7,164.5,374.9,160.1,378.2,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.7,136c2.5-10.7-5.6,3.5-2.5,3.2C327.3,138.8,328.5,136.9,328.7,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.7,9.6c-2.5,1.2,1.1,4.7,2,6.1C397,17.8,392.2,9.5,390.7,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.9,78.2c-1-6.9-3,4.7,1.6,5.2C430.3,82.2,424.5,80.4,424.9,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.9,42.3c1.7-1,6.2-2.8,4.8-5.3C338.1,37.6,332.2,40.4,334.9,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.2,144.6c4.4,0.8-1.1-4.8-2.4-5.7C399.8,140.5,404,143.1,405.2,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.5,98.9c-2.2-2.4-8.4,3.7-5.2,4.2C358.2,99.5,364.9,102.1,362.5,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.6,143.1c1.7,0.6,7.6,3.9,6.8-0.2C434.9,143.5,427.3,139.5,429.6,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.1,156.9c0,2,0.6,4.8,1.8,6.2C442.8,162.2,443.6,153.2,441.1,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.4,64.4c0,0.2-0.1,0.6-0.1,0.5c0.1,1.7,1.8,8.4,3.7,6.2C429.7,70.8,425.8,61.6,425.4,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.7,57.1c-0.4-3-4-5.4-2.7-0.7c0.4,1.2,1.1,2,0.6,3.2C360.1,61.6,362.5,58.6,360.7,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.2,82.7c-6.2,0.3,7.9,5.1,6.5,0.8C387.8,83,385.3,83.9,383.2,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.4,49.1c0.3,1.7,0.3,8.4,2.7,4.8C395.8,52,395.8,43.3,393.4,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.5,46.8c-2.2,1.7,2.9,5.3,4.5,4.8C444,49.1,440.3,47.5,438.5,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.9,139.3c1.4-0.7,6.9-0.6,4.4-3C439.7,136.3,429.7,140.4,437.9,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,97.8c1,0.6,1.7,1.3,2.7,1.9C444.3,97.2,439.1,94.4,440.3,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.2,37.5c-1.6-0.9,0-5.8-2.5-4.3C360.4,36.2,368.1,44.2,365.2,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.4,54c0,1.6-0.5,4.2,0.4,5.8C344,61.5,343.7,52.3,340.4,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.1,3.2c-1.7,0.1-9.4-2-6.8,1.4C342.2,4.5,347.3,6,347.1,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324,3c-9.1-0.9-0.5,2.1,3.1,2.2C333.1,4.3,325.8,3.3,324,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.9,69c1.9,1.5,1.3-2.4,1.7-3.3C424.1,55.5,416.8,63,417.9,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.7,140.9c2.7-1.7-5.7-6.1-6.1-3.2C413,138.9,415.7,140.9,417.7,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.5,95.6c-0.6,2.1,1.5,6.4,2.5,2.4C336.4,94.4,336.3,87.9,334.5,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.2,125.8c-8.2-3.8-0.4,3.1,2.7,4C390.5,128.5,385.9,127.1,385.2,125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.6,70.1c-1.2-5.8-2.7,2.4-1,4.4C336,77.6,334,71.9,333.6,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.8,125.4c5.5-1.5-6.1-4.2-5.9-1.5c1,1.4,4.2,1.2,5.9,1.4C433.7,125.4,433.8,125.4,433.8,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.2,155.4c-0.8-2.6-2.1-5.8-4.2-7.6C376.1,147.3,381.7,158,382.2,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,113.1v-2C442.8,111.6,442.8,112.6,443.1,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.2,50.3c-3.4-4.5-1,4-2.4,5.6C374.1,58.2,374.8,52,374.2,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.9,118c-2.2-0.4-2.5-5.3-4.6-3.8C314.8,116.9,323.9,123.5,320.9,118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332,138c-3.1-0.6-0.4,4.9-3.4,6.4C331.9,146.6,333.2,139.6,332,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.7,156.9c1.9-0.8,5.3-2.9,5.5-5C327.2,150.8,318.5,156.9,322.7,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.9,130.1c0.5-1.5-1.8-3.2-1.8-5C346.9,123.1,350.2,132.7,352.9,130.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.4,99.8c-1.6-0.1-5.9-3.2-5.1,0.2C432.8,101.7,440.5,103.3,436.4,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.9,2c-2.5-0.2-5.2-1.2-7.6-1.1C345.7,2.4,360.3,5.8,355.9,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,94.8c-1.2-1.1-3.6-3.6-5-1.6C409.3,94.9,417.4,99.6,415.1,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.1,154.6c6,0-4.8-6.2-4.2-1.8C422.7,154,424.8,154.1,426.1,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.8,129.7c-0.7-1.4-2.7-4.7-4.4-3c2.1,1.5,2.8,5.4,4.6,6.6C337.8,132.4,336.1,130.9,335.8,129.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.9,67.8c1.1,1.4,1.1,5.2,2.8,5.4C427,71.6,421.2,61,421.9,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.9,24.1c-3.5,1.9,2.9,3.5,4.4,3.9C339.8,25.5,334.6,24.4,332.9,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.2,88.3c-0.9,1.2-4.1,5.6-0.9,5.6C345.5,93.4,348.8,86.4,345.2,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.3,8.3c-5.8,2.3,2.8,2.5,4.8,1.1C379.8,6.3,376.2,8.3,374.3,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.4,42.4c-5.2-1.9,2.7,5.1,4.6,3.6C423.6,43.6,418.8,43.6,417.4,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.2,63.1c-3.2-1.2-0.2,4-0.6,5.6C370.7,70,370.2,64,368.2,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.1,134.4c2.3,4.6,4,1.1,1.1-1.6c-2.4-4.1-5.2-1.3-1.3,1.4C396.9,134.2,397,134.3,397.1,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.3,5.3c-1.4-0.8-0.3-3.2-1.8-3.7c-2,0-0.8,2.3-0.9,3.5C397.2,8.1,401.9,8.6,399.3,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360,63.7c0.8-3.2-2.4-5.2-2.2-0.9C357.1,66.9,366.1,66.8,360,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.3,20.1c-1.7,1.2,1,3.5,0.7,5.2C425,31.9,429.2,19.5,424.3,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.4,78.4c-0.2,2.3,5.7,4.9,3.7,1.6c-4.2-1.6-0.9-6.1-3.1-5.4C374.5,75.8,374.1,77,374.4,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.9,90.3c-2.9-3.9-3.6,11,0,5C339.4,93.7,339.6,91.9,339.9,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431,0.7c1.4,2.6,11,2.7,4.9,0.1C434.8,0.5,430.8-1.2,431,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.2,119.3c-1.3-0.9-1.5-1.2-2.3,0.3c-0.5,1.7,2.9,2.5,3.9,3.7C386.5,122.9,382.8,120.2,381.2,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.4,75.8c1.7,6.6,3.4-7,1.3-7C407.1,70.9,406.5,73.5,406.4,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334,106.2c-0.9,1.8,0.3,4,2,2C337.8,104,336.3,100.3,334,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.6,97.4c0.9,1.1,4.6,4.5,3.7,1C425.7,95.2,419.6,92.1,423.6,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.3,126.5c1.1,1.3,3.5,4.9,4.9,2.4c-0.6-1.6-2.9-3-4.3-4.5C389.6,124,388.8,126.2,390.3,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331,102.7c2,6.3,4.3-8.4,0.3-4.1C330.8,99.9,332.1,101.5,331,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.5,64.9c0.2-1.6-1.8-7.6-2.5-3.9C327.4,65.7,331.8,69.5,330.5,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354,80c1.7-0.3,3.7-8.8,0.4-5.8C354.2,75.7,351.8,79.9,354,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.1,137.9c1.2,5.7,3.9-4.1,1.7-5.1C337.3,132.6,338.9,136.4,338.1,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.4,31c-4.2-3.3-8.8,2.3-3.9,1.2C400.3,32.6,403.2,34.3,402.4,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.1,132.5c-1.1,2.2,3.8,3.1,4.8,5.1C369.4,136.5,362.7,132.1,361.1,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.4,3.3c-1.2-0.5-2.3-2.2-3.4-2.2C423.4,4.1,435.6,10,429.4,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.6,157c-4.4-1.1,2.9,5.8,4,5.8C375.1,160.9,371.1,158.3,369.6,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369,139.1c1.4,0.5,4.7,5,5.1,1.9C374.3,138.9,365.2,134.5,369,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.9,83.4c-3.5,1.4,2.4,3.3,2.9,5.1C399.9,88.6,394.1,83.9,392.9,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.7,115.2c-1.5,1.8,4.3,2.3,5.4,2.8C374.8,115.5,369,113.9,367.7,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.1,84.7c-0.5,1.3-2.5,2.3-0.9,3.6C443.8,86.1,440.6,71.9,440.1,84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.2,137.4c1.5-0.7,0.6-1.9-0.4-2.6C403,127.3,404.5,136.4,409.2,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.6,112.1c-0.9-1.7-5.1-5-3.8-1.2C378,113.2,383.6,117.3,380.6,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.2,141.7c1.6,0.4,3.9,3,5.4,1.9C418.5,141.5,408,137.9,411.2,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.5,61.7c-2.6-0.4-4.4,0.6-1.7,2.4C394.4,65.1,398.1,61.4,392.5,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.4,53.6c-0.1-0.1-0.2-0.1-0.3,0C421.2,66.1,427.2,67.1,423.4,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.7,104.6c-0.3-5.5-3.6,5.8-0.6,6.4C423.8,109.9,420.7,106.8,421.7,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.7,49.4c-0.2,1.8-5.8,4.4-2.1,5.2C332.4,53.9,337.3,47.1,332.7,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.7,87.7c2.7,1.1,3.3-3.7,3.7-5.4C365.9,79.9,363,86.8,363.7,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.3,119.4c-0.4-1.1-2.5,0.1-3.5-0.1C420.7,119.1,434.8,124,435.3,119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.1,4.2c-1.3,0.9,0,2.1,1,2.5C443,6.1,443.5,3.6,442.1,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.5,31.4c0.2,1.5,0.6,4.5,2.1,5C439.9,36.1,437.5,27.4,435.5,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.8,14c-4.2-1,1.2,9.1,2.5,4.6C391,17,389.4,15.6,388.8,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.1,8c-0.4-0.2-0.6-0.8-0.8-1c-3.3,1.6,1.7,4.1,3.1,5.1C435.7,11.4,431.5,8.6,430.1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,0.6c-0.5,3.9,3.1-0.3,4.6-0.6C322,0.1,318.7-0.3,318.2,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,79.8c-1.2,1.9,3.9,2.4,4.4,4.5C406.2,84.3,398.8,78,397.2,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.7,65.6c-3.2-1.8-1.2,5.3-0.5,6.7C326.2,73.2,323.4,67.1,323.7,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.5,3.4c-5.1,2,0,3.5,2.4,1.1C384.7,2.8,380.2,1.4,378.5,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.1,47.3c1.8,0.9,2.5-1.1,3.6-2.1c0.6-0.9,2.7-1,2.4-2.3C339.1,41.4,332.6,46.2,334.1,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.7,18.4c0.7,1.8,1.2,6.7,2.8,2.3C430.1,17.6,425.8,12.7,426.7,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.3,40.3c-1.7,0.3-3.7-0.1-5.4,0C416.6,43.6,428.2,43.4,425.3,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.6,37.6c-5.8,1.4-1.7,4.2,1.8,1.4c1-0.5,2.6-2.8,0.7-2.9C418.3,36.6,417.4,37.9,416.6,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.5,131.2c-4,0.7,5.2,4.6,5.5,3.6C382.2,132.3,376.7,132.2,375.5,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,43c10.8,8.7,1.2-6.2-0.1-0.1C367.2,42.8,367.2,42.9,367.3,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377,64.3c2.6-0.7,0.5-4.7-0.1-6.4C373.9,56.6,376.1,63.4,377,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.5,3c-0.8,1.9-4.4,1.7-3.6,4.1C371.3,9,376.2,2.3,372.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.1,26.4c-4.8-6-5.2-0.8-0.9,2.4C392.6,28.7,393.3,27.1,392.1,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387,94.6c0.3,2.1,8.5,5.5,5.8,1.9C391,96.2,388.3,92.8,387,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.9,105.8c-1.7-1.2-3.8-2.4-5.8-3.2C368.9,103.3,378.1,109,377.9,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.1,8.7c-1.4,0-7.3-1.7-5,1.1c1.7,0.1,7.4,2.7,6.4-0.8C442.4,8.6,441.4,9,441.1,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.9,138.4c0.6,1.7,1.6,5.8,3.6,5.8C394.5,143.1,391.2,135,389.9,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.3,27.1c-2.6-3-4.4-0.3-0.6,2.1C372.9,32,373.2,28.1,369.3,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.9,18.8c-0.3-0.7-1.4-0.2-1.6,0.4C394.7,26.1,400.8,26.3,394.9,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.7,12.3c2.1,1.5,8.7-6.3,3.7-3.9C323.1,9.3,320.2,10.3,320.7,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.5,145.4c1.6-2.3-2.7-3.2-3.6-4.9C352.3,141.2,358,146.2,359.5,145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377,19.7c-4.2-2.9,0.4,6.3,2.3,5.1C380.1,22.9,377.9,21.1,377,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,0.6c0.4,0,1-0.2,1.2-0.6C404.4,0.1,401.4-0.3,403.6,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.8,154.5c1.6,0.6,3,2.8,4.7,2.2C417.8,154.8,410.4,150.6,410.8,154.5 C410.8,154.3,410.8,154.4,410.8,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.3,81.2c-1,1.4-2.9,6.3-0.4,6.6C340.8,87.4,342.8,79.3,340.3,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.8,79.2c1.3,1,5.7,4.2,6.4,1.6c0-0.7-8.4-4.5-6.7-1.8C378.5,78.9,378.6,79.1,378.8,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.9,160c1.5,0.4,6.4,3.9,5.6,0.5C393.4,159.7,385.6,156.5,388.9,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.5,15.9c1.2,0.5,2,2.6,3.4,2C381.2,15.7,368.7,10.2,374.5,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.7,49.8c2.2,3.2,2-3.2,1.6-4.7C402.1,39.5,401.4,48.1,401.7,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.7,153c0.9,0.9,4.1,5.7,4.9,3.2C366.5,154,358.7,148.5,361.7,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.3,81.7c-3.1,0.6,5.5,8.1,4.5,3.6C399.3,84.4,397.8,81.3,396.3,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.5,42.8c-2.5-0.5-2.8,4.3-3.1,6C392.6,51.4,393.5,43.9,393.5,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.9,6.4c0.7,1.1,3.7,4.4,4.4,2C410.2,6.3,402.8,1.5,405.9,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.6,123.6c1,0.7,7.3,2.7,6.4-0.2C423.4,122.8,419.4,121.2,418.6,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.9,127.7c1.7,0.3,4.7,4.8,5.3,1.6C376,127.5,368,124.2,370.9,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.1,113.4c-2.7,1.5,1.9,3.9,3.1,5C411.9,117.1,407.6,113.9,406.1,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.5,40.6c-5.5,0,1.9,4,3.8,3.6C364.2,42.5,359.8,41.4,358.5,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.8,163.1c4.1,1.3-3.2-7-4.5-4C409.9,160.9,412.3,162,413.8,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.7,49.9c-0.6-1.4-3.3-6.1-4.5-3.1C356.8,48,361.8,54.1,360.7,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.3,106.1c-5.8,0.2,2.3,2.5,3.7,4C375.6,109.1,370.5,106.5,369.3,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347,42.1c-2.4,1.1,1.1,3.7,2.2,4.5C353.3,47.8,348.7,41.8,347,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.4,146c1.7,0.9,3.4,2,4.9,3.2C393.6,148.9,379.9,141.8,383.4,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416,0.2c0.3,1.2,1.8,0.9,1.9-0.2C417.8,0.1,415.7-0.2,416,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.9,0.6c1.8-0.9-2.1-0.3-2.3-0.5C384,0.9,385.1,1.1,385.9,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.8,139c-1.1-1.4-4.4-3.2-3.8-0.2C421.7,140.7,427,143.6,423.8,139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.2,39c-3.6,5.7,2.8,1.5,3.5-1C332,34.7,328.9,38,328.2,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.9,0.6c0.5,0.3,1.1-0.2,1.4-0.6H377C377.3,0.3,377.6,0.5,377.9,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.7,83.8c-2.7-1.1-0.5,4.9-0.1,6.3C335.9,91.9,332.7,85.3,332.7,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411,133.1c1.4,0.7,3,3.8,4.3,2.1C416.1,132.5,407.9,129.1,411,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.5,119.6c0.2-2-3.8-1.5-4.4-3.3C416.8,116.8,424.7,122,425.5,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.4,61.3c-0.9-1.4-0.8-5.1-2.8-5.1C425,58.4,431.5,68.4,429.4,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.8,144c-2.4-1.1-2.9,3.1-4.5,4.2C330.1,152.2,335.9,145.6,334.8,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.2,75.5c1.8-0.3,4.7,2.3,5.7,0.6C400,73.7,389.7,72.9,393.2,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.6,147.8c-2.1,2.1,3.5,3,3.6,5.2C379,152.9,373.4,147.2,371.6,147.8L371.6,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.5,131.6c1.2,0.8,4.3,5.1,4.1,1.4C386.8,130.8,380.1,126.9,383.5,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.5,122.9c4.4-1.9-6.7-4.7-5.1-0.9C395.1,122,396.8,122.8,398.5,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.9,79.6c-3.8-0.8,2.4,6.6,4,4.3C376.4,81.9,372.7,81.4,371.9,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.4,1.4c3.7,6,5.6-1.5-0.1-1.3C406.4,0.5,406.4,0.9,406.4,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.7,143c4.4,1.7-0.9-7.4-2.3-4.9C342.6,140,344.4,141.2,344.7,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.4,58.4c-0.9-5-2.4,5.1-0.5,5.6C335.2,64.6,332.4,60,332.4,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.8,148.3c6.8,4.2-0.3-3.4-1.6-4.3C389.6,144.9,391.4,148,392.8,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.5,134.5c-1.1-1.2-1.8-4.1-3.6-3.7c-0.9,1.3,4.5,9.6,3.8,3.8C359.6,134.7,359.5,134.6,359.5,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.5,128.9c1.7,0.9,6.5,1.9,5.5-1.2C431.8,128.4,425.8,126,427.5,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.8,117.6c1.6-1.7-3.2-3.4-3.9-5C435.3,113.8,440.1,118.4,441.8,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.7,159c-0.9-2.9-4.1,1.5-6.1,0.9C318.3,161.5,327.3,162,328.7,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.7,136.8c1.1,0.8,3.4,6.7,3.7,2.7C388.1,136.4,381.6,132.3,384.7,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428.4,117.2c1.1,0.5,1.9-1.4,0.9-1.9C423.7,111.9,422.2,115.4,428.4,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.4,142.2c5.4-6.6-7.2,1.9-3.5,3.1C318.9,144.2,320.2,143.2,321.4,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.4,158.3c0.4,1.5,1,6.2,3,3.3C440.8,159.6,436.7,153.3,437.4,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.5,91.9c-1.7-0.1-4-1.5-5.4-0.2C367.2,93.8,376.7,94.8,373.5,91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.5,140.2c-3,1,1.6,3.9,2.5,5.1C343.7,144.5,338.3,141.5,337.5,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.4,142.8c1.8,0.8,5.4-0.2,4.7-2.6C441.7,141.1,438.1,140.7,438.4,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,56.8c-3.2-4.3-2.5,1.7-0.5,3.7C384.4,61.1,383.8,57.8,382.8,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.1,23.5c1.7,1,2.3,4.9,4.6,4.2C414.1,26.7,408.2,19.7,408.1,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.7,47.6c-3.1-2.2,0,6.4,1.4,6.1C434.4,52.2,432.4,49.2,431.7,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436,22.7c-1.4-0.4-2.1-3.1-3.6-2.7C429.3,22,437,27,436,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.4,52.5c-2.6,1,1.4,3.5,2.3,4.5C368.6,57.1,364.3,52.7,362.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.8,34.3c-0.8-1.1-4.5,0-2.6,1.2C424.9,38,430.2,36.4,424.8,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.5,9.3c-1.4,0.5-5,2.3-1.8,3.1C347.2,12.2,351.5,7.7,346.5,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.3,15.2c-1.5-0.6-3-0.3-4.5-0.2C351.5,17.6,362.6,18.5,359.3,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.7,37.8c-1.6-0.2-2.7,1.2-1.2,2.3c1.4-1.2,3.1,1,4.3,0.6C401.1,39,397.1,37.6,395.7,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.6,143c4.2,5,3.1-2.5-0.3-3.1C396.7,140.8,397.6,142.2,398.6,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.3,152.9c-1.6-3.1-9.4-3.7-3.2-0.4C395.3,153.2,397.7,156.2,397.3,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,9.7c-1.4,0.3-5.2,0.3-4.2,2.4C333.3,13.3,339.5,11.4,336.1,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.9,142c-3.9-1-6.9,8.7-1.7,2.9C325.5,144,328,142.8,326.9,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.3,130.7c-1.6-2.5-10.5,4.1-3.6,2.1C440,132.2,442.3,132.5,442.3,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.4,125.1c5,4.3,6.3,1.4,0.9-1.7C374.5,122.7,373,125.1,374.4,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.6,116.4c-1.3-0.9-3.7-6-4.8-2.8C431.7,114.9,434.2,119.3,435.6,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.2,127.9c-1.1-0.9-3.9-3.3-3.9-0.6C366.5,129.4,371.9,132.6,369.2,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.2,2.8c0.5-2.7-4.8,0-5.9-2.1C323.5,3,331.8,3.5,333.2,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.7,113c-3.2-2.6-1.1,2.6,0.3,3.7C341.4,119.1,338.8,114.2,337.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.6,40.9c-2.5,6.3,4.4-1.8,4.1-3.4C391,37.3,389.3,39.5,388.6,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.8,54.8c1.5,0.2,5.8-3.5,2.9-4.2C404.4,51.7,400.6,52.8,402.8,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.5,69.2c-2.1-1.4,0.1,6.6,1.5,6.7C391.7,75.2,389.2,70.2,388.5,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386,63c-2.4-4.2-1.8,1.8,0.2,2.7C390.2,67.6,389.5,64.2,386,63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.8,74c-3.4,7.4,2,1.6,2.3-2C431.8,68.3,430.4,72.9,429.8,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.4,127.3c4,0.3-0.8-3.3-2.1-4.1C391.7,124.7,395,126.4,396.4,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.6,121.3c-6.1-5.3-0.5,4.2,2.1,3.4C380.5,123.4,378.3,122,377.6,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.2,132.7c2.4,4,3.3,0,0.5-1.9C364.6,128.3,364.2,131.6,367.2,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,164.6c-0.4-1.6-4.3-4.4-4.4-1.3C349.6,164.1,353.3,167.8,353,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.4,107.8c1.4-0.5,6.3-5.1,3-5.1C358.1,104.3,352.8,106.7,355.4,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.7,154.1c-1,1.6,2.9,3.3,3.7,4.7C382.5,157.7,377.2,154.2,375.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317,160.6c1.1-0.9,4.1-1.6,3.9-3.2C319.2,156.2,312,160.7,317,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.4,94.2c-5.2-1.8,1.2,5.3,2.6,3C329.4,95.9,327.3,95,326.4,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396,101.2c-2.7,2.5,3.7,2.8,4.6,0.9C400.5,99.7,397.5,101.2,396,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349,33.8c-3.4,1.2,0.8,3.3,2.9,2.6C354.3,34.4,350.7,33.6,349,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.2,104c-2.5,3.2,6.7,4.4,3.6,1C328.5,105.6,327.5,103.1,326.2,104L326.2,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,1.7c1.1,0.3,1.7-1,1-1.7c0,0-2.7,0-2.7,0C421.2,0.6,421.5,1.3,422.3,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.9,151c2,1.1,2.1-3.1,1.7-4.3C335.3,144.9,334.6,149.9,335.9,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.6,13.9c0.2-1.3-1.3-3-2.2-1.4c-0.1,1.4,1,2.7,0.7,4.4C424.1,18.1,424,15.2,423.6,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.5,13.4c-1.2-0.7-2.2-1.6-3.5-1.9C373.2,12.7,381.6,17.3,380.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.7,127.3c1.4,2.8,3.2,0,1.2-1.6C412.3,121.8,410.5,125,413.7,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.3,102.3c-1.5-0.1-3-0.9-4.4-0.9C387.9,104.2,397,105.8,394.3,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.9,103.4c-6.1-1.4,1.6,5.4,2.9,2.3C390.2,104.8,388.9,103.7,387.9,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326,147.3c-0.9,0.9-4.9,1.4-3.5,3.1c1.5,0.9,8.5-3.9,3.9-3.3C326.4,147.1,326.2,147.2,326,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.1,159.7c0.8,0.8,0.7,3.8,2.2,2.9C365.8,159.9,359.4,152.8,362.1,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.3,30.6c3.5,2.8,2.9-7.3,0.1-3.6C408.1,28.2,409.4,29.4,408.3,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.4,137.3c-0.5-1.1-1.2-6.4-2.8-3.6C332.7,135.1,334.2,140.8,335.4,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.8,146.4c-3.3-0.5,3.5,8,2.9,3.8C364.8,148.9,364.1,147.4,362.8,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,76.9c1.7,0.2,2.9,5.4,3.8,2C404.7,76.8,398.6,73.1,400.8,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,13.6c-1.5-0.8-5.9-0.6-3.6,1.7C339.9,15.3,344.4,16.4,342.1,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.5,109.1c-2.6-2.4-2.9,4-0.7,3.9C344,113.1,342.7,110.4,342.5,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.3,164.4c-0.1-3.6-4.9,0.9-3,2.3C326.6,168.2,328.1,165.4,328.3,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.5,112.3c1.3,3.7,1.7-1.7,1.2-3.1C407.9,104,408.9,110.3,409.5,112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.7,1c0.1,1.9,2.2-0.6,3-1C364,0.1,361.3-0.5,361.7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317,165.3c1.4,0.5,5.5-1,5.4-2.4C321.4,162.2,315.1,163.9,317,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,103.5c3.7,1.2-0.1-5.4-1.7-3.6C326.4,101.4,327.9,102.5,328.9,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.2,131.6c2.8-0.6-3.7-5.8-4.6-4.9C326.6,128.5,328.7,130.7,330.2,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.6,9.2c-2.3,3.2,5.2,0.6,4.4-1.2C366.6,6.9,364.9,8.7,363.6,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.2,14.6c2.1-2.5-1.5-2.4-3-1.1C320.9,16,324.7,15.9,326.2,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.8,2c0.5,3,2.6-0.9,3.4-1.9C359.4-0.2,358.7,0.5,357.8,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.2,98.9c-4.7-0.7,1.4,4.1,3.3,1.4C394.5,98.5,392.4,99.3,391.2,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.5,106.2c-1.5-2.1-4.7,0-1.7,1.2C384.7,109.6,387.5,108,384.5,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.3,118.5c0.3,1.7,3.4,5,3.2,1.5C360,118.6,358.2,113.9,358.3,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.9,29.7c0.5,1.1,2.4,0.4,3.3,0.1C336,27.4,328.3,26.3,329.9,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.2,22.7c-0.6-1.2-4.1-2.4-3.6-0.2C414.9,23.6,419.9,26.6,417.2,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.6,122.4c1.5-0.3,3.8,0.5,4.7-1C441.1,119.5,434.6,120.6,436.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.5,71.2c1,1.1,5.2,3.2,4,0C402.4,70.9,398.9,68.5,399.5,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334,59.4c-0.1,1.3,1.1,4.6,2.9,3.3C337.4,61.7,335.3,57.4,334,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.4,36.1c1.2,0,2.3,2.3,3,1.3C377.4,34.9,371.4,32.3,372.4,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.5,140.4c-3.9,0.2,1.6,3,2.8,3.3C383.3,141.8,379.8,141.1,378.5,140.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.3,13.2c2.7,3.1,1.8-5.6-0.7-3.3C397.2,10.8,397.8,12.4,398.3,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.3,77.2c-1.2-7-4.2,4.4-0.2,1.6C326.4,78.3,326.6,77.7,326.3,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351,94.6c0.9,2.6,3.6-0.8,3.2-2.5C352.4,90.4,351.5,93.2,351,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.6,115.1c-1.6,1.1,1.1,2.2,1.8,3C387.4,118.4,383.9,114.6,382.6,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.5,83.4c2.3,4.5,3.1-7,0.3-2.9C357,81.4,357,82.7,356.5,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.1,43.4c-1-0.3-1.6-1.8-2.7-1.3C349.1,43.6,356.4,47.5,355.1,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.3,69.4c0-4.5-2.6-2.6-1.5,0.8C374.6,74,377.1,71.8,376.3,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.5,137.1c-3.2,3.2,0.4,2.1,2.6,0.8C322.4,136.1,319.2,136,318.5,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.5,14.3c-0.2-1.1-2.5-2.7-3.6-2.3C402.5,13.1,407,16.8,407.5,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.1,23.6c-2-2.1-2.4,1.1-0.8,2.4C407.6,28.6,407.5,25.1,406.1,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406,105.2c-0.8-0.9-1.2-3-2.8-2.7C401.9,103.9,406.7,109.5,406,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.9,20.9c0.6,0.8-0.6,3.7,1.4,2.4C389.7,20.5,385,16.9,385.9,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.9,93c0.5-1.6-0.8-3.2-1.1-4.8C434.5,87.6,436.1,94.9,437.9,93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.3,37.3c-1.3-4.2-3.1,5-0.2,3.9C387.8,40.1,386.9,38.5,387.3,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.1,153.2c1,0.3,2.5,4.1,3.1,1.9C369.8,153,364.3,149.7,366.1,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.3,157.9c1,0.5,2.5-0.5,1.5-1.4C383.1,154.5,379.9,156.5,385.3,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.1,128.9c1,0.3,1.6,1.9,2.7,1.4C414,128.3,408,125.4,409.1,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.3,14c2.3,2.6,2.4-5.2-0.2-3C425.1,12,426.1,13,426.3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328,29.5c-1.3-0.3-2.6,0-2.2,1.6C326.6,33.3,330.7,30.6,328,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.5,3.3c-0.9,2.1,4.2,1.3,4.4,0.1c-0.8-1.3-3-0.5-4.3-0.3C364.6,3.1,364.5,3.2,364.5,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.7,131.8c2-0.5,1-3.1-0.2-4C397.5,128.3,399.2,131.3,399.7,131.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.6,113.7c0.4-0.7,2.6-3.2,0.6-3.1C355.1,111,353.9,118.3,356.6,113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.2,73.8c2,2.2,3.2-4.5,0.5-2.9C318.9,71.6,319.2,72.9,319.2,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.2,150.5c-0.9-0.6-3.3-2.5-2.8-0.1C386,152.2,390.6,152.6,388.2,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342,166.5c1.2,1.2,3.5,0.2,1.6-1.1C341.7,163.3,339,164.7,342,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.8,60.6c1.7,2.8,3.6-1.9,1.3-2.3C362.7,58.1,363,59.7,362.8,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.2,128.3c-1.1,1.1,1,1.9,1.6,2.7C382.9,132.8,380.1,127.2,378.2,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.5,6.8c-0.2,2.2,4.6-0.3,4.2-1.4C350.4,5,348.5,6,347.5,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.8,144.4c-1.6,1.1,1.6,2.2,2.5,2.6C377.4,146.3,374.1,143.8,372.8,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.3,65.1c-1.4-0.5-2.3,2.6-1.1,3.4C416.4,69.2,416.9,65.9,416.3,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.3,15.3c-1.8,0-3.1,5.3-0.9,3.3C351.4,17.5,353.5,16.3,352.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.7,63.1c-1.7-1.9-1.8,2.8-0.2,3C440,65.8,439.3,63.9,438.7,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.4,164.4c-0.8,0.7-0.5,2.5,0.5,2.8C423.3,167.3,423.2,162.5,421.4,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.7,133.8c-2.3-1.3-1.6,1.9-0.1,2.4C390.8,135.9,390.4,134.3,389.7,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.7,164.6c-2.3-1.3-1.7,2-0.1,2.3C377.8,166.6,377.5,165.3,376.7,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.8,13c1.5,0.1,1.7-2.1,0.1-2C327.9,10.9,328,12.9,328.8,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.3,123.1c0,0.1,0,0.1,0.1,0.2C375.4,123.2,375.4,123.2,375.3,123.1L375.3,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387,165.9c6.4,1.9,16.9-5,3.5-1.8C388.8,163.7,385.3,163.4,387,165.9C386.9,165.9,387,165.9,387,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.3,161.7c7.2,4.5,1.6-5.3-1.6-1.6c-0.8,0.7-2.6,3.7-0.6,3.5C333,163.2,333,160.6,334.3,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,161.6c1.5,1.2,2.9,2.7,4.3,4.1C373.5,164,365.5,155.8,366.3,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.6,162.7c1.5,0.7,3.5,3.9,4.6,1C438.4,161.8,434.2,158.5,434.6,162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388,167.4c-2.7,0.5-8.1-1.9-9.5,0.1c0,0,10,0,10,0C388.4,167.5,388.2,167.5,388,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.5,164.7c-1.4-3-5.1,2.2-7.3,2.9C395.6,167.9,399.9,167.5,400.5,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.5,166.8c-4.2-7.3-5.9,1.6,0.4,0.6C339.8,167.3,339.6,167,339.5,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,166.9c0.2-1,0-2-0.2-2.9c-2.9-3.6-1.6,0.6-2,2.5C415,168.1,418.7,168,418.7,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.9,166.1c-2.6-10-5.7,2.8,0.6,1.4C349.3,167.1,349.1,166.6,348.9,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.5,166.4c0.3-2.5-3-0.7-2.5,1.1C365,167.4,366.7,168,366.5,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,167.2l0.1,0.4C377.9,168.7,371.6,162,372,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.3,162.9c1.3,1.6,3.3-1.1,1.3-1.9c-2.2-4.3,7.7,6.1,8.8,3c3.6,2.1,2.1,4.1,6.4,3.6 c-3.8-4.9-10.6-7.5-16.4-10c-1,0.4-0.2,2.2-1.3,1.6c-4.1-1.3-1.2,2.6,0.9,3.5C419,162.6,419.1,162.8,419.3,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.9,166.5c-2,3.9,7.4-1.8,2.1-2.7C440.5,164.7,439.7,166,438.9,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.1,166.3c0.6-1.5-0.3-2.3-1.7-2.3C403.5,166.3,406.4,169.9,407.1,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.2,167.4c-1.7-1.3-2.9,0.7,0.1,0.2C354.2,167.5,354.2,167.4,354.2,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.2,166.4c-0.5-2.8-2.5-1.1-2.3,1.2C322,167.6,323.1,167.9,323.2,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.3,167.5c0.1-1.3-0.7-4.8-1.9-2.2C328.4,166.7,328.7,167.9,330.3,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.5,166.8c3.4,3.5,1.9-5.6-0.7-3.5C410.1,164.4,410.5,165.6,410.5,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.3,164.7c-2.3-0.9-2.6,3.9,1.3,2.8C426.6,166.8,426.5,165.6,426.3,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,65.6c-0.1-0.2-0.1-0.5-0.2-0.7v1C315.1,65.8,315.2,65.7,315.2,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.9,59.3c-1.3-0.7-0.8,1.3-0.9,1.9C316.8,76.6,322.2,66.9,315.9,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.2,123.1c-2.2-2.1-5-3.7-7.2-5.9C312.8,120.1,327.1,129.6,322.2,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,109.9c0.9-2.7-0.5-2.2-0.1,0.2C315,110,315.1,109.9,315,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.8,155.1c12-6.2-0.5-5-0.9,0.3C315.2,155.3,315.5,155.2,315.8,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.9,135.4c0.9-1.9-3.8-2.3-2.8,0.5C316.1,135.6,317.3,136.6,317.9,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.7,77.2c-0.3-1.1-0.9-2.1-1.7-2.9C313.8,82.1,318.9,81,316.7,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.6,141.5c3-1-1.5-3.8-0.6,0.1C315.2,141.5,315.4,141.5,315.6,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317,83.6c-0.6-0.6-1.4-0.9-1.9-1.7C313.1,86.3,322.4,87.5,317,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,35.7c0-0.4,0-1.1-0.2-1.4v2.3C315.1,36.3,315.1,36,315.2,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,27.3L315,27.3c1.7,0.6,1.4-2.2,0.1-2.5L315,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.5,43.8c-1-4.7-0.3,5.7-0.5,5.7C317.5,49.1,315.2,45.6,315.5,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.3,151.7c10.8-4.7,1.9-8-0.2,0.1L315.3,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.9,6.5c-6.6-1.5-0.3,3.2,2.7,2.4C322.3,6.9,319.3,6.8,317.9,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,127.1v1.4C315.3,128.2,315.5,127.4,315,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.8,10.9c-1.8,0.6-2,1.2-1.8,3.1C316.4,13.8,318.7,11.8,316.8,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,145.5c0.5-0.2,0.5-1.4-0.2-1.4C315.1,144.2,314.8,145.8,315.2,145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,94.9v2.8C317.6,98.1,316.6,95.7,315,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.1,101.4c-0.2-0.5-0.6-0.8-1.1-1C314.4,102.5,316.1,105.4,316.1,101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,131.1v2.2C316.5,132.7,317,128.8,315,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.1,3.6c1.1-0.2,1-1.4-0.1-1.5L315.1,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,21c2.6,0.8,1.7-2.6-0.3-2.4C315,18.7,314.6,21.4,315.2,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.3,175.3c2.1,2,3.6-2.4,4.8-3.7C411.8,166.8,407.4,174,407.3,175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.6,173.1c-0.4-1.3-4.5-4.8-5.4-2.1C316.8,172.3,320.5,175.7,321.6,173.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.5,169.4c1.6-0.2,5.3,1.1,4.1-1.9c-3.5-0.3-17.3,0.2-4.3,1.9C384.2,169.4,384.4,169.4,384.5,169.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.1,167.6c-0.3,3.2,3,0.6,4.4,0C397.3,167.6,393.3,167.6,393.1,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339,170.3c2.1,4.4,3.5-4.2-1.7-2.7C337.7,168.5,338.6,169.4,339,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.5,170.7c1.3-0.1,1.6-2.2,2-3.2C416.3,166.6,413.5,169.9,416.5,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,168.2c0.1,4.6,4.3,3.4,2.1-0.6C359.4,167.8,357,167.1,357.7,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.5,169.2c0.8,1.4,4.3-2.4-0.5-1.6C347.2,168.1,347.5,168.7,347.5,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,167.5c-3.1-0.8-2.7,2.2-2.4,4.5C366.7,173.6,365.9,169.2,366.3,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.3,169.6c-0.3,1.8,1.4,3.5,2.5,1.6C375.7,168,371.8,165.6,372.3,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433,167.7c1.8,2.7,4.9-1-0.1-0.2L433,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438,167.7c-0.7,2.7,2.1,2,3,0C440.8,167.7,438.2,167.7,438,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.2,170c0.5-0.7,0.5-1.6,0.6-2.4C403.4,166.5,404,171.2,406.2,170z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354,172.2c1.8,0.8,2.1-1.9,1.1-2.9C352.7,164.5,351.5,169.8,354,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.4,170.9c1.6,0,0.9-2.4,1.5-3.3C320.7,166.6,319.4,170.6,321.4,170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330,171.6c1.6-0.5,0.1-2.9,0.3-4.2C327.7,166.6,329.2,170.9,330,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.3,167.6c1.7,0.8,1.2-0.3-0.2,0L411.3,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.5,167.9c2.9,4.7,6.5,4.7,2.1-0.4C427.5,167.7,424.2,167.1,425.5,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.6,412.5c-1.9,0.7-7.3-1.1-6.1,2.4C437.5,415.4,446.8,414.5,441.6,412.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,315.9c0.5,1.5,1.4,8.8,3.2,7.8C358,322.8,355.4,313.8,353,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441,316.4c-0.7-1-3.3-2.7-2.7-0.3c7.4,11.7,5.2-8.1,1.8-11.3c-0.3-1.1-3.2,0.2-1.9,0.9 C440.8,308.6,440.5,312.9,441,316.4C441.2,316.3,441.1,316.4,441,316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.7,179.2c0.6,1.6,0.4-0.4,0.4-0.8C442.7,178.5,442.6,178.8,442.7,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.6,335.1c3.3-0.2,0-5.5-0.1-7.5c1.8-0.1,2.1-2.4,1.5-3.9c-1.4-9.5-4.8-6.4-2.1,1.4 C365,328.3,364.6,331.8,366.6,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.3,294.9c5.2,10.7,2-1.5,0.3-4.8c4.4-0.6-5.8-10.5-5.3-5.4C357.4,291.8,350.9,287.9,354.3,294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.6,178.4c-3.3-4.9-1.1,6.2-6.3,11.1c4.4,2.1,7-7.3,6.3-10.9C405.5,178.9,405.6,178.6,405.6,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.2,411.2c2,6,4.5,3.1,1.8-1.3c3.6,2.1,2.7-1,0.7-2.5c-1.2-1.1-0.9-3.7-2.6-4c-2.1,0.5-0.1,2.5,0.1,3.8 C362.9,407.9,364.6,409.5,365.2,411.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.6,276.9c2.4-0.9,9.4-2.8,5.7-5.5c1.1-1,4.4-1.9,3.9-3.7c-0.8-2.5-9.8,4.9-4.3,4.2 C377.5,273.6,370,274.6,372.6,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.3,369.3c7.2,0.9,19.6-7.4,3.9-2.8C355.9,367,351.2,367,353.3,369.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.4,315.4c4.5,4.7,0.2-8.1-2.2-2.6C324.6,320.2,328.2,327.4,327.4,315.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428,190.4c1.2,2.3,3.3,4.5,3,7.3c-0.7,1.6,1,3.6,2.4,2.2C434.7,196.4,430.6,186.9,428,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.4,396.8c11.7-0.7-1.5-5.7-3.2,1.6c-0.7,1.9,3.2,6.9,4.1,3.4C411.3,400.1,406.4,397.6,410.4,396.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.4,228.6c1.9,0.1,10.7,0,7.5-3C437.7,226.9,422.5,224.6,433.4,228.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.9,314.5c0.6-8.3-4.6,5.4-4.7,7.9c2.3,3.3,2.3-2.3,2.9-3.7C322.7,319.3,321.4,315.9,321.9,314.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.8,177.3c-3.6-3.5-2.2,8.6-2.8,10.5C365.8,189.3,364.5,179.7,364.8,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.5,271.5c2,0.4,3.9,6.2,5.3,3c-0.2-2.8-7.5-5.7-1-4.6C428.3,268.7,413.4,265.1,417.5,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.4,254.6c6.8,0.1-8.2-8.8-8.8-5.8C431.3,251.6,436,252,438.4,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.3,398.4c2.6-1.3-4.2-6.2-4.1-9.2C423,387.9,430,399.4,432.3,398.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.7,237.5c3.1,2,13.7-0.1,5.7-1.6C438.6,236.4,432.5,233.7,434.7,237.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.5,261.1c1.8-0.1,6.3,1.4,6.1-1.5c-1.2-2.1-7.8,2-6.5-3C341.3,250.4,338.2,261.7,342.5,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.1,375.8c-1.2-1.2-8-2.1-5.6,0.7c3.3,0.1,5.8,2.3,7.9,4.4C374.8,379.9,370.6,376.7,369.1,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.9,212.9c2.5,0.3,7.1,0.3,6.2-3.1C441,210.7,435.3,209.5,436.9,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.6,174.8c-3.2-0.6-3.6,2.3-0.7,2.5c2.1,0.1,4.3-1.9,6.2-0.7C444.1,172.6,439.8,173.6,437.6,174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.6,411.7c2.5-0.5,0.2-13.7-2.6-9.9C321.6,404.2,320.5,411.2,322.6,411.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,208c9.3-4.5,0-4.1-4-0.5C381.2,214.7,383.6,209.8,386.4,208z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.9,278c0.4,2.5,8,7.2,8.8,3.6c-1.7-1.3-4.6-1.1-5.9-2.9C349.9,275.8,346.8,273.1,347.9,278z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.5,326.4c1.4,1.3,5.7,5.3,6,1.5C409.1,325.6,399.5,318.4,405.5,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.3,416.6c0.3-1.8,3.5-4.7,0.6-5.8C413.7,412.4,409.4,418,414.3,416.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.4,411.7c4.2,3.1,1.7-6.9,3-8.8C339.8,402,341.7,409,341.4,411.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,335.4c8.2-0.2,3.3-19.2,2.1-4.5C356.2,333.2,349.8,333.9,353,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.1,275.3c5.3-1.8-9.2-17.2-4-7.6C368,269.8,368.4,274.2,370.1,275.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.9,205.1c-0.7-5-5.1-4-1.3-9.6c-1.7-1.9-3.5,3.1-3.9,4.5C328.5,201.5,331.1,206.5,332.9,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.8,375.7c1.6,2,4.3-2.2,6.5-2.3C364.1,368.8,346.1,371.3,346.8,375.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440,390.9c3.6-0.9-4.3-17.2-3-8.3C438.3,385.2,438.1,389.5,440,390.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.8,286.5c2.4,1.2,14.3-4.1,8.2-5.1C375.9,284.6,365.7,283.7,368.8,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.9,412.1c0.1,2.7,3.4,3.9,2.7,0.6c-2.3-2.4-0.1-7.5-3.4-9C373,405.4,376.3,409.5,375.9,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.3,319.4c3.6,3,0.1-8.2-0.8-9.2c-2.8-0.3-1.7,2.6-1,4.2C356.4,316.2,355.1,318.7,357.3,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.6,204.4c2.5,0.5,7.6-10.7,2.5-8.3C426.2,198.7,420.8,202.6,423.6,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.7,298.3c5.3,1.1-3.7-5.7-2.5,0C382,305.2,387.9,305.9,381.7,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.8,253.5c3,0.2,1.3-4.7,1.8-6.6C351.3,236.4,347.1,251.4,349.8,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.4,274.8c0.1-1.4,3.3-4.8,0.1-4.4c-2.6,1.4-4.5,11.5-0.7,10.4C325.3,278.9,324.1,276.6,325.4,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.3,277.4c5,4.2,0.6-5.4-3.1-4.6c-1.3,0.2-4.9-1.5-4.1,1.1C408.6,275,412,274.4,413.3,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.4,312.7c1,1.9,3.3,10.9,6,7.5c-1.3-1.3-5.2-12.4-6.3-7.8C382.2,312.1,382.3,312.4,382.4,312.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.5,408.5c3-16.3-6.2-8.6-0.2,0.1C326.2,408.6,326.4,408.6,326.5,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.2,397.9c1.8,1.1,7.6-2.4,5.2-4c-2.2,2.9-5.1,1.1-7.6,0C396.8,395.8,400.5,397.1,402.2,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.1,224.7c1.3-5.1-3.3-12-2.4-2.6c0.8,2.1-0.5,3.3-1.8,4.7C377.7,228.9,380.5,225.8,381.1,224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.4,264.2c1.9-0.2,10.9-0.4,5.3-2.2C436,261.1,423.6,263.5,434.4,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362,389c1.3,1.8,8.1,7.7,7.9,3.1C367.8,392.6,357.3,382.2,362,389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.5,411.8c3.5,6.3,2.2-9.1,0.6-9.7C395.8,402.2,397.4,409.9,397.5,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.9,333.1c4.3-1.7-6.2-5-7.4-7.8C380.4,325.1,391.4,332.7,392.9,333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.5,335.2c2.9-2.4-2.6-2.4-4.2-2.2c-1.6,1.6,1.1,3.9,0.8,5.8c-0.4,1.3,1.6,5,2.3,2.5 C390.6,338.6,386.6,333.4,391.5,335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.4,299.5c1.7,1.6,0.7,2.9,0.8,4.9c-0.7,2.4,1.9,5.4,1.8,1.5C348.5,293.6,339.5,294.5,345.4,299.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.6,340c2.2,1.6,3.8,8,6.8,6.6C330.4,345.2,321.4,334.1,322.6,340z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.8,396c-2.4-6.3-1.9,7.1-2.4,9C443.6,406.8,443.2,397.8,442.8,396z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.6,260.4c0.1,2,4.6,8.2,4.8,3.8C360,262.2,357.6,249.7,357.6,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.4,242.3c1.5,1.3,4.7,1.6,3.8-1.3C441.6,241,439,240,439.4,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.1,359.3c-4.6,0.6,4,12.7,5.4,7.1C415.9,364.9,414.2,362.1,413.1,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.5,401.4c4.5-0.4,2.8,8.4,6,6.6C408,398.9,399.1,397.9,401.5,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,238.6c-6.9,5.3,7.2,1.1,6.2-3C346.9,232.7,345.7,237.8,342.1,238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420,215.9c-2.3,3.3,6.3-0.2,8.6,1.3C432.9,213.9,421.7,213.7,420,215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.6,413.5c1.3-1,1.4-7.7-0.9-5.7c0.8,2.1-6,10.1-1.2,8C410.4,414.8,409.8,415.6,410.6,413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.6,392.8c2.3,0.7,1.8-2.8,3.1-3.4c0.3,1.2,0.9,2.9,2.3,3c1.8,0.2-0.4-6.9-2.5-3.5 c0.4-2.1-3.1-3.9-2.1-0.9C419.7,389.6,416.9,391.5,418.6,392.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.9,384c7.9,3.3-3.4-8.8-6.1-4.9C353.8,381,357.6,381.6,358.9,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401,338.2c7.3,8.1,0.1-5-3.1-6.6C394.3,331.4,400.3,336.9,401,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.3,344.3c1.8,1.2,7.1-5.4,9.1-6.7C356.2,334.2,346.1,343.5,347.3,344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.3,240.3c1.8,1.6,1.8-1.8,3.3-2.5c1.2-1.3,6.4-3.7,3.2-5.3C331.3,234.4,324.4,237.7,326.3,240.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.6,412c0-1.8-1.6-6.7-3.2-3C345.7,413.3,347.9,422.3,348.6,412z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.4,318.8c1.6-1.8-2-3.4-3.1-4.4C380.9,304.6,389.7,320.3,393.4,318.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.2,179.2c4.2,2.2,7.6-10.9,3.2-4.7C390.3,176.4,385.8,177.6,387.2,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.9,234.8c1.8,1.2,8.3,4.1,4.6-0.4C424.5,231.8,414.4,230.8,422.9,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.8,195.5c1.1,5.4,11.2,0.3,3.6,0.1c-3.5,0.5-1.6-2.1-1.9-4.1C436.7,189,436,194.3,436.8,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.6,201.5c1.3,1.4,3,7.6,5.3,4.8C371.2,203.8,364.6,194.4,365.6,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.4,415.2c-0.3-0.8-2.3-2.1-2.5-0.6C321.9,416.8,325.8,418.7,324.4,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.4,216c4.1-0.3,14.1-10.7,3.8-4.6C396.9,212.6,392.4,213.8,394.4,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.1,189.3c-2,1.7-0.6,3.7,0.8,5.1c0-0.8,0.1-2-0.4-2.3C443,191.6,443.4,187.8,442.1,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.9,342.8c1.5,2.9,3.4-3,2.5-4.6c-1-2.8-7.5-6.4-3.7-1.2C406.4,338.6,406.7,340.6,405.9,342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398,289.2c7.6,3.6,3.2-3.7-1.8-2.5C389.3,287.4,394.3,289.1,398,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.6,337.3c0.5,3.4,3,2.7,2.2-0.7c0.6-2.2,3.1-4.6,1.7-6.9c-1.8-1.1-1.5,0.5-1.5,1.8 C382.9,333.4,381.3,335,381.6,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.3,253.8c0-2,5.2-4.1,1.4-4.7C327.9,250.8,328.1,263.8,332.3,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.4,183.1c13.4,0-6.4-5-6.1-1.5C379.6,183.1,382.5,182.6,384.4,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.6,281.5c-5.4-0.4,5.2,9.8,6.4,6.7C366.1,285.6,361.9,284.3,360.6,281.5 C360.7,281.5,360.7,281.5,360.6,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338,240.7c1.1-5.1-6.6,3-9.2,1.4C329.3,247.3,335.8,242.1,338,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384,352.3c1.7,0.7,9.2-7.2,5.1-7.6C388,347,381.5,350.1,384,352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.4,340.8c0.9-1.7,2.2-7.7-0.7-7.4c-1.4,2.1,0.5,5.5-2.1,7.4C353.4,343.6,358,342.9,358.4,340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.8,339.2c3.4-2.2-4.9-5.1-6.5-5.4C427.6,334,436.2,339.5,437.8,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.1,227.9c0.8,1.7,7.3,5.3,6.6,1.5C422.8,228.6,413,221.3,418.1,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.3,254.4c-0.5,2.9,2.9-0.2,4.2,0.4c1.7-0.2,5.1,1.4,5.8-0.7C408.9,251.7,402.4,252.3,400.3,254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.5,269.9c4.2,7.3,1.2-6.3-0.4-7.6C367.9,262.8,371.2,267.9,371.5,269.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.5,186.2c-1.6,4.9,11.6-2.6,6.1-4.5C391.8,183.1,390,185.6,387.5,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.4,206.6c-0.4,0.6,0.2,1.1,0.6,1.5v-2.3C442.7,206,442.3,206.2,442.4,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.5,247.8c2.5,0.5,8.6-3.8,5-5.5c-2.2,0-2.6,3.5-5,3.8C381,246.2,381.1,247.8,384.5,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.2,266.7c4.1,3.3,9.4-5.9,1.5-1.3c-1.2,0.6-1-1.1-0.9-1.8C375.7,255.5,372.2,264.5,375.2,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.8,319.4c3.4-0.4-3.6-5.3-3.3-7.9C391.6,309.9,396.2,320.7,398.8,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.4,221.1c1.4-1.3,6.5-7.6,1.6-5.1C397.5,218.5,390.3,226.8,398.4,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.7,416.3c-0.2-2.8-4.8,0.1-6.1,0.8C397,416.8,403.7,417.9,402.7,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.7,251.8c-1,2.1,2.3,1.8,3.6,2.6C440.8,258.4,430.1,249.6,425.7,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.9,321.7c0.1-0.2,0.4-0.5,0.2-0.8c-0.1-2.1,0.8,1.9,2,0.1c1-0.3-0.5-8.2-1.9-6.9 c-1.5,1.3,0.1,3.6-0.1,5.4C329.2,317.4,329.4,323.4,331.9,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.7,192.4c0.7,1.6,2.8,8.6,4.3,4.2C356,193.7,350.3,185.7,351.7,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435,282.3c7.8,3.3-2.4-6.3-4.7-5.1c-0.7,2.4,3.3,3.6,4.8,5C434.9,282.2,435,282.2,435,282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.1,374.8c1.1,1.4,5.9,8.9,6.3,4C434.9,377.7,429.8,369.9,430.1,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.4,386.9c1.5,1,5.1,3.2,5.4,0.1C376,385.2,364,379.4,373.4,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.5,230.1c0.7,1.2,1.1,6.1,3.1,3.3c-2.5-3.7-1.6-5.2,0.9-8.4C411.7,220.6,407.4,228.1,408.5,230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.5,358.5c1.8-0.4,10.1-4.2,6.2-6.1C360.9,353.4,351.6,357.9,355.5,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,249.2c1.6-1.9,4.7-1.8,6.3-3.7c-0.1-3.1-5.4,0.7-7,1.4c-2.4,1.1-1.9,5,0.6,2.5 C328.7,249.4,328.8,249.3,328.9,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.2,412.1c3.1,3.7,2.7-7,1.9-8.3C383.9,402.7,385.4,410.1,385.2,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417,212.8c1.9,3.3,4.8-3.3,5.4-5C420.5,202.9,418.2,211.1,417,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.2,390.6c-0.3,0.7,0.7,1.3,0.8,2V390C442.8,390.2,442.5,390.4,442.2,390.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.1,306.4c3.7-1.4-4.8-5.1-6.1-6.3C412.7,302,420.5,305.7,422.1,306.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.6,312.9c5.1,4.6-0.3-6.1-0.7-7.9C346.8,304.3,351.1,311,351.6,312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.5,259.2c1.9,0,3,0.7,2.6-1.8C441.6,257,437.6,257.6,440.5,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.9,282.2c0.6-1.2,3.3-5.4,0.4-4.9c-0.7,2.3-7.6,7.8-2.7,8.2C326.2,284.3,327.2,283.3,327.9,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.1,263c3.8-1-2.8-2.4-4.6-7C358.5,257,364.5,263.5,367.1,263z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.9,297c-0.3-3.3-2.7-0.5-2.1,1.5c0.3,1.9-2.5,4.1-1.3,5.6C334.4,305.2,335.1,299.1,334.9,297z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323,202.3c5.6,5.4,2.2-3.2-1.2-4.5C317.2,195.9,321.3,200.9,323,202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.7,294.5c-3.9,1.3,4.3,4.8,5.6,5.4c2.8-2.2-3.5-5.2-5.5-5.5C401.9,294.5,401.8,294.5,401.7,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.3,414.5c-0.6-1.4-1-6.4-3.2-3.8C388.8,413.4,392.6,420.9,392.3,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351,383.3c2.4-1.7-8.6-9.5-7.4-4.3C346.9,378.7,348,383.8,351,383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.8,262c2.6,4.3,7.3,1.7,1.2-0.7c-2-1.8,3.3-5.9-0.3-6.3C336.2,257.1,335,259.7,336.8,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.9,224.1c2.6,3.4-0.9,3.8,0.3,5.4C372.1,228.8,360.2,214,363.9,224.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.7,390.5c1.7,0.8,11.7-0.7,7.3-2.9C343.7,388.6,338,387,338.7,390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.2,401.4c2.4-1.4-1.8-6-2.2-8.3C431.5,393.4,435.1,401.9,437.2,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.2,224.1c-2.1-1.9-10-0.2-7.9,2.8C328.8,223.1,337.6,228.7,333.2,224.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.8,373.3c-3,1.3,0.5,5.5,2.1,6.8c2.6,2.7,4.5-0.7,1.1-1.9C403.2,377.1,403.2,374.4,401.8,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.9,257.1c3.7,3.8,11.3,4.8,2.8-0.2c-1.5-0.1,0.7-0.6,0.2-1.5C414.5,253.5,409.6,255.6,411.9,257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.1,301.6c-1.9-1-3.2-4.2-5.2-4.4C365.4,300.4,378.4,308.4,373.1,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.2,222.1c9.4,6.2,1.2-6.6-7.1,0.5C346.2,223.6,348.8,221.3,351.2,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.4,249.3c2.9,0.5,3.4,4.4,6,5.1C420.8,252.3,410,243.5,411.4,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,223c-0.7-4.2-2.7-1.3-3,1.4c-0.3,1.3-3,2.8-2.2,4C405.1,229.4,407.9,225.1,408,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.8,390.4c1.9,0,7.1,3.3,6.8-0.3c-2.1-0.1-10.7-4.2-8.8,0.4C352.4,390.3,353.1,390.3,353.8,390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.8,224.2c1.9,0.3,6.7,0.3,3.9-2.3C429.8,221.2,419.9,223.7,429.8,224.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.7,193c6.4-6.7-3-2.8-4.6,1.4C390.8,197.6,393.2,193.6,394.7,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.2,415.5c-2.8-1.5-2.9,2.4,0.4,1.4C320.3,416.5,320.3,416,320.2,415.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.6,296.8c6.9,1.4-1.6-4.4-4.2-4.4C403.3,294.6,409.1,295.7,410.6,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.9,177.4c2.1,0.7,11-8.9,6.1-7.7C389.4,173.1,382,175.3,383.9,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.3,394.6c2.2,0.6,4.8,1.3,6.4,2.7C364,394.1,349.9,390.1,353.3,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.1,273.8c-0.5,3.2-4.4,5-4,7.6c1.7,3.1,8.2-9.1,3.8-7.7C385.2,273.6,385.1,273.7,385.1,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.9,250.3c-0.9,8.3,5.4-3.9,1.7-5.9C339.8,244,342.3,248.7,340.9,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.7,217.5c4.1-6.3-3.4-2.4-4.5,1.4c0.7,3.5,3.2,0,4.5-1.2C408.6,217.7,408.6,217.6,408.7,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.6,200.6c-4.5,4,6.5,1,6.9-1.6C392.3,195.5,388.9,201.1,386.6,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324,235L324,235c3.3,0.7,9.2-12,2.7-5.2C326.2,231.5,322.2,233.3,324,235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.7,336.7c3.7,5.6,2.2-6.3,0.4-7.6C374.8,329,378.1,334.6,377.7,336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.1,267.2c-0.5,3.6,6.5,0.8,8.5,2.2C408.6,266.1,398.7,266.8,397.1,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,175.4c3.9,3.3,4.5-9.9,0-6.7C420.2,170.8,421.8,173.3,420.4,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.6,199.4c0.4,1.7,0.5,7,3.3,5.2C374.7,202.3,371.5,192.9,370.6,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.2,245.9c1.4-0.8,8.3-1.8,4.6-3.8C322.9,241.8,313.2,248.2,321.2,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.5,369c1.5,0.1,1.7-2.6,0-2.3c-2.2,1-7.1-2.5-7.7,0.5C338.3,369,342.1,368.8,344.5,369z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.2,203c2.8,2.1,3.2-4.6,4.5-6.1C418.1,192.5,414.7,202,415.2,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,244.9c-0.1-7-5.2,5.6-1.6,6.5C340.3,250.4,339,246.8,339.7,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.8,302.5c-2.1-16-7.2-6.9-0.4,0.2C330.4,302.7,330.6,302.7,330.8,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.6,271.9c0.8,1.5,0.8,6.7,3.5,4.4C354.6,273.5,348.3,264.4,349.6,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335,286.5c2.7,1.3,2.4-3.8,3.5-5.3C340.3,273.5,333.3,284.1,335,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.6,323c1.4,0.7,9.8,6,8.6,1.9C425,324.2,416,319.6,417.6,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.7,197.2c-1.8-1.1,1.8-7.4-2-5.2C331,200.3,340.7,201.1,336.7,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.4,353.4c5.5,1.3,4.8-15,1.8-4.5C367.9,350.7,364.6,351.8,366.4,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.1,239.8c1.3,0.5,1.3-1.4,2.1-1.9c1.4-0.9,6.9-3.1,3.9-4.9C336.5,233.9,329.4,237.5,332.1,239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.7,324.3c3,7.8,3.9,1.1,1.5-3C336.2,316.6,336.8,322,337.7,324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.9,381c0.4-1.5-2-1.6-2.7-2.6c-1.1-0.9-3.5-4.5-4.7-2.2C395.9,377.9,401,383.5,402.9,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.6,280.1c5.7,0.4-3.7-4.9-4.5-6.4C360.1,275.2,367.1,278.9,368.6,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,349.5c-0.5-1-1-6-2.4-3.9c-0.6,1.6,2.1,4-0.1,4.4C316,353,325.6,354.5,325.3,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428,289.8c5.5-0.5-3-3.9-4.3-5.5C419.4,284.4,426.2,289.5,428,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.6,275.5c-2.6-5.4-5.8,12.8-2,7.1C320.3,280.3,320.4,277.4,321.6,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.3,193.4c1.4,4.5,4.1-2.9,5-4.6C423.8,183.9,421.5,192,420.3,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.9,231c4.1,0.3,11.7-8.2,3.4-3.8C388.1,228.2,383.1,229.1,385.9,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.9,335.4c0.7,1.7,5.2,6.3,5.3,2.5C363.9,336.4,359.2,327.2,360.9,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.1,361c1.7,2.1,11.1-3.6,5.2-3.4C371.7,358.6,367.3,358.6,368.1,361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.4,284.6c2.1,3.5,3.2-8,2.1-8.5C330.6,276,330.2,282.9,330.4,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.6,416.5c-1.7-1.3-3.2-3-3.5-5.4C377.9,404.7,382.4,420.7,386.6,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.2,239.4c12,8.4,6.2-1.3-0.7-2C423,238.1,423.5,239.1,424.2,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443,333.9c0,0,0.1-2.2,0-2.1C442.3,332.2,442.2,333.6,443,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.4,213.5c5.6-0.3-2.7-3.3-4.1-4.5C335.4,209,342.1,213.4,344.4,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.3,178.7c3.9-5.2-5.5-0.3-6.3,1.9C392.2,183.3,395.5,179.5,397.3,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.2,273.8c1-6.3-16.8-5.8,0.2,0.1C416.1,273.8,416.1,273.8,416.2,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.3,185.7c-1-1.7-3.4-7.6-5.5-4.4C337,182.7,341.4,191.7,341.3,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.7,202.4c-2.5,4.6-0.7,7.9,1.9,2.2C415.5,201.2,412.7,196.5,411.7,202.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.1,331.7c5.9,4.3,0.6-3.8-1.3-5.8C322.9,325.5,327.2,330.2,328.1,331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.3,397.7c2.1-0.8,6.6-6.7,1.7-4.4C323.4,394.1,319.5,401.3,324.3,397.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.9,271.5c0.3-1.1-1.8-3.9-2.7-2.3c1.6,2.3-1.7,4.1-2.1,6C327.7,278.2,330.8,273.2,330.9,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389,258.9c0.2-4.2-7.7,3.6-6.6,5.2C384,265.4,387.5,260,389,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.3,230.6c-0.5,1.5,1.5,2.9,2.2,1.2c0.4-2.2-0.7-4.3,0.6-6.3C349.4,222.4,348.2,228.7,349.3,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.6,393.5c1.4,1,2.6-0.8,3.8-0.9c1.5,0,3.9-0.3,4.5-1C349.6,389.2,341.5,390.6,342.6,393.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.6,232.2c1.5,1.3,11.2,3.1,6.8-0.6C438.5,231.8,432.6,228.6,433.6,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385,374c-0.1-1.5,1.6-1.7,2.4-2.6c1.3-2.7-3.2-0.2-3.8,0.8C381,377.1,385.3,382.8,385,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391,257.2c3.3,1.3,2-4.9,3.8-6.5C392.2,246,390.8,255.8,391,257.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.7,338.5c-1.7-3.5-2.1,1-1.9,2.7c-0.1,1.5-1.9,3.4-0.5,4.8C386.4,347.8,386.9,340,386.7,338.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.5,384.1c7.7-6.8,0.5-7-0.8-0.7c-7.9,0.5,2.3,5.4,0.2,0.8C319.1,384.4,319.4,384,319.5,384.1z  M318.9,383.8L318.9,383.8L318.9,383.8L318.9,383.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.1,377.6c1.1,1.4,2.8,9,4.6,4.3C421.8,380,418.3,371.5,418.1,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.5,191.1c2.6-0.9-1.3-4.5-2.8-4.6c-1.8,0-4.3,4.2-2.3,4.9c1.6-0.4,1.1-4.5,3.3-2 C346.2,190,346.4,191.2,347.5,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.3,341c1-1-0.9-2.4-0.6-3.7C420.9,326,417.9,341,423.3,341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.9,318.7c3.8,0.9,1.6-5.6,1.3-7.7C366.8,309,368.9,316.9,368.9,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.2,339.2c-1.8-0.7-6-6.4-7.1-4.8C326.1,336,333.9,342.9,334.2,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.3,416.1c-0.3-1.1,0-2.1-0.4-3C367.1,412.7,370,419.6,371.3,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.3,206.1c1,1.6,4.6,3.7,5.1,0.9c-0.4-1.7-3.1-0.5-3.4-2.3c-3-4.8-4.3-3.3-1.7,1.2 C431.1,205.9,431.2,206.1,431.3,206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.8,229.1c8.4,0,3.2-15.4,2-2.8C383.5,227.3,379.7,227.6,381.8,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.6,395.2c0.9-4-7.5,3.7-5.5,5.9C319.4,402.7,318.6,396.4,321.6,395.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.5,364.6c1.8,0.6,4.1,7.6,5.2,3.5C425.4,365.2,417.4,360.2,419.5,364.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.7,323.3c1.6,1.2,2.7,6.4,4.9,3.3C403.7,324.1,396.3,317.9,398.7,323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.7,290c7.1-1.3-1-2.6-3.6-2.6C369.8,287.1,376,291.2,378.7,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.5,260c2.2,0.5,6.1,2.1,7.9,0.8c0.5-2.1-1.7-1.7-3-1.6C401.1,259,394.4,257.4,397.5,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.5,381.2c1,1.5,2.8,7.7,5,5.1C385.7,384.7,380.4,375.4,380.5,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.9,416.4c0-2.3,1.7-4.9,1.8-6.9C335.6,407.9,332.3,418.5,336.9,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,229.2c0.4,1.5-0.6,4.2,1.4,4.8C349.3,232,346.1,219.5,345,229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.8,369.2c1.7,1.8,4.5,5,7.1,4.3c1.5-2.1-3.1-2.6-4.1-4.2C414.3,367.7,411,366.7,411.8,369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.1,235.1c2-0.7,2.9-4.6,0.1-4C397.8,233.8,392.5,240.9,400.1,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,216.1c-0.1,0,0.1-2.2-0.1-2C442.6,214.6,442.2,215.9,443.1,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.7,307.6c0.2,2,2.6,7.7,3.8,3.3C362,308.4,358.2,301,358.7,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.3,343.6c1.6,1.4,3.2,6.3,5,6C433.9,347.6,424.4,338.8,426.3,343.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.5,388.8c0.7-0.1,1.8-1.6,0.9-2c-2.8,0.4-5.1-4.6-7.6-2.8C391.3,385.8,396.8,388.3,398.5,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,350.5v-0.8C442.7,349.9,442.9,350.2,443.1,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.8,385.1c-1.8-1.2-3.4-3-5.6-3.6c-3,2.3,3.4,3.6,4.4,5.5c1.1,1.3,2.5-0.9,1.3-1.8 C350,385.2,349.9,385.1,349.8,385.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.5,391.2c-1.9,5.8,7.1-3.2,4.1-6C413.7,384.5,415.6,391.2,412.5,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.2,349.9c3.2-0.8,3.9-12,0.4-8.3C365.8,348.1,359.2,349,363.2,349.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.8,408.7c2.1,0.4,2.5-1.7,3.2-3.2C337.1,396.1,327.6,404.9,328.8,408.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.5,392.3c1.3-0.9-1.6-9.6-3.4-7.1C430.2,387,431.1,393,433.5,392.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368,282c4,3.8,13.6-5.1,4.4-1.4C371.2,281.1,367.3,280,368,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.5,251c0.9,0.8,1.9,1.4,2.6,2.4C444.4,248.3,438.3,248.4,440.5,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.9,388.7c1.7-7.6-4.3-10.4-2.4-5.4C441.8,384.7,440.8,388.2,442.9,388.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.3,188.1c3.7,3.4,5.1-9.2,1.1-6.9C417.5,183.7,415.8,185.9,415.3,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.2,245.4c5.1,2.8-1-5.9-2.4-6.4C350.4,239.8,355.4,243.8,356.2,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.2,377.9c1.8,0.3,6-1.4,3.8-3.4c-1.9,1.5-4.7,0.7-7,1.5C322.6,379,326.5,377.8,328.2,377.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.8,351.5c4.3,2.4,8.9-10.3,2.9-3.3C379,349.8,374.6,349.8,376.8,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428,320c6.2-0.2-3.1-4.1-5.1-4.3C420.1,317.4,426.7,319.4,428,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.8,386.3c5.8,0.7,4.3-3.3-0.5-2.2C319.1,384.9,319.9,388.5,324.8,386.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.1,362.1c1.9-0.7,7.8-1.5,5.9-4.4c-1.8-0.4-3.1,2.3-5.2,2.3C335.9,359.8,334.6,361.7,337.1,362.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.6,391.8c1.7-0.1,8.6-0.4,2.9-1.9C388.4,388.6,380.8,392.4,389.6,391.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.9,381.9c4.1-3.2-9.9-4-6.6-0.5C329.4,381.6,331.7,381,333.9,381.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,380.4c1.8,1.3,3.7,3.6,5.8,4.1C370.3,382.8,359.6,375.5,361.3,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359,253.2c3.4,5.2,2.9-10.2,0.1-6.6C358.4,248.5,359.4,251.2,359,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396,256.3c1.1,1.4,5-5.3,4.8-6C399.3,246.9,394.7,255.3,396,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.2,391.1c3.1-3.8-5.8-2.1-6.6-0.7C316.2,393.3,321.6,391.3,323.2,391.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.5,278.9c5.6,1.4-1.6-4.1-2.2-6.1C352.2,273.2,357,277.8,358.5,278.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.9,415c-0.9-2.1-3.2,0.1-2.6,1.9C351.7,417.1,351.3,417,351.9,415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.8,222.7c-1.3,6.2,4.7-3,2.6-5.7C367.9,215,370.1,221.1,368.8,222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.6,217.4c1.6,5,2.9-4.8,3.3-6.3C366.1,208.4,366.1,215.7,365.6,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.1,213.4c-0.5,1.7-4.8,4.8-1.9,5.9c2.5-0.2,7.8-8.3,2.5-8.3l0,0c1-0.9,1.1-2.5,2.6-2.6 c2-6.8-11.2,5.2-2.7,2.7C412.4,211.9,412.6,212.8,412.1,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.3,413.3c-3-0.9-2.1-6.3-4.8-7C423.3,408,428.8,420.2,429.3,413.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.2,415.4c-0.5-11.9-5.6,3.3,0.2,1.6C328.1,416.5,328.4,415.9,328.2,415.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.7,371.4c0.4-1.4-2.8-11-3.8-6.2C392.7,366.6,393.3,374.2,395.7,371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377,179.6c0-6.4-3.4-0.1-2.6,3C375.2,187.2,377.6,181.8,377,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329,234c1.6-0.8,7.7-5.3,4.4-6.6C332.5,229.2,325.6,232.6,329,234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.9,206.6c5.6-1.3,2.6-4.3-1.5-1.8C389.6,206.2,393.1,208.6,396.9,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373,293.4c4,5.1,2.7-3.3-3.4-4.9C367.6,290.4,371.8,292.2,373,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.7,220.2c0.9,0.2,1.6,0.7,2.5,1.1C444.7,217.2,436.4,216.6,440.7,220.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.5,171.6c-1.4,2.1,1.7,1.9,2.6,0.7C443.5,169.2,442.4,169.8,440.5,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410,318.7c0.8,1.5,4.2,7.7,5.6,4.2C415.2,321.8,408.8,313.9,410,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.7,411c-0.3-1.9,1.2-7-1.8-6.4C317.4,406,316.7,415.3,319.7,411z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.4,213c6.6-0.1-2.8-4.1-5.4-2.2C423.6,213.6,429.1,211.8,430.4,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.3,359.5c1.6-0.8,7.4-5.8,2.8-5.3C319.3,355.9,311.4,360.4,317.3,359.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.5,366.4c0.7-3-5.4-0.9-7.1-0.5c-3.6-0.5-1.2,2.1,1,1.9C386.4,367.4,388.6,366.8,390.5,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.8,201.5c1.9,0.1,6.3,0.1,5.4-2.9C441.7,199.2,435.6,199,437.8,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,240.4c-5.5-1.2,2.9,4.9,4.5,5.3C374.5,243.7,368.9,241.4,367.3,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,266.2c-1.4,0.2-1.6,1.9,0,1.8L443.1,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.6,395.1c0.9-0.6,0.3-1.6-0.4-2.1C379.6,377.5,380.8,396.1,385.6,395.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.6,213.8c1.9,1,4.1,6.5,6,4.7C355.6,216.1,346.8,208.3,349.6,213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.5,214.5c1.8,0.5,6.6-6.5,2.8-6.7C406.5,209.8,402.4,212.8,404.5,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.6,292.6c2.6,6.7,3.8-7.8-0.1-6.2C341.2,288,342,290.7,341.6,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,178.2c-1-3.9-7-4-6.7,0c1,0.5,1.5-0.9,2.2-1.4C339.2,177.1,340.3,181.4,342.1,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.7,354.7c5.4-2.6-7.3-1.7-7.8-0.2C383.4,357.3,387.2,354.4,389.7,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.1,257.8c2.6,0,5.7,3,7.9,2.2C413.4,257.5,400.6,254,404.1,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.9,231.9c7.4-3-6.7-2.9-4.9,1.5C391.5,235,393,231.3,394.9,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.7,265.9c3.2-2.2,5,1.1,6.4-0.2C403,261.4,392,262.5,395.7,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.6,234.1c0-2.5-2.9-2.8-1.7,0c0.2,1.8-4,1.7-3,3.7C340.3,240.2,344.8,236.2,343.6,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.4,363.2c-1.2-1.8-1.3-3.5-0.5-5.4C398.5,352.9,398.3,369.8,402.4,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,386.2c3.9-1.9-4.4-3.8-5.7-4C335,385.2,340.1,385.6,342.1,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.2,383.8c0.8,1.5,4.6,5.4,4.9,1.8C356.6,384,349.4,376.6,353.2,383.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.6,377.3c0.2,0.4,0.3,0.8,0.4,1.2C444.3,369.4,438.2,372.3,442.6,377.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.1,281.6c1-5.9-13.4-5.4-3.3-2C410.1,280.1,410.5,283.4,412.1,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.2,178.1c-0.5-1.7-0.1-5.8-2.5-5.7C357.7,173.2,358.9,181.2,361.2,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.7,186.8c3.5-5.2-5-0.6-5.2,2.1C406.2,191.8,407.9,187.3,409.7,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.2,367.8c6.8-4-3.8-2.6-4.9,1C327.8,371.6,332.2,368.3,333.2,367.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.5,228.2c-1.6,1.1-5.9,1-6.1,3.2C336,233.9,345,230,341.5,228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.9,233.4c-0.6-2.5-5-0.3-7-0.2C377.2,236.4,387.7,235.1,387.9,233.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.2,294.2c-1.7-3.3-1.2-3.9-1.1-7.3C327.6,283.8,329,298.1,332.2,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.8,378.4c4.7,3.3,0-6.9-3.3-4.8C433.4,375.5,438.7,376.1,438.8,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.5,185.5c0.2-1.5-1.5-9.4-3.7-5.9C357.9,181.3,357.3,187.3,360.5,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.4,217.9c3-1.9-4.4-2.9-5.6-4C324.6,214,333.6,218.5,335.4,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.1,402.6c-0.5-9-5.4,5.6-0.9,4.8C384.6,406.2,383.4,404.1,384.1,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.1,397.9c2.2,0.1,4.5,2.6,6.1,2.2C376.3,397.7,365.1,393.6,367.1,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.7,395.1c1.7,5.7,4.2,4.4,1.9-0.6C380.3,389.7,376.5,389.9,380.7,395.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.7,393.2c1.9-4.2-7.6,0.4-6.4,2.6C329.7,397.6,334.4,393.5,335.7,393.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342,206.7c1.1,0.8,1.7,3.7,3.2,3.1C348.3,205.5,335.2,200.2,342,206.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.4,176.3c0.4,1.6,3.7,5.8,3.9,2.3c-1.2-1.7-2.3-3.5-2.4-5.7C425,171.8,424.7,175.2,425.4,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.9,266.2c1.3,1.1,11.7,1.1,7.1-1.9C419.4,265.8,412.8,262.9,413.9,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.6,255.8c2.7-7-3.5-2.1-2.8,2.2C326.7,262.2,327,257.6,327.6,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.5,177.4c1.1-1.6,1.3-6.6-1.3-3.8C353.6,176.6,353.4,184.2,356.5,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.4,254.8c0.3,2.3,3.6,5.5,3.2,1.4C367,252.4,361.4,248.9,364.4,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.3,174.8c-0.6-9.8-2.6,2.5-1.8,5.7C351.6,182.2,351.7,176.2,351.3,174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.6,194.5c5-0.3,6-12,1.5-4C375,192,371.7,193.5,373.6,194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.5,362.2c8.8-4.5-1.8-1.9-4.7-0.9C385,363.7,390.4,362.9,391.5,362.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.4,344.1c-3.2-1.6-2.4,5.4-3.5,7.4C410.9,353.5,410.8,346,411.4,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.2,186.3c0.9-4.7-4,0.5-2.5,5.8C333.6,194.2,332.1,187.6,333.2,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.6,409.9c1.2,2,1.8,5,3.3,6.4C359.2,415.6,353,404.8,352.6,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.3,302c6.3,1.5,0.9-3.3-2.1-3.5C383.2,298.3,388.3,301.4,390.3,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.8,209.8c0.1-1.9,1-7.7-2.1-6.8C358.9,203.9,359.6,213.3,361.8,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.6,292.9c2.7,7.2,2.8-1.9,1.2-4.9C336.3,284.1,337.4,291.4,337.6,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.3,394.1c0.8-4.2-8.6,2.7-5.5,4.5C337.2,397,340.3,396,341.3,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.5,296c2.9-1.3-5.3-8.5-5.3-4.3C427.9,292.8,429,296.4,431.5,296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.6,352.1c1.9,2.3,5.4-1.8,6.5-3.5C352.7,345.4,347.3,351,346.6,352.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.5,358.9c1.8,0.6,4.7,6.7,5.4,2.7C442.6,359.2,434.3,354.1,437.5,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.2,373.1c1.8-0.2,9.9,0.5,10-1.1c-0.5-1.1-12.1-1.5-10.1,0.9C359.9,372.9,360,373,360.2,373.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.3,223.2c-1.5-0.5-7.4-2.8-7.6-0.3C315.7,224.3,324.8,226.2,323.3,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.7,310.2c-0.4-1.4-1.1-5.6-3.1-3.7C370.9,309.3,375,317.7,374.7,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.1,236.4c-0.8-1.3-3.1-5.7-4.2-2.7C353.5,236.5,360.3,243.4,357.1,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.2,329.6c1,0.6,2.4,0.3,3.5,0.7c9.9,3-2.7-6.6-3.3-0.6C421.1,329.6,421.2,329.6,421.2,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.8,269.4L435.8,269.4c2.2-0.9,4.6,2.5,6.3,0.4C442.9,266.7,430.9,266.7,435.8,269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.3,273.3c1.9-8.6-5.2,1.6-2.6,3.7C337.7,277.6,337.5,274.4,338.3,273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.5,221c-1.6,5.4,2.9,2.1,2.7-1.2C376.6,213.9,373.2,217.1,373.5,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.6,379.4c1.7,5,4.5,3.9,2-1c-0.4-1.1,0.6-4.1-1.5-3.3C409.4,376.1,409.5,378.1,409.6,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.8,305.9c1.6,0.1,9.6,0.4,6.6-2.4C409.9,303.2,402.6,303.3,404.8,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.1,377c1.1,2.9,5.4,3.8,2.9-0.2C415.1,373.3,410.9,371.4,414.1,377z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.4,292.5c0.1-2-1.2-9-2.5-3.5C322.7,291.5,324,298.9,325.4,292.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.5,191.5c0.8-1.6,5.4-2.3,3.8-4.4C382.4,187.1,373.4,195.6,381.5,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.9,306.3c-0.4-1.5,0.3-5.4-1.5-5.6C335,303,338.8,314.1,338.9,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.5,358.2c1.7-0.2,9.6-3.5,4.8-4.3C351.1,355,343.7,356.5,347.5,358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.6,183.8c-3.4,2.8,9.4,9.1,3.9,3.5C432.1,186,432.1,183.7,429.6,183.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,268.8c0.5-0.2,1.1-1.3,0.4-1.5C348.3,254.7,349.5,270.2,354.1,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.7,214.6c2.1,2,2.2-6,3.2-7.4C362.9,205.5,362.1,212.6,362.7,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.3,236.7c-4.6-5.3-0.3,5.1,3.1,4.9C417.3,239.7,412.4,238.1,411.3,236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.2,191.7c-5.3,3.3,4.5,2,6.1,0.6C389.9,189.6,386,191.5,384.2,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.4,187.4c2.8,1.6,2.6-6.4,1.5-7.1C364.9,180.4,365.9,185.5,366.4,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.6,365.8c1.9,0.1,7.1,3.1,7.8,0.9C441.1,365.4,430.2,362.6,432.6,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.1,378.1c2,1,4.3,1.7,6.1,3.1C344.8,379.1,333.5,373.3,335.1,378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.9,284.1c7.6-3.1,0.2-3.3-3.6-1.1C385.8,285.7,389.6,284.4,390.9,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,318.4c1,1.1,3.6,4.9,4.5,2C407.3,317.5,399.1,312.9,403.6,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.5,407.2c4.1-2.1-4.9-12.8-2.5-5C378.8,403.3,377.8,406.7,379.5,407.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.8,247.5c1.5,0.9,7.2,0.3,5.1-2C371.9,246.2,361.5,244.4,368.8,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.7,358.5c4.4,1.7-2.1-6.6-2.8-7.3C420.2,352.4,424.7,356.9,425.7,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.7,290.8c0.2-1.3-3.9-7.4-5.2-7.3C343.9,284.3,349.8,293.2,350.7,290.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413,335.2c2.2-1.2-4.3-3.9-5.2-4.1C404.8,332.6,411.5,337,413,335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.7,249c6.5,2.2,1.4-3-2-3.5c-2.8,0.7,0.3,3,1.8,3.4C422.5,248.9,422.6,248.9,422.7,249z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.7,406.9c4,1.5-0.3-7.3-1.8-6.2c-1.7,1.8,0.7,4.1,1.3,6C434.4,406.5,434.6,406.7,434.7,406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.6,351.8c2.5-4.4-9-1-6.3,1.3C334.2,353.3,336.5,351.6,338.6,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.4,405.4c4.1,1.6,1.5-6-0.2-7C426.2,400,430.5,403,429.4,405.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.6,342.7c-2.1-2.5-1.8,4.9-3.2,6.2C361.3,352,362.5,344.5,361.6,342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334,275.2c3-3.1-2.3-9.4-2.6-6.3C334.6,271.5,329.5,275.7,334,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.6,416.8c-0.2-3,4-6.6,1.8-9.1C420.5,409.1,415.9,417.6,419.6,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.1,246.6c2.2,0,4.3,0.8,6.4,1.7C412.2,245.7,398.7,242.7,401.1,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395,242.2c1.9-0.4,7.3-1.9,2.8-3C394.6,239.1,388.3,243.3,395,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.9,315.8c2.6,6.4,3.4-5.3,0.6-5.9C339.5,310.2,341.5,314.2,340.9,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.1,185.5c0.4,1.6-0.2,6.1,2.6,4.3C375,187.5,371.9,179.9,371.1,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.8,270.7c0.7,1.3,2.6,4.7,3.7,2.1C367.1,269.3,359.3,264.1,363.8,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431,176c0.9,1.9,0.5,7.4,2.5,7.4C436.2,183.1,433.4,175.2,431,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.5,268c1.5,1.1,3.4,4.8,5.4,3.4C363.4,269.7,354.6,263.3,356.5,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.9,210.8c4.1,6.5,2.5-2-0.4-3.9c-0.6-1.5-2.3-0.6-2,0.8C322,208.8,323.5,209.6,323.9,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433,415.9c-1.7,0.4-0.8,1.5,0.7,1.1C433.4,416.7,433.3,416.2,433,415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.4,218.9c8,0.6,2.8-3-1.9-2.4c-1.3-0.3-2.1,1.5-1.1,2.4C342.2,218.8,343.5,218.3,344.4,218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.1,275c1.7,0.7,2.9,2.2,4.7,2.7C442.3,277,431.1,270.1,432.1,275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,263.1c2-0.1,7.3,3.3,7.5,0.4C427.3,262.3,418.3,259.4,420.4,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.5,234.5c-4.9,2.1,8.4,3.9,6.6,0.7C375.2,234.2,372.6,234.2,370.5,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.2,352.6c2.3,0.2,2.4-4.6,3.1-6.4c-1.3-4.5-4,5.4-3.2,6.3C372,352.5,372.1,352.5,372.2,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.1,301.3c-0.6-2,0.8-4.6-1-5.8C320.5,294.7,323.8,306,325.1,301.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.3,339.9c2.2-0.4,5.3,4.2,6.8,1.5C435.1,339.7,425.1,335.1,429.3,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.3,277.1c2.1,1.1,4.4-7.8,1.2-6.9C341,271.9,338.6,275.9,340.3,277.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.1,242.1c1.2,1.5,5.4-4.6,5.2-5.6C324.9,234.1,320,240.9,321.1,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.8,393.8c-0.3-2.3-6.1-4.2-4.4-0.9c2.1,0.6,3.4,2.4,4,4.4C380,397.6,379.8,394.5,378.8,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.7,236.8c-2.2-9-4.4,10-0.4,3.9C351.3,239.4,351.6,238,351.7,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.4,187.5c0.6,4.1,6.6-3.4,4.5-4.5C412.7,182.2,412.2,187,410.4,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324,222.2c1.7-0.5,6,1.3,6.5-1.1C330.2,219.2,319.3,219.4,324,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.4,401.2c1.2-1.9,6.3-2.8,4.6-5.7C343.8,395.9,339,398.9,341.4,401.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,394.1c3.9-3.3-3.7-12.7-1.5-3.6C404.3,391.3,403.8,394.5,405,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.4,253.1c1.4,0.3,1.4-1.9,2.1-2.7c0.5-1.3,3.6-3.5,0.6-3.8C389.7,246.5,386.3,252.5,388.4,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.2,370.8c-1.1-0.9-5.3-6.9-5.9-3.2C403.5,368.9,406.7,374.5,408.2,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384,256.2c5.5-2.7-3.3-2-5.3-0.4C377.3,259.2,382.5,256.4,384,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.5,171.4c-3,2.2,3.7,3.1,5.2,1.6C439.3,168.9,434.4,171.9,432.5,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.5,247.4c5.9-2.7-0.9-2.8-3.5-0.8C319,249.6,324,248.7,325.5,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,399.5c4.4-4.3-9.2-2.4-4.7,0.7C349.7,399.1,351.4,399.6,353,399.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.4,176c2.4,0.1,2.9-5,3.3-6.8C324.7,166.6,322,175.3,323.4,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.5,203.1c-0.4-3.3-3.6-2.5-2.2,0.5C335.7,209,340.4,208.4,336.5,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.4,274.3c1.1,1,4.7-0.6,2.7-1.6c-2.1,0.1-4.2-1.9-6.2-1.6C433.7,272.8,438.2,273.8,439.4,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.8,407.1c1.5,0.5,6.7,6.6,5.2,2C416.9,406.4,407.2,403.6,412.8,407.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.6,249.5c1.4,0.8,2.7,1.7,3,3.4c0.7,1.3,2-1,1.4-1.7C421.8,248.2,413.7,244.9,417.6,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.7,182.1c-3.4-1.2-4.9,11.6-1.2,4.4C441.1,185.2,443.4,183.3,441.7,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.4,300.9c6.6,5.1-0.7-4.6-2.5-5.6C335.1,296.6,338.5,299.6,339.4,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.8,208.4c-1.3,1.2,1.7,2.2,2.3,3.1C378.8,219.4,373.8,206.5,369.8,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.4,295.1c1.9-2.1-1.1-6.5-1.8-2.4C316.5,295.2,318.8,299,320.4,295.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.6,215.3c0.3,2.5,3.7,0.3,5.3,1.2C443.2,214.2,432.3,212.7,432.6,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,203.8c2.5-4.3-7-3.9-3.8,2.3C381.1,204.3,379,202.7,382.8,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.8,395.5c4.9-1.8-5.3-4.5-5.7-1.1C388.8,396.3,393.2,394.3,394.8,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.4,287c3.5-3.3-10.3-7.4-3.9-2.6C430.9,285.1,431.5,287.7,433.4,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.9,307.6c-1-4.9-4.1,3.8-2,5.2C336,314.2,334,309.1,334.9,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.8,260.4c2.4,3.3,2.2-3.4,3.1-4.8C334,251.9,331.7,258.6,332.8,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.9,205.9c3.6,3.4,0.8-5.7-0.9-6.2C351.8,198.9,355.1,205,355.9,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.6,356.2c6.6-3.8-14.9-0.7-5.6,0.5C372.9,356.1,374.6,356,376.6,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.5,255.3c3.2,4.7,4-9.3,0.5-5.5C345,251.6,345.4,253.7,344.5,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.4,223c3.5,2.7,1.2-6.6-0.3-6.7C355.9,216.9,359.8,221,359.4,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.1,375c4.4,3.8,1.2-3.7-0.5-5.2C387.9,369.1,391.6,373.7,392.1,375z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.5,282.4c0.2,0.1,0.4,0.1,0.6,0.2C444.1,278.1,438.9,280.8,442.5,282.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,191.6c1.6,0.9,2.4,2.3,3.5,3.6C324.2,195,314.5,185.9,315.4,191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389,263.7c3,2,8.3-8,3-4.4C391.6,261,387.8,262.1,389,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.3,225.2c0.2,0.1,0.5,0.2,0.8,0.3C443.8,222.5,441.1,222.3,442.3,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.1,294.3c4.2,5.6,3.3-1.1-0.2-2.8C363.9,287.5,364.1,293.7,367.1,294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.1,177.9c4.7-0.1-5.6-7.4-5.1-3.4C376.3,176.1,378.3,176.7,380.1,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.3,400.3c-1.6,4.6,7.5-1.1,5.4-3.3C337.8,397.5,336.1,399.3,334.3,400.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.1,326.7c1.2-0.3,2.5-7,1-7.3C375.6,319.2,373.9,328.7,376.1,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.1,198c5,3.6,13.3-2.7,2.4-0.6C381.7,197.3,379.5,196.2,380.1,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.4,196.3c2.1-1.2,0.6-11.5-1.5-5.7C338.7,192.4,337.6,195.6,339.4,196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.8,298.5c6.2-0.2-1.3-4-3.8-2.8C389.9,297.8,394.4,298.2,395.8,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.4,355.2c1.3-0.6,5.1-4.6,2.9-5.5C344.2,348.8,338.6,355.5,342.4,355.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.8,233.6c-5.4-0.2,5.6,8,5.3,4C366.9,235.8,364,235.6,362.8,233.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.3,212.6c4.9-2.3-3.9-3-5.7-1.6C386.8,214.4,391.6,211.7,393.3,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.7,221.3c-1.2,0.8-0.3,3.3,1.1,1.9c1.4-1.2,5.8,0.3,5.2-2.4C423.8,219.2,418.7,220.9,417.7,221.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.4,357.4c0.3-1.5,3.6-5.1,1.3-5.7C410.5,352.9,406.2,363.2,411.4,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.4,230c3.5-4.8-4.4-0.6-5.5,0.6C316,233.8,321.3,230.8,322.4,230z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,317.1c2.6,0.6,4-9.4,0.7-6.4C337.2,312.8,334.3,315.7,336.1,317.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.2,178.6c-1.7-7.8-2.3,1-2.1,3.8C329.4,185,329.6,180.3,329.2,178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.5,416.8c-0.3-1.4-1.4-4.3-2.9-2.4C357.5,416.7,358.9,417.4,360.5,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394,220c1.8-5.1-7,2.4-5.1,3.6c1.7,0.4,3.5-2.4,4.9-3.5C393.8,220.2,393.9,220.1,394,220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.3,244.1c1.7,0.2,6.6,4,6.2,0.2C430.1,243.6,424.4,240.5,425.3,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.8,412.8c0.3-1.9-0.6-8.7-2.4-3.8c0.7,1.7-0.2,4.3,0.9,5.6C396.2,415.2,396.1,414.2,395.8,412.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.6,409.4c1.8,1.3,5.2,4.5,4.5,0.1C441.2,408.8,436.3,404.1,438.6,409.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.4,238.9c1.4,0.6,5.1,2.3,4.9-0.4C420,236.5,410.8,235,416.4,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370,172.3c0.3-1.3,1.1-3,0.2-4.1C366.6,167.6,366.7,180.3,370,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,345c0-1,0.3-2.3-1.1-2.2C435.1,340.2,438.4,344.7,443.1,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.5,399c2.5,3.5,2.9-0.8,1-2.6c-0.1-1.4-0.2-5.2-2.1-2.8C362.3,395.2,363.2,397.3,363.5,399z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.2,416.9c4.7,1.4,2-5.1-0.1-2.4C340.5,415.2,340.3,416.2,340.2,416.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.8,199.5c1.6-6.3-15.8,3.9-0.1,0C401.6,199.7,401.7,199.6,401.8,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.1,328.5c-0.1,0.4-0.2,0.9-0.1,1.3C443.4,332.1,443.5,326.5,442.1,328.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.2,219.8c-1.4-0.5-9.2-0.6-5.9,2.2C337.1,221.4,341.8,222.8,341.2,219.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.4,364.6c2.2,0,5.2,1.1,6.9-0.7C347.3,362.4,336.8,361.8,340.4,364.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319,306.7c2.2,0.8,2.1-2,2.9-3.2C323.7,297.3,315.7,304.8,319,306.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329,364.9L329,364.9c1.4-2-6.8-1.2-7.7-2.5C316.9,364.4,327.5,365.8,329,364.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.2,263.9c-4.6,0.3,5.4,4.7,5.8,3.8C411.6,265,406.8,265.1,405.2,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.8,346.3c-1.7,0.1-0.8,2.8-1.6,3.8C354,358,360.8,347.7,356.8,346.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.1,242.9c1.7,0.8,2.6,3.8,4.6,3.4C416.2,244.4,404.9,237.3,409.1,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.3,258.9c1.6-0.2,8.2-0.1,5.8-2.7C375.2,256.1,366.5,257.1,370.3,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.8,219.9c3.8,2.7,10.6-3.2,3.5-1.8C432.9,218.5,430.5,217.6,430.8,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.7,267.4c-1.1-3.5-5.6,3.1-5.1,4.7C384.7,273.3,386.3,268.6,387.7,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.6,315c0.4-1.6-2.6-7.5-4.3-4.7C405.4,311.6,406.4,317.2,408.6,315z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.9,415.3c1.3,4.7,4.7-7.1,0.7-6.3C370.9,410.2,373.7,413.6,371.9,415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.3,271.9c1.4-4.5-7.3,1.6-5.8,2.5C391.6,275.3,393.8,273,395.3,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.2,237.6c-0.1-3.2-4.9-0.8-6.9-0.9C378.9,240,385.5,237.9,387.2,237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.1,171.2c1.2-3.6-4.9,0.5-6.2,1.2C393.9,175.7,398.6,171.6,400.1,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.1,258.6c5.2,2.5,3.9-1-0.2-2.3C416,254.1,417.5,257.6,421.1,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.7,288.8c1.3,0.8,2.4,1.9,3.3,3C413,292.5,402.2,283.1,403.7,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.8,228.5c1.2,0.9,3.4,4.9,4.3,1.7C362.5,227.6,355.2,223.3,358.8,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.1,186.6c0.9-1.6,3.1-3.9,2.7-5.8C399.2,178.4,394,188.4,398.1,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.9,333.3c1.9,0.2,3.7,1.1,5.6,0.9C442.5,331.4,430.5,330,433.9,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.5,344.7c-6.3-12.7-6.4,0.8,0,0.1C333.5,344.9,333.5,344.8,333.5,344.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.5,363.3c0.8,0,2,1.3,2-0.3c-1-2.4-5.4-1-7.6-2.3C345.5,362.2,353.3,363.6,354.5,363.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.8,208.4c1.6,0.2,5.1,4.7,5.6,1.6C332.4,208.1,325,204.4,326.8,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,175.8c0.9,0.8,2.3,5.1,3.5,2.5C347.7,175.2,339.9,170.2,343.3,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.8,179.4c-1.7-1.6-2.5,2.5-3.7,3.4C434,188.2,442.2,181.7,439.8,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.1,342c4.4-0.8-2.6-3.7-3.5-5.2C331.4,336.8,337.7,341.4,339.1,342z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.8,171.4c0.8,1.5,6.1,4.8,4.3,1C380.8,172,376.9,167.8,377.8,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.5,323.8c-0.1,1.7,1.9,6.6,3.4,3.5C362,325.5,359.8,317.5,359.5,323.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.6,193.9c0.6,1.4,3.3,5.2,4,2c-0.4-1.4-2.4-2.5-1.8-4.2C362.7,189.8,360.9,192.4,361.6,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.6,277.7c-0.6-2.7-4.8,0.6-6.5,1C386.7,281.7,394.5,279.3,394.6,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.4,183c-0.3,3.8,2.2,9.2,1.9,1.8c-0.3-2.1-0.4-4,0.1-5.9C321.2,177.6,320.8,181.6,321.4,183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.2,270.4c2.2-2.6-4.2-1.8-5.7-2.1C422.7,270.1,430.9,271.2,432.2,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.1,388.2c4-1.8-6.7-6.4-4.9-2.2C333.6,386.9,335.6,387.4,337.1,388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.7,327.1c1.5,0.8,4.7,1.6,3.8-1.2C413.8,324.5,406.9,323,412.7,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.7,288.8c4.7,1.2-2-8.6-3.4-3.9C407.4,286,409.4,286.8,409.7,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.5,370.5c1.9-0.8,7.2-0.4,3.6-3.2C376.7,368.1,368.2,369.3,374.5,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.2,403.6c1.5,0.9,6.1,4.8,6.2,1.1C421.2,404.3,413.1,399.3,416.2,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.8,267.9c3.7-1.8-4.3-3-5.4-4.7C333,265.5,338,267.6,339.8,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.8,253.6c1.4,0.5,2.6-0.6,4-0.3C390.1,251.5,372.2,249.8,376.8,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.5,365.1c0.4,1.4,2.9,4,3.5,1.6C398.9,363.7,395.7,357.6,396.5,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.6,385.7c0.4-1.6-0.1-6.4-2.5-5.5c-1.2,1.5,1.2,3.4,0.9,5.1C423.9,387.5,426.3,387.8,426.6,385.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.8,338.5c6.7-2.8-7.2-4.6-3.8-0.4C339.2,338,340.6,338.3,341.8,338.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.5,292.9c4.8-0.3,0.8-3.4-2.3-2.7c-1.5-1-2.5,1.6-0.9,2C384.3,292.4,385.6,292.5,386.5,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.7,344.6c0.9-3.1-6.3,0.9-6.8,1.9C397.1,348.7,401.5,345.8,402.7,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397,274.7c1.3,0.2,7.5-1.6,6-3.4C402.1,270.1,394.3,273.5,397,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433,362c1.4,0.4,6.2,2.7,4.6-0.5C435.3,360.3,426.6,358.5,433,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.9,358.9c4.4-0.4,5.2-4.3,0.2-1.7C328.6,357.5,328.3,361.7,333.9,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.6,294.8c4,0.7-0.2-4.9-1.6-5.7C418.7,289.7,421.8,293.9,422.6,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,207.2c-0.3,1.7,4.5,8.6,4.7,4.3C353.2,210.5,352.7,205,350.5,207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.8,356.1c3.6-0.5,5.7-4.3,0.6-2.4C392.1,354.4,392.8,358.1,396.8,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.9,352.8c5.3-0.9,4-13.7,1-2.8C403.4,350.7,401.6,352.1,402.9,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430,309.7c4.4,0.9-3.2-9.4-3.1-4.6C428,306.5,428.6,308.5,430,309.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.7,208.4c-3.5-1.4-2.1,7.5,0.5,6.1C380.9,212.9,380,210.1,379.7,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344,265.9c3.6,0.5,8.1-3.3,2.1-2.4C344.2,263.1,340.8,265.1,344,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.3,202c-1.1-1.2-3.1-5.9-4.3-3C340.5,200.8,345.8,206.4,345.3,202z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.2,337.9c-0.8-1.6-1.5-3.4-2.7-4.6C368.5,332.7,374.6,342.7,375.2,337.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.3,295.8c-3,1,1.8,3.8,2.7,5C423.1,300.6,417.7,296.6,416.3,295.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.5,264c7.5-1.2-6.9-4.5-5.2-1.1C409.8,263.6,411.8,263.5,413.5,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.3,191.9c-2.6-2-2.7,4.8-1.9,6.1C347.1,198.5,346.3,193.6,346.3,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.8,310.3c1.6,0.5,5.7,3.2,5.5-0.1C419.1,309.3,411.1,307.3,414.8,310.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.3,297.7c0.2,2.3,3.8,6.1,2.5,1.5C365.1,294.9,360.1,291.2,363.3,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397,392.5c1.8-1.2,3.3,0.9,4.8,0.5C405.3,389.3,393.8,389,397,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.6,366.4c4.6,0.4-2.4-5.4-3.6-5.3C424.1,363.4,428.5,364.7,429.6,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.2,228.1c-1.6,2,3,4.2,2.8,6.7C419.6,237.5,415.4,227.8,413.2,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.6,227.1c1.5-0.3,6.3-5.3,3.1-5.8C400.8,223,396,225,398.6,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.4,246.5c0.1-1.6,2.2-5.4,0-5.9C345.6,240.7,344.1,249.1,347.4,246.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.3,257.3c1.6,0.1,5.5,5,5.6,2.3C431.3,257.1,422.3,253.8,425.3,257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.1,174.2c2.8-1.1-0.6-4-1.6-5.4C331.8,168.5,335.4,174,337.1,174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.3,240c3.1,2,7.7-8,2.6-3.3C390.2,237.8,386.9,238.5,388.3,240z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.9,286.1c1.4,1,8.2,0,6-2.4C383.5,284,377,283.7,378.9,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403,203.5c2,0.1,8.4-4,4.5-5C406.8,200.2,399.6,203.4,403,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.8,300.1c-3,1.7,2.8,4.8,4,4.6C402.7,302.4,398.2,301,396.8,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.5,251.4c-0.5-1.2,0.7-6.1-1.7-4.3C352.1,249.6,355.2,257.6,355.5,251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.9,415.1c0.1-0.4-0.2-1.7-0.8-1.5C420.9,415.5,425,419,423.9,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.9,207.4c1.9,0.3,4.3-1.6,5.1-3.2C408.8,201.1,400.8,206.8,403.9,207.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.4,358.4c1.2,0.9,6.9-4.6,4.1-4.9C328.2,353.9,323.2,357,325.4,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432,240.4c1.1,1,6.5,3.8,5.1,0.5C435.9,239.6,429.7,236.8,432,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.4,195.7c0.1-4.2-4.3,2-4.1,3.8C377.5,201.3,378.6,197.2,379.4,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.3,272.9c1.2,1,3.2,4.5,4.9,2.9C363.2,274.1,355.3,268.1,357.3,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416,289.9c1.6-1.6-1.8-4.9-2.8-6.1C410.7,284.6,414.1,290.6,416,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.8,409.3c-1.4-2.2-3.1,2.2-4.5,3C327,417.3,335.3,412.1,334.8,409.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.5,353.2c-0.3-2.8-4-3.7-2.8-0.4C438.1,356.2,444,357.5,440.5,353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.9,287.8c-0.2,1.7,2.6,7.2,4,4C361,290.4,358.4,282.5,357.9,287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.6,281.1c3.3,3.8,1.1-4.4,1.2-5.9C342.8,273.1,344.7,279.8,344.6,281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.4,302.9c0.2,0.2,0.5,0.4,0.7,0.6C444.2,299,439.6,300.8,442.4,302.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.2,231.4c-1.7-1.1-2.8-5.4-5.1-3.3C353.2,229.5,358.8,235.5,358.2,231.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.5,342.2c4,2.3,6.9-9.4,3-3.9C345.2,340,341.6,340.5,342.5,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,364.4c-2.1-1-1.7,2,0,2.3V364.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436,393.6c2.4,6.6,2.9-0.3,1.6-3.1C435.8,389.5,434.9,392.3,436,393.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.4,204.4c3.6,1.2,0.7-5.3-0.9-5.9C360.1,199.9,362.5,202.7,363.4,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.6,378.4c3.9,4.3,1.9-3.1,0-4.5C386.1,374.3,387.8,377.1,388.6,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419,201.6c-0.6,1.5-2.8,6.4,0.5,5.3C420.5,205.4,422.3,200.4,419,201.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.6,370.9c1.2,1.8,4.1,1.1,2.4-0.9c-1.2-1.1-2.9-1.4-3.6-2.9C426.8,367.3,429.1,370.3,430.6,370.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.2,360.8c3.3-1,5.5-3.3,0.4-2.5C317.7,359.1,316.8,364.9,321.2,360.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.1,288.4c0.1-2.4-4.1-0.7-5.7-0.9C381.5,290,389.8,290.9,390.1,288.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.9,242.2c1.8,0.6,2.2-2.6,2-3.9C360.8,231.5,357.5,239.7,358.9,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.5,194.4c1.3-3.3-6.2-1-6,0.9C397,197,401.6,195.3,402.5,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.2,323.9c4.6-2.2-1.1-12-0.5-2c-0.7,0.9-0.9,2,0.6,2H346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.2,264.1c3.4-0.2,0-12.1-0.8-3.6C354.8,262,353.3,263.4,355.2,264.1C355,264,355.1,264.1,355.2,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.7,365.7c0.5,1.2,6.3-1.8,5.7-2.7C381.5,361.2,374.2,364.1,376.7,365.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.7,407.5c0.6-1.1,7-5,3.3-4.8C337.4,403.1,330.9,407.9,335.7,407.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.1,193.8c0.8,2.3,2.7-0.3,1.7-1.7c-0.6-1.2,0.9-2.1,0.6-3.3C357,186.5,355.7,192.4,357.1,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.5,381.4c1.8,4.3,3-5.4-0.1-5.5C424.9,376.8,428.4,379.5,427.5,381.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329,263.7c2.8,6.3,2,0.2,1.7-2.9C329,257.1,328,262.1,329,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.2,182.6c0.5,1.6,0.5,6.4,3.1,3.7c-0.2-1.5,0.1-3.8-1.2-4.6C426.4,181.7,424.4,181.6,425.2,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436,347c-0.9-1.2-3.8-5.8-4.5-2.3C432.1,346.8,436.1,350.8,436,347z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.3,308.9c3.2,0.1-0.1-5.3-0.6-7C361,302.3,364,307.2,364.3,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.7,402.6c5.7-2.5-1.3-2.2-3.5-2.4C417.2,402.1,422.1,403,423.7,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.1,304.9c4.8,0.2-3.8-8.2-3.7-3.1C412,302.2,412.8,303.8,414.1,304.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.1,400.5c1.8,0,7.9-2.7,4.8-4.3C417.6,398.1,412.3,397.3,414.1,400.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.8,340.7c0.9,1.4,0.8,3.4,1.8,4.7C422.4,346.5,416.3,332.6,416.8,340.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.9,278.6c7.7-0.2,5.5-8.5-0.3-0.4C377.6,278.2,377.7,278.4,377.9,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,403c1.9,0.4,2.8,3.2,4.2,3c3.3-2-4.7-6.9-4.3-3.1C367.2,402.8,367.2,402.9,367.3,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.3,296.3c-0.5-1.3-2.4-6-4-4.1C345.6,293.3,349.9,300.2,350.3,296.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.9,178.2c0.6-2.3,4.5-6.2,1-7.6C401.2,171.7,397.7,182.7,401.9,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399,330.9c1.5,1,3.9,3.8,4.9,0.9C403.5,329.9,397.6,327.5,399,330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.7,327.8c2.6,0,1.2-2.6,1.7-4.3C371.2,317.4,368.7,325.9,370.7,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.4,309.1c1.3,1.7,4.3,4.5,3,0.1C435.5,306.3,430.4,304.3,434.4,309.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369,367.1c3.5,1.9,7-6.2,3.3-3.9C371.3,364.7,368.1,364.7,369,367.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.5,386.7c-4.8-6.1-5.9-1.8-1.2,2.1C392.4,388.8,393.3,387.5,392.5,386.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.1,348c3.4,3.4,4.7-8.4,1.4-3.8C335.7,345.8,332.8,346.7,334.1,348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.1,369.7c1.7,0.1,7.4,2.7,6.4-0.8C441.3,368.9,433.8,366.7,436.1,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.2,309.4c2-0.4-1.4-6.5-2.6-6C422.6,303.3,426.3,310.7,427.2,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.4,387.5c1.7,0.6,2.8,2.2,4.5,2.9C374.9,389.5,365.1,382.6,366.4,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.3,326.3c3.4-1.1-1.1-3.7-1.8-5.3C390.8,322,395.3,325,396.3,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.7,381.2c1.3,2,4.4,5.5,3.4,0.7C395.8,379.5,392.3,376.1,393.7,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.1,202.4c2.1,6.5,13.6-0.8,3.5,0.9C437.2,204.1,435,200.8,435.1,202.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.3,216.1c1.1,0.8,4.5,3.4,5.1,1.3C328.8,215.3,320.3,212.3,324.3,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.8,367.8c-1.2,0.4-7.3,3.8-4.2,4.9C323.1,371.4,328,370.2,325.8,367.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.6,267.8c0.2-1.8-1.2-4.3-1.6-6.2C324,260.1,326,268.6,328.6,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.3,380.9c1.3,1.2,1.9,4.1,3.8,4C380.8,383,374.6,376.3,375.3,380.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,360.6c2.8,0.1,4.5-10.2,1-5.1C404.9,357.1,401.7,359.7,403.6,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.5,349.4c4-4.2-8.8,0.5-3.7,2.4C391,351.4,392.5,350.2,393.5,349.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.2,215.3c5.1,2.9,1.7-2.2-1.2-2.9C332,211.3,335,215.1,337.2,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.6,316.3c0.5,1.6,1.7,4.9,3.2,2C362.8,314.2,357.7,311.4,359.6,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.8,259.2c-0.9-2.7-6.2,2.9-4.4,4.4C378.3,263.8,382,260,381.8,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.1,349.8c-0.2-1.7-4.1-5.9-5.1-2.9C438.5,348.3,440.3,351.8,442.1,349.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.5,321.8c0.6-7.5-2.8-1.2-2.4,2.7C380.3,327,381.1,322.7,381.5,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343,182.5c1.3,1.1,3.8,3.1,4.1,0.3C346,180.3,339.1,178.9,343,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.9,283.8c1.9,1.3,2.8-3.9,2.1-5.2C341.5,276,339.5,283.2,340.9,283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.5,375.9c1.2,0.5,2,2.6,3.4,2C381.2,375.7,368.7,370.2,374.5,375.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.7,409.8c2.2,3.2,2-3.2,1.6-4.7C402.1,399.5,401.4,408.1,401.7,409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.3,295c4.3,3.8,0.7-6.9-2.1-4.3C432.2,292.2,433.9,293.4,434.3,295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.6,242.5c6.8,1.6,0.6-2.6-2.5-2.7C376.3,240.4,381.1,242.3,382.6,242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,232.3c3.7-2.6-3.9-2.3-5.3-1C373.4,234.2,377.5,232.2,379.2,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.4,183c1.8,1,2.4-3.1,3-4.3C422.8,175.6,419.6,182.1,421.4,183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.8,307.7c1.6,0.1,3.1,0.8,4.7,0.4C405.7,305.1,392,305.3,396.8,307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.7,333.9c1.4,0.5,3,2.4,4.4,1.9C432,333.4,422.2,330.4,424.7,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385,214.3c-1.9-3.8-3,1.9-1.8,3.8C384.8,221.1,386,215.7,385,214.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393,405.5c2-6.7-3.9,1.1-2.4,3.7C393.1,410.4,392.2,406.8,393,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378,293.2c2-0.1,4.1,3.4,5.4,1C383.5,292.1,376,289.6,378,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.9,366.4c0.6,1.5,5.1,4.8,4.2,1.3C409.1,366,403.3,361.6,405.9,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.8,244.7c0.2,4.4,3.9,2.3,2-1C363.5,239.3,360.4,241.6,361.8,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.9,402.2c1.9,0.3,3.5,2.2,5.5,1.9C365.1,402.2,355.2,398.5,356.9,402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.8,348.9c-0.6-1.8-2.2-1.6-2.8,0.2c-0.5,1.4-2.7,1.1-2.9,2.6C329,353.7,331.7,350.4,332.8,348.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.9,301.4c1.5,0.5,6.2,1.9,4.2-1.1c-1.5-0.8-8-1.6-4.5,1.2C401.6,301.4,401.8,301.4,401.9,301.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.1,192.7c-1-5.9-3.5,1.7-1.6,3.7C369.8,197.1,369.2,194,369.1,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.1,297.6c-3.6-1.2,0.3,6.7,1.9,5.6C432.2,301.5,429.8,299.2,429.1,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.9,352c-0.5-1.8-1.7-3.3-1.9-5.1C413.5,345.8,417.3,356.3,418.9,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.6,180.9c-3.1,0.9,1,5.4,1.9,6.9C358,187.7,353.7,182.2,352.6,180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.2,240.7c4.3-0.8,2.8-2.9-0.9-2.2C367.8,238.8,370.1,241.1,374.2,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.5,409.9c3.9,5.2,2-3.6-1.2-4.1C354.4,406.4,358.2,408.5,358.5,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.4,340.2c0.3,1.3,1.6,4,3,2.3c0-2.8-5.8-9.8-3.1-2.5C397.3,340,397.4,340.1,397.4,340.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.9,196.1c1.8,1.4,2.7-2.2,4-3.2C414.4,188.6,407.5,195,409.9,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.1,406.9c2.6-0.7-1.8-4.9-3.1-4.8C344.6,403.3,348.6,406.5,350.1,406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,255.7c-2.2-3.2-3.1,3.6-2,4.9C353.9,262,352.6,257.3,353,255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431,328.6c4.5,1.3-2.7-9.3-2.7-4C428.9,326,430.1,327.4,431,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,354.5c-1.3,0.5,1.9,8.8,3.3,5.6C417.4,358.5,416.9,353.9,414.7,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425,278.6c0.7,1.1,2.6,3.4,3.6,1.5C428.9,277.6,421.5,273.2,425,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.1,178.4c0,10.1,4.4-5.6,0.5-3.6C317.8,175.6,318.4,177.3,318.1,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.9,356.7c-2.3,0-6.7,5-1.9,4C386.8,359.4,390.9,357.7,387.9,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328,402c1.2-1,5.8-4.3,3-5.5C329.6,397.5,325.8,400.5,328,402z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.4,315.9c0.6,2.5,5.4,5.4,3.2,1.1C419.1,314.8,414.6,312,416.4,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.8,359.3c0.6,3.3,5-0.8,5.4-2.3C380.4,355.1,378.3,358.3,376.8,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.6,329.6c-1.2-1.2-1.1-5.4-3.2-4.9C332.8,326,335.4,331.9,337.6,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.3,340.5c4,3.2,0.7-2.9-0.4-4.3C389.5,334.5,392.1,339.4,393.3,340.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,338.6c0.8,1.1,2.7,4.6,4.3,2.9C372.6,340,366,334.5,367.3,338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427,416.2c-1.6,0.5,0,0.8,0.7,0.7C427.5,416.7,427.4,416.2,427,416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.2,324.5c-1.1-0.6-1.2,1.2-0.7,1.8c0.7,1.2,2.6,0.7,3.2,2.1c0.8,1.7,3-0.5,1.8-1.4 c-1.1,0.2-1.3-0.7-1.9-1.4C437.1,324.8,435.7,325.2,435.2,324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.5,308.4c0.8,1.2,1.9,5.1,3.7,4.2C392.2,310.9,387.9,304.6,387.5,308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.5,295.4c-0.2-1.5-2.1-2-2.3-3.5C414.6,290,420.2,300.3,421.5,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.8,209.5c1.3,1,1.8,6.1,3.8,3.4c0.1-1.7-3.6-7.5-4-3.5C355.6,209.3,355.7,209.4,355.8,209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.3,360c-0.3,2.2,2.5,5.3,4,2.6c0-1-1.6-1.2-1.9-2.1C408.5,358.2,407.2,358,406.3,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.1,228.1c2.9,1.4,12.4-3.4,4.2-2C370.9,226.6,367.7,226,368.1,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332,331.6c8,10.3,3.9-3.7-0.4-0.3C331.7,331.3,331.8,331.5,332,331.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.9,246.4c6.3,0.8,0.8-3.5-2.2-2.7C435.1,245.4,437.7,245.8,438.9,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.8,232.3c-0.1,1.8,2.2-0.2,3.1,0.6C376.7,230.7,367.5,228.9,364.8,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.2,195c1.7,2.2,3.8-1.4,4.6-2.8C408.2,188.8,404.3,193.9,404.2,195z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.1,329.2c2.5,6.1,3.2-0.4,1.3-3.3C320.1,325,321.4,328.3,321.1,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.5,204.8c-3.7,0.8,2.5,3.6,3.6,4C432,206.6,428.1,205.3,426.5,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.1,195.3c1.9,4.5,3.9,0.5,1.5-2C323.4,190.3,321.3,193.7,323.1,195.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,185.1c-1.6,0-3.3-2-4.9-1.1C375.9,186.3,385,188.5,382.8,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.1,300.4c4.4,6.4,1.3-5.7-2-3.2C435.8,298.5,437.8,299.1,438.1,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.8,352.2c8.5-3.2,3.2-5.7-1.2-1.1C393.9,351.5,394.1,352.1,394.8,352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.5,286c0.7,0.8,1.8,0.9,2.8,1.2c1.4,0.9,0.6-1.4,0.8-2C441.9,284.4,438.9,283.3,439.5,286z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.2,219.2c-1,0.7-2.1,3.9-0.2,3.6C417.4,220.7,420.1,213.6,415.2,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375,250.8c1.8,0.5,7.9-1.4,3.6-2.4C377.3,249.1,371.7,248.8,375,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.1,297.7c-2.4-5.4-2.4,6.9,0.6,4.1C426.6,300.6,425.2,299.1,425.1,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,416.8c-0.2-1.9-3.5-2-2.5,0.2C380.4,416.9,383.1,417.2,382.8,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.5,384c1.1,0.8,4,6.4,4.4,2.6C412.3,385,407.4,379.8,408.5,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.8,271.8c0.7-1.2,3-3.2,1.9-4.5C322.6,265.9,319.5,273.1,322.8,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414,344c2.8,1.7,1.4-5.1,0.7-6.4C412.1,337.6,413.9,342.4,414,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.4,252.1c-1.4-2.7-5.2,4.8-2.3,5.1C321.8,255.9,323.6,253.7,323.4,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.4,286.4c-1.4-5.5-5.4,3.4-1.1,3.3C321.7,289.3,319.5,288.2,321.4,286.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433,413.7c1.2-1.6-0.6-5.1-1.8-6.6C428.8,406.9,431.9,413.5,433,413.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.7,384.4c0.8,0.1,2.1-0.9,1.4-1.7C431.3,377.3,429.7,381.7,434.7,384.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.6,416.9c2.1-1.5-1.8-4.1-3.2-4.4C359.8,413.2,364.2,417.1,365.6,416.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.9,322.5c0.7-6.1-3.6,0.3-2.3,3C343.5,326.9,343.5,323.8,343.9,322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.8,394.3c-0.8-1.1-4.5,0-2.6,1.2C424.9,398,430.2,396.4,424.8,394.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.9,230.8c0,0.2,0.1,0.3,0.2,0.4v-1.8c-0.4,0.3-0.4,0.8-0.3,1.3C442.8,230.7,442.9,230.8,442.9,230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344,370.5c-3.1,4.1,8.5-0.2,3.8-1.8C346.5,369.2,345.4,370.1,344,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.8,374.9c-4.7,1.4,1.5,2.4,3.4,2.5C361.5,375.4,357.4,374.8,355.8,374.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.3,400.7c4.4-1.5-4.7-5.2-4.4-1.5C394.9,400.3,397,399.1,398.3,400.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428,233.4c1.5,0.3,5.6,3.4,4.9-0.1C431.7,232.5,426.4,229.7,428,233.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.7,181.5c1.4-0.2,2.9-9.7-0.1-7.4C331.7,176.3,329.5,180.2,331.7,181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.9,334.5c0.8-0.9,3.1-5.3,0.8-5.6C347.9,329.3,344.7,335.8,347.9,334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.3,372c3.5-3.3-5.9-2.6-4.4,0.1C333.1,373,334.9,371.9,336.3,372z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.1,354.7c1.2,0.5,4.1,3.2,5,2.1C433.9,354.9,425.4,351.6,427.1,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.1,307.4c2.4,2,1.7-3,1.7-4.3c-2.7-2.6-2.3,2.7-1.8,4.3C355,307.2,355,307.3,355.1,307.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.7,273.4c3.2-0.6-4.5-10-2.3-4.1C346.4,270.5,345.6,273.4,347.7,273.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417,333.4c4,0.6,0.1-4.4-2-3.9C413.3,331.4,416.1,332.1,417,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.6,259.4c-2-0.6-2.9,4.5-1.9,5.5C322.5,265.6,323.7,260,322.6,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.3,305.6c0.1,10.8,4-1,0.2-2.4C377.6,303.8,378,304.8,378.3,305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.2,362.8c0.5-2.6-4.8-0.1-5.9-2C323.5,363,331.8,363.9,333.2,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.9,345.1c3,4.1,2.9-5,0.6-4.9C374.9,340.8,376.4,343.8,375.9,345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.4,300.9c0.1-2.5-6.6-6.5-3.4-1.9C374.1,299.7,375.1,303.6,376.4,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.8,282c0.6,1.1,0.7,4.7,2.5,3.2C421.8,283.4,416.1,276.5,417.8,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.1,294.1c0.7,1.2,1.6,5.1,3.5,3.1C442.1,295.1,437.2,290.4,438.1,294.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.8,331.4c0.8-1.2,2.1-6.7-0.8-4.9C344.5,328.2,341.4,332.2,344.8,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.2,246.6c2.3-0.2,3.4-2.4,0.5-2.6C393.2,244.7,391.5,248.4,396.2,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.7,402.3c0-1.8,4-3.3,2.6-4.9C389.7,397.2,385.5,405.7,389.7,402.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,349.1c1.6,0.1,3.4-3.6,2.4-4.7C340.8,343.7,336.9,349.5,339.7,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.8,414.8c1.6,0.3,5.8-3.3,2.9-4C404.5,411.9,400.6,412.9,402.8,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.7,304.5c-1.6-0.5-3.6-1.7-5.2-0.8C387,305.7,395.3,307.3,393.7,304.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.4,190.9c1.7,0.6,3.7-3.3,2.2-4.4C419.8,185.4,418.1,189.9,419.4,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,226.3c0.9,0.8,2.4,0.9,3.6,1.2C429.9,225.9,419.8,221.9,422.3,226.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.9,279.1c0.8,1.1,7.3-1.2,5-2.8C400.3,276.3,396.7,277.1,396.9,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.1,313.5c1.2,0.4,2.7,4.1,3.6,1.5C413.7,311.6,406.2,309.9,410.1,313.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.2,247.7c1.3,0.6,2.7,1.4,4.3,1.4C441,247.3,430.8,244.2,433.2,247.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.6,313.1c1.4-0.1,4.4,1.9,4.7-0.2C403.7,310.8,396,310.6,399.6,313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.7,276.4c-2,1.1-0.2,2.2,1.4,2.4C443.3,277.4,443,276.5,441.7,276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.4,289.9c1,1.1,2.7,2.6,3.4,0.4C438.4,287.8,432,286.3,435.4,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.4,350.8c2.3,3.7,2.2-8.1-0.6-4.7C412.5,347.6,413.7,349.2,413.4,350.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.4,313.3c0.6,2.4,4.3,2.5,2.3-0.4C348.5,308.8,345,309.2,346.4,313.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.9,343.3c-0.3-4.1-7.4,2.8-3,3.1C394.1,344.8,396.2,344.5,396.9,343.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.9,308.9c4.8-2.3-3.6-2.5-4.7-0.9C405,310.3,408.6,308.4,409.9,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.2,326.2c-0.8-1.1-2.3-4.1-3.6-1.8C390.3,326.8,394.5,330.8,393.2,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.1,333.8c-0.4-1.4-0.7-3.4-1.7-4.4C316.3,329.2,319.8,337.9,321.1,333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.5,315.4c2.9,3.2,2.3-3.3,1-4.2C362.9,311.5,364.8,313.7,364.5,315.4 C364.5,315.3,364.5,315.3,364.5,315.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.1,324.8c3.9,4.1,2.8-1.1,0.1-2.3C437.5,320,437.8,324.5,440.1,324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.6,338.1c1.6,1.8,1.6-0.6,1.5-1.7C441.9,336.1,440.8,336.7,441.6,338.1 C441.5,338.1,441.6,338.1,441.6,338.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.6,279.5c0.7,1.3,1.8,4.8,3.6,2.6C366.5,280.2,363.8,276.4,362.6,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.2,300c-0.4-1,0.7-5.2-1.2-4.3C358.5,297.6,360.5,306.6,361.2,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.5,393.8c-2.4,2.1,1.6,2.9,3.4,2.6C354.4,394.3,350.2,393.5,348.5,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.1,218.5c1.5-0.2,6.4-2.8,2.9-3.8C389.7,215.6,385.8,216.4,388.1,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.3,308.9c1.4,4,1.8-2,2.6-3.2C328.6,301.1,326,307.1,326.3,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.6,273.5c0.7-1.7-2.7-1.8-3.8-2.4c-2.7,1.2,2.3,3.9,3.5,2.8C429.2,273.9,429.4,273.7,429.6,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.5,235.5c1.1,4.3,3.2,2.6,1.5-0.8C405.7,229.8,403.5,231.4,405.5,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.4,358.5c0.8,1.1,1.7,2.3,2.8,3.2C426.8,361.7,417.5,354.3,419.4,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,192.2c2.1,0.9,0.3-6,0-7C324.3,185.1,326.6,190.7,327,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.6,376.7c0.5-1.2,0.1-3.3-0.6-4.4C420.1,370.3,421.9,379.5,423.6,376.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.2,372c-4.5-1.5-1.2,2.8,1.3,3.1C381.9,374.2,379.4,372.7,378.2,372z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418,243.9c1.2-0.3,2.4,0.8,3.4,0.3C423.3,240.6,413.3,241.5,418,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.3,244.3c1.1,0.8,7.8,1,5.4-1.2C379.2,242.8,375,242.1,375.3,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,284.8c2.1,1.2,8.1-2.6,3.4-2.5C399.3,282.9,395.8,282.4,397.2,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378,316.2c2,3,2.5-4.1,1.5-5.3C377.2,310.9,378.7,314.7,378,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.4,329.5c0.2,0.2,0.8,0.5,1,0.5C355.1,321.5,350.7,318.1,351.4,329.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.4,336c-2.7-3.3-2.8,1.4-0.6,2.8C327.7,340.6,326.8,337.5,325.4,336z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370,252.7c1,0.6,3.2,2.2,4,0.8C373.9,250.5,363.3,250.2,370,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.3,204.2c2.6,0.5,0.4-3.9-0.1-4.9C346.3,199.4,348.1,203.1,349.3,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,297.4c-3.1-1.9-3,5.6-0.1,4.6C433.4,300.9,433.4,298.6,433.1,297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.7,294.5c1.9,0.4,4.5-3,1.5-2.7c-0.4,0.4-0.9,0.5-1.5,0.4C390.6,291.8,390.4,294.9,392.7,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.3,390.6c4,2.7,2.5-7.9,0-3.4C408.5,388.4,409.2,389.5,408.3,390.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.5,175.2c-0.1,1.3,0.6,4.7,2.2,3.4C417.5,176.7,415.2,171.1,414.5,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.6,343.2c-1.4-1.2-2.6,1.5-4,0.9C346.8,347.5,355.6,345.8,354.6,343.2L354.6,343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.7,374.7c0-2.5-6.9-1.9-4.1,0.6C339.9,374.7,342.3,376.8,342.7,374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.7,309.3c0.3-1.6-0.3-3-0.5-4.5C341.7,301.3,342.7,312.6,344.7,309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.9,300.2c1.9,9.6,3.9-0.1,0.3-1.8C350.9,298.8,350.1,299.8,350.9,300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.7,293.8c2.7-1.6-2.4-4.5-3.4-2.7C409.6,292.6,412.6,293.8,413.7,293.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.3,315.7c3.5-0.9-2.9-4.2-4.3-2.7C428.3,314.3,430.9,315.1,432.3,315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.8,361.4c1.2,1.8,7.5-6,3.7-4.1C364.7,358.9,361.6,359.4,361.8,361.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.1,367.5c-1.2,0.5-4.1,1.1-3.7,2.8C364.5,372,370.7,367.7,367.1,367.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.2,375c2.9-0.4,1.6-3.8-0.9-2C321.4,373.8,322.7,376.8,325.2,375z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.4,363.1c1.2,0.1,5.5-6.3,2.2-4.7C360.2,359.7,357.3,361.8,358.4,363.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.6,250.1c-1.2,0.1-3.3-1.5-3.8,0.2C403.2,252.7,411,252.7,406.6,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342,223.4c-1.9-0.3-4.4,1.8-5.2,3.2C337.7,228.1,343.2,224.4,342,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.4,326c-0.7-1-2.1-4-3.3-1.9C327.4,325.8,331.3,329.7,331.4,326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.8,180.5c0.4,0.5,1.2,1.3,1.9,0.9C412.5,177.2,408.4,173.5,409.8,180.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.8,308.6c2.5,0.8,1.5-2.1-0.1-2.6C380.5,303,381.1,307.7,383.8,308.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.3,321.3c4,1.8-0.2-5.5-2.3-2.8C432.2,319.4,433.3,320.7,434.3,321.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.1,318.3c1.1-1.6,0-5.2-2-2.8C373.3,317.4,372.3,320.9,375.1,318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.3,181.6c2.1,0.7,2-2.6,2.3-3.9C374.9,169,368.6,178.2,371.3,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.9,240.6c-1.6-0.5-4.3,0.1-2.6,2.1C403.4,243.5,407.2,242.6,403.9,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.5,310.2c2.1,2,4.9-9.2,2-4.2C322.9,307.2,320.6,308.8,321.5,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.4,314.2c3.1,2.9,2.3-0.7,1.2-2.8C433.6,309.3,433.2,313.1,434.4,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.3,303c-0.1,0.8,0.7,1.5,1.3,2C439.6,304.6,432.8,296.3,434.3,303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.6,197c2.8,1.1,2-2.6,0.2-3.5C347.1,193.1,348.4,195.9,349.6,197z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.7,270.5c0.5-0.9,2-6-0.5-4.2C317.4,267.7,315.9,270.8,318.7,270.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.2,342.2c-0.4-1-0.2-5.1-1.7-4.5C409.1,338.6,410.7,344.7,412.2,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.9,389.7c0.5,1.1,2.4,0.4,3.3,0.1C336,387.4,328.3,386.3,329.9,389.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423,347.6c0.4,1.6,2.8,3.5,2.6,0.8C425.2,345.9,421,343.8,423,347.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.5,384.6c2.5-0.8-3.6-5.1-3.9-2.3C414.7,383,416.1,385,417.5,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.3,196.5c1.3-0.9,2.6-3.6,0.2-3.9C414.4,193.4,412.4,197.5,415.3,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.2,352.9c0.1,1.8,3,1.9,2.1-0.2c0.2-1.6-2.9-3.9-3-1.4C432.6,351.8,433.2,352.3,433.2,352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.7,199c0.9-0.5,3.3-2.3,1.9-3.2C423.2,194,419.7,199.4,422.7,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.2,238.4c1.3,0.7,4,2,2.9-0.7C402.9,235.9,398.4,235.9,401.2,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,170.5c-0.6-0.7-1.5-2.8-2.6-1.8C342.8,170.8,348,175.1,346.9,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.6,280.5c4.5,1.1-2-6.2-2.2-2.4C419.6,279.2,421,279.6,421.6,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.1,321.8c0.2-1.1,1.4-4.1-0.1-4.7C348.2,316.8,347.8,322.8,350.1,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.2,332.9c0.6,1,1.7,2.3,2.8,1.1C343.3,331.4,337.7,328.9,340.2,332.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.8,186.2c1.2,1.9,4.5,1.5,2.8-0.7C350.3,183.4,347.4,184.5,348.8,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.9,397.8c3.4-1.7-3.4-6-2.5-1.7C373.4,396.5,374.2,397,374.9,397.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.7,296.6c1.2,0.5,3.2,1.6,3.6-0.2C389,294.2,383.7,293.8,385.7,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.9,339.7c1.3-0.1,0.2-3.7-0.4-4C424,335.4,424.8,340.3,426.9,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.3,373.2c2.2,2.6,2-3,0.3-3.6C396.6,369.5,397.6,372.3,398.3,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.6,205c0-4.2-3.2,1.9-2.9,3.6C375.3,210.5,375.4,205.7,376.6,205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.4,306.5c1.1,4,2.9-2.7,0.8-4C365.9,302.1,368.1,305.4,367.4,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.9,323.3c0.3,1.7,3.2,2.7,2.5,0.4C325.4,321.1,321.1,320.2,322.9,323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.7,296.9c-0.6-1-0.4-3.3-1.6-3.7C349.6,293.9,353.8,300.8,353.7,296.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.4,282.1c1.4,0.2,0.9-1.2,1.4-2.1C337.1,274.9,331.4,279.9,334.4,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.5,330.5c0.7,3.1,3.9,1,1.9-1.3C373.6,326.8,371.3,328.7,372.5,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.6,292.4c-0.1-1.3-0.7-2.3-0.9-3.7C331.3,286.9,333.8,295.5,335.6,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.2,404.1c1,1.5,4,1.3,2.8-0.6C353.8,401.8,349.8,401.9,352.2,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.7,197.3c-2.2-3.3-3.2,4.6-0.6,3.5C360.1,199.9,359.7,198.4,359.7,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.6,311.4c-0.3-2.5-5,2-2.8,3.3C317.2,315.2,317.7,312.2,318.6,311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.6,217.6c2.9,3.6,2.1-1.4,0.3-2.8C319.3,214,319.3,216.9,320.6,217.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.5,374.3c-0.1-1.1-2.8-3.1-3.8-2.1C403,373.4,406.9,376.7,407.5,374.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407,386.8c0.6-1.1-1.2-5-2.7-3.4C403.7,384.4,405.6,387.6,407,386.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386,382.6c0.9,3.5,3.2-2.8,0.9-3.5C384.6,379.1,386.2,381.3,386,382.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.3,397.3c-1.3-4.2-3.1,5-0.2,3.9C387.8,400.1,386.9,398.5,387.3,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.2,281.4c0.6,1.3,5.4,1,3.9-1.1C404.8,279.7,402.5,279.6,402.2,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.5,291c0.5,0.4,1,0.9,1.6,1.3c0.5-1.7-0.9-3.1-1.7-1.3C441.4,290.9,441.4,291,441.5,291z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.1,311.7c1.2,1.1,3.8,2,3.4-0.4C425.6,310.1,420.9,309.7,423.1,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.1,223.2c-0.3,1.8,4.2,1.4,3.9-0.1C440,221.7,436.2,221.9,436.1,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.1,319.5c-3.6-0.1,1.1,6,1.8,2.4C426.7,321.1,425.6,320.2,425.1,319.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.5,329.2c-3.1-8.8-2.8,5.4,0.1,0C382.5,329.3,382.5,329.3,382.5,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.5,259c1,0.2,3.7,1.4,3.6-0.3C437.2,256.7,431.3,256.9,433.5,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.5,306.3c-0.8-0.3-2.6,0.1-2.1,1.3C418.5,309.6,423,307.4,418.5,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.6,343.1c2.2,2.7,2-1.2,1.5-2.7C379.1,338.8,379,341.8,379.6,343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.3,370.6c-2.2-0.2-1.5,3.2-0.5,3.9C428.7,374.6,428.2,371.5,427.3,370.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398,293.5c1,0.1,2.9,0.4,3.2-0.9C401.8,290.2,395.7,291.8,398,293.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376,309c1.2,3.4,2.6-0.2,1.9-2.1C376.8,305.7,375.1,307.7,376,309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.7,391.3c0.7-1.8-1.7-2.4-2.8-1.5C324.9,391.7,327.7,392.6,328.7,391.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.2,266.5c1.2,0.6,3,0.8,3.9-0.3C434,264.7,426.8,264.3,429.2,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.1,250.7c1,0.3,2.5,0.4,3.3-0.2C388.2,247.9,381.2,248.2,384.1,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369,363.4c-0.8-1.2-3-0.5-4.3-0.3C363.4,365.3,368.6,364.7,369,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.1,342c-3.2-1.1-0.6,5.2,1.3,2.4C319.1,343.4,317.4,342.8,317.1,342z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.8,185.5c-1.6-0.4-2.6,2.9-1.7,3.9C336.7,189.7,337.6,186.3,336.8,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.8,349.5c-0.4-0.9-0.9-2.5-2-1.5C418.4,349.8,422.5,353.6,421.8,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.9,228.6c-0.9-0.2-2.9-1-2.4,0.7C428.7,231.7,434.1,230.2,430.9,228.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.7,367.6c1.1,0.6,4.1-1,4-2.1C350.7,365.2,346.7,366.2,347.7,367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.1,346.4c-0.8-3.2-5.8,3-1.7,1.9C345.9,347.7,346.7,347.2,347.1,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.1,378.8c1.1,1.1,1.2-0.8,1.7-1.4C354.4,373.6,348.9,376.6,350.1,378.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.8,373c1.1,0.2,1.6-1.2,0.8-1.8C328.3,370.5,327.6,372.6,328.8,373z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.9,300.3c2.2-5.6-5.6-0.5-3.9,5.8C315.6,303.8,317.5,302.2,318.9,300.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,287.8c1.3-2.2,1.5-5.5-0.1-7.6L315,287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,295c0.5-1.4,2.8-2.8,0.2-3.5C314.7,291.1,315.1,295,315,295L315,295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.4,254.8c-1.9-3.3-4.1,3.3-3.5,5C316.6,258.7,317.8,256.5,318.4,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.3,236.3c7-2,7.4-5.8-0.3-2.7C315.1,233.8,314.7,236.4,315.3,236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,268.9c3.8-3.4,3.9-15.2-0.1-4L315,268.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.9,238.8c2.2-2.2-1.3-3.2-2.3-0.7c-1.5,1.5-4.5,0.9-3.7,3.7C316.9,241.9,319.6,240.4,320.9,238.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.7,341.2c3.1-1.7-3.5-4.7-4.8-6.2C314.4,337.7,317.3,340.4,319.7,341.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316,186.1c5.8,8.4,2.7-5.1-0.8-3.6C315.1,183.7,315.2,185.1,316,186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,395.7c0-0.4,0-1.1-0.2-1.4v2.3C315.1,396.3,315.1,396,315.2,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.7,209.5c0.4-2.3-3.4-2.9-4.8-4.2C314,207.6,318,211.1,319.7,209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,196.5c3-1.4-1.2-3.7-0.3,0.2L315.4,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,213.4L315,213.4c4.8,4.3,3.6-1.1,0.1-2.9L315,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.8,347.5c-1.2-1.8-3.8,1.7-5.8,1.2C313.7,353.4,321,350.1,320.8,347.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.5,355.3c-0.4-2.3-0.6,0.3-0.5,0.8L315.5,355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.2,386.2c0-0.6-0.6-1.1-1.1-1.4v2.4C316,387.7,316.2,386.9,316.2,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.3,250.8c0.6-3.6-5.7,0.6-4.4,2.8C316.6,253.3,318.1,252,319.3,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.1,409.6c2.4-0.7,0-4.9,0.1-6.9C314.8,401.6,315,409.9,315.1,409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,310.6c2.8-1.3,3.2-6.5-0.3-2.9C315.1,307.8,314.6,311.6,315.4,310.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,220c3.7-0.6-2.3-3.3-3-4.8C314.8,217.6,315.5,219.5,318.2,220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.5,202.6c7.5,4,5.1-0.7-0.4-2.4C315.2,200.5,314.8,202.7,315.5,202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.6,367.1c-1.8,0-6.2-2.7-5.5,0.6C316.7,368.1,322.8,370.7,320.6,367.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.6,244.5c2-2.4-2.7-2.5-1.6,0.6C315.5,244.9,316.2,244.6,316.6,244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.5,248.6c0.8-2.4-0.9-1.9-0.4,0.3C315.2,248.8,315.4,248.7,315.5,248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.9,228.2c4.3,0.6,1.8-2.7-1-2.3C315,226.9,314.4,228.7,315.9,228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317,275.1c0.9-1.1,0.5-4.3-1.2-2.5C314.2,275.6,315,281.2,317,275.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,176.6c2.1-0.5,0.5-3-0.1-4.2L315,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.5,372.2c0.3-2.5-3.4-0.8-2.5,1.8C315.8,373.4,317.3,373.6,317.5,372.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,327.7c0.3,1.5,2.1,0.5,1.8-0.6C316,322.8,313.9,323.8,315.4,327.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.1,363.6c1.1-0.2,1-1.4-0.1-1.4L315.1,363.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,381c2.6,0.8,1.7-2.6-0.3-2.4C315,378.7,314.6,381.4,315.2,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,57.6c-4.8-3.1-1.2-2.2-2.8-4.5c-2.6-1.7-15.9,0.3-8.5,1.9c12.1-0.4,3.7-0.3,10.5,5.1 C95.5,63,97.1,59.2,88.7,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.7,63.7c-5.9,3.9,3.9,1.5,6.4,0.9c0.2,2.7,15.5-0.4,12.7-3.3c-3.9,1.8-8.1,1.5-12,2.6 C109.1,60.8,103.8,64,101.7,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.1,87c-0.2-0.2,0,6-0.1,6C-0.5,91.2,2,88.1,0.1,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.1,85.1c-0.7,2.7-2.3,6.5,0.4,8.1c-0.6,1.2-1.9,4,0.6,3.7c2.7-3.8,7.6-16.4,0-5.8 C190.3,89.7,191.7,82.1,189.1,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.8,99.1c1.9-3.3-2.9-2.1-3.1,0.5c-0.4,2-5.4,4.5-2.9,6.3c2,0.2,2.4-3.8,3.8-3.1c4,2.8,9.3-10.3,1.1-2 C195.5,100.3,196.6,99.6,196.8,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,146.4c12.1,4.3-1.9-6.5-5.6-3.9c-1.6,2,6.4,3.2,4.5,3.6c-1.5,0.1-4.1-2-4.7,0 C58.9,148.3,66.2,149.7,65,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.8,104c2.6-3.3-4.8-2.1-6.5-1.9c-2.5,4.5,6.1-0.1,5.1,3.1c0.9,2.7,5.6,1.9,7.7,3.8 C176.3,108.1,162.7,104,163.8,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.7,150.8c-4.4,0.8,6.7,6.1,8.3,6.3c3.4-2.3-6.3-4.1-7.5-6.5c4.5-2.4-8.3-11.3-3.1-4 C38,147.7,41,149.9,39.7,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106,95c1.8-0.7,4,1.3,5.4-0.4c0.6-4.3-14.7-0.2-6.2,0.4c0.7,1-2,0.7-2.6,1.2c-1.2,0.8-6.2,2.2-3.4,3.6 C101.5,98.5,107.9,98.1,106,95C105.9,95,106,95,106,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,150.9c4.4,3.1,2.7-2.7-2-3.7c-4-2.4-0.5,3.8-5.3-2.1c-3.4,1.4,2,5.2,2.9,7.2c3.1,1.6,1.6-2.6-0.1-3.6 C47.1,148.8,49.1,150.3,50.4,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,125.4c0.7,2,10.6,1.3,7.6-1.8c-8.1,1.8-6.7-3.3-14.2-0.1C153.9,129.3,161.8,121.3,162.3,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,115.4c8.6-5.8-13.8,0.2,6.7,7.4c1.5,1.3,3.6,0.7,1.9-1.2C10.6,119.1,4.6,119.2,4.6,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.6,6c-5.7-2.1-19.9,14.6-8.1,5.9C161.1,9,169.1,9.4,167.6,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.2,20.9c-1.3,0.5,0.9,2,1.1,2.8c2.6,2.9,3.7-0.7,5-2.6c2.9,2.2,6.6-9.3,2.6-7c-2.7,10.7-4.2,2.7-5.6,7.7 c-0.1,0.6-0.5,2-1,0.8C115.8,21.7,114.4,21.6,114.2,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,44.6c-1.8-3.9-2.8,0.4-1.3,2.5c-3,0.7,1,5.4,1.6,7.3c4.5,0.6-2.1-6,1.2-4C12.3,51,6.4,46.4,6.5,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.5,154.5c2-4.3-7.4-1-9.7-2.1c-0.4-0.3,2-2.8,0-2.9C145.1,156.3,158.9,154.8,162.5,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.6,4.4c5.4-0.3,6.4-3.8,0.3-2.4c-3.3,1.6-7.7,0.5-10.4,0.9C167.9,7.5,174.7,4.6,177.6,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.7,49.5c-4.1-11.6-3,5.4-0.8,8.3C195.7,58.9,192.2,51.6,192.7,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6,4.5C1.3,5.2-0.7,4.9,0,8C1.9,8,7.5,6.2,3.6,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.5,60.1c-4.3,12,4.8,1.3,2.2-7C203.4,44.9,206,58.9,204.5,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.7,12.1c-1.2-4.1-9.7-5.8-4-0.6C102.8,16.5,108.1,22.9,103.7,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.7,148.8c-0.4,2.2,8.4,4.1,4.5,0.4c-6.1-2.7,1.1-2.8-8.9-6.3C45.9,145.9,57.5,146,54.7,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.4,107.2c-5.5,0.7-10.4,6.8-1.9,5.9C193.7,109.7,202.4,110.2,197.4,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,139.6c1.1,1.6,4.5,6,3.6,1.2c1.6,0.2,7.5,4.7,6.1,0.6C8.4,140.4-0.5,135.2,0.5,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,38.5c-0.7,2,3.3,6.9,4.3,3.4c-0.1-1.9-4.7-3.8-1.1-5.4C62.2,35.8,48.7,30.6,47.2,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.8,0.1c1.3-0.1,2.7,0.4,3.9-0.2h-5.2l0,0C185,0,185.4,0,185.8,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.9,21.3c-6.3-8.5,0.3,7.1,1.6,9C103.9,29.4,99.6,23.5,98.9,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.4,141.8c3.9-15.3-5.9-7.5-2.8-6.2c0.6,0.6,1.8-0.6,1.3,0.7C182.8,137.9,183,145.2,185.4,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.6,69.7c-0.9,2.2-7.3,13.1-1,6.8C154.4,74.2,156.7,60.3,152.6,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,3.8c1.5-6.2-2.1-3.8-2.2,0.7c-2.2-2.5-3.5,1.9-1.8,3.1c1.1,0.5,1.2-2.9,1.8-1.9 C121.8,12.6,125.1,7.5,124.6,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,16.5C87,15.1,86.7,5.9,83.7,10c1.5,2.5,1,5.8,3.3,7.8C88.8,20.5,91.7,18.8,88.9,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,156.9c-2.1-1.6-12.4-6.8-12-2.5C27,153.4,37.5,161.6,36,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.8,62.1c-14.1-2.3-3.7,4.3,3.7,1.9C100.9,61.4,96.3,62.2,94.8,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.1,50.8c-1.1-1.9-2.5,0.6-3.6,0.4c-4.2-4.4-12,10.6-1.2,1.4C167.7,51.3,169,56.3,171.1,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,118.8c2.9-0.4,1-2.7-1-2.5c-2.8-0.9-3.8-4.3-6.1-5.7C88.6,114,93.8,118.5,97,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3,29.8c0.1,2.3,4.5,11.4,7.1,7.7C70.5,36.1,69.4,27.3,66.3,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.3,103.6c2.3,0.6,10.6,8.4,10.2,3.2C87.1,106.2,79.7,99.1,79.3,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.8,71.9c-1.9-2.6-2.1-5.8-3.2-8.7C67.4,53.8,75.8,83.3,75.8,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.7,51.4c-0.9-4-1.9-1.8-1.3,0.9c-0.6,2.5-8.1,4.1-4.3,7C128.5,57.5,133.2,55.2,131.7,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.3,71.6c0,1.2-1.5,2.7-0.4,3.6c3.6,0.4,4.7-14.1,0.7-10.9C12,66.6,12.5,69.3,11.3,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.7,76.5c-1.9-1.8-3.2,2.5-4.3,3.6C188.4,90.7,205.8,81.2,203.7,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.4,11.9c0-3.8-12,8-9.5,8.8C174,18.9,178,14.8,180.4,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.9,2.1c3.1-5.7-7.4,3.2-8.6,5.1C143.6,12.1,150.2,2.9,151.9,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,16.8c-1.1-1.6-9.9-3.9-7.1-0.3c3.2,0.1,5.7,2.3,7.8,4.4C14,20.5,12.1,17.6,10.7,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.8,161.8c1.1,1.3,4.4,4.4,3.4,0.6c-1.4-1.3-9.8-10.1-9.7-5.9C41.6,158,43.9,160,45.8,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195,33.5c-3.2-3.3-2.4,11.6,0.3,11.1C196.8,45.1,195.2,34.8,195,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155,26.8c-1.5,1.2-7,7-3.7,7.4c1.5-4.1,5.4-6.3,8.3-8.9C159.8,22.3,155.6,25.5,155,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,57.2c2,6.7,5,8.2,1.8,0.3C59.1,48.1,52.5,49.9,52,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.2,74.4c-2.9-4.4-3.7,0.4-0.9,2.1c2.3,1,5,1.4,7.5,2.1C99.2,75.5,90.8,76.1,89.2,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.4,57.5c1.4-2.2-0.9-9.8-1.8-3.6c0.9,2.8-1.5,5.3-1.7,8.1C201.8,65.9,202.6,58.9,203.4,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.6,27.1c-0.6-1.4-2.8-10.6-4.1-5.8C76.9,24.6,80.9,37,80.6,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,43.8c-3.5,0.1,0.7,4.5-0.3,6.4c-0.7,1.9,2.2,7.1,3.1,3.2C17,50.6,17.6,46.6,16,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.3,79.4c-4.3,0.9,5.5,6.9,6.3,9.1C118.7,86,111.4,81.3,109.3,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84,81.8c-0.5,0.4-1,2.2-0.1,2c2.8-2,8.3,2.9,9.8-0.6c-1.5-2-7.4-2-9.8-1.2C84.1,81.8,84,81.8,84,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.7,58c0.1,2.4-0.5,11.5,3.2,9.6C197.8,65.3,199.3,56.4,195.7,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,100.4c-2.2-0.1-8.2-5.3-8.1-0.5C126.8,100.9,138.4,104.9,133.2,100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.1,70.5c-1.6-0.5-7.1,14.6-2.7,9.8C193.1,77.3,197,73.5,195.1,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,100.8c-19.8-3.9-2.5,7.7-7.5,0.8C20.9,101.2,28.6,104.3,26.6,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8,72.6c-1.9-4.5-7.5,9.8-3.8,11.4C137,80.6,136.4,75.7,139.8,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.1,114.9c3-1,6.9,0.5,9.5-0.7C118.3,111.1,103.6,111.2,107.1,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9,155.6c6.1-3,1.9-20.3,0.1-2.8C189.9,153.8,188.4,155,189.9,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.1,150.8c2.4,0.1,8.8,5.7,8.6,1C73.8,151.2,65.1,146.1,67.1,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,21.7c-1.6-4.1-9.6,9-5.7,9.4C142.7,28.1,144.9,24.5,146.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.3,48.8c-2.5-2.1-0.1-8-3.5-9.5c-2,0.7,0.3,2.8,0.1,4.2c0.4,1.9,0.7,9.4,3.5,5.6 C203.1,49.1,203.2,48.9,203.3,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.2,34.6c-7.2-1.1,3,7.1,5.6,1.8C50.5,31.8,43.2,37.6,41.2,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.9,77.9c-1.4,3.3,5.8,2.9,7.9,3.7C103.4,82.2,88.5,78,85.9,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.9,105.4c1,1.7,6,9.9,5.4,4.1C74.2,106.7,65.7,96.4,69.9,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,29c-0.6-1.6-4.1-4.2-3.6-0.9c1.5,1.5,9.2,9.2,9,4C8,31.4,5.7,30.8,4.5,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,46.5c-0.9-9.5-3.1-0.6-2,3.6C39.6,58,39.6,49.6,39.2,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,66.7c-1.1,2.6,2.6,5.3,1.5,7.6c-1,1-2.5,2.2-1.9,3.7C81.2,79.4,80.4,65.3,76.5,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.1,138.7c2.6,2.2,5.8-0.8,1.5-1.5c-1.5-1.2,3.6-0.9,4.4-1.8C75.9,131.7,60.8,135.7,67.1,138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.8,158.6c2.5-2.2,0.6-7.8,1.5-11.1C133.9,141.1,131.3,159.8,133.8,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.9,36.5c-2.3-6.9-2.1,6-2.6,8.3C82.8,47.6,83.7,37.9,82.9,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.2,73.7c1.7-1.6,7.7-8.4,3.4-8.9C138,67,127.2,77.6,134.2,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.6,76c-0.3,2.4-5.1,4.7-3.3,6.7C148.2,83,151.3,66.6,146.6,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.2,104.6c2.5,0.5,6.4,1.6,8.9,2C123.2,103.8,110.1,100.6,111.2,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155,87.9c0,0.6,0.9,2.1,1.4,1.1c0-2.5,2.8-2.9,4.8-2.9C172.2,83.9,153,81.8,155,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,0.3c0.8,9.5,11.2,8.4,4.7,4.8C54.4,4.1,54.4-1.9,51.7,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,93c-6.2-4.3,1.5,6.4,3,7.7C65.8,101,59,94.8,58.4,93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156,98.5c-2.5,3.6,7.2-0.1,9.3,1.7C167.7,96.3,157.8,97.1,156,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,74.2c-2.8-2.9-0.3,3.8,0.8,4.7c0.3,3.5,9.7,1.2,6.4-0.9C29.8,79.9,27.7,77.9,26.5,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.4,42.6c-0.6-0.6-0.1-2.4-1.3-2.2c-1.4,0.3-2.9-1.8-3.8-0.2c-0.7,2.1,3.9,1.8,3.6,4.3 C46.6,52.3,48.6,47.2,46.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,94.4c-1.2-0.2-2.2-0.7-3.4-1c-1.6-0.2-1.3-1.8-1.8-2.8c-1.3-1.6-1.4,1.7-1.1,2.6 C68.8,97.2,81.8,98.9,75.2,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.6,0c0.5,0.1,0.8,0.2,1.2,0H133.6L133.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,51.5c-6.4,9.5,5.7,2,2.3-4.1C49.2,46.7,49.8,50.1,48.8,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.1,29.6c-2.6,5,1.6,3.5,2.4-0.3c0.7,0.7,0.8,3,2.4,3c2.1-0.3-1.1-7.1-2.3-3.3c0.2-1.2-1.5-3.7-2.3-2 C59.4,27.8,59.8,28.9,59.1,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.1,94.7c-11.1,3.7,1.6,2.7,5.5,1.3C157.2,93.1,152.8,94.1,151.1,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,22.1c-0.4-1-0.1,2.7-0.2,2.6C2.6,25.5,2.4,22.4,0.2,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.3,26.8c-1.3-1.1-7.8-7.4-6.6-2.8C198.1,26,207.2,34.4,202.3,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137,16.4c1.1,8,1.6-6.6,4.7-9C138.1,5.2,137.3,14,137,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4,75.8c-1.7-0.4-3.3-2.4-5.1-1.3c-2.1,1.3,5.3,2,5.4,4.9C124.5,85.1,124.1,77.3,120.4,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.8,72.8c2.4,2.1,7.3,3,10.4,4C114.9,74.3,102.9,71,101.8,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.6,14.4c0.8,7,1.2-3.2,6.9-4.3C149.3,5.3,140.9,11.5,141.6,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.3,48.5c-7.1-4.3-6.2-0.5-0.3,1.9C127.7,54,129.5,49.9,121.3,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.8,156.1c7.3-0.3,9.3-17.2-0.3-0.2C195.7,155.8,195.8,155.9,195.8,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133,118.6c6.5-2.9-2.8-2.5-5.4-2.6C123.1,118.2,131,119.5,133,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.1,76.1c-1.7-3.3-5.4,7.6-4.6,9.1c2,0.9,1.9-2.4,2.6-3.6C187.7,79.7,189.1,78.3,189.1,76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.9,111.8c2,0,9.3,7,7.8,1.7C123.3,112,113.3,107,116.9,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.2,4.6c-3.3-0.7-12.1,10.4-5.3,5.8C156.3,8.5,162.2,7.3,160.2,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.1,111.1c-1.3-1.3-11.6-1.5-7.9,2.3C202.1,112,210.6,114.6,208.1,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,28.2c-0.6,5.3,12.7,8.1,4.3,1.7C107.1,28.2,106.4,26.4,104.2,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.8,115.8c-1.7,0.9-9.5-0.4-8,2.5C183.1,119.7,196.5,117.2,189.8,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.4,43.7c-2.4,0.4-4.7,2.3-7.2,2.8C163.7,51.4,177.6,46.8,174.4,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99,83.4c0.5,2.4,8.2,1.8,10.6,2.5C114.9,84.7,99.3,81.8,99,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,45.5c-3.4-2.7-1.7,10.9,0.2,10C200.7,53.1,198.1,48.6,198.4,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.7,22.2c-3.7-0.7-1.6,6.7-7.9,4.8C117.1,32.2,125.9,25.7,123.7,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.3,21c2.1-6.5-8.2,4.4-5.8,7C137.8,30.4,140,21.8,142.3,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.6,145.2c4-11.1-3.1-4.9-1.2,1.4c-1.9,8.8,4.7,1.3,0.6-1L122.6,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.8,65.4c-2.1,1.4-8.2,1.3-8,4.3C177.3,71.3,189,66.8,184.8,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,103.1c1.1,1.1,14.3,1.2,10-1.8C95.4,102.7,90.1,100.2,88.3,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.2,126.2c-4.9,0.9,3.7,4.5,5.6,4.2C163.8,128.6,152.5,128.1,151.2,126.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.7,164.4c3.5,2.3,1.7-8.9,1-10.4C118.3,154.9,121.7,161.5,120.7,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,110.5c-7-2.5,2.7,5.7,5.1,5.9C33.2,114.6,27.1,111.5,25.5,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.5,64c-2-3.4-3.6,7.2-3.3,8.4C193,74.9,193.5,65.8,193.5,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150,44.7c0.5-5.6-6.3,6.7,1,9.2C152.8,51.3,147,47.7,150,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,105.5c1.6-4.3-6.3,1.3-8.5,1C94.7,110.9,105.1,106.9,106.2,105.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,70c-10.6,0.8,3.9,2.8,6.6,2.3C122.7,69.3,115,70.9,114,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,164.7c1.9-1,0-2.3-1.5-2.3C-0.1,163.6-0.2,165.1,1.5,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.6,2.8c-0.2-2-6.8-4-5.2-0.8C100.3,2.4,105.2,12.9,102.6,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.9,61.9c-0.4-7.5-3.3,5.9-1.7,7.7C144.8,75,142,63.6,142.9,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.9,57.9c-1.6,4,3.4,0.8,5,0.1c1.4-0.5,3.4-0.1,2.8-2.2C40.5,54,37.2,57.4,34.9,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,16c-1-1.5-3.7-4.9-4-1.4C71.7,19.2,80.4,23.9,73.9,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.1,25.5c-2.3,1.2,1.8,8,3.5,8.5C101.2,34.1,96.4,24.6,95.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.8,23.2c-6.9-1.1,8.9,9.9,6.6,3.3C15.9,26.3,14,24.4,11.8,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,95.8C17.8,96.3,8.2,95,8.7,97.1C10.6,97.8,20.9,99.2,19.6,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2,52.2c2.9,3.9,3.1-7.8,1.5-8.6C24,44.8,25.7,49.6,25.2,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.8,46c-0.8-2.8-2.8,1.8-2,3.1c0.8,1.4,4,8.1,5.3,4.2C145.1,50.9,142.1,48.8,142.8,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.5,34.4c-2.7,0.3,1.3,6.5,1.8,8.3C193,44,189.6,34.7,187.5,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116,44.6c2.6,3,14.7-3.3,6.6-2.2C120.9,43.5,115.3,41.6,116,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.1,93.4c-1.7,4.3,6.5,0.8,8.5,1C170.6,90.1,163.3,93.9,161.1,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.5,107.5c3-0.9-0.7-4-0.2-5.9C52.6,88.3,46.8,104.7,51.5,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9,89.2c-7.6,5.8-0.7,6.2,1.5,0.4c1.6-3.6-3.5-9.9-1.3-2.9C149.1,87.5,149.4,88.6,148.9,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.2,54.5c-2.5,0.3-5.3-2.8-7.4-1.9C108.7,56.4,122,58.5,116.2,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.8,8.2c-1.8-0.1-8.2-1.4-9.1-0.1C192.6,10.3,206.3,11.4,202.8,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.2,55.1c4-2.9-6.6-2.8-8.2-2.7C116.9,55.1,124.3,55,126.2,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1,35.3c-1-2-3.1-3.1-4-5.4c-4.5-0.3,0.6,4.5,1.8,5.9C85.7,38.4,88.6,37.4,88.1,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.2,121.5c-4-2-14.3,3-4.9,1.9C179.1,123.1,183.3,124.5,182.2,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.5,86.4c-4.8-7.3-3.5,3,2.3,3.6C149.7,90.2,143.5,87.3,141.5,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.8,159.1c1.7,1.1,8.2,5,5.9,0.5C71.8,158,63.5,154.1,67.8,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.1,112.5c7.7,4,2-3.1-2.6-3.6C125.5,108.3,130.1,112.6,132.1,112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.7,81.7c-1.9-0.4-3.9,1.4-5.9,1.5c-1.2,0.4-3.6-0.1-2.6,1.9C167.8,86.5,179,83.4,175.7,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.8,79.6c-0.7,5.6,7,6.5,1.9,1.6c-1.7-2.4,2-6.8-0.3-8.2C58.9,74.8,59.3,77.6,58.8,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156,38.8c-1.9,0.6-5.7,11.4-3,10.2c1.8-2,1-5.1,2.3-7.3C156.6,40.4,160.2,36.2,156,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.4,152.9c0.1-3.8-9.6-11.7-5.2-5C81.9,149.1,83,155.9,85.4,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,85.9c-2.6,2-1.5,3.5,1.2,1.5c2.2-0.8,4.4,1.9,6.4,1.3C18.7,86,10.8,84.1,9,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.7,94.1c0-1.3-2.8,1.2-4,1.1c-1.3,1.1-5.3,0.2-4.4,2.7C135.6,98.9,144.2,96.7,142.7,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,20.7c-3.3-1.5-1.2,2.5-0.6,4c0.7,1.3,0.4,5.2,2.8,3.8C93.1,26,90.9,23.1,90,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.6,104.8c1.9,1.1,9,3,7.6-1.1C127.2,104.5,120.3,100.9,121.6,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,50.1c-0.8,0.9,1,12.1,3.2,8.2C32,55.9,32.8,50.3,29.6,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,139.4c0.6-1.2-2.9-5.2-3.5-7.4c-1.1-2.8-4.1,0-1.6,1.2C32.9,134.8,33.4,140.8,36.3,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,96.5c1.3-2.7-4.6-3.1-6.7-6.1C78,93.6,84.4,97,86.8,96.5C86.7,96.5,86.7,96.5,86.8,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,39.1c4.6,6.5,1.6-3.7-0.2-6C71.9,33.7,74.2,37.4,75.1,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.8,13.3c-3.2,1.1,0.6,5.9,2.4,7.1c2.7,2.4,3.5-1.4,0.5-2.3C43.1,17,42.8,14.6,41.8,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,132c2.4-0.3,1.8-2.3-0.4-1.8c-2.7,0-4.4-3.6-6.7-3.7C55.7,128.5,63.5,132.7,65.3,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,91.3c-2.9,0.3,0.5,1.9,1.6,2.1c2.6,0.6,3.8,3.4,6.3,4.1C28.9,96.6,18.8,91.1,17.1,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.5,79.2c1.2,4.4,5.5-7.3,4.1-7.9C7,70.2,6.6,77.3,5.5,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.7,36.4c-1.1-1.5-5.2-11.4-6.4-6.6C199.1,30.6,203.8,42.8,203.7,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,32.7c-6.1,0.3,4.7,10.4,4.2,4.3C105.3,36.3,103.7,34.4,103,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.3,98.6c-7.4,1.8,5.2,1.5,5.5,4.1C50.5,103.1,43.2,96.9,40.3,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.9,16c-7.7,2.8,5.2,1.3,7.2,2C193.6,14.3,186.9,15.7,184.9,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.4,120.4c1.8,0.5,9.3-0.7,7.8-3.6C160.1,116.8,150.8,118.4,153.4,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.1,80.9c-1.7-0.6-6.9-4.7-7.7-2.1C112.6,80.2,124,86.3,119.1,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166,28.6c-1.9,1.2-9.7,5.7-6.3,7.7C160.6,33.6,169.4,31.2,166,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.1,101.3c-2.8-3-2.8,9.4-0.8,9.4C184.2,109.8,182.9,103.5,183.1,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.4,115.7c-2-0.3-10-3.3-7.5,1.1C198,116.3,206.3,120.1,203.4,115.7L203.4,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,29.9c-0.4-0.3-0.1,1.9-0.2,2C0.6,31.5,0.9,30.2,0.2,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.7,52.2c-7.7,0.2,3.9,3.1,5.6,4.2C107.8,53.5,102.7,52.5,100.7,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.4,99.1c-2.3,3.2,2.9,2.1,4.4,0.8c1.1-0.4,0.6,1.8,1.5,2C182,95.6,177.4,97.4,173.4,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.5,26.6c-1.7,1.4-8.5,3.2-7.9,5.5C157.3,33.8,167.8,27.5,164.5,26.6L164.5,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185,20.7c-2.8,0.2-5.2-3-7.7-2.6C174.9,20.6,189.6,25.4,185,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.5,81c1.1-1.1,5.1-6.1,1.2-5C195.1,78.4,189.9,86.3,196.5,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.9,78.3c3.5,2.6,1.1-7.1,2.1-8.8C122.9,67.7,123.3,76.5,123.9,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.7,0.4c1.1,0.5,2.4-0.6,3.7-0.4h-4C171.5,0.2,171.6,0.3,171.7,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,103.8c-1.9,2.2-5.6,1-7.2,3.2C129.5,110.9,144.2,105.4,138.6,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.1,34.7L0,37.1C0.6,36.4,0.9,35.4,0.1,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,129c2,0.2,4.2,0.4,5.8,1.3C145.1,125.3,127.7,126.3,136.4,129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,76.4c-0.6-2.8-0.2-5.6-0.8-8.3c-2.9-1.7-0.7,8-0.7,9.7C82.2,82.6,84.6,78.6,83.7,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.7,0.6c-3.8,11.4,0.2,8,2.4-0.5C139.7,0.2,137.7-0.3,137.7,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,111.8c-1.3-1.8-1.8-5.1-3.7-6.2C52.3,106.1,59.5,118.5,59.4,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.4,134.3c4.6,4.5,0-12.7-4.3-3.4C125.4,132.9,125.3,126.5,126.4,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.1,156.9c0-0.2,0-0.4-0.1-0.5v1C0.1,157.2,0,156.9,0.1,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.4,42.4c-2.2-1.2-5.2,3.5-7.9,3.8C130.6,50.8,141,44.3,140.4,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.6,9.6c-5.9-2.9,0.9,7,3.2,5.5C101.1,14.7,96.4,10.5,95.6,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,87.4c2.7,0.6,7.3,6.8,9,3.6C27.2,90.2,17.3,83.5,19.1,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.2,90.2c-0.8-1.2-5-4.2-4.8-1.1c1.2,1,7.6,7.3,7.5,3.2C87.8,90.8,85.9,91.2,85.2,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.3,59.3c-0.3-2.4-2.8-1-3.9,0.1c-1.1,0.7-5.5,1.2-3.9,3.2C176.8,63.4,180.6,61.1,182.3,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,67.4c-2.6-3.9-7.2-0.8-1.5,1.3C18.7,75.5,26.7,72.8,24.8,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,16c-1.1,2.9,10.4,8.8,5.8,3.4C39.5,18.9,37.5,14.2,35.7,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.3,72.9C3.4,78.8,9,62.8,3,66.2C4,68.3,3.4,70.7,2.3,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155,22.5c-12.7,7.3-4.3,11.2-0.1,0.1C155.1,22.7,155,22.6,155,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,124.4c4.4,1.2,7.9-2.8,1.4-2.4C145.5,121,142.8,124,148.5,124.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.2,86.2c2.5-5.4-4.6,1.7-6.2,2.8C175.3,93.6,181.4,87.6,182.2,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.5,87c-1.5,2.3-3.6,4-5.5,5.9C197,97.7,207,87.6,202.5,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.9,109.8c7.4,3.6,0.2-3.8-3.2-4.3C33.7,106.4,40.8,108.4,41.9,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.8,40.4c-1.8,0.9-5.8,0.5-6.4,2.3C101.7,46,113.9,40.4,106.8,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.6,87.5c-2,0.4-9.3,0.6-7,3.6C168.7,91.2,175.5,90.6,173.6,87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184,6.6c-2.1,0.1-8.3-1.9-8,1.6C177.5,8.5,188.4,9.4,184,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,120.1c2.7-3.5-5-2.3-7-3C137,120.4,144.9,120.3,146.8,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.4,61.3c-5,2.4,2.6,3.8,5.6-2C188,55.1,185.4,61.4,183.4,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.9,95.8c-1.7-1.7-5.2,3.7-6.5,4.9C187.9,104.8,194.5,97.1,193.9,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,123.3c3.4-1.3-5.1-6.5-6.6-5.9C41.2,119.8,48.1,121.4,49.5,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,0.2c0,2.8,3.7,0.3,5.1-0.1H8 M8,0c0,0.1,0,0.2,0,0.2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,46c-1.5,0.8-8.9,3.2-4.9,4.7C96.8,50.2,105.7,45.8,99.8,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,69.4c0.3,3.2,4.5,1.6,6.5,2.3C41.1,70.1,30.1,67.3,29.2,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.1,64.3c-2.6,0.3-2.7,5-4.7,6.8C201.2,78.9,208.1,66.7,207.1,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,49.4c-2.6,4,7.2,11.3,4.5,6.3c-2.6-1-1.6-5.8-4.5-6.2C21.1,49.4,21.1,49.4,21,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.8,117.8c2.5-0.1,5.4,5,7.1,2.7C127.6,118.1,116.6,113.5,119.8,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.5,0h-0.8C102.9,0.2,102.9,0.1,103.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,41.8c-0.9-0.9-3.3-1.5-1.9,0.4c0.5,0.4,1.7,0.9,1.5,1.7c-0.7,1.5-2.9,2.1-2.7,3.9 C184.3,50.7,189.7,43.1,185.3,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.6,48.6c-2.2-1.7-4.5,2.8-6.3,4C174.6,57.3,182.3,49.8,181.6,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.7,114c4.3-1.3-3.4-5.7-5.6-5.5C119.7,111.3,126.5,111.6,127.7,114z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.6,18.6c-2.6,0.8-9.2,10-3.7,6.2C164.7,23.2,170.9,19.7,167.6,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,150.5c-0.4-1.9-6.1-9-7.5-6.3c1.4,2.1,4.7,3.2,5.7,5.8C21.8,151.7,24,153.1,23.5,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.9,70c-1.5-0.2-9.1-3.2-7.5-0.2C93.1,71.5,104.9,72.7,98.9,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.4,92.6c-7.5-3.3,6,9.1,5,3.7C39,94.8,37.1,93.8,35.4,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.7,82.2c1.1-0.1,2.3-2.3,0.9-2.7c-2.5-0.1-9.9,8.8-5.2,7.2C69.3,84.8,71,83.4,72.7,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,160.6c-11.4-5.1,2.3,5.4,5.1,2.4C31.3,160.8,27.1,161.6,25.8,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.6,136.5c-3-1.9-3.1,5.3-3.3,7.2C203,147,203.5,137.8,203.6,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.6,88.6c1.6,2.6,2.4,5.5,3.7,8C49.7,96.7,44.6,84.9,42.6,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,70.4c-4.3-2.1-4.2,16.2-2.2,8.2C54,75.4,57.3,73.3,57,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.3,48.2c-2,3.3,5.4,2.7,7.4,2.9C112.2,48,104,48.9,102.3,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,59.8c-2.5-0.3-4.2-0.1-5.1-2.7C41.3,61.9,55.2,65,50.4,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,14c6.6-6.9-2.4-3.2-1.9-0.1C21.8,19.6,25.7,20,25,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.6,158.5c3.3-2.3-3.6-4.5-5.6-4.8C67.5,156.6,74.1,157.1,75.6,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.4,63.6c-0.9,1.6-6.1,7.8-1.9,7.6C159,69.7,164.6,62.8,160.4,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.8,16.4c-3.9-5.1,0.9,12.1,3,5.5C61.8,20,61.2,18.2,59.8,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.1,120c1.5-0.2,3.9-0.1,4.6-1.5C110.4,114.7,94.5,119.8,105.1,120z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.2,64.8c-5.3-1.5-1.3,2.4,1,3.3c0.6,1.6-1.2,3.1,0.6,4.1C53.9,71.4,53,65.2,50.2,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,54c0.2,2.1-0.1,8.7,3.4,7.3c1.2-1.2-1.1-2-1-3.3C11.4,56.3,11.3,51,9.1,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.4,85.3c-1.5-0.3-7.5-2.4-5.5,0.6C53.4,87.2,64.1,89.2,56.4,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.6,104.6c-5-1.5,2.1,4.1,3.8,4.5C84.8,109.4,77.6,105,75.6,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.8,3.7c-6.5-3.5,0.4,4.3,1.9,5.8C66.7,8.7,63.1,4.8,61.8,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,124.9c6.8-1.6-2.3-2.2-3.8-3.8C114.4,121.9,120,125.9,122.2,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197,12.6c-1.4-2.3-10.8-3.2-7.2,0.3C192,10.8,197.8,16.8,197,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,1.1c0.3,4.1,3.4,2.3,2.2-1.1C111.1,0.2,108.9-0.6,109.8,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.6,43.7c-0.8-0.7-12.1-0.1-7.1,2.5C107.6,45.8,113.1,46.9,112.6,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,83.3c1,2.7,3.4-5.4,4.2-6.5C51.5,71.8,46.9,81.4,47.5,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.9,0.2c-1.7,1.1-6.6,1.4-5.4,4.1C163,4.4,174.3-0.2,166.9,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,19.3c-1.9,1,0.7,3.5,1.2,4.8C27.7,32.7,25.1,19.6,21,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43,128.4c3.3,3,7.8,1.7,2.1-1.2C40.8,123.9,37.2,126.3,43,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.5,107.7c-1.7,0.6-8.5,0.4-6.8,3.1C148.9,111.8,160.8,108.6,154.5,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.2,140.8c6.1-6.2-1.9-3.3-2.9,1c-0.4,1.4-0.4,4.5,1.9,3.6C146.4,144,145.7,141.9,147.2,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,154.7c-1.8-0.7-3.9-1.5-5.5-2.7C51.8,152.5,65.9,160.2,63,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.1,10.4c-3-3.9-7.3-3.5-2.2,0.7C57,14.8,62.9,13.4,56.1,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182,148.3c6,3-1.6-8.3-1.2-3.4c2.7,5.5-1.2,0-3.4,1.2C177,147.3,181.2,149.6,182,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,116.2c-1.6-0.6-6.5-3.3-5.9,0.2C35.3,117.4,45.5,120.7,39,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,123.1c2.2-0.3,6.7,1.9,7.3-1.2C141,120.8,130.7,119.9,134.1,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,26c1.7,0.9,5.9,4.9,6.4,1.1c-1.7-0.7-11.3-6.4-6.6-1.1C33.3,25.9,33.4,26,33.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,39.2c0.8,2,0.7,4.2,0.2,6.3C210.1,49.6,207,30.5,205.3,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.8,66.8c-1.1-3.8-9.5,7.1-4.4,5.7C167.2,70.3,171.1,69,170.8,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.5,31.2c-1.9,5.8,7.1-3.2,4.1-6C53.8,24.4,55.5,31.2,52.5,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9,24.7c-2.2,0.5,0.1,3.4,0.3,4.8C74.2,37.8,74.5,25.6,70.9,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,120.6c6.4,1.5,2.7-2.7-1.1-2.8c-3.3,1.2,1.2,10.3,0.8,2.6C28.5,120.7,28.6,120.6,28.7,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.6,0c-2-0.4-9.6,0.4-6.4,3.4C158.4,2.4,160.2,0.5,162.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,25.1c-0.3-1.6-2.2-6.3-3.7-3.3C80.7,24.9,84,32.9,83.7,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.3,97.5c-1.8,1.6-7.7,1.2-6.6,4.4C139.5,102.3,147.7,99.8,144.3,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2,30.8c0.1,2.3,4.8,0.5,6.3,0.9C40.4,31.2,27.7,28.5,25.2,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.5,89.5c-3.2,1,5.7,5.3,6.6,5.2C45,92.3,38.4,89.6,36.5,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.8,154.5c-0.6,1.8-1.1,3.4-2.2,5C193.6,162.8,199.5,142.9,192.8,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.2,9.1c-4.2,0.5,3.3,8.7,4.8,5.2c-1-1.8-3.7-3-4.5-5.3C89.5,9.2,89.3,9.1,89.2,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,18.7c-3.3,0.8,6.9,8.4,6.1,4.3C6.3,21.4,4.2,18.6,1.8,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.6,44.9c-1.5,0.4-4.9,2.8-5.8,4.2C172.9,53.1,183.1,44.7,178.6,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.1,0.9c7.8,3.6,9.9-2.2-0.6-0.8C88.7,0.3,88.9,0.6,89.1,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.9,0c-1.6,0.9-4.7,1.7-4.9,3.6c0.8,2.2,4.7-2,6.6-2.1C198.3-0.2,194.1,0.2,192.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,25.9c-1.4-0.5-6.9-5.1-5.6-1.2C181.7,26.8,190.4,31.3,185.3,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.6,69.3c-2.3-0.6-1.3,4.2-1.5,5.4C0.6,73.2,3.4,70.7,1.6,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.2,37.7c-1.3-0.7-2.5-3-3.7-2.9C92.1,37.7,105.1,44,100.2,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.7,81.1c-3.2,0.8-9.2,13.2-3.7,6.4C74.4,85,79.4,84,77.7,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.5,105.2c-1.7-0.9-8.3,0.7-6.1,3.6C201.8,108.6,208.4,107.9,206.5,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.7,61.2c-6.2-5.3-1,3.3,0.8,5.3C135.4,66.2,132.7,62.3,131.7,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.9,127.6c3.6-4-8.1,0.4-8.4,2.1c0.1,2.3,3-0.7,4.1-0.7C80.9,128.7,82.9,128.6,83.9,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,49.8C63,40,64.9,54,68,55.3C71.8,54.7,66.9,51.6,66.7,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.5,108.9c2-0.6,8.8,0.8,6.5-2.9C111.3,106.4,104.2,105.8,106.5,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.9,16.5c-2.6,0.7-6.1,3.2-7.1,5.3C158.1,24.1,167.9,16.9,164.9,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.4,65.7c-6.6,2.3,2,2.6,4.6,2.1C43.6,65.2,38.2,64.7,36.4,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.5,6.5c-4.4-9.4-2,8.5,1.2,5C35.9,9.8,34.9,8.1,34.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,125.4c1.7,0.9,7.7,4.5,7.3,0.5c-1.3-0.5-7.8-3.8-7.1-0.5C140,125.3,140,125.4,140,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.1,90.6c2,0.2,5.6,4.7,7.1,3.1C67.6,91.7,58.1,86.2,60.1,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.7,157c-1.4-2-2.1-4.5-2.5-7C112.6,143.7,113.5,160.9,117.7,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.8,77.1c-2.3,0.6-6.5,3.5-1.8,3.4C176.8,79.4,182.5,75,174.8,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.4,99.6c-3.1-1.7-11.7,6.6-3.5,3.4C147.2,101.9,150.7,101.8,149.4,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.8,17.3c-2.4,0.2-5.9-0.3-7.8,1.2c-1.2,3.1,4.2,0.5,5.7,1C200.3,19.9,201.4,18.6,200.8,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,141.1c3.4-2.1-3.2-4.8-4.2-6.9C39.3,135.6,46.3,139.5,47.5,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,5.8c-8.1,1.6,6.2,3,6.7,0C29.4,3.9,26,5.6,24.1,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,32.8c-3.7,0.3-9.6,11.1-3.1,4.8C146.6,36.2,149.4,34.7,148.5,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,32.5c-1-2.9-3.7-10.1-2.8-2.1C21.9,36.2,28.8,36.5,24.5,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,159.1c4.8,1.4-3.9-10.7-3.9-6.1C89,155.1,89.6,157.7,91.6,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.6,56.9c1.7-0.2,5-8.7,1.3-7.5C187.3,51.8,182.6,55.6,185.6,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.4,46c-4.5,3.3,9.5,2.5,6.7-1.2C128.9,45,126.8,46.5,124.4,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.3,26.3c-0.8-1.7-5-6-6.1-3.6c-0.2,1.7,2.7,1.7,3.7,2.9C192.7,27.6,195.5,30.3,194.3,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.5,35.6c-3.4-7.1-3.6-0.4-1,3.2C94.5,41.4,95.5,36.8,93.5,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.1,65.7c-2.1-2.7-2.1,2.4-1.7,3.8c0.2,1.5-2.2,3.8,0,4.5C149.3,73.1,147.3,68,148.1,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130,134.8c2.6,5.4,2.4-5.9-0.1-7C126.4,127.8,130.8,132.8,130,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.2,53.8c-0.9,1.8-1.4,10.7,1,4.9c2.1-3.4-2-13.5-0.9-5.1C134.3,53.5,134.3,53.6,134.2,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.9,4.5c-10.5,0.8,0.4,2.2,3.8,2.4C209.4,4.6,204.4,4.6,202.9,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.5,17.8c1.4,1.5,1.5,5.8,3.5,5.7C105.8,22.5,100.7,13.4,99.5,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,139.2c1.8,1.2,3.3,6.9,5.5,5.7C28.6,142.7,19.3,133,22.6,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,99c-4.8,2.3,10.3,3.9,6.8,0.6C10.2,99.4,8,98.5,5.7,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,1c0,1.3,0.5,4.1,2.2,3.4C43.9,3.1,39.7-2.7,39.3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.4,63.6c-1.9-1.4-1-4.6-3.2-6.2c-3.1,0.3,0.8,3.7,0.6,5.4C80.1,65.6,84.3,67.2,83.4,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.8,157.1c1.7,1.4,0.6,7.7,3.7,5.9c0.5-2-1.6-4.3-0.9-6.3C88.2,156,84.6,155.2,85.8,157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.6,11.7c1.1-5.8-4.1-3.4-0.8,4.6C134.5,19.3,131.1,12.7,131.6,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.4,101.5c-2.9-1.8-11.1,4.3-5,3C149.9,103.2,154.1,104.3,153.4,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.5,15.7c-0.8-1.7-3.2-5.1-3.5-1.4C81.8,18.3,86.8,22.2,84.5,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,104.8c-0.9,0.6-3.6,3-1.7,3.8c1.1-2.3,8.6-3.8,5.9-6.4C5.4,102.5,4.6,104.1,2.9,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.7,65c-4.9,3.5,10.6,2.1,6.1-0.9C176.9,63.7,174.7,65.3,172.7,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.6,37.8c-2.9,3.3,7.7,3.4,7.1,0.6C125.9,36.3,121.8,38.9,119.6,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.3,16.2c-1.2-1.4-4.6-4.6-5.5-1.5C77.1,15.9,82.2,23.1,80.3,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.6,45.8c1.6,5.6,4.1-4.8,1.9-6.1C21.2,38.9,21.9,44.3,21.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.4,37.2c-4.1-2.9-6.6,0.1-2.7,1.2c1.4,0.4,2.8,1,3.8,2C15.3,39.4,13.6,37.4,11.4,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9,32.3c1.7,2,2.5,4.6,3.6,6.8C26.4,38.3,18.7,27.5,18.9,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.6,15.3c1.2-0.6,5.3-2.4,2.7-3.8C171,12,163.2,19.6,171.6,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.2,37.1c-1.7,0.1-9.1,7.5-4.6,6.8C145.3,41.4,150.6,39.7,149.2,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.7,89c-1.3,3.2,4.2,2.6,5.7,4.3C105,92,96.6,88.7,94.7,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128,148.7c0,1.4,1,5.9,2.6,3.3C130.9,147.9,126.3,138.8,128,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,108.6c-6.3-0.9,1.8,3.4,3.6,4.6C36.5,111.9,31,109.4,29.6,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,135.8c4-1.1-6.1-8.7-5.4-4C55.7,132.9,57.5,134.7,59.2,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,19.7c-3.2,1.1,4.2,5,4.6,6.9C210.8,25,205.3,20.3,203.2,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1,148.2c1.5-1.9,2-5.4,3.7-7.6C90.3,137.4,85.2,148.4,88.1,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,95.1c-2.5,2.7,0.4,2.7,1.8,0.4c1.1-2.1,4.4,0.4,5-1.7C6.4,90.8,3.2,92.8,1.5,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.8,85c-5.2-0.5,7,8.3,5.9,3.7C125.8,87.5,123.7,86.2,121.8,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,2.1C27.4,4.6,35.4,1.2,35,0C32.4-0.1,27.8,0.6,26.5,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.5,39.3c-1.8,1.3-7.7,0.5-7.2,3.4C132.6,43.3,142,41.5,138.5,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,129.8c0.5-3.1-10.1,3.9-8,5.6C141.9,134.6,144.8,131.3,147.4,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,148.7c-0.7-1.2-5.1-6.4-4.2-2.3C7.7,149.4,13,158.2,9.3,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.8,66.1c3.5-5.7-3.3-0.9-4,2C161.7,72.9,165,67.9,165.8,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.2,40.6c-7.2,3.1,1.8,3.2,4.4,1C171.8,39.1,168.6,40.4,167.2,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9,133c2,0.5,4.3,0.8,6.2,0.4c2-3.1-4-1.6-5.6-2.6C148.2,130,147.9,132.7,148.9,133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.7,123.8c1.7,0.7,7.4,2.3,4.1-0.8C5.9,121.4-3,119.8,4.7,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.6,55.8c-2.1-2-8.4,5.8-3.7,5C164.7,59.2,169,57.6,167.6,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.3,0.3c4.3,6.4,5.6-1.6-0.4-0.3C79.1,0.1,79.2,0.2,79.3,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.7,11.3c-7.1,2.1,8.2,2.5,8.4,0.6C7.9,10.2,4.3,11.7,1.7,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.3,51.6c-1.6,1.1-1,3.4-1.8,5c0,1.2-2.3,3.8-0.6,4.3C156.8,60,159.9,52,157.3,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.7,20.9c-5.9-0.7-12.1,6.3-2.4,2.3C175.4,23.2,178.5,22.2,176.7,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.5,15c-1.1,7,4.8-3.3,3.3-5.1C118.6,8.1,118.6,13.9,117.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,115.8c1.7-0.4,2.5,1.7,4.2,1.4c1.7-1.5-1.1-1.9-2-2.7C173.3,111.7,167.2,115.2,174.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,107c-4.3-6.2-2.4,1.2-0.5,3.8C68.8,115,69.3,108.4,67.3,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.7,21.9c-2.8-3.8-3,4.6-3.1,6.1C133,29.9,131.5,23.6,132.7,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,19.4c2.1,5.6,4.2,2.9,1.9-1.5C51.9,12.5,48.5,16,49.6,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.2,35.5c1.1,2.3,9.4,0.5,7.3-2.7C128.6,34.3,124.8,33.9,123.2,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186,94.2c-2,0.1-3.4,8.8-0.1,7.2C185.6,99.1,188.9,95,186,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,17c0.8,2,4.5,4.3,3.4,0.5C56,14.1,50.5,11.4,54.1,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.2,146.4c-1-5-4.4,3-3.8,4.7C206.9,153.4,207.4,147.9,208.2,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.1,0.9c1.8,3.3,4.2-2-0.4-1C106.9,0.2,107.1,0.5,107.1,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,55.7c-1,2.2,2.5,3.4,3.3,5.3C105.2,62.8,98.9,54.9,96.7,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,122.3c2-2.2-2.3-2.9-3.2-4.4C51.7,113.3,51.2,120.3,58.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,148.9c2.3,0,3.8,7.1,5.5,3.4C80.2,145.4,71.3,148,76.5,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.9,5.5c-2.3-0.1-5.4-2.1-7.4-1C71.4,6.5,82.6,9.3,79.9,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.7,80.3c0.8,5.6,15.8-7.9-0.2-0.1C155.7,80.1,155.7,80.2,155.7,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.6,71.2c-3.7-1.5-7.9,9.1-2.4,4C168.8,73.9,172,72.7,170.6,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.6,138.8c3,0-0.9-5-0.4-6.7c-0.1,0.2-0.1,0.3-0.1,0C103.4,128.4,105.8,138.2,107.6,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,163.8c0.2-0.5,0.8-1.3,0.2-1.7C34.4,154.8,36.1,160.7,44.5,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.7,0c-6.5-1.6-10.1,6.7-4.6,2.8C199.2,1.5,203.1,2.5,202.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,43.1c-0.4-1.5-1.6-2.7-2.5-3.8c-2.8,0.7,0.4,3.6,0.8,5.1C18.7,49.6,21.4,46.1,20.1,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.3,116.9c1.8,1.2,6.4,1.1,3.5-1.4C148.7,114,141.7,113.5,148.3,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.1,111.6c-1,2.1,3.4,6.2,5.3,6.3C60.5,116.4,54.2,112.5,53.1,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.4,81.4c-4.6-1,1.8,4.7,3.5,5.4C133.9,84.8,128.4,83,127.4,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.7,106.4c-3.3,1.4,3.1,5.4,4.4,6.3C41.1,110.3,36.2,108,34.7,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.5,40.9c-0.9,1.9,3.1,9.4,4,4.9C75.3,44.7,74.5,39.1,72.5,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.4,42.2c-0.7-4.1-5-4.7-2.6-0.1C69.5,46.6,71.7,47.6,71.4,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,85.6c-0.1,1.8,8.8,6,8,2.4C52.5,87.5,43.2,84.5,44.5,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,56.1c1.2,4.4,4-6.5,3.9-7.8C60.8,46,58.3,55,58,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.5,88.9c-1.7,0.2-3,8.3-0.1,7.6C183.8,94.8,185.7,89.8,183.5,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,115.1c-1.2-1.3-8.1-5.7-6.8-2C12.4,112.9,17.7,120.2,16.8,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.6,27c-1.9-1.5-8.1,9.4-3.4,6.3C144.8,31.3,148.9,28.7,147.6,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77,61c-1.9-0.5-3-6.6-4.7-4.3C71,58.7,77.9,66.3,77,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.3,155.6c-2.6-2.8-2.6,6.4-1.7,7.5C180.2,164,179.1,157.3,179.3,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,61.5c-8.8-0.1,1,2.5,2.5,4.6C46.4,64.9,42.6,62.4,41.6,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.9,45.2c1.5,9.6,2.7-3.6,2.3-5.4C157.7,40.1,158.1,43.5,157.9,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,109.9c-2.4-2.1-10.3-1.3-4,0.9C165,111,170.2,113.5,167.3,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.9,101.1c1.7,0.1,9,0,6.6-3.1C111.7,99,105.8,98.1,106.9,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,126.3c0.5,2-2.4,6.6,0.8,7C198,133,198.6,124.4,195.6,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.7,127.1c-2.8-1.9-3.6,4-4.1,5.8C201.4,135.1,203.7,128.1,203.7,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.8,125.5c7.9,1.6-4.8-7-3.8-1.2C108.9,125,110.8,124.8,111.8,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.7,14.1c-1.5,0-8.6,3.6-5.6,5.2C158.2,17.9,165.4,16,162.7,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.7,78c-1.4,1.6-2,4.6-1.5,6.5C1.7,84.4,5.8,74.2,1.7,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174,74.4c-3.8-0.5-9.7,8.5-2.8,3.7C172.2,77,174.9,76.3,174,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.5,127.7c-8.4-2.9-9.1,2.2,0.1,1.9C178.9,129,178.7,128.1,178.5,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,23.2c1.6-5.2-2.8-3.6-2.4,0.8C106.2,30,107.3,27.5,107.3,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.6,20.5c-1.2,0.4-9.5,2.9-6.6,4.7C148.9,24.3,154.5,23.3,153.6,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,32.4c-1-1.5-5.4-2-3.6,0.5c2,0.6,3.4,2.2,3.9,4.2C20.8,37.8,19,33.4,18,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,131.5c2.3-0.9-0.3-2.7-1.4-3.5C-0.2,129.2-0.3,131.2,1.3,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.8,127.1c2.8,0,0.1-3.5-0.9-4.5C-0.1,123.7-0.4,126.5,0.8,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,70.2c-1.8,2.2,2.7,9.2,4.1,5.4c-1.3-1.2-3.8-2.9-2.8-5.2C22.4,68.1,19.4,68,18.7,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.6,133.4c1.5,1.7,2.5,3.6,4.1,5.3C20.1,139,10.2,127.9,11.6,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.9,93.8c-8.3-4.5-1.3,2.6,1.8,3.9C133.3,96.9,129.8,94.8,128.9,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.8,28.1c0.9,1.4,0.8,6.3,2.4,6C47.4,32.5,44.6,23.1,42.8,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.3,7.6c1.3,1.3,4.2,6.8,5.9,3.3C46.9,10.1,43.1,4,42.3,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.6,149.1c2.9,1,0.8-6.6,0.6-8.2C135.3,140.2,137.3,147.5,137.6,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.2,38c-0.8-0.1-1.4-1-1.3-1.8c-0.9-1.1-2.1,1.2-1,1.9c1.1,1.3,7.7,6.1,6.5,1.8 C113.9,39.7,112.7,38.5,111.2,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.7,109.3c-2.3,0.1-4.1,1.5-6,2.5c-2.6,3.5,1.9,1.1,3.3,0.1C5.6,111.9,10,110,6.7,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,159.4c4.2,2.2-1-4.9-0.4-6.8C93.1,151.5,95.6,158,96.7,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.4,55.1c-2-0.2-7.2,5.4-3.2,6C171.2,59.4,174.8,57.2,173.4,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.8,9.6c-1.3-1.7-9.9,0.2-6.4,2.5C169.1,10.2,173.6,12.3,173.8,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.7,76.5c0.1-3.5-6.5,3.2-6,4.1C180.4,82.4,183.7,77.9,184.7,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.7,45.2c-6-1.9,4.2,4.1,4.4,5.6C60.8,49.2,53.9,46.3,52.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,124.7c0.1-2.1-8-6-6.6-1.8C44.4,122.7,46.3,126.7,48.5,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.8,1.2c1.4,2.5,2.3,0.7,2.2-1.1C118.9,0.2,117.3-0.4,117.8,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,159.9c6.2,4.6-0.6-4.5-3.4-4.8c-1.6,1.4,2,3.6,3.1,4.7C14.3,159.7,14.5,159.8,14.6,159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,98.3c-1.9,1.5,0.7,5.4,1.8,6.9C61.2,105.9,56.2,99.7,55.3,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.2,58.3c-7.3-1.9-0.5,3.1,3,2.8C113.1,59.1,108.7,58.6,107.2,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,32.7c-1.4,0-4.3,0.5-3.2,2.5c1.8-0.1,3.8-0.6,5.6,0.4C38.4,34.8,34.3,32.6,32.5,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,88.1c2,0.4,6.8,3.2,7.8,0.7C32.9,87.8,23.1,85.5,25.5,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,163.9c2.1,0.6,5.7,3.8,7.3,2.3C26.7,164.5,14.9,160.1,18.2,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173,28.6c1.4-0.3,5.5-0.2,3.8-2.6C173.1,25.4,164.7,31.6,173,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.7,9.6c-2.5,1.2,1.1,4.7,2,6.1C37.1,17.8,32.4,9.4,30.7,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,78.2c-1.2-6.9-3,4.7,1.5,5.2C70.3,82.1,64.3,80.4,64.9,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.2,37.6c-0.5-1.9-8.2-1.2-6.2,1.7C171.3,39.3,176.2,39.6,176.2,37.6C176.2,37.7,176.2,37.7,176.2,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,144.6c4.4,0.8-1.2-4.8-2.4-5.8C39.8,140.3,44.1,143.2,45.2,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.8,86.4c-1.2,3.1,4.6,1.3,6.4,1.6C103.2,85,97.3,85.3,95.8,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.7,32.9c1-5-5.6,2.3-5.3,4.4C134.3,40.5,137.1,33.5,138.7,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.9,95.8c-1.7,0-7.5-0.4-5.7,2.6C169.7,98.9,176.2,98.5,173.9,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.4,143.8c3.2,1.2,1.9-6.8,0.4-7.6C92.7,137,94.2,142.1,94.4,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5,98.9c-1.9-1.3-2.8,0.1-2.4,2C1.6,101.4,4,100.8,2.5,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.7,113.1c-1.8,0.1-6.1-4.5-5.7-0.6C162.8,114.4,171.8,116.2,167.7,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.5,39.1c-6.1,1.2,1.4,3.7,4,2.3C183.3,38.8,178.9,39.3,177.5,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.8,138.7c-2.4-5.6-3.2,4.7-1.7,5.5C191,145.3,189.2,140.3,189.8,138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,113.1c1.5,1,4.6,5.7,3.3,0.6C102.3,109.7,94.6,109,100.8,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,143.1c1.7,0.6,7.6,3.8,6.9-0.2C74.9,143.5,67.4,139.5,69.6,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.8,163c3.7,1-0.3-4,1-5.1c-3.8-4.8-2.4,2.5-1.2,5C82.7,162.8,82.7,162.9,82.8,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.4,64.4c0,0.2-0.1,0.6-0.1,0.5c-0.3,1.9,3.2,10,3.8,5.2C68,69.2,66.7,62.1,65.4,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,57.1c-0.4-0.5-0.4-1.2-0.7-1.8v4.9C1.5,60.2,1.6,57.9,0.7,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.8,26.9c-3.3,3.3,2.2,2.8,2.6-0.3C129.6,22.1,124.3,22.9,123.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28,85.2c6.4-1.3-5.6-2.8-6.7-2.1C22.1,85.4,26,85.1,28,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,49.1c0.6,1.7-0.2,4.2,0.9,5.6C38.1,56.5,35.2,42.2,33.4,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82,49c-1.1-0.7-4.3-3.8-3.9-0.8C78.5,51.8,87.2,52.5,82,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.9,139.3c1.4-0.8,6.7-0.4,4.6-3C80.1,136.3,70,140.4,77.9,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.4,98.6c-1.3-0.8-6.1-4.4-5.1-0.8C82.3,99,88,104.5,85.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.1,109c3.6-3.6-5.8-1-6.4,0.7C138.4,112.3,142.3,108.7,144.1,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.8,53.1c0.5-2.7-2.2-6.1-2.2-1.6C193.1,55.8,196.9,60.2,195.8,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,37.5C3.8,36.4,5,31,2.3,33.7C0.9,36.7,7.2,44,5.2,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.4,122.3c-0.5-1.3-7.2,3.7-6.2,4.5C190.2,128.5,197.1,123.7,195.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9,69c1.9,1.5,1.3-2.4,1.7-3.3c0.6-1.6,2.8-5,0.9-6.1C59.3,62.3,57.5,65.7,57.9,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.9,55.3c-3,0.1-0.9,5.9-2.6,7.8C146.4,66.4,148.4,55.7,146.9,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.1,66.6c-0.9-1.5-0.2-5.4-2.2-5.5C83,63.4,88.3,75.9,87.1,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.7,140.9c2.7-1.7-5.7-6.1-6.1-3.2C53,138.9,55.7,140.9,57.7,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.8,11.2c0.6,1.7,1.7,4,2.7,5.3C111,16.4,106.1,7.9,104.8,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,128.7c-1.4-1.2-5.7-5.7-7.3-3.4C22.2,126.2,28.6,131.8,28.7,128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,125.4c5.5-1.5-6.1-4.2-5.9-1.5c1,1.5,4.2,1.2,6,1.4C73.7,125.4,73.8,125.4,73.8,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.4,150.8c0.9,1.5,1.6,5.5,3.5,5.2C23.8,154.2,15,142.9,18.4,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.8,138.5c-2-3.4-3.2,5.2-2.1,6.5C134.7,145.4,132.7,140.3,133.8,138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.1,32.3c-2-0.9-4-4-6.2-3.2c-1.2,1,3.7,3.3,4.4,4.3C184.1,34.4,187.2,33.1,185.1,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.5,74.4c-7.5-0.7-0.5,2.4,2.4,3C104.9,76.5,101,74.6,99.5,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,111.6c-0.9-2.2-3,0-1.8,1.4c1.8,0.6,3.4,2.6,5,3C90.2,114.1,86.1,112.7,85,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,50.3c-1-2.7-3.1-0.7-1.7,1.3c-0.1,1.7-0.4,3.1-0.6,4.6C14.5,57.4,14.7,52,14.2,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.2,133.6c3.4,4.2,2-5.4-1.8-5.2C95.7,128.9,102.1,130.7,101.2,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.2,90.6c-1.3-1-8.1-0.8-6.2,2.1C157.5,92,163.7,93.6,162.2,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.6,0.5c0.7,0.8,1.2,0,1.7-0.6C132,0,129.3-0.5,130.6,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91,49.8c-0.9,1,0.7,11.6,2.9,7.4C92.7,55.4,93.5,50.2,91,49.8L91,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.8,142.1c2,0.9,1.6-2.3,2.2-3.4C195.4,131.8,189.1,139.4,191.8,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.6,102.3c4.4-1.5-7-6.2-5.2-2.3C73.1,101,74.7,101.7,76.6,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,61.8c-1.9,9.4,3.5-3.1,2.4-6C136.7,55.9,136.8,60.1,136.4,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,94.8c-0.8-1.7-6.1-4-4.8-0.6C51.6,95.5,57.2,99.2,55.1,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.1,154.6c6.1-0.1-5.5-6.4-4.3-1.5C63.1,153.8,64.8,154.2,66.1,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,104.7c1.5,0,5.6,2.3,5.7-0.2C174.9,102.4,166.2,101.5,169.6,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,0.6c1.5-0.9-0.4-0.5-0.9-0.6C121.4,0.4,121.8,0.6,122.2,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.9,67.8c1.1,1.4,0.9,5.2,2.7,5.4C67,71.7,60.9,60.8,61.9,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.7,166.7c6-0.6,6.8-10.2,2.4-3.5C193.5,164.7,190,164.7,191.7,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.3,8.3c-5.8,2.4,2.8,2.4,4.8,1C19.8,6.1,16.1,8.2,14.3,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.4,42.4c-5.2-1.9,2.7,5.1,4.6,3.6C63.7,43.5,58.7,44,57.4,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118,99.1c7.6,2.9,7.3-1.7,0.3-2.2C117,96.8,117,98.9,118,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,63.1c-3-1.5-0.4,4.7-0.4,6C10.7,69.2,9.7,64.4,8.2,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166,147.8c2-0.4,4.4,1.4,6.1,0.5C173.5,145.2,162,145.2,166,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.2,58.8c-4.6,3,9,2.7,5.8-0.5C120.2,59,117.9,58.7,116.2,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.1,134.4c0.9,1,1.4,3.5,2.8,1.7C40.1,131.7,30.8,128,37.1,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.5,130.3c3.3,1.4,4-2.1,0.4-2.1C162.3,127.1,161.5,131.9,166.5,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,5.3c-1.3-0.8-0.5-5.2-2.8-3.2C34.5,5.3,41.7,10.7,39.3,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.9,145.2c-0.4-5.9-3,1.7-2.3,4.2C110.8,153,110.9,146.7,110.9,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,63.7c0-0.1,0-0.1,0-0.2C-0.5,68.5,4.1,65.8,0,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,61.5c-0.1-0.1-0.1-0.3-0.2-0.4v1.5C0.1,62.2,0.3,61.9,0.2,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.4,6.2c-1.7-1.3-5-3.2-6.7-1.4C88.8,6,91.4,6,92,6.2C93.3,6.8,97.3,9.4,96.4,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,20.1c-1.7,1.2,1,3.5,0.7,5.2C64.9,32,69.2,19.5,64.3,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.7,48.3c-1.5-0.3-5.7-2-3.5,1C113.9,51.6,120.7,50.8,114.7,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,30.5c-2.4,2,10.3,4.7,7.8,1C118.2,30.7,116,32.1,113,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.4,78.4c-0.2,2.3,5.7,4.9,3.7,1.6c-4.2-1.6-0.9-6-3.1-5.3C14.6,75.9,14.1,77.1,14.4,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,0.7c1.4,2.7,11.6,2.9,4.9,0.2C74.8,0.6,70.9-1.1,71,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.6,139.5c-1.6-0.3-4.1-2.6-5.2-0.9c-0.5,2.3,3.1,1.7,4.2,3C171.1,142.9,171.8,139.9,170.6,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,43.5c-1.8,0.4-4.5,1.7-5.6,3.3C91.7,49.7,99.6,44.9,97,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.9,158.4c1.7,0.4,4.2,1.6,5.8,1C171.6,156.4,160.8,155.5,163.9,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.1,120c-1.3-1.1-4.4-1.1-6.2-1.2C164.1,121.4,172.9,122.9,172.1,120z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,119.3c-5.1-2.5-0.1,5,2.6,3.9C25.6,121.2,22.6,120.5,21.2,119.3L21.2,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.4,75.8c1.7,6.6,3.4-7,1.3-7C47.1,70.9,46.5,73.5,46.4,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.2,4.4c0.6,3,3-0.9,3.2-2.3c1-2.2,0-2.2-1.9-2.1C113,1.4,112.9,3.2,112.2,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,65.3c0.9-1.3,3.9-5.1,1.4-5.8C157.4,59.3,153.9,66.5,157.5,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,139.9c-0.1-6.3-2.8,0.9-2.9,3.5C126.2,146.9,127.5,141.5,127.8,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131,125.1c4.4-3.1-7.6-2.4-5.5,0.6C126.9,126.2,129.4,125.5,131,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129,79.7c0.8,1.7,3.8,5.3,3.7,1.4C131.8,78.5,127,74.4,129,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.9,158.6c0.4-1.3,3.3-5.3,0.6-5.4C204.8,153.9,202,162.4,205.9,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.6,161.3c2.2,3.8,2.5-8,0.8-7.9C110.6,155.2,112.2,158.8,111.6,161.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.6,97.4c1.1,1.6,5.4,4.5,3.3,0.5C65.1,94.6,59.7,92.6,63.6,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.3,126.5c1.2,1.3,2.7,4.2,4.7,2.9c0.5-1.9-2.9-3.4-4.1-5C29.6,124,28.8,126.2,30.3,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.1,6.3c-0.8-0.9-1.3-2.7-2.3-3.1c-3.4,0.3,1.3,7,2.9,5.1C110.5,7.3,109.9,6.8,109.1,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.2,67.6c-1.2,0.4-5.8,6.1-3.1,6.6C186.7,72.6,189.6,69.9,188.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,31c-4.3-3.4-8.6,2.6-3.8,1.1C40.3,32.5,43.4,34.2,42.4,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.1,132.5c-1.1,2.2,3.8,3.1,4.8,5.1C9.4,136.5,2.7,132.1,1.1,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,3.3c-1.2-0.5-2.3-2.2-3.4-2.2C63.4,4.2,75.6,9.8,69.4,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,160.3c-0.9-1.2-3.9-5.2-5-2.8C8.8,159.3,16.3,165.7,12.9,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.5,159.4c0-1.9,4.2-5.3,1.4-6.2C142,153.4,138.5,161.6,142.5,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,139.1c1.5,0.6,4.5,4.8,5.1,1.9C14.3,138.9,5.2,134.5,9,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,83.4c-3.2,1.6,2.7,3.5,3.2,5.3C39.8,87.7,34,84.2,32.9,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,114.5c-4.1,2.1,2.9,3,4.3,3.5C14.7,115.8,10.4,114.6,8.8,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.1,84.7c-0.5,1.3-2.5,2.3-0.9,3.6c2.2-1,3.9-8.4,1.4-8.8C79.5,81,80.8,83,80.1,84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,137.4c1.5-0.7,0.6-1.9-0.4-2.6C43,127.3,44.5,136.4,49.2,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,112.1c-0.9-1.6-5.1-5.2-3.8-1.3C18,113.1,23.6,117.2,20.6,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.5,1.2c-3.7,4.2,2.1,1.8,3.8-0.2C149.7-1.1,144.2,0.1,143.5,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.2,141.7c1.6,0.4,3.9,3,5.4,1.9C58.5,141.6,48.3,137.8,51.2,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,61.7c-2.6-0.4-4.4,0.6-1.7,2.4C34.4,65.1,38.1,61.4,32.5,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.3,53.6c-0.1-0.1-0.2-0.1-0.3,0C61.1,66.5,67.2,66.8,63.3,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.7,104.6c-0.3-5.5-3.7,5.9-0.7,6.4C63.7,109.9,60.5,106.8,61.7,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.9,160.7c1.4,1.3,6.9-5.9,3.8-5.8C200.4,156.1,196.6,158.7,197.9,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.5,32.3c-1.3-1.8-9.6,0-5.2,1.8C173.7,33.6,178.5,34.7,177.5,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.7,87.7c4.7,1,4.8-13.2-0.3-1.1C3.3,87,3.2,87.6,3.7,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.3,151.1c2.7-12.6-5-6.9-0.1,0.1C118.1,151.2,118.2,151.2,118.3,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.9,11.1c-2-0.6-6.8,5.7-3.5,5.6C182.1,14.7,187.1,13,184.9,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.3,119.4c-0.4-1.1-2.5,0.1-3.5-0.1C60.9,119.2,74.7,124,75.3,119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.4,141.8c1.6-0.4,3.5-6.5,0.8-6.3C206,136.6,204.4,140.9,206.4,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.5,2.8c-1.7-4.7-3.4,3.5-1.6,5C135.4,7.7,134.4,4.5,134.5,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.1,88.9c-1.6-0.7-3.6-3.2-5.2-1.7C132.6,89.1,142,93.2,139.1,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,6.6c0.8-2-2.3-1.4-3.4-1.4C76.7,1.9,85.4,10.3,88,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,31.4c-0.1,1.4,1.5,7,3.2,4.1C78.7,34,77.7,27.8,75.5,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.1,14.9c-1.6-0.2-8.2,3.4-4.2,4.4C149.2,18.1,153.9,17.2,152.1,14.9L152.1,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.3,45.7c-2-2.5-6.3,4.7-2.8,4.4C163.2,49.3,167.1,46.3,165.3,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.8,14c-4.2-1,1.2,9.1,2.5,4.6C31,17,29.4,15.6,28.8,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.1,8c-0.4-0.2-0.6-0.8-0.8-1c-3.3,1.6,1.7,4.1,3.1,5.1C75.7,11.4,71.5,8.6,70.1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,79.8c-1.3,1.8,3.9,2.4,4.4,4.5C46.2,84.3,38.8,78,37.2,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.5,3.4c-2.2,0.1-3.1,3-0.5,2.6c0.9-1.1,5.7-1.7,4-3.4C20.8,1.6,19.6,2.8,18.5,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.1,65.8c-2-1.1-6.6-2.1-7.3,0.7C124.1,65.6,129.7,69.5,129.1,65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.1,89.8c1.5,0.3,5.3,2.1,5.2-0.4C113.5,87.9,103.3,86.4,110.1,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,18.4c0.7,1.8,1.2,6.7,2.8,2.3C70.1,17.6,65.8,12.7,66.7,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.2,87.7c-1-1.3-7.1-0.7-6.7,1.6C87.9,89.8,92.8,89.6,93.2,87.7C93.2,87.8,93.2,87.8,93.2,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.3,56.3c-0.8-1.8-1.8-8.3-4.1-7C137.7,50.3,140.9,60.5,141.3,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.1,120.3c1.6,0.4,5.7,1.2,3.8-1.6C114.5,117.1,108.2,118.6,113.1,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.7,53.9c-1.2-0.5-2.2,1.2-3.3,1.6c-0.4,0.3-1.5,0.1-1.6,0.8C177.1,60.1,186.1,55.5,182.7,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,40.3c-1.7,0.3-3.7-0.1-5.4,0C56.6,43.6,68.1,43.5,65.3,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,37.6c-3.5,0.2-4.2,3.9,0,2.2C60.1,38.7,61.4,33.9,56.6,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.1,110.4c-0.7-0.9-2.7-6.6-3.1-3.5C93.2,109.8,98.9,118.6,96.1,110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.9,11.6c3.8-0.8,0.1-11-0.6-3.9C126.2,9.3,124.5,11.1,126.9,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.6,95c5.5-0.1-6.7-6.9-4.5-2.4C132.4,93.8,134,94.4,135.6,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,50.7c-2-0.9-1.7-7.1-3.6-5.9C84.1,46.9,87.9,55.4,88.7,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,131.2c-4.3,2,10.5,5.8,4.5,1.7C18.7,132,16.9,131.9,15.5,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,43C17.9,51.7,8.8,36.8,7.3,43C7.2,42.8,7.2,42.9,7.3,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.6,75.8c1.5,2.1,2.4-0.7,3.6-1.6C164.1,69.3,155.6,72.4,156.6,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,64.3c2.6-0.7,0.5-4.7-0.1-6.4C13.9,56.6,16.1,63.4,17,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.9,10c-1.4,1.6-0.7,6,1.2,2.7C115.5,9.8,114.1,4.8,111.9,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142,150.9c2.9,3.1,0.8-7.6-1-6.7C140,145.7,141.4,149.2,142,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.5,3c-0.7,1.3-2.2,1.5-3,2.3c-2.4,3.1,2.7,2,3.7,0.3C14.3,4.8,14,1.6,12.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1,26.4c-4.8-6.1-5.2-1-0.9,2.3C32.5,28.6,33.3,27,32.1,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,139.1c0.2-1.7,4.9-5.5,1.7-5.8C119.4,133.7,115.7,141.6,119.2,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,94.6c0.3,2.1,8.5,5.5,5.8,1.9C31,96.3,28.2,92.7,27,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,105.8c-1.4-1.9-10.4-5-4.7-0.8C14.5,105.6,17.4,108.4,17.9,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.4,8.8c-1.8,0.5-5.9-1.7-6.8,0.2C75.7,10.6,84.5,12.4,82.4,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.9,138.4c0.6,1.7,1.6,5.8,3.6,5.8C34.5,143.1,31.2,135,29.9,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,136.7c-1.5-4.5-5.8,5.4-1.7,4.5C197.8,140.2,197.6,138,198.4,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,27.1c-2.6-3-4.4-0.3-0.6,2.1C12.9,32,13.2,28.1,9.3,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.9,18.8c-0.3-0.7-1.4-0.2-1.6,0.4C34.7,26.1,40.8,26.3,34.9,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.4,92.6c-2.1,1.9,3.8,3,4.8,4.2C99.8,94.4,94.4,92.6,92.4,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,24.1c-0.2-1.5-2.3-6-4.1-4.6C14.6,20.8,18.6,26.9,19.4,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.6,0.6c0.4,0.1,1-0.3,1.2-0.6C44.4,0.1,41.4-0.3,43.6,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.8,154.5C61.7,162.2,52.1,148.2,50.8,154.5C50.8,154.3,50.8,154.4,50.8,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.3,20c3.6,3.8,1-3,1.4-4.9C125.9,12,126.6,18.6,127.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.7,66.2c-2.2,0.2-3.5,4.9-2.3,6.1C201.2,73.8,202.3,67,201.7,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.2,80.8c1.5,0.5,9.4-0.3,5.2-2.4C103.6,79,99.4,77.9,100.2,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,79.2c1.3,1,5.7,4.2,6.4,1.6c0-0.7-8.4-4.5-6.7-1.8C18.5,78.9,18.6,79.1,18.8,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,160c1.5,0.4,6.4,3.9,5.6,0.5C33.4,159.7,25.6,156.5,28.9,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.7,14.1c-5.5-3.2-0.3,5.1,2.2,3.8C19.7,16.3,15.8,15.3,15.7,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.7,49.8c0,0.5,0.4,1.1,1,0.9C45.7,46.7,40.8,36.2,41.7,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.5,126.9c2.9-4.1-10.1-3.3-4-1.1C89,125.7,90.1,127.6,91.5,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.7,153c0.9,0.9,4.1,5.7,4.9,3.2C6.5,154.1-1.3,148.4,1.7,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,81.7c-3.1,0.7,5.6,8.1,4.6,3.6C39.4,84.4,37.9,81.2,36.3,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157,140.6c0.2,2,8.3,2.4,5.6-0.7C160.9,140.7,157.8,138.4,157,140.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180,111.3c1.6-2.3-3.9-3.7-5.3-4.9C172.6,108.5,178.4,110.6,180,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,20.6c-0.6-1.5-2.2-5.2-3.4-2C90.9,21.1,95.5,25.4,94.1,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.8,165.4c1.1,0.3,4.6-6.6,1.9-6.2C136.4,160.3,133.2,164.6,135.8,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,42.8c-2.5-0.5-2.8,4.3-3.1,6C32.5,51.5,33.5,43.8,33.5,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,6.4c0.7,1.1,3.6,4.5,4.3,2C50.1,6.3,42.8,1.4,45.9,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,123.6c1,0.7,7.3,2.7,6.4-0.2C63.4,122.8,59.4,121.2,58.6,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.9,127.7c1.8,0.3,3.8,4.1,5.1,2.2C17.1,127.6,7.3,124.2,10.9,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.6,75.7c-2.4-2.4-3.1,3-4.5,4.1C141,83.1,142.9,77.3,143.6,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.4,115.4c1.7,0.3,2.8,4.1,4.6,2.6C51.2,116,43.7,110.9,45.4,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,41.1c-0.5,1.9,1,4.2,2.8,2.3C3.2,42.4,0.8,41.6,0,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,163.1c4.1,1.3-3.1-7.1-4.4-4C50,160.9,52.4,161.9,53.8,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,49.9C0.3,49.6,0.2,49,0,48.5c0.1,0.1-0.2,3.3,0.2,3C0.8,51.4,1.4,50.2,0.7,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,106.1c-6,0.3,1.5,2.1,2.8,3.5C16.1,111,10.8,106.1,9.3,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.7,15.1c1-0.9,4-3.6,1.2-3.9C145.9,11.7,143.4,19.1,147.7,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,148.3c-1.4-1.4-4.8-4.6-6.8-3.2C23.2,146.1,29.3,150.9,29.6,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.8,146.6c4.3-0.2,4.5-3.6,0-2.1C148.8,145.1,148.3,149.1,151.8,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.9,33.1c-6.8,10.1,0.7,8.3,0.3-0.3C154.2,33.1,154.1,33.1,153.9,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132,67.3c-1.2,1.7-5.1,5.9-4,7.7c1.2,0.5,1.7-1,1.7-1.8C130.3,71.8,133.6,68,132,67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,30.9c-1.6-4.7-3.1-5.4-3.6,0C86.2,30.7,88.7,34.1,88.6,30.9L88.6,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.2,154.8c2.2,1.7,2.8-3.3-3.7-2.3C165.1,154.8,169.7,154.9,171.2,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,0.2c0.3,1.2,1.8,0.9,1.9-0.2C57.8,0.1,55.7-0.2,56,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,124.5c6,0.7,0.4-2.5-2-3.3C93.8,121.7,97.6,124,99.1,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.9,0.6c1.8-1.1-2.1-0.4-2.3-0.6C24,0.8,25.1,1.1,25.9,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115,68.2c1.4-0.2,6.9,1.3,5.8-1.1C119.5,66,113.3,65.4,115,68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,139c-1.1-1.4-4.4-3.2-3.8-0.2C61.7,140.7,67,143.6,63.8,139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,20c-0.8,1.4-4.6,5.5-1.7,6.1C135.2,24.6,138.9,21,136.1,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.5,61.7c0.9,4.9,3.4-3.9,2.1-5.6C148.4,54.9,151.3,60.7,149.5,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.9,138.9c0.4-1.4,3.1-5.5,1.9-6.3C112.9,132.4,109.7,139.3,112.9,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,0.6C18.5,1,19,0.3,19.4,0H17C17.3,0.3,17.6,0.5,17.9,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.7,92.1c0.2-0.6-0.8-1.6-1.3-0.9C172.4,95.5,178.8,97.8,180.7,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.1,154.2c-1.6-4.1-2.7,4.5-1.9,5.2C126.9,160.5,125.9,155.7,126.1,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.3,36.9c1.4,0.7,3,1.1,4.4,1.9C187.9,37.8,176.8,32.4,179.3,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.4,125.9c1,2.8,3.7,2.1,2.1-0.6C93.3,120.7,89.9,120.9,93.4,125.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.8,11.7c-0.4,5.6,4.7-3.2,2.3-4.1C115,6.5,115.4,10.6,114.8,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,133.1c1.1,0.8,2.2,2.2,3.4,2.7C58.4,133.7,47.1,128.5,51,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.6,135.3c3.9,0.6,1-9.1-0.6-4.9C191.2,132,188.6,134.4,190.6,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.6,5.4c-1.3-1.4-0.6-5.1-3.1-5.3C125.6,1.2,131.5,10.1,130.6,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5,119.6c0.2-2-3.8-1.5-4.5-3.3C56.7,116.8,64.7,122,65.5,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,61.3c-0.9-1.4-0.9-5.1-2.8-5.1C65,58.4,71.8,68.3,69.4,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.6,151.2c1.6,0.1,3,1,4.5,1.2C169.7,149.6,158.2,147.8,161.6,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.2,75.5c1.8-0.2,4,1.6,5.4,1C40.9,73.7,29.3,72.9,33.2,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.1,137.9c2.3,0.9,1.8-3.9,3.2-5.2C137,129.3,133.8,136.7,135.1,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.8,41.6c1.4-1,3.6-2.1,3.7-4C131.9,35.8,123.7,42.5,128.8,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.6,147.8c-2.1,2.1,3.5,3,3.6,5.2C19,152.9,13.4,147.2,11.6,147.8L11.6,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,131.6c1.2,0.8,4.3,5.1,4.1,1.4C26.8,130.8,20.1,126.9,23.5,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,122.9c4.4-1.9-6.7-4.7-5.1-0.9C35.1,122,36.8,122.8,38.5,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.9,79.6c-3.8-0.8,2.4,6.6,4,4.3C16.5,81.9,12.7,81.2,11.9,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.4,1.4c3.7,6,5.6-1.5-0.1-1.3C46.4,0.5,46.4,0.9,46.4,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.6,72c-1.1-1.3-5.2,0.7-5.5,2.1C176.3,76.2,182.8,73.7,181.6,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,148.3c6.8,4.2-0.3-3.4-1.6-4.3C29.6,144.9,31.4,148,32.8,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.6,88.2c-3.3,1.1,2.6,3.8,3.9,3.6C125.4,90,120.9,88.5,119.6,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,128.9c1.7,0.9,6.6,1.9,5.5-1.2C71.8,128.4,65.8,126,67.5,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165,37.7c4.2-1.7,4.5-5-0.3-1.9C161.3,37.6,161.4,40.5,165,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.2,114.7c-0.9-0.6-1.7-2.3-2.6-2.2C74.2,115.3,86.4,120.6,80.2,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,140.8c1.3-2-5.1-8.9-4.2-4.3C25.9,137.2,26.4,142.1,28.3,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.2,41.1c-3.6-1.2-3,2.6,0.1,2.3C98.1,43.2,98,40.1,94.2,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.4,117.2c1,0.4,1.9-1.4,0.9-1.9C63.7,111.9,62.3,115.5,68.4,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.4,101.3c-1.2,0.1-4.5,0.5-4.3,1.9C199.4,106,206,103.3,203.4,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.3,158.3c0.2,1.7,1.8,6.6,3,2.9C80.2,159.4,77,153.3,77.3,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,138c1.7,0.1,3.5,1.1,5,0.8C92.3,136,83,135.3,85,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.4,91.9c-1.6-0.1-4.8-1.8-5.5,0.2C8.1,93.8,16.4,94.7,13.4,91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.5,114.4c4.1-1.2-2.6-3.1-4-2.6C150.3,114.4,153.8,114.6,155.5,114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104,147.5c3.2,1.1,1.3-5.8,0.5-7.3C102.2,141,104.7,145.6,104,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,142.8c1.3,1.1,8.6-1.4,5.7-3C82.4,141.1,78.8,140.5,78.4,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,56.8c-3.2-4.3-2.6,1.7-0.5,3.7C24.4,61.1,23.8,57.8,22.8,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,5.4c-1.4-0.5-3.1,0.9-4.6,0.5C184.4,9.3,195.2,7.8,192.4,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.1,23.5c1.7,1,2.3,4.9,4.6,4.2C53.9,26.7,48.1,19.8,48.1,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.8,150c1.8-4.7-1.9-4.1-1.8,0.1C89.8,153.8,93.2,153.8,92.8,150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.5,112.1c-1.3,0.1-6.4,1.4-3.9,2.9C139.9,114.6,146.4,113.5,142.5,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.7,47.6c-3.3-2.2-0.1,6.3,1.3,6.1C74.3,52.2,72.2,49.3,71.7,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,22.7c-1.4-0.4-2.1-3.1-3.6-2.7C69.3,22,77,27,76,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.4,52.5c-2.6,1,1.4,3.5,2.3,4.5C8.6,57.1,4.3,52.7,2.4,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.9,0.2c0.2,0,0.2-0.1,0.3-0.2h-1.1C85.4,0.1,85.7,0.1,85.9,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.8,34.3c-0.8-1.1-4.5,0-2.6,1.2C64.9,38,70.2,36.4,64.8,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,37.8c-1.7-0.4-2.8,1.9-1,2.2c1.7-1.2,3.7,2.2,4.8-0.1C39.8,38.5,36.8,37.7,35.7,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,143c0.7,1.4,3.2,2.9,3.1,0.3C40.4,140.1,35.4,138.5,38.6,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,130c-1.1,1.5-1.4,5.6,1.2,3.2C208.3,131.2,206.9,125.5,205.3,130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.3,128.9c-0.5-2.8-3.5,1.4-5.3,1.2C180.8,133.6,188.3,130.6,188.3,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,146.7c3.4-2.4-6.6-4.6-4.4-1C159.4,146,160.8,146.4,162.3,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,97.8c-0.3,1.7,1.9,1.3,3,1.6C99.8,99.9,93,95.9,90.5,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.3,93.8c1.6,0.2,7.4,1.3,6-1.4C120.4,92.3,111.6,92.3,115.3,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.3,152.9c-0.8-1.1-5.9-4.9-5.6-1.8C33.3,151.5,38.1,156.9,37.3,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.4,161.5c1.6,4.9,2.5-0.8,1.5-2.9c-1.2-3.5-2.5,1.1-1.6,2.8C129.3,161.3,129.4,161.4,129.4,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.3,130.7c-1.6-2.5-10.5,4.1-3.6,2.1C80,132.2,82.4,132.5,82.3,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,123.3c-2.8,2.1,2.4,2.4,2.8,4.5c3.5-0.1-0.9-3.8-2.3-4.3C15,123.3,15,123,14.7,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.6,116.4c-1.3-1.2-2.4-3.3-3.9-4C69.1,113.1,75.2,119.8,75.6,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.8,159c3.2-0.9,0.3-13.3-0.2-3.2C107.8,156.8,106.1,159.2,107.8,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.2,127.9c-1-0.6-2.4-2.4-3.6-1.7C4,128.8,12.6,132.8,9.2,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.5,158.4c1.5,0.6,4.6,4.5,4.6,1.2C175.9,157.9,171.1,155.2,171.5,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,40.9c-2.5,6.3,4.4-1.8,4.1-3.4C31,37.3,29.3,39.5,28.6,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.3,157c0.9,0.8,5.9-4.4,3.3-4.7C139.3,152.8,135.6,155.8,137.3,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.8,134.3c1.1,1.2,0.9,3.5,2.5,4.2C102.9,138.3,96.6,130.1,96.8,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.8,54.8c1.5,0.2,5.8-3.5,2.9-4.2C44.4,51.7,40.6,52.8,42.8,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.3,156.2c2.1,1.1,4.5-5.9,2.2-6c-1.1,0.3-0.8,1.7-1.1,2.6C101.7,154.1,99.1,155.5,100.3,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.7,126.6c1.4,0.6,4.5,4.7,4.7,1.3C107.7,126.4,103.3,123.5,103.7,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,69.2c-2.1-1.4,0.1,6.6,1.5,6.7C31.7,75.2,29.2,70.2,28.5,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.6,64c-1.6,0.3-2.6-4.2-3.3-1.7c-0.4,3.9,7.4,5.6,3.5,1.6C27.8,64,27.7,64,27.6,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,74c-3.4,7.4,2,1.6,2.3-2C71.8,68.3,70.4,72.9,69.8,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.4,127.3c4,1-2.6-6.2-3.1-3.1C32.5,126,35.4,126.4,36.4,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.3,23.7c-0.5,2.2,8.7,7.8,4.5,3C112.3,25.8,111.3,23.2,109.3,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.7,130.5c1.6-0.4,4.8,1.8,4.8-0.8C90,127.9,83.1,128.4,85.7,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.6,121.3c-6.1-5.3-0.5,4.2,2.1,3.4C20.5,123.4,18.3,122,17.6,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.6,84c-0.5,1.1,1,5.9,1.7,3.2C153.5,84.5,152.3,76.8,151.6,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,89.3c-7.4-2.1,0.7,4.7,2.5,1.4C109,89.4,106.9,90.1,106.2,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,132.7c2.4,4,3.5,0.1,0.6-1.9C4.9,128.3,4.2,131.5,7.2,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.8,47.7c-5.4,2.7,0.5,12,0.2-0.1C155.9,47.7,155.8,47.7,155.8,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.7,154.1c-1,1.6,2.9,3.3,3.7,4.7C22.5,157.7,17.2,154.2,15.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,37c3.6-2.1-4.2-2.7-5.3-1.9C112.8,37.2,116.6,36.4,118.1,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.3,4.7c-1.3-0.5-6.1,2.1-3.8,3.8C152.9,8.5,156.3,6.6,155.3,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,101.2c-2.7,2.5,3.7,2.8,4.6,0.9C40.5,99.7,37.5,101.2,36,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.5,122.9c-1.3-0.6-4.5-1.3-5.1,0.5C200.2,124.7,207.3,125.6,204.5,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184,164.6c2.1,1.7,2.4-4.2,2.1-5.2C184,158.3,183.6,163.4,184,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.9,157.9c-1.3,0.2-4.2-1.3-4.1,0.9c0.6,1.7,6.4,1.8,4.5-1C161.2,158,161.1,157.9,160.9,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.8,119.3c1.3,0.6,4.6,4.2,5.1,1.4c-1.1-0.7-5-4.2-5.4-1.7C84.5,118.9,84.6,119.2,84.8,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,1.7c1.1,0.3,1.7-1,1-1.7c0,0-2.7,0-2.7,0C61.2,0.6,61.5,1.3,62.3,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.6,13.9c0.5-2.2-2.8-2.8-2.2-0.5c1.1,0.9,0.2,3.1,1,3.7C64.5,17.5,63.9,15.2,63.6,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,13.4c-1.3-0.7-4.1-3.2-4.7-0.7C16.6,14.2,20.7,16.5,20.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.5,130.7c-1.9-2.9-7.2,4.7-3,4.3C93.8,133.1,95.3,131.7,96.5,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.8,80.4c-1.4-0.7-7.1,1-3.9,2.5C165.3,82.7,169,82.5,167.8,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201,121.1c2.5-2.9-7.3-2.3-4.8,0.1C197.7,121.4,199.4,121.2,201,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185,155.2c2.9-1.8-2.1-3.4-3.6-3.9C179.7,152.5,183.8,155.1,185,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,127.3c1.4,2.8,3.2,0,1.2-1.6C52.3,121.8,50.5,125,53.7,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,102.3c-1.5-0.1-3-0.9-4.4-0.9C28,104.3,37,105.7,34.3,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,11.3c0.1-0.5-0.7-1.6-1.2-1C132.6,16.2,136.6,20.1,136.1,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.6,87.3c-1.6-1.7-2.9,1.9-3.8,3C195.5,93.3,199.8,88.7,198.6,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,103.4c-6.1-1.4,1.6,5.4,2.9,2.3C30.2,104.8,28.9,103.7,27.9,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192,119.6c-1.1,0.7-7,2.8-3.5,3.6C189.9,122.6,194,121.7,192,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.1,108.2c-1.5-6.3-4.3,4.4-0.2,3C187.1,110.3,186.8,109,187.1,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,14.3c-0.8-0.5-2.3-2.1-3.2-1.4C198.6,15.9,207.7,17.9,203.2,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.4,134c1.8-2.1-5.3-1.8-5.7-1C166.9,135.1,170.8,133.9,172.4,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.2,159.7c0.9,0.8,0.6,3.8,2.1,2.9C5.9,159.6-0.7,153.4,2.2,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.3,150.9c-0.4-1.5,0-5.3-2.5-4.4C186.3,147.7,187.4,153.1,189.3,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.2,115.2c2.1,2.4,5.9-5.5,1.9-2.8C183.1,113.1,181.2,113.6,182.2,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.6,150.6c1.8,0.9,6.1,0.2,3.7-2.3C158.1,148.7,153.9,148.5,155.6,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.3,30.6c2.5,2.2,3.8-4.4,0.8-4.5C47.1,27,49.5,29.2,48.3,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.8,138c2.3-4.3-3.6,0.1-4.1,2C141.7,142.4,143.8,138.8,144.8,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,36.7c0.7-4-7.2,0.8-3.7,1.8C140,37.8,141.8,37.6,142.6,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.7,145.8c0.4-1.3,0.2-3.1,0.7-4.5C113.9,137.3,111.1,148.8,114.7,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.8,146.4c-3.3-0.5,3.5,8,2.9,3.8C4.8,148.9,4.1,147.4,2.8,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.8,76.9c1.7,0.2,2.9,5.4,3.8,2C44.7,76.8,38.6,73.1,40.8,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.3,142.3c-0.2-1.1-2.3-3.9-3-1.9C174.2,142.9,179,146.9,177.3,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4,163.1c1.8,3.9,2.3-1.4,1.6-3.3C114.9,158.2,115,161.6,115.4,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.9,150.4c1.5,5,3.6-3,0.5-3.4C145.8,147.3,147.3,149.4,146.9,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.6,140.7c3.6,3.6,1.6-6.3-0.9-3.7C178,138.2,178.3,139.5,178.6,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.8,30.7c-3.2-4.4-2.8,2.6-0.3,3C191.4,33.4,191.7,31.2,190.8,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,42.9c-1.1-0.4-3.4-4.9-4-2.5C86.2,42.1,92.1,47.7,89.8,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,63.7c-1.8,0.3-2.8,7,0.1,4.3C152,66.8,154.1,63.8,152,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.8,164.9c2.1-0.3,1.4-3,2.5-4.5C144.7,157.5,142.5,163.9,143.8,164.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.7,146.4c-0.5-3.9-3.3,2.9-3.1,4C100,151.5,99.7,147.6,100.7,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.6,113.4c1-0.9-0.4-8-2.1-5.4C49,109.1,48.9,115.1,50.6,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.7,152.1c1.2,0.2,2.5,2.1,3.5,1.5C177.1,150.8,169.4,148.6,171.7,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.4,125.7c-4.2,2.6,1.9,2.3,3.3,0.1C187.6,122.7,184.7,125.1,183.4,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.2,111c-1.5-0.3-2.6-1.6-3.9-2C305.9,110.4,314.7,114.5,313.2,111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.9,0.4C0.9,3,4,0.9,4.7,0C4.4,0.1,1.7-0.4,1.9,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.3,151.5c4,0.4-3.6-6.2-3.4-2.4C174.4,150.4,176.4,150.5,177.3,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,10.8c1.3-0.3,6.1-2.8,2.8-3.3C5.9,7.8,1,10.1,4.3,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,1.9C0.2,1.3,0.6,0.6,1.1,0C-0.4-0.4,0.1,1,0,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,31.7c-3,2.3,5.4,0.4,5.6-1.3C130.1,27.6,126.3,32.2,124.6,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,98.9c-4.7-0.7,1.4,4.1,3.3,1.4C34.5,98.5,32.4,99.3,31.2,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.4,132.6c-1.1-0.1-3.8,0.4-4.7,1.2C174,136.3,181.3,134.8,179.4,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.6,157.9c-0.9-3.5-2.9,3.6-1.5,4.7C183.2,163.3,182.7,159.2,182.6,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,106.2c-0.8-1.2-3.6-1.4-2.8,0.6C23.6,108.6,28.1,109.3,24.5,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,121.5c1.7-0.4,0.7-2.4-0.4-3.2C0.2,118.7-0.2,121.5,0.5,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.2,144.5c-3.3-1.9-3.4,6.6-0.8,3C196.4,146.5,198.3,145.3,197.2,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,69.7c1.2,0.4,3.7,1.2,4-0.5C106.6,67.5,99.9,67.1,102.9,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.2,22.7c-0.6-1.2-4.1-2.4-3.6-0.2C54.9,23.6,59.9,26.6,57.2,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.7,131.5c8.9-4.2,0.4-4.6-1-0.3C116,131.2,116.4,131.4,116.7,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.2,121.6c-0.5,1.3,1.7,0.6,2.3,0.7C85.2,122,77.8,118.7,76.2,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.5,159c0.2-1.2,2.6-5.5-0.2-4.7c-0.4,1.3-2.3,5.5,0.2,5C187.4,159.1,187.4,159.1,187.5,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125,166.1c1-0.9,1.4-2.6,2.2-3.8C126.1,159.2,122.2,166.1,125,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,82.3c-1.5-1.1-4.6,3.3-2.2,4.1C146.1,85.1,148.3,84.1,147.4,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110,17.2c-0.9,0.5,2.1,5.2,3.3,4.5C113.9,20.3,112,16.9,110,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,71.2c1,1.1,5.3,3.2,4,0C42.4,70.9,38.9,68.7,39.5,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148,142.9c-1.1,3.4,6.2-0.4,3.3-1.9C150.3,141.5,148.7,142,148,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.8,155.3c-2.9-5-2,3,0.3,3.5C151.9,158.7,150,156.3,149.8,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,35.4c0.6,5,2.9,1.2,2.1-1.8C196.8,31.9,195.3,34.2,195.6,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.7,138c3.4-1.9-7-2.9-5-0.4C153.2,138.1,155.1,137.6,156.7,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,36.1c1.2,0,2.3,2.3,3,1.3C17.4,34.9,11.4,32.3,12.4,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.9,146.2c-2.2-2.5-2.3,4.2-0.5,4.2C127.4,150.2,125.7,147.5,125.9,146.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,142c1.4,0.1,3.2,2.8,3.9,0.7C22.3,140.7,14.7,138.8,18,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.3,13.2c2.2,2.6,2.2-3.1,0.4-3.7C36.7,9.4,37.8,12.2,38.3,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102,162.1L102,162.1c3.1-1.2,1.9-8.3,0-3.1C102,160,100.3,161.7,102,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,115.1c-1.6,1.1,1.1,2.2,1.8,3C27.4,118.4,23.9,114.6,22.6,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,69.4c0-4.5-2.6-2.6-1.5,0.8C14.6,74,17.1,71.8,16.3,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,14.3c-0.1-1.1-2.7-3.1-3.7-2.1C43.1,13.4,46.9,16.8,47.5,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.1,23.6c-1.6-2-2.7,0.8-1.1,2.1C47.2,28.7,47.6,25.5,46.1,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,105c2.3,5,3,0,0.6-2.1C42.7,101.4,42.4,104.2,44,105z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.9,20.9c0.6,0.8-0.6,3.7,1.4,2.4C29.7,20.5,25,16.9,25.9,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.9,93c0.4-0.6-0.8-5.2-1.6-4.9C74.9,88.9,76.2,94.8,77.9,93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.5,3.2c-5.1-2.1-1.6,2.9,0.9,2.5C188,4.8,187.4,3.5,186.5,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.3,37.3c-1.3-4.2-3.1,5-0.2,3.9C27.8,40.1,26.9,38.5,27.3,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,153.2c1.2,0.4,1.7,3.2,3,2.4C10.4,153.4,4.5,149.5,6.1,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,156.5c-1.3-0.2-2.5-1-3.7-1.1C20.3,157.4,28.5,159.5,26.9,156.5L26.9,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.7,158.2c-0.9-0.4-2.1-0.6-3.1-0.9C150.1,159.2,158.4,161.9,155.7,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.8,147.8c0.8-8.1-5.1-2.8-0.3,0.2C85.5,147.9,85.7,147.9,85.8,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.1,128.9c1.1,0.4,1.9,2.5,3,1C52.9,127.6,47.9,125.8,49.1,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.2,21.7c-0.1-1.8-2-1.1-1.9,0.4C85.5,25.3,89.6,24.6,87.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3,14c2.2,2.5,2.4-4.6,0-3.2C65.2,11.8,66.3,12.9,66.3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,28.9c-1.2,0.6-3.6,5-1,3.7C133.9,31.8,136.3,29,134.1,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,3.3c-1,3.2,9.4-0.7,1.9-0.5C5.8,2.8,5,2.9,4.5,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.7,131.8c2-0.5,1-3.1-0.2-4C37.4,128.4,39.3,131.2,39.7,131.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.5,18.4c2.1,2.8,3.3-3.5,0.6-3C114.6,16.1,114.7,17.6,114.5,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,135.4c1.9-1.7-5.1-2.6-4.3-0.7C160.9,135.5,162.6,135.2,164,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.3,119.6c-0.8-0.2-3.5,0.8-3,1.9C185,122.8,189.7,121.1,187.3,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,64.3c-1.8-2.7-2.7-5.9-3.4-9.1C305.1,52,315.6,73.3,314.8,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,59.3c-0.7,0.3-0.3,1.3-0.1,1.9L315,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,117.2c-2.2-0.6-1.1,2.1,0,2.7L315,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.4,105.6c-5.9-9.4-2.7,3.9,1.7,4.7C317,109.1,312.9,107.1,312.4,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,153.8c-1.4,0.4-4.4,2.8-2.5,4.1C314.2,158,315,155.2,314.9,153.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,134.2c-1.6,0.6-9.2,2.3-5.1,3.8C311.9,136.7,316.2,137.6,315,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,73.9c-3.7-4.3-1.1,3.4,0.3,5C315.1,78.6,315.2,73.9,314.8,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.8,141.6c0.2,0,2.1-0.1,2.2-0.1c-0.1-0.4,0.3-2.3-0.4-1.9C308.5,138.7,304.4,143.5,312.8,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,81.9c-5-4.5-3.6,1,0,2.7C315,84.6,315,81.9,315,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,34.3c-3.1-0.4-1.3,4.6-3.3,5.7C309.5,44.6,317.5,39.1,314.9,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.5,0.3c0.5,0.2,1.1,0.1,1.5-0.3h-1.8C310.3,0.1,310.4,0.2,310.5,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.5,24.3c-0.9,3.2,3.7,1.7,5.4,3C315.9,24.1,311.6,23.4,309.5,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,42.5c-2.9-1.1-2.1,7-0.1,7.2C315,49.7,314.8,42.3,315,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.5,150c-1.3,1.4,1.1,2.8,0.5-0.2C314.9,149.9,314.7,150,314.5,150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,5.9c-2.1-0.9-2.1,1.8-0.1,1.8L315,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,127.1c-1.4-0.7-4.1-3.4-5.3-1.6c-0.7,1.5,1.5,1.3,2.2,1.9C313.1,128.1,315.8,129.9,314.9,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,11.6c-1.5,0.1-2.3,2.3-1.3,3.3C315.6,15.3,314.9,12.7,314.9,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.5,145.9c2-4.9-2.7,0.6-3.9,1.4C309,150.4,313.9,147.3,314.5,145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,94.5c-5.1-1.8-1.4,1.7,0.4,3.1C314.9,97.2,315.3,94.5,314.6,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.9,99.9c-2.3,1-0.3,2.7,1.2,3.4C315.1,102.2,315.5,100,313.9,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.3,131.9c-4.4,3.2,2,3.2,0.8-0.8C314.8,131.5,314.6,131.7,314.3,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,3.6c0.4-1.8-0.8-1.7-2.1-1.9C308.7,1.7,312.9,4,315,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,18.5c-1.6-0.3-1.2,2.6,0.1,2.5C314.9,20.8,315,18.5,314.8,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,150.5c-0.9-0.6-3.3-2.5-2.8-0.1C26,152.2,30.6,152.6,28.2,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.8,60.6c1.7,2.8,3.6-1.9,1.3-2.3C2.7,58.1,3,59.7,2.8,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,128.3c-1.1,1.1,1,1.9,1.6,2.7C22.9,132.8,20.1,127.2,18.2,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.8,144.4c-1.7,0.9,2.8,3.5,3.1,2.1C16.2,145.3,13.9,144,12.8,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.3,65.1c-1.4-0.5-2.3,2.6-1.1,3.4C56.5,69.2,57.1,65.9,56.3,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.3,19.7c-0.7-0.2-1.4-0.5-2.1-0.1C185.5,21.7,193.4,22.6,189.3,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105,154.7c1.3,0.5,1.4-1.4,1.7-2.2C106.9,148.8,103.4,153.5,105,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.2,95.1c-1.1-1.7-4,0.1-2.1,1.4C90.2,96.8,91.8,96.5,91.2,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.7,63.1c-1.6-1.8-1.7,2.3-0.5,2.9C79.9,66.5,79.5,63.8,78.7,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4,132.5c0-1,0.3-3.1-1.3-2.1C131.7,131.3,133.7,134.8,134.4,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.4,164.4c-0.8,0.7-0.5,2.5,0.5,2.8C63.3,167.3,63.2,162.5,61.4,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,133.8c-2.3-1.3-1.6,1.9-0.1,2.4C30.8,135.9,30.4,134.3,29.7,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,166.5c0.6,1.2,2.1-0.2,1.3-1.1C15.9,163.3,13.8,165.2,16,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.9,105.8c1.4,0,0.9-3.1-0.2-3.3C176.5,102.8,177.2,105.2,177.9,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,4.2c0.9-1.6-1.2-2.9-1.7-0.9C115.8,4.2,117.6,5.2,118.1,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.2,131.9L107.2,131.9C107.2,131.8,107.1,131.9,107.2,131.9c-0.1,0.1-0.2,0.2,0,0.2 C107.2,132.1,107.2,132,107.2,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,123.1c0,0.1,0,0.1,0.1,0.2C15.4,123.2,15.4,123.2,15.3,123.1L15.3,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,112.6L87.1,112.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.9,164.7c14.1,6,1.6-4.4-3.8-2.6C213.1,165.2,220.3,163.3,222.9,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.4,164.1c7.9,1.5-4.8-7-7.5-6.7c-1.9,3.6-1.2,0-3.1,1.5c-1.7,2.1,2.2,2.5,3,4c1.3,1.6,3.3-1.2,1.3-1.9 C303.1,157.8,310.3,163.4,311.4,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.9,96.6c-6.2,9.9,0,8.9,2.6,0c4.6-2.7,3.7-0.6,5-7.3c-0.5-6.6-3.1,4.1-4.1,5.8 C240.5,95.4,238.6,95,237.9,96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.1,78.8c-0.9,1.5-0.5,5.7,1.7,3.9c0.5,11.4,3.5-2.8,2.5-7.4c-3.1-3-2,3.8-2.6,5.3 C232.3,80,232.7,77.5,231.1,78.8z M232.9,81.8L232.9,81.8L232.9,81.8L232.9,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.3,150.8c-4.4,0.9,6.4,6,8.1,6.3c3.6-2-6.3-4.3-7.5-6.4c3.7-1.1-5.3-10.5-4.2-5.5 C281.7,146.8,285,149.3,284.3,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295,150.9c7.1,3.7-3.1-8.1-4.5-3c-1.3-0.3-3.2-5.2-4.1-1.1c1.5,3.8,9.2,9.5,3.9,1.9 C291.6,148.8,293.6,150.3,295,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,118.4c8,7.4,16.9,5,2.3-0.6c-2.2-2-0.4-2,1-3.2C252.1,110,245,116.1,247.6,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.1,44.6c-1.9-3.9-2.8,0.2-1.3,2.5c-2.9,0.6,0.8,6,1.9,7.4c3.4-0.5-0.7-3.4,0-4.7 C257.3,52.2,251.3,46.7,251.1,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.8,106.4c-0.9,4.3-4.3,8.7-0.8,12.6c4.5,0.5-0.2-3.7,0.8-5.5C231.3,111.6,235,102.5,230.8,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.1,5.8c-13.4,4.1,0.3,3.5,5.3,1.3C252.3,3.2,245,5.2,243.1,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.4,148.8c-0.5,2.3,8.3,4,4.4,0.4c-6.1-2.7,1.1-2.8-8.9-6.3C290.6,146,301.5,145.9,299.4,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.1,139.6c1.2,1.6,4.4,6,3.6,1.2c1.6,0.2,7.5,4.7,6.1,0.6C252.9,140.4,244.1,135.1,245.1,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.4,35.9c1.7-4.1-14,0.7-4.6,7.3C300,40.1,286.5,37.1,299.4,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.4,74.6c-3.1,1.6,1.7,9.4,3.4,11.4C212.9,85.2,207.2,76.5,206.4,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.4,158.8c3.5-4-16.4-8.1-11.1-4.3C273.4,154.8,277,157.4,280.4,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.7,161.1c-3.1-2.1-6.7-3.7-8.8-6.7C216.6,156.2,232.4,167.5,229.7,161.1L229.7,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.9,71.6c-2.2,8.3,4.8-1,3-4.9c0.5-2.3-3.1-4.6-2.3-1.2C257,67.6,257.2,69.9,255.9,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.7,15.8c-1.2-1.2-8-2.1-5.6,0.7c3.3,0.1,5.8,2.2,7.9,4.4C259.4,19.9,255.3,16.6,253.7,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.4,163.4c5.9,2.6-5.2-8-7.6-8.2C281.1,155.7,291.6,161.9,292.4,163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,57.2c-0.2,2.4,5.6,9.5,3.1,3.6c-0.4-1.1-1.3-2.1-1.1-3.3C303.6,48.5,297.8,49.5,296.6,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.9,50.4c2.9,6.9,2.5-5.5,3.1-7.5C224.7,42.1,226.3,47.9,225.9,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.4,11c-1.3-1.7-10.3,2.1-9.9,4.8c1.3,2.1,3.3-1.6,5.1-1.6C237.7,12.9,242.4,13.2,241.4,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.6,43.8c-3.5,0.2,0.5,4.5-0.2,6.4c-0.2,1.5,0.8,5.9,2.9,4.2C262.7,51,262.1,47.1,260.6,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233,141.5c8.2,5.4-1-3.8-0.6-7c-3.8-2.6-1.2,5.5,0.6,6.6C232.9,141.1,233,141.3,233,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.2,100.8c-19.9-3.9-2.4,7.7-7.4,0.8C265.5,101.2,273.5,104.3,271.2,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.8,147.1c1.6,1,10.2,2.9,6.1-0.7c-3.4,0.6-7.4-3.1-10.4-2.1C232,146.1,235.5,146.6,236.8,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.3,40.7c-2.2-6.7-4.3,8.3-0.3,7.9C212.5,48.2,210.9,42.5,211.3,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.6,35.7c0.3-2.8-1.1-0.9-2.3-0.2c-2.1,1.1-3.9-1-5.8-1.4C280.6,38.3,290.9,39.5,292.6,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.1,29c-0.8-1.5-4.1-4.3-3.6-0.8c1.4,1.6,9.2,9.3,9,4.1C252.5,31.7,250.2,30.9,249.1,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.1,51.2c-1-2.7,1.1-7.7-1.8-9.1c-1.9,0.9-0.3,5.9-0.6,8C280.9,52.6,285.1,54.8,284.1,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.3,0.3c-0.1,6.5,9.4,10.3,5.9,5.3C298.9,5.7,299.2-2,296.3,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.6,97.9c-2-1-3.8-8.2-6.1-5.1C300.6,95.7,310.2,105.2,306.6,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.2,157.4c1.9,0.9,4,4.8,6.2,3.4C245.2,157.9,230.7,149.7,238.2,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.1,74.2c-2.9-3-0.3,3.8,0.8,4.7c0.3,3.2,9.3,1.6,6.5-0.9C274.4,79.9,272.5,77.7,271.1,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292,45.9c-2-5.2,0.3-5-5.4-6.3c-2.7,2.3,3.1,2.2,3.1,4.7C289.1,47.3,293.3,50.9,292,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.4,51.5c-4.1,5.2-0.8,6.6,1.9,1.8C297.9,48.8,294.5,42.8,293.4,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.2,30.7c-0.5-1.6-1.2-4.1-3-1.8c0.4-2.1-3-3.9-1.9-0.9c0.4,1.5-2.9,4-0.5,4.7c2.1,0.1,1.5-3,2.8-3.5 C306.8,32.9,311.3,32.5,309.2,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.8,22.1c-1.3-1.7-6.2-5.7-7.3-2.5c2.3,1.3,4.5,2.5,6.4,4.7C246.4,25.9,247.6,22.9,244.8,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.4,117.6c-0.3-1.6-4.2-8.9-4.3-4.5c1.5,2.7,3.1,5.8,2.8,8.8C220.3,123.5,220.3,118.9,219.4,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230,48.7c0.8,2.4-0.1,5.7,1.1,7.8C235.2,58.6,232.6,43.9,230,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.3,115.6c0.1,2.1,2.8,12.7,4.6,6.5C236.6,120.3,236.4,113.7,233.3,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218,151.9c3.3-6-4-1.6-3,5.4C218.2,161.3,217.4,153.6,218,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.9,53c-0.5,2,0.2,12.2,3.5,8.8C209.2,59.6,211.8,52.7,207.9,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.7,67.5c-1.6-1.7-0.1-10.1-3.7-7.3c0,2.1,1.7,13.3,3.7,7.6C225.8,67.8,225.8,67.7,225.7,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.1,110.5c-0.7-0.3-1.7-1.6-2.3-0.6c-1.7,2.8,5.3,4.1,6.6,6.5C279,116.1,271.6,111.2,270.1,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.4,86.9c-0.1-1.8-1.8-11-3.6-6.4C218.6,82.6,220.2,93.7,221.4,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.1,164.7c3-2.7-7.1-3.6-8.6-3.7C236.4,164.2,243.8,163.9,246.1,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.3,55.2c-1.7,0.5-8.8,2.9-4.9,4.8C282.3,58.7,291.7,56,285.3,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.3,122.4c-2.6-1.1-3.8-3.9-5.3-6.1C221.1,115.1,232.3,128.3,232.3,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.5,23.2c-5.5-0.9,4.1,7,6.3,5.1C264.8,25.7,257.9,25.4,256.5,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.2,95.8c-3.2,0.1-7.5,0.3-10.8,0.4C251.7,98.7,266.6,98.9,264.2,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.8,52.2c2.8,3.9,3.2-7.8,1.5-8.6C268.6,44.7,270.3,49.6,269.8,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.8,112.3c2.4,7.9,3.5-2.9,2.4-5.8C234.1,105.6,236.2,111.2,234.8,112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,104c0.9,5.1,4.8,3.9,2-0.6c-1-2,0.9-5.4-0.4-7C293.7,97.8,294.7,101.7,294.2,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.8,84.1c0.6-1.6-0.7-1.9-1.6-2.8c-1.7-2.2,2-7.3-0.3-8.3C302.8,75.4,302.3,85.7,306.8,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.6,85.9c-1.1,0.3-2.2,3.5-0.4,2.4c2.2-2.2,5.1,0,7.5,0.6C264.4,86.6,255.3,83.8,253.6,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.2,50.1c-0.8,0.9,1,12.1,3.2,8.2C276.6,55.9,277.2,50.4,274.2,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.9,17.4c-2.1-0.5-2.6,2.1-0.2,2c2.2,0.8,3.2,4.2,5.7,4.1C237.9,22.4,231.2,17.6,229.9,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.9,139.4c1-0.6-3-5.5-3.4-7.4c-2.4-3.1-3.6,0.3-1.1,2.1C277.5,135.5,278.6,141,280.9,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.5,28.2c-7.9,1.7-0.1,3,3.5,1.8C235.1,28.2,229,26.7,226.5,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227,75.8c0.2,2.7,0,6.7,0.5,9C230.7,85.3,229.6,72.3,227,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.4,13.3c-6.1,3.2,11.6,13.8,2.1,3.8C287.4,16.2,287.4,13.9,286.4,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.4,130.6c-3-0.3-5.5-1.8-7.7-4C297.8,127.5,312.3,135.8,311.4,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.7,91.3c-4.3,0,7,5.1,7.9,6.3C273.6,96.7,263.3,91.3,261.7,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.1,79.2c1.4,4.2,5.4-6.9,4.1-7.9C251.4,70.5,251.3,77.2,250.1,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.3,98.7c-3,3.1,6.6,0.8,7,4C295.2,103.3,287.7,96.7,283.3,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.1,30.2c2.6-0.5,7.1,2.9,9.2,0.7c0.3-1.2-0.8-1-1.6-1.1C241.5,29.9,235.9,25.9,236.1,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.9,89.1c-3.4,1.9-4.9,13.8-1,5.6C234,93.1,238,89.7,234.9,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.7,34.7c-1.4-1-5.4-3.1-6.8-2c-1.1,2.5,2.9,2.5,4.6,3.1C244.1,37.3,246.1,37.5,244.7,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231,159.4c7.4,5.1-0.1-4-3.1-5.1C224.5,155.3,229.8,158.3,231,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304,111.8c-1.4-1.6-1.8-5.9-4-6.1C297.3,106.7,304.1,118.3,304,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.3,71.4c-1.4-1.5,0.1-7.4-2.8-6.4C216.8,67.7,224.1,78.5,222.3,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.3,6.1c-7.2,1.1,9,5.6,7,1C228.1,6.6,225.5,7,223.3,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.7,156.9c-0.1-1.3-5.6-8.3-6.5-5.9c-0.4,2,3,3.1,3.7,4.8C242.1,157.1,244.4,159.3,244.7,156.9 C244.6,157,244.7,156.9,244.7,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.7,87.4c2.8,0.8,6.6,6.4,9,3.7C272,90.2,261.4,83.2,263.7,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.1,91.2c0.8,1.6,1.1,5.4,3.7,4.1C216.7,92.2,211.3,80.9,213.1,91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.7,65.9c-3.9-1.5-2.9,2.2,0.1,2.6c0.1,1.3-2.5,2.6-1,4.1C269.8,73.7,271,66.4,267.7,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237,63.5c-0.1,2,4.8,2.8,2.9,0.2c-0.6-1.6,0.5-4.7-1-6.1C235.8,56.5,237.9,61.8,237,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.3,16c-1,2.9,10.2,8.7,6,3.4C284.2,18.8,282.5,14.1,280.3,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.9,72.9c0.8,4.5,3.9-3.5,3.4-5.2c0.2-1.8-3.5-3.2-2.8-0.7C248.8,68.6,247.1,71.1,246.9,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.5,109.8c8,4.4-2.2-7.4-4.7-3.5C281.8,108,285.8,108.1,286.5,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.9,105.2c-6.2-0.7,6.4,9,5.6,3.5C214.5,107.6,212.6,106.8,210.9,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.1,123.3c3.9-0.9-5.8-7.3-6.7-5.6C286.7,120,292.6,121.3,294.1,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.6,0.2c0.2,2.7,3.9,0.2,5.3-0.2C257.9,0.1,252.2-0.3,252.6,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.8,69.4c0.3,3.1,4.4,1.6,6.4,2.3C285.6,70.1,274.8,67.6,273.8,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.6,49.4c-2.5,4.2,7.2,11.2,4.5,6.3c-2.6-1-1.6-5.8-4.5-6.2C265.8,49.3,265.7,49.4,265.6,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208,115.3c-5.6-1.5,5.6,11.8,5.5,6.2C210.9,120.3,209.5,117.7,208,115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.4,152.1c4.1-1.5-8.3-12.2-6.5-7.3C264,146.3,266,149.7,267.4,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.5,92.7c-0.2,1.3,9.4,7.9,7.2,3.5C283.1,95.1,278.9,90.3,277.5,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.8,32.8c-2,0.4-8.9,1.1-6.7,4.1C207.8,35.9,215.7,35.9,212.8,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.4,89.1c-2.4,0.7-5.4-5.6-6.7-2.8C307.2,88.2,315.4,92.4,313.4,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274,163.7c5.3-1.6-5.6-3.2-7-4.7C263.5,160.8,272.4,163.1,274,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.8,93.7c0.2-2-4.5-9-4.1-4.2C288.9,91.5,292.4,100.7,291.8,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.7,70.4c-4.2-2.3-4.5,15.3-2.2,8.6C298.8,75.6,301.5,73.5,301.7,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.5,62.2c2.3,0.9,3.5-2.1,1-2.6c-2.4,0.1-3.9-0.5-4.7-2.6C287.7,58.6,291,62.9,293.5,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.6,31c-1.2,0.5-3.6,0.7-2.2,2.6c2.4,0.3,5.2-1.3,7.7-1.6C237.2,31,230.8,29.7,229.6,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.6,14c6.6-6.9-2.4-3.2-1.9-0.1C266.3,19.4,270.4,20,269.6,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.4,16.4c-3.3-3.7-0.3,4.4,0.3,5.8C309,26.3,306.2,18,304.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.6,65.2c-3.4-1.8,0.3,9.4,1.6,9.4C215.6,73.8,211.4,67.5,211.6,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.8,64.8c-4.6-1.7-2.1,2.5,0.8,3c1.1,1.3-1.3,4.4,1.3,4.4C297.9,69.9,297.8,65.5,294.8,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.7,54c0.1,2.1,0.4,9.8,3.7,6.9C255.4,58.3,256.8,50.6,253.7,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.3,73.5c1.6,4.1,4-4.8,6.2-5.4C242.5,64.1,236.2,71.8,236.3,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301,85.3c-1.7-0.1-6.3-2.6-6,0.3C297.3,87.1,308.9,89.5,301,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.7,6.2c-1.2-1.2-4-5.3-5.4-2.3C305,5.6,310.3,14,308.7,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.3,79.5c3.7-9.2-3.7-1.1-3.3,3.1C293.5,86.7,293.7,80.1,295.3,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.6,19.3c-1.9,1,0.5,3.5,1,4.8C272,32.4,269.4,20.2,265.6,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.4,49.5c-2.6-1.3-4.6,5.1-4,6.7C222.3,58.8,222.4,51.1,223.4,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.6,128.4c3.2,3,7.8,1.8,2.2-1.2C285.9,124.1,281.8,126,287.6,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.6,154.7c-2.1-0.6-4.4-2.1-6.2-3C298,154.5,309.8,159.2,307.6,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.6,12.1c-2.5-0.8-4.2-3-6.1-4.4C292.1,7.9,305.9,17.2,303.6,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.6,116.2c-1.6-0.6-6.5-3.3-5.8,0.3C280.1,117.2,290.4,120.8,283.6,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278,26c1.7,0.9,5.8,4.8,6.3,1.1C282.7,26.3,272.4,20.7,278,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.8,27.5c3.9-1-3.8-6.2-5.6-5.7C227,24.6,232.4,25.5,233.8,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.1,154.1c2,2.5,7.4-4.3,5.1-6.5c-1.5-0.8-2.2,0.7-1.5,1.9C225,151.4,222.1,152,222.1,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301,29.3c1.2-1.3,0.5-6.1-1.5-3.4c0.4,3.1-2,4.6-3,7C298.5,34.3,300.1,30.7,301,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218,41.7c-2.2-0.9-2.7,2.1-3.6,3.4C210.5,53.5,219.4,44.6,218,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.3,120.6c6.4,1.5,2.7-2.7-1.1-2.8c-3.1,1.1,0.9,10.5,0.8,2.6C273.1,120.7,273.2,120.6,273.3,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.5,17c-1.7-0.3-6.9,0.6-4.2,2.8c2.2-1.2,8.3,0.4,7.4-3.7C212.8,15.3,211.7,17.4,210.5,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.9,78.5c-2.4-5.6-2.2,5.2-1.7,6.9C216.4,87.5,214.8,80.2,214.9,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.8,111.5c-5.6-2.1,2.4,5.1,3.7,6C272.2,116.5,265.8,112.9,264.8,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,0.1c-3.8,3,5.4,1.5,6.1-0.2C227.1,0,221.2-0.4,221.2,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.9,30.8c0.2,2.3,4.7,0.5,6.3,0.9C285.1,31.2,272.4,28.5,269.9,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.1,89.5c-2.9,1.6,4.8,4,5.9,5.3C291.4,93.7,282.7,89.1,281.1,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.1,19.3c-6.2,1.4,5.6,3.8,6.2,1.6V21C219.1,18.1,214.9,19.8,213.1,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.9,116.6c-1.2-1.7-2.2-6.5-4.6-5.6C208.5,112.6,215.8,123.8,213.9,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.4,18.7c-2.5,1.7,3.9,5,5.4,5.7C254.2,22.6,248.3,18.5,246.4,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.2,69.5c-0.2-1.3-0.5-4.9-2.5-3.2c-0.3,2.2,1.1,4.9-0.1,7.1C229.3,76.2,231.3,71.2,230.2,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.9,29.4c-6.4,1.8,1.7,3.2,4.3,1.8C213.4,27.9,208.7,28.9,206.9,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.2,69.3c-1.3-0.9-6.9,10.5-2.6,7.9C244.1,75,247.3,71.2,246.2,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.6,58.5c-1.5,7.6,4.2-0.6,2.7-4.1C233.5,52.9,234.3,57,233.6,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.9,86.1c0.3,1.4,0.7,6.3,2.9,4.4C241.5,87.8,237.8,77.1,237.9,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,52.5c-3-0.9-2.1-6.4-4.8-7.1C308.6,46.9,313.8,58.6,314.6,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.3,50.3c-1,1.3-0.7,9.4,2.4,6.7C213.7,55.2,215.5,49.2,212.3,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281,65.7c-6.5,2.2,1.9,2.7,4.5,2.2C288,65.5,282.7,64.8,281,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.1,6.5c-3.2-6.9-2.3,2.2-0.6,4.7C281.9,13.6,279.8,8,279.1,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.2,92c-1.9-1.1-4.3-3.4-6.6-3.3C302.1,90.3,314.4,96.9,311.2,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.2,96.2c-0.2,2.4-2.2,4.5-3.4,6.3C225.6,105.5,231.5,92.6,226.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.1,141.1c3.7-0.5-4.2-7.5-5-6.7C285.6,137.2,290.7,139.1,292.1,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.7,99.7c-2.4-0.3-2.8,2.6-3.9,4.2C218.5,110.9,232.1,104.4,230.7,99.7L230.7,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.7,5.8c-4.6-0.1-1.6,2.8,1.3,1.9c1.4-0.9,5.3-0.3,5.5-2C273.9,4,270.7,5.5,268.7,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.5,90.2c-2.2-0.8-3.1-2.9-4.1-4.8C200.8,84.6,210.5,95.8,210.5,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.1,32.5c-1-2.9-3.7-10.1-2.8-2.1c0.1,5.1,6.1,6.5,3.1,2.5C269.5,32.9,269.3,32.7,269.1,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.9,79.3c-3.7,3.7,4.4,2.1,2.3-6.1C221.5,70.8,224.5,78.4,222.9,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.2,139.2c1.8,1.2,3.2,7,5.5,5.7C273.2,142.7,263.9,133,267.2,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.4,99c-3.6,2.6,5.5,2.4,6.8,2.3C258.9,98.3,252.1,99.4,250.4,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284,1c0.2,5.7,4.3,3.5,2-1C285.3,0.1,283.3-0.4,284,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.8,23.7c-2.1,0.3-8.6-3.8-5.2,1C223.3,25.7,230,27.4,226.8,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237,21.7c0.1,1.9,3.8,7.1,5.6,4.6c0.4-1.6-1.8-2-2.7-3C238.9,22.6,237.1,18.7,237,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.5,104.8c-8.3,7.1,7.6,0,4.3-2.6C250,102.6,249.3,104.1,247.5,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,4.8c-1.8,0.8-8.5,2.7-5.9,5.2C215.3,8.7,221.8,7.6,219.5,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.2,45.8c1.5,5.6,4.1-4.8,1.9-6.1C265.9,38.9,266.7,44.4,266.2,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,37.2c-2-1.6-6.7-1.8-3.6,0.9c1.7,0.5,3.6,1,4.7,2.3C259.9,39.6,258,37.2,256,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.5,32.3c1.7,2,2.3,4.7,3.6,6.8C270.9,38.4,263.7,27.5,263.5,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.3,33.2c1.9-4.2-7.5,0.5-6.3,2.6C214.4,37.6,219,33.5,220.3,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.2,108.6c-6.3-0.9,1.7,3.5,3.7,4.6C281.1,111.9,275.6,109.2,274.2,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304,133.3c-1.1-1.3-5.8-5.3-5.5-1.5C300,133,306.9,138.5,304,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.1,95.1c-1.3,0.3-1,3.7,0.1,2c2.1-3.7,5.5-1.4,6.8-3.3C251,90.8,247.8,92.7,246.1,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.1,2.1C272,4.5,280,1,279.6,0C276.9-0.1,272.6,0.6,271.1,2.1C271.1,2,271.1,2.1,271.1,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.1,51.3c-5.5-9.3-1.6,5.9,0.8,4.8C242.1,54.7,240.7,52.7,240.1,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.7,130.8c0,1.2,0.1,6.5,1.6,6.6C237.3,138.2,235.1,128.2,232.7,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.9,148.7c-0.7-1.3-5.1-6.4-4.2-2.3C252.3,149.4,257.7,158.2,253.9,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.9,32.7c-1.9,1.2-6.7,3.3-4.4,5.9C221.6,37.5,229,33.5,224.9,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.3,123.8c1.7,0.7,7.4,2.3,4.1-0.8C250.6,121.6,241.8,120,249.3,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,11.3c-7,2.2,8.3,2.7,8.5,0.8C252.6,10.3,249,12.2,246.3,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.8,158.4c3.5-3.8-8.1-11.7-3-4.3C233.2,155,233,159.3,234.8,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.3,16c-1.5-3.4-2.1,1.3-1.9,2.9c-0.2,1.7,3.2,5.8,3.3,2.5C296.6,19.8,296.3,17.8,296.3,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.1,17.4c-1.3-1.1-2.3-4.3-4.1-4.1C295.4,15.5,304.7,23.3,302.1,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229,57c-2.6,1.5,1.4,10.3,2.8,5.8C229.9,61.2,232.3,56.7,229,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.3,118.3c1.5,1.3,3.6,4.1,5.7,4c1.8-1.8-1.4-2.8-2.5-3.7C299.4,116.8,296.8,114.7,297.3,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.7,100.8c-0.9-1.1-2-1.5-3.2-1.9c-1.1-0.8-2-3.1-3.6-1.8c-0.3,1.8,6.7,7.3,7,3.8 C209.8,101,209.8,100.9,209.7,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.9,149.8c-1.2-1.6-4.8-5.2-6.5-3.6C229.3,147.1,236.6,155.5,234.9,149.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,16.5c-5.7,0.1,3.3,3.8,4.6,4.7C228.1,19,223,16.8,221.2,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.2,70.1c-0.2,5.7,6.9-5.6,2.8-5.8c-1.6,0-0.5,1.9-0.8,2.7C233.2,67.7,232.5,68.8,232.2,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.1,163.8c0.3-0.5,0.7-1.2,0.2-1.7C279,154.9,280.8,160.6,289.1,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.7,43.1c-0.5-1.3-1.7-3.5-3-3.8c-2,1.7,0.8,3.4,1.2,5.1C263.2,49.6,265.8,46.2,264.7,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.7,111.6c-1.1,2.4,3,4.9,4.7,6.3C306.6,117.9,298.8,112,297.7,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.3,106.4c-3.6,1.6,2.8,4.3,3.8,6.3C286.8,111.6,280.6,107.6,279.3,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.1,88c0-0.5-8.7-3.4-8.1-2.4C288.9,87.5,297.9,91.6,297.1,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.8,126.7c-1.2-1.3-4.3-6.5-4.2-1.9C227.7,127.5,235,131,231.8,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.2,57.4c1.3,0.6,1.1-2.4,1.6-3.3c0.4-1.9,3-4.5,1.2-6.3C304.7,50.4,301.9,54.4,303.2,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.7,116.1c0.6,0.2,0.6,1.3,1.3,1c2.7-2-7.2-7.7-7-4.3C256.1,113.5,257.8,115.1,259.7,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.1,128.2c-1.8,2.3,6.5,10,4.2,4.2C226.6,131.3,226.3,126.2,224.1,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.8,63.5c-1.2-1.9-7.8-3.9-5.4,0C285.8,63,291.5,68.9,288.8,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.9,123.6c-0.9,1.3-1.8,5.7,0.8,3.5c1.3-1.5,2.3-9.9-1-6.5C222.1,121.6,222.9,122.7,221.9,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.8,139.2c3.3,0.4,1.5-5.4,0.5-6.8c-2.9-0.4-0.7,2.7-1,4.3C237.5,137.5,236.8,138.9,237.8,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,78c-0.6,1.5-4.3,6.3-1.5,6.7C246.2,84.6,250.1,75.1,246.3,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.6,32.4c-1-1.5-5.2-2-3.5,0.5c2.2,0.6,3.3,2.4,4,4.4C265.7,37.3,263.8,33.3,262.6,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.9,131.5c2.9-1.6-3.2-5.1-4.6-6.2C238.9,126.9,244.3,130.6,245.9,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.7,122.3c1.8,1.1,2.4,4.7,4.3,4.8C248.8,124.9,238.2,116.4,241.7,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.3,70.2c-1.8,2.2,2.7,9.2,4.1,5.4c-1.2-1.2-3.9-2.8-2.9-5.2C266.9,68.2,264,67.9,263.3,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,133.4c1.6,1.5,2.7,5,4.7,5.3C263.4,136.9,254.3,128.5,256.2,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.2,38.2c-3.7,5.7,3.9,0.6,4.8-1.3C231.2,33.8,227,37.2,226.2,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.4,28.1c0.9,1.3,1,6.5,2.3,6C291.8,32.5,289.1,23,287.4,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.6,10.5c-2-0.8-3.3-5.3-5.8-3.7C286.6,8.5,292.3,14.7,292.6,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.6,37.1c-2.6-0.2-3.9,4.3-0.7,2.6C239,40.1,240.5,36.5,234.6,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.1,112.1c4.9-0.7,6.7-4.3,0.4-2.2C244.2,111.1,242.1,116.2,248.1,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.7,46.1c-8.4-4,1.1,2.4,2.3,4c0.6,1.8,2.6,0.1,1.4-1.1C301.5,47.7,300,47,298.7,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.1,124.7c0.1-3.6-10.8-4.6-5.1-1.6C289.8,123.1,291.3,126.5,293.1,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.7,92.9c-1.3-0.3-8.5,1.7-6.7,3.6C201.5,96.3,209.3,95,206.7,92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,155.5c-0.4,1.7,9.4,9.7,6,4.1C259.9,158.6,256.6,154.3,255.3,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.9,98.3c-1.9,1.7,0.8,5.2,1.9,6.9C305.9,106.4,301.2,99,299.9,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.1,32.7c-8,2.1-1,2.1,2.3,2.9C282.8,34.8,278.9,32.5,277.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.1,88.1c2,0.4,6.3,2.9,7.6,1C278.6,87.7,266.9,85.7,270.1,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,85.9c-0.9-0.2-2.7-1.7-3.3-0.6C309.8,86.7,315,88.8,313.6,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.8,163.9c1.7,0.5,7.9,5,7.2,1.3C269,164.4,260.2,160.1,262.8,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.4,138c0.3-1.7-1-7.9-3.3-5.8c-0.2,2,2.5,3.9,1.5,6.3C211.1,139.7,214,139.1,213.4,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.3,9.6c-2.5,1.2,1.1,4.7,2,6.1C281.7,17.7,277.1,9.3,275.3,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.3,79.4c0-1.6,1.1-6.8-1.3-2.2C304.9,83.1,314,86,309.3,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.2,37c-1.4,0.5-7.8,3.6-4.7,5.3C221.2,41.4,225.9,39.3,224.2,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.8,144.6c4.3,0.6-1-4.8-2.4-5.7C284.4,140.5,288.6,143.1,289.8,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.1,98.9c-2.2-2.4-8.4,3.7-5.2,4.2C242.6,99.6,249.2,102.1,247.1,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.5,160c-2.4-0.9-3.5,3.5-4.2,5.1C214.1,168.1,217.3,161.3,216.5,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313,71.8c2.2-1.4-0.4-3.7-1-5.4C309,59.3,310.1,71.2,313,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.3,57.1c-0.4-3-4-5.3-2.7-0.7C243.4,62.5,246.9,60.2,245.3,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.8,82.7c-6.1,0.3,7.6,5.2,6.5,0.8C272.4,83,269.9,83.9,267.8,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278,49.1c0.6,1.7-0.5,7.6,2.7,5.2C280.5,52.5,280.4,43.2,278,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,166.6c3.6,0.4-2.1-9.2-4.1-7.3C249.8,161.8,253.1,163.7,253.5,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.8,37.5c-1.5-1-0.1-6.6-2.8-3.9C245.7,36.7,252.3,44,249.8,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225,54c0,1.5-1,7.6,2.3,5.6C227.6,58,228.3,52.7,225,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.7,3.2c-1.6,0-9.7-1.9-6.8,1.4C226.7,4.5,232.4,6.2,231.7,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.6,3c-1.4,0.6-3.8-1.8-4,0.4c1.2,1.9,4.5,0.6,6.4,1.7C218.4,4.5,210.9,3.4,208.6,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.5,69c1.1,1.4,1.9-1.4,1.5-2.3c0-1.9,3.3-5.8,1.1-6.9C303.8,62.4,302.2,65.8,302.5,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.3,140.9c2.7-1.7-5.7-6.1-6.1-3.2C297.6,138.9,300.3,140.9,302.3,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.1,95.6c-0.6,2.1,1.4,6.4,2.5,2.4C220.9,94.4,221,87.9,219.1,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.1,124.5c-3.5,1.2,4.1,4.3,5.4,5.3C275,128.2,268.6,125.3,267.1,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.2,70.1c-1.1-5.6-3,1.6-1,4.4C220.6,77.6,218.7,71.9,218.2,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.8,152.9c-0.8-1-2.6-7-3.8-4.1C262.7,151.4,269.4,160.5,265.8,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.8,50.3c-1-2.7-3.1-0.7-1.7,1.3c-0.1,1.7-0.4,3.1-0.6,4.6C259.1,57.3,259.4,52.2,258.8,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.2,125c0.1-2.2-3.3-2.9-3.6-5.3c-2.9-1.8-1,4,0.7,4.5C208.2,124.6,209.7,126.7,210.2,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.6,138c-3.2-0.7-0.3,4.7-3.4,6.4C216.6,146.7,217.5,139.5,216.6,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.9,156.6c4.5-5.2-5.2,0.7-5.6,2.1C208.6,161.3,211.6,157.5,212.9,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.5,130.1c0.4-1.5-3.3-8.2-3.9-3.8C234.3,127.9,235.2,131.9,237.5,130.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,2c-2.5-0.2-5.2-1.2-7.6-1.1C230.6,2.4,245.4,5.6,240.5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.7,94.8c-1.1-1.1-3.6-3.7-4.9-1.7C294.1,95,302.2,99.3,299.7,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.4,154.3c1-2.4-3.3-2.1-4.6-3.2C303.7,152.6,310.5,155.3,312.4,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218,129.1c1.9,6.5,3.9,0.6,0.1-2.9C213.3,122.5,216.3,126.9,218,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.5,70.7c-0.9-1.5-1-4.6-2.5-5.3C304.2,66.9,311.2,77.8,309.5,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.9,25.7c-1.6,0-4.4-3-5.3-0.7C216.4,27.5,225.2,29.2,221.9,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.8,88.3c-0.9,1.2-3.8,5.6-0.7,5.6C230.6,93.5,233.7,86.2,229.8,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.9,8.3c-5.8,2.3,2.8,2.5,4.8,1.1C263.9,6.1,260.9,8.4,258.9,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.9,44.6c-2.1-0.2-4.8-3.4-6.6-2.4c0.3,1.8,6.9,6.1,6.8,2.3C307.1,44.7,307,44.6,306.9,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.8,63.1c-3.1-1.2-0.3,4-0.6,5.6C255.3,70,254.8,64,252.8,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.7,134.4c0.5,2.5,4.1,3,2.3,0.2C281.4,128.9,276.7,130.1,281.7,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.9,5.3c-1.3-0.8-0.4-3.3-1.8-3.7c-1.5,0-1.2,1.5-1,2.5C280.8,7.8,286.8,9.1,283.9,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.6,63.7c0.6-7.5-5.1-0.7-0.6,1.8C247.2,67,247.4,64.9,244.6,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.9,20.1c-1.5-5.3-2.1,3.4-2.1,4.5C309.8,24.8,310.1,21.7,309.9,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259,78.4c-0.2,2.3,5.7,4.9,3.7,1.6c-4.2-1.6-0.8-6.1-3.2-5.4C259,75.8,258.6,77.1,259,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.5,90.3c-1.9-3.4-4.3,7.7-0.8,6.1C225.4,95.2,223.5,92.1,224.5,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.9,121.3c-1.6-0.9-5.8-4.8-5.4-0.8C265,121.9,269.2,125.3,268.9,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,69.7c-1.3-3.3-3.4,9.7-0.2,7.6C292.4,74.8,294.1,72.2,293,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.6,108.2c-0.1-1.4,2.2-5.1,0.3-5.3C218.3,103.2,217.1,111.8,220.6,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312,98.5c-1.1-1.7-3-2.5-3.8-4.3C303.6,93.9,313,103.7,312,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.9,126.5c1.1,1.2,3.5,4.9,4.9,2.4c-0.6-1.6-3-3-4.3-4.5C274.2,124,273.4,126.1,274.9,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.6,102.7c2,6.3,4.1-8.5,0.2-4.1C215.3,99.9,216.5,101.4,215.6,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.1,64.9c-0.3-1.4-0.7-7-2.7-4.3c0.9,1.6,0.1,6.1,2.2,6.3C215.9,66.8,215.7,65.7,215.1,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.6,80c1.7-0.2,3.7-8.8,0.5-5.8C238.9,75.6,236.6,79.9,238.6,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.9,137.3c1.2,5.6,4.1-4,1.7-5.1C221.1,132.1,222.8,135.8,221.9,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.7,32.5c1.7-1.5,3.2,0.8,4.7,0.4C290,28.9,277.8,29.1,281.7,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.7,132.5c-1.4,2.2,3.1,2.4,3.8,4.2C254.7,139.6,248.3,131.4,245.7,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.8,159.8c0.9,1.2,4.8,5.3,3.5,1.3C256.8,157.5,248.7,154.1,254.8,159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.6,139.1c1.3,0.5,4.7,4.9,5,1.9C258.9,139,249.4,134.4,253.6,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.5,83.4c-3.5,1.5,2.5,3.5,3.1,5.3C284.3,87.7,278.6,84.1,277.5,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.3,115.2c-1.5,1.8,4.3,2.3,5.4,2.8C259.6,115.4,253.6,113.9,252.3,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.8,137.4c1.5-0.7,0.6-1.9-0.4-2.6C287.6,127.3,289.1,136.4,293.8,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.8,141.7c1.4,0.8,2.9,1.4,4.3,2.2C305.7,143.2,292.5,137,295.8,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279,61.6c-1.3,0.1-2.8,0.2-4.1,0C271.6,65.5,284.1,64.5,279,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308,53.6c-1.9,0.8-0.1,4.5-0.4,6.3C308.4,68.6,310.1,56.4,308,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.3,104.6c-1.4-7.3-3.4,12.4,0.5,4.5C305.9,107.8,306,106.2,306.3,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.1,48.6c-1.4-1.5-4.1,6.3-3.1,6.7C218.5,55.4,219.3,50.6,219.1,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.3,87.7c2.7,1.1,3.3-3.7,3.7-5.4C250.5,79.9,247.6,86.8,248.3,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.4,14c-3.5-0.7-0.3,6,1.7,5.8C277.3,18.1,273.9,15.9,273.4,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.8,0.6c-0.5,3.9,3.1-0.3,4.6-0.6C206.6,0.1,203.3-0.3,202.8,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.7,79.5c-3.9,1.1,3.2,3,3.6,4.9C290.5,83.6,284.6,79.6,282.7,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.1,3.4c-5.1,2-0.1,3.5,2.4,1.1C269.3,2.7,264.9,1.4,263.1,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,42.7c-2.3-0.7-4.1,2.3-6,3.3C217.3,50.4,225.3,43.7,224.8,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.9,16.3c-3.1,0.5,0.8,4.3,0.2,6.4C315.3,23.5,314,16.5,311.9,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.9,40.3c-1.7,0.3-3.7-0.1-5.4,0C301.2,43.6,312.8,43.4,309.9,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.1,36.4c-1.7,0.7-3.8,1.3-5.5,2.2C296.8,42.8,306.9,38.2,304.1,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.1,131.2c-2.2,0.7,0.3,2.5,1.6,2.3c1.3,0.3,2.7,2.5,4,1.4C266.9,132.3,261.4,132.3,260.1,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,43c1.9,0.4,2.7,3.1,4.2,3c3.3-2-4.7-6.9-4.3-3.1C251.8,42.8,251.8,42.9,251.9,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.6,64.3c2.6-0.7,0.6-5.2-0.5-6.6C258.6,57.2,260.8,63.5,261.6,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,3c-0.6,0.9-1.5,1.8-2.6,1.8c-3.4,3,1.8,3.1,3.3,0.8C258.8,4.8,258.6,1.6,257.1,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.7,26.4c-0.9-0.7-1.5-1.5-2.2-2.3C268.2,21.6,279.4,33.8,276.7,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.6,94.6c0.3,2.1,8.6,5.5,5.9,1.9C275.7,96.2,272.9,92.8,271.6,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.5,138.4c0.6,1.7,1.6,5.8,3.6,5.8C279.1,143.1,275.7,135,274.5,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.9,27.1c-1.3-2.9-5.1-0.1-1.5,1.1C254.4,31.7,259.7,29.5,253.9,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.5,18.8c-0.3-0.7-1.4-0.2-1.6,0.4C279.2,26.2,285.2,26.2,279.5,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,12.3c1.4,0.8,3.3-1.7,4.8-2.2c1.5-0.9,0.3-3.6-1.1-1.7C207.7,9.3,204.7,10.3,205.3,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.2,145.4c1.6-2.1-2.3-3-3.2-4.5C236.7,139.6,242.4,146.7,244.2,145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.6,19.7c-4.6-3.3,1.4,8,2.5,4.5C264.3,22.3,262.4,21,261.6,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,32.2c-0.3-1.1-1.9-4.2-3.2-3.1C309.6,29.9,314.2,35.8,313.6,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.2,0.6c0.5,0.1,0.9-0.4,1.3-0.6C289.1,0,286.2-0.2,288.2,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.5,156.1c0.1-2.1-5.8-5.3-5.1-1.4C296.8,155.3,299.7,158.6,300.5,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.9,81.2c-1,1.4-2.9,6.3-0.4,6.6C225.4,87.3,227.4,79.3,224.9,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.4,79.2c1.3,1.1,5.6,4.2,6.3,1.6c-0.1-0.7-8.1-4.5-6.6-1.8C263.1,78.9,263.2,79.1,263.4,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.7,159.3c-7.2-2.9-2.1,2.1,1.8,2.7C280.9,161.1,278,159.5,276.7,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.1,15.9c1.1,1.2,4.6,3.7,3.6,0.3C261.1,13.5,254.5,11.5,259.1,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.4,43.1c-2.2-0.3-1.6,7.4-0.1,7.6C289,49.3,288.1,44.8,287.4,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,153c0.8,1.2,5.3,6.3,4.7,2.5C250.1,153.8,243.5,148.5,246.3,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.9,81.7c-3.1,0.7,5.6,8.1,4.6,3.6C284,84.4,282.5,81.2,280.9,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.1,42.8c-2.5-0.5-2.8,4.3-3.1,6C277.2,51.4,278.1,43.9,278.1,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.8,8.4c-0.7-1.5-3-4.3-4.8-4.1C288.6,5.6,294,11.4,294.8,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.8,123.9c-0.2-1.7-8.6-2.1-5.9,0.4C305.7,124.1,309.5,126.6,309.8,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.5,127.7c1.7,0.3,3.5,3.3,4.8,2.6C262.8,128,252.1,124,255.5,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.2,114.2c-4.7-2.4-0.8,3.4,1.4,4.2C296.2,117.3,293.3,115.5,292.2,114.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.2,40.6c-5.6,0,2,4,3.8,3.6C248.8,42.5,244.4,41.4,243.2,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.8,160.3c1.3,0.6,4.5,5,4.9,1.9C299.6,160.2,291.8,156,294.8,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.3,49.9c-0.6-1.4-3.2-6.1-4.5-3.1C241.4,48,246.4,54.1,245.3,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.4,107.4c-1-1-5.1-2.6-4.6-0.1C254.2,108.1,261.6,112,256.4,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.6,42.1c-2.5,1.3,1.6,4.4,3.2,4.8C237.4,46.2,232.9,41.9,231.6,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.2,148.3c-1.1-1.2-5.9-5.3-6.8-2.8C269.2,146.2,272.9,150.9,274.2,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.6,0.2c0.7,2.1,3.5-0.9-0.1-0.2L300.6,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.5,0.6c0.3-0.1,0.3-0.4,0.6-0.6h-2.9C268.7,0.8,269.6,1.1,270.5,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.9,39c-3.9,5.9,3.9,1.2,3.4-1.7C215.9,35.3,213.3,38.3,212.9,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.5,0.6c0.5,0.3,1.1-0.2,1.4-0.6h-2.3C261.9,0.3,262.2,0.5,262.5,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.3,83.8c-2.7-1.1-0.5,4.9-0.1,6.3C220.5,91.9,217.3,85.3,217.3,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.6,133.1c1.2,0.8,3.8,4.4,4.4,1.5C299.5,132.3,292.8,129.2,295.6,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.7,116.5c-4.1-0.1,2.2,4.5,4,3.7C311.9,118,306.6,118,305.7,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.4,144c-2.4-1.1-2.9,3.1-4.5,4.2C214.7,152.2,220.2,145.6,219.4,144L219.4,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.9,75.5c1.6-0.2,7.1,2.9,5.4-0.5C282.3,74,274.9,73,277.9,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,147.8c-2.1,2.1,3.5,3,3.6,5.2C263.6,152.9,257.9,147.3,256.2,147.8L256.2,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.5,132.7c1.5,2.6,4.2,2,1.9-0.8c-2.1-2.9-7-3.7-2.4,0.4C268.9,132.3,269.2,132.5,269.5,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.1,122.9c4.2-1.9-6.8-4.7-5.2-0.9C279.7,122,281.4,122.9,283.1,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.6,146c2.6-2-6-5.1-7.2-3.8C301.5,143.6,309.5,145.9,310.6,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.7,147.4c1.8-0.3,3.6,0.9,5.3,0.8C311.1,145.5,300,144.3,302.7,147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.5,79.6c-3.8-0.8,2.4,6.6,4,4.3C261,81.8,257.3,81.4,256.5,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.2,106c-1.6-0.3-3.3-4.1-4.6-2.7C256.6,105.9,265.2,110.3,262.2,106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.9,0c-0.3,4.8,6.9,4.9,2,0.1C292.9,0,290.7,0.2,290.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.3,143c4.3,1.5-0.7-7.3-2.3-4.9C227.2,140,229,141.2,229.3,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217,58.4c-1.3-4.2-2,3.7-1.1,5.2C219.5,65.8,217.2,60.1,217,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.4,148.3c6.7,4.1-0.3-3.4-1.6-4.3C274.2,144.9,276,148,277.4,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.1,134.5c-1-1.2-1.9-4-3.6-3.7c-0.9,1.3,4.5,9.6,3.8,3.8C244.2,134.7,244.1,134.6,244.1,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.3,160.6c-0.6-2.8-4.7,1.8-7,0.9C205.3,164.5,211,161.9,212.3,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,136.8c1.6,0.6,1.7,4.6,3.6,3.9C274.5,137.8,265.9,131.6,269.3,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.1,116.8c0.3-0.5,0.5-1.2-0.2-1.5C305.4,110.6,309.4,118.2,314.1,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.1,91.9c-1.6-0.1-4.8-1.8-5.5,0.2C252.8,93.8,261.1,94.8,258.1,91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,140.7c-0.5,1.4,4.6,6.8,4.8,3.2C224.6,143,222.9,139.6,221.2,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.4,56.8c-3.3-4.3-2.7,1.7-0.6,3.7C268.8,61.1,268.3,57.9,267.4,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.5,26.5c-1.3-1.2-2.5-4.8-4.5-4C291.8,23.4,297.9,30.6,297.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247,52.5c-2.5,1,1.4,3.6,2.3,4.5C253.1,56.9,248.7,52.8,247,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.4,34.3c-4.2-1.5-3.7,1.5-0.1,2.5C312.6,37.8,312.3,35,309.4,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.1,9.3c-1.2,0.7-4.6,1.6-2.1,3.1C231.8,12.5,236.7,7.6,231.1,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.9,15.2c-1.5-1-7.2-0.1-4.2,1.8C241.6,16.7,246.8,18.9,243.9,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.3,37.8c-5.2,1.4,0.8,2.1,2.6,3C286.1,39.9,282.1,37.4,280.3,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.2,143c0.7,1.9,3.9,2.6,3-0.1C284.5,139.8,280.2,138.7,283.2,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.9,152.9c-0.8-1.1-5.9-4.9-5.6-1.8C277.9,151.5,282.6,156.9,281.9,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.7,9.7c-1.5,0.1-6.2,0.9-3.8,2.7C218.5,12.7,223.9,11.5,220.7,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209,147.9c2.2,2.8,2.7-3.7,3.6-4.9C210.3,141.2,209.5,146.3,209,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259,125.1c5.1,4.3,6.3,1.4,0.9-1.7C259.1,122.7,257.6,125.1,259,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.8,127.9c-1.1-0.7-3.3-3.2-3.9-1C250.2,129.3,256.7,132.4,253.8,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.8,2.8c0.5-2.7-4.8,0-5.9-2.1C208.1,3,216.4,3.5,217.8,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.3,113c-3.2-2.6-1.1,2.6,0.3,3.7C226.1,119.1,223.6,114.3,222.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.2,40.9c-2.1,6,3.3-1.1,4.2-2.7C277.2,35.8,273.7,39.8,273.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.2,51.7c0.1-0.5-0.2-1.4-0.9-1.1C283.2,54.1,288.8,56.9,291.2,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.1,69.2c-2.1-1.4,0.1,6.6,1.5,6.7C276.4,75.3,273.8,70.1,273.1,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.6,63c-3.4-5-0.8,5.2,2.6,3.3C274.9,63.8,271.5,64.4,270.6,63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281,127.3c0.4,1,1.3-0.1,1.5-0.7c0-1.9-2.7-2.1-3.6-3.4C276.4,124.8,279.6,126.4,281,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.2,121.3c-5.6-4.7-1.3,2.4,1.5,3.6C265.9,124.5,263,121.8,262.2,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.8,132.7c2.8,4.4,3.5-0.7-0.6-2.8c-0.9-0.8-2.1,1.2-1.2,1.7C250.7,131.9,251.4,132,251.8,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,164.6c-0.2-2.4-6.1-3.9-3.8-0.7C235.1,164.4,237.7,167.9,237.6,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.1,107.8c1.3-0.6,6.2-5.1,2.8-5.1C242.6,104.2,237,107,240.1,107.8C240,107.8,240,107.8,240.1,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.9,157.7c1.5,2.4,3.1-0.3,1.1-1.5C259.9,152.5,258.2,154.6,262.9,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.9,94c-3.2-0.1,1.9,3.8,2.9,3.8C215.6,96.9,211.4,93.9,209.9,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.6,101.2c-3.4,2.7,6.1,3.1,4.2-0.3C283.4,100.7,282,101,280.6,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.7,33.8c-4.3,1.3,3.4,4.6,3.5,1.4C237.4,33.3,234.6,34.2,233.7,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.3,1.2c2.2,1.7,3.4-2.1-1.1-1.2C305.6,0.4,305.9,0.8,306.3,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.5,151c2.1,1.4,3-5.5,0.3-4.6C219.7,147,219.4,150.2,220.5,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.1,13.8c0.7,1.1,0.1,5,2.2,2.9C309.7,14.5,306.2,9,306.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.1,13.4c-1.1-0.6-2-1.4-3.1-1.8C257.2,11.8,266.1,17.8,265.1,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,124.8c0.1,1.5,2,2.2,2.5,3.6C303,129,296.7,120.6,296.6,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279,102.3c-1.5-0.1-3-0.9-4.4-0.9C272.7,104.2,281.7,105.8,279,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.5,103.4c-5.5-1.3,0.6,4.7,2.7,2.7C275.2,105,273.3,103.9,272.5,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208,152.6c1.9,0.6,4.1-1.6,5.6-2.6C214,147.7,206,151.6,208,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.8,159.7c0.8,0.8,0.7,3.8,2.2,2.9C250.5,159.8,244,152.8,246.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.9,30.6c3.3,2.6,3.1-6.5,0.3-4C292.4,27.8,294.1,29.3,292.9,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.1,137.3c-0.6-1.2-1-6.3-2.9-3.5C217.4,135.1,218.9,141,220.1,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.4,146.4c-2.7-0.1,1.5,5.2,2.6,5C251.5,150.1,248.5,147.5,247.4,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.2,78.9c-0.7-1.5-2.4-3.8-4.1-3.7c-1.6,1.7,2.6,2.6,2.5,4.4C288.1,80.9,289.1,79.8,289.2,78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7,13.6c-1.5-0.8-5.9-0.6-3.6,1.7C224.5,15.3,229,16.4,226.7,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.3,23.8c-1.5-0.2-4.4-1.5-4.2,1.1C210.8,26,216.6,26.5,214.3,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.1,109.1c-2.5-2.4-2.9,3.9-0.8,3.9C228.4,113.3,227.4,110.2,227.1,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.3,108c0.5,1.7,0.5,4.2,1.2,5.7C296.8,113.7,295.1,105.2,293.3,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,1c0.1,1.9,2.2-0.5,2.9-1C248.5,0.2,245.7-0.6,246.3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.9,99.5c-2.8-0.3-0.5,4,1.2,4.2C216.8,102.9,213.7,100.7,212.9,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.8,131.6L214.8,131.6c2.9-0.8-3.1-5.1-4.3-5.1C211,128.4,213.3,130.2,214.8,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.3,9.2c-2.6,3.5,6.5,0.2,4-1.5C250.9,7.5,249.5,8.4,248.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.8,13c-4.5,2.3,0.8,3.6,2.4,1.1C211.7,12.3,210.1,12.4,208.8,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.4,2c0.5,3,2.6-0.9,3.4-1.9C244-0.2,243.3,0.5,242.4,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.8,98.9c-3.6-0.9-0.9,2.8,1.5,2.1C280.8,100.5,277.9,98.6,275.8,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.1,106.2c-3.1-2.6-3.6,1-0.3,2C270.9,109.7,271.2,106.6,269.1,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.9,118.5c0.4,1.6,3.2,5.1,3.1,1.5C244.5,118.6,242.9,113.9,242.9,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.2,27.9c-3.4,2.3,4.2,3.7,3.2,0.3C217.5,27.3,216.3,27.9,215.2,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.5,23.4c-0.8-1.1-3.7-3.4-4.3-1.1C298.9,23.2,303.7,26.8,302.5,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.1,71.2c1,1.1,5.2,3.2,4,0C287,70.9,283.5,68.5,284.1,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.6,61.8c-0.7-1.2-1.4-4.2-3.1-2.5C218,60.8,221.3,65,221.6,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257,36.1c1.3,0.1,2.2,2.3,3.1,1.3C262.1,34.9,256,32.3,257,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.7,77.8c1.3,0,2.1,1.7,3.1,1.2C315.7,77,309.8,75.3,310.7,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.1,140.4c-4.7-0.3,4,5.3,3.3,2C265.8,141.3,264.2,141.1,263.1,140.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.9,13.2c2.7,3.2,1.8-5.6-0.7-3.3C281.7,10.8,282.4,12.3,282.9,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.1,82.3c-1.6-0.8-5.2,3.5-2.1,3.3C204,85.3,206.2,83.2,205.1,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.6,74.8c-0.9,1.2,0.5,5.7,2,3.2C212,77,211,73.2,209.6,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,94.6c1.3,3.6,5.5-3.9,1.4-2.9C236.2,92.4,236,93.7,235.6,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.1,83.4c1.9,4.3,3.5-6.2,0.2-3.2C241.4,81.2,241.7,82.6,241.1,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.7,43.4c-1.1-0.4-1.8-1.9-3.1-1.2C234.5,44.3,241,47,239.7,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261,69.4c-1-6.5-2.3,0.3-1.3,2.8C261.2,73.1,261.2,70.3,261,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.1,14.3c-0.1-1.1-2.5-2.7-3.6-2.3C287.1,13.1,291.6,16.8,292.1,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.8,23.6c-0.3-1.2-2.3-0.7-2,0.5C290.3,27.7,293.3,27.9,290.8,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.2,107.2c1.5-1.4-0.3-3.7-1.5-4.7C285.8,102,289.7,106.6,290.2,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.5,20.9c-0.1,2.4,1.2,4.3,1.9,0.9C273.1,18.1,269.1,18.7,270.5,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.9,37.3c-1.3-3.5-2.5,2.8-1,3.9C272.9,41.8,271.6,38.4,271.9,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.7,153.2c1.2,0.4,1.7,3.2,3,2.4C255,153.4,249.1,149.5,250.7,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268,157.3c1,0.7,4.8,1.3,3.4-0.8C270,155.8,264.7,154.7,268,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.7,128.9c7,5.2,0.5-5.8-0.1-0.2C293.5,128.7,293.6,128.8,293.7,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.9,10.9c-1.2,0.8,0.2,4.8,1.5,3.1C313.1,12.9,312.4,9.4,310.9,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.1,3.3c-0.2,3.8,10.2-1.9,0-0.2C249.2,3.1,249.2,3.2,249.1,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.2,14.2c-1.1,0.1-5.2-0.3-3.5,1.8C216.7,16.2,221.4,15.7,219.2,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.3,131.8c2-0.5,1-3.1-0.2-4C282.3,128.5,284,131.3,284.3,131.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.2,113.7c1.1-0.9,2.4-4.5-0.1-2.6C239.7,112.5,238.9,117.9,241.2,113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.5,164.2c3.6,1.3,14.6-3.6,4.6-2.6C165.6,161.9,161.7,162.2,162.5,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.5,165.5c8-4.4-4.1-0.2-6.6-1.6C23,166.7,33,166,34.5,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153,165.6c1.6-0.8,5.7-5.3,1.6-4.2C152.3,162.8,146.5,169.2,153,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.8,164.8c1.5-0.4,3.4-4.2,2.6-5.6C109.1,157.8,106.2,165.1,107.8,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.4,163.7c1.2,0.7,2.1,3.8,3.7,3.5C97.9,165,89.5,157.4,91.4,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,161.6c0.9,1.1,2.5,1.6,3.3,2.9C15.1,169.2,6.7,153.8,6.3,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.2,165.8c0.4,1.1,5.4-5,4.5-5.3C105.3,159.1,100.9,164.4,102.2,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.6,165.5c1,1,1.4-1.1,1.7-1.8C198.8,158.2,188.4,159.7,189.6,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.7,163.2c1.5-0.1,2.7,1.8,4,1.2C206.8,161.3,195.7,159.9,200.7,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.6,162.7c1.2,0.4,1.8,1.7,2.8,2.2C82.4,164.4,73.1,157.2,74.6,162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.1,162.4c1.4,0.8,7.1-1.3,3.7-2.6C149.3,159.9,146.1,160.3,147.1,162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.3,163.6c1.4,1.4,3.2-0.7,3.5-1.9C98.8,159.4,95.1,161.9,96.3,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.5,161.7c-1.3-1.2-2,1-3.1,1.3c-1.3,0.8-6,3-2.7,4.1C278.5,166.1,284.5,164.3,282.5,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.1,165.5c1,0.8,2.3,2.3,3.2,0.5C212,163.6,206.6,162.6,208.1,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.5,164.1c2.8-6.9-3.5,0.8-2.5,3.3c0.4-0.1,1.9,0.3,1.3-0.6C187.2,165.7,188.2,165,188.5,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28,167.4c-2.4,0.5-8.6-2-9.5,0c0,0,10,0,10,0C28.4,167.5,28.2,167.4,28,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.9,166.2c7.6-8.4-1.8-2.6-4.1,1.6C155.1,167.9,157.7,168,157.9,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166,166.8c-1-1.7-3.8,0.4-5.4,0.7C160.8,167.2,167.2,168.3,166,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,166.2c3.6-4.7-5.5,0-6.8,1.3C108.6,167.6,111.7,167.6,113.4,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,164.9c-1.8-1.7-4.3,2.1-6.3,2.6C144.2,167.6,148.6,167.9,148.5,164.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.9,166.9c5.3-3.2-5.6-1.8-7.1-0.2C174.8,168.6,180.8,167.4,181.9,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,164.3c0.5-5.4-4.9,2.1-6.4,2.9C138.8,167.9,139.9,165.5,142.2,164.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,164.7c-1.6-2.9-4.9,2.2-7.2,2.9C35.6,167.8,40.1,167.5,40.5,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.9,167.5c3.4,2,10.6-6.2,5.4-4.1C173.1,164.9,168.6,166,168.9,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.7,166.9c0.2-1,0-2-0.2-2.9c-2.9-3.6-1.6,0.6-2,2.5C55,168.1,58.7,168,58.7,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133,166.4c1.8-4.7-3.7-0.2-5.1,1C129.2,167.3,132.1,167.8,133,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.9,167.5c0-3.9-7.2,1.3,0.2,0.2L122.9,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.6,167.5c5,0.5-1-4.7-3.5-4C194.6,165.8,200.8,165.7,201.6,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,166.4c0.4-2.5-2.9-0.9-2.5,1.1C5,167.4,6.7,168,6.5,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.4,167.3c-0.7-5.6-5.5,1.4,0.1,0.3C14.4,167.5,14.4,167.4,14.4,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.3,162.9c2.8,1.7,2.1-1.7,0.5-2.9c3.1-0.6,6.8,6.6,9.5,3.9c3.5,2.1,2.2,4.1,6.4,3.6 c-3.7-4.9-10.7-7.4-16.4-10c-1,0.4-0.2,2.2-1.3,1.6C53.7,157.8,57.3,162.1,59.3,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.6,167.1c-1.6-0.4-4.2-1.5-5.2,0.2c-0.2,0.2,6.1,0,6.1,0.1C199.3,167.3,198.9,167.2,198.6,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.3,167.4c-0.2-3.4-3.6-0.8-5.1,0.2C113.3,167.5,118.5,167.8,118.3,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.4,164.7c-2.2,1.1,0.3,3.6,2,2.9C207.4,166.8,207.6,165.3,206.4,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.9,166.5c-0.1,0.4-0.5,0.8-0.8,1.1C84,169,82.9,160,78.9,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,166.3c0.6-1.5-0.3-2.3-1.7-2.3C43.5,166.3,46.4,169.9,47.1,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.7,167.5c1.1-1.2,2.5-3.9-0.3-3.4C98.4,166.2,95.2,168.2,99.7,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.5,166.8c3.2,3.3,2.1-4.9-0.6-3.7C49.5,164,50.5,165.7,50.5,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,167.5c1.6,0.3,5.3-1,3.6-3C89.2,163.9,86.3,166.2,86.8,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.9,167.5h5.3C264.4,165.1,253.1,161.8,262.9,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.1,167.5c-1.4-3-5.1-4-5.9-0.1C230.2,167.4,236.1,167.5,236.1,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.4,166.5c0.9-2-2.6-6.7-2.2-2.6c0.5,1.3-0.2,2.4-0.5,3.7C301.6,167.5,303.6,168,303.4,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.2,166.2c0.5-3-3-0.7-2.9,1.2C256.4,167.3,258.1,167.8,258.2,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.3,166.8c2.3-4.8-2.6-1.9-3.4,0.9C294.7,167.6,297.3,168.2,297.3,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.6,167.5c-0.1-1.4-2.5-1.9-2,0C278.6,167.5,280.6,167.5,280.6,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.4,167.5c3.1,1.2,6.3-4.3,3.8-4.3C247.8,163,248.1,166.5,246.4,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.2,164.6c-1.5-2.9-3.1,1.6-3.9,2.9C284.5,168.1,285.5,166.3,286.2,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3,164.7c-2.2-1-2.6,3.9,1.2,2.8C66.6,166.8,66.3,165.6,66.3,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.6,166.7c-0.4-3-4-1.9-2.6,0.8C310.4,167.3,313.5,168,312.6,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.3,163.5c-2.1-1.2-2.5,2.6-3.2,3.9l0,0C308.1,168.2,310.7,165.2,309.3,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,167.4c-1.1-3.8-4.9,1.1,0.1,0.1C240.5,167.5,240.5,167.4,240.5,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.8,167.5h2.6C274.1,163.8,269.4,163.4,272.8,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.3,166.8c-1-1-7.5-2.3-5.5,0.7C217.1,167.2,223.1,168.2,222.3,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.8,167.3c-0.2-1.4-2.4-1-2.7,0.2C250.2,167.4,252.9,167.7,252.8,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.8,167c-0.4-1.2-1.5-0.2-1.9,0.5C224.3,167.4,226.1,167.8,225.8,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.6,2.3c-2.5-2.3-1.8,4.1,0,3.1C311.7,4.8,310.7,3.2,310.6,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.8,150.5c-0.9-0.6-3.4-2.5-2.9-0.1c0.5,1.4,4.5,2.7,3.2,0.3C273.1,150.7,272.9,150.6,272.8,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.4,60.6c1.6,2.8,3.6-1.9,1.3-2.3C247.3,58.1,247.5,59.7,247.4,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.4,71.3c1,3.7,2.2-0.5,1.8-2.2c-0.5-4.3-2.1-0.2-1.6,1.8C207.4,70.8,207.4,71.1,207.4,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.8,128.3c-1.3,1.1,0.9,1.9,1.5,2.7C267.4,132.9,264.7,127.2,262.8,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.1,6.8c-0.1,2.2,4.5-0.3,4.2-1.4C235,5,233.2,6,232.1,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.4,144.4c-1.8,0.9,2.1,2.9,2.9,2.3C261,145.3,258.7,143.9,257.4,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.9,65.1c-1.4-0.5-2.2,2.5-1.2,3.4C301,69.2,301.5,66,300.9,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.9,15.3c-1.4,0.2-3.4,4.2-1.1,3.7C235.8,17.8,238.3,16.3,236.9,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,133.8c-2.3-1.3-1.6,1.9-0.1,2.4C275.4,135.9,275,134.3,274.3,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.3,166.7c1.3,1.5,2.1-1.2,0.6-1.8C289.1,163.8,288.9,166.1,290.3,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.5,137.8c0.2,0.7,0.9,1.5,1.5,1.7C308.4,138.9,304.7,135.2,304.5,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.8,156.7c-1.8,0.2-0.1,2.3,0.7,2.7C312.1,158.9,310.8,157,309.8,156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.3,11.1c-1.3-0.7-2.1,1.3-0.8,1.8C214.5,13,215.2,11.7,214.3,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.6,7.3c0.5-1.1-1.3-0.9-0.9,0C312,7.4,312.4,7.7,312.6,7.3C312.6,7.4,312.6,7.4,312.6,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.9,123.1c0,0.1,0,0.1,0,0.2C260,123.2,260,123.2,259.9,123.1L259.9,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.3,175.3c5.8,1.9,6-13.1-0.1-0.2C47.1,175,47.2,175.2,47.3,175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186,167.8c-1.8,0.1-8,2.2-3.6,3.1c1.8-0.1,7.8-2.9,3.5-3.7C186.2,167.6,186.1,167.7,186,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,169.4c1.6-0.2,5.3,1.1,4.1-1.9c0.1,0.3-13.4-0.9-9.2,1c1.6,0.5,3.3,0.7,5,0.9 C24.3,169.3,24.4,169.4,24.5,169.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,167.8c0.1-0.1,0.2-0.2,0.3-0.3C152.2,166.4,153.5,171.8,156.5,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.6,170.9c2.5-0.4,5.5-1.8,8.1-2.7C166.5,166.5,154.6,167.9,157.6,170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.6,170.1c1.8-0.3,3-1.9,4.8-2.4C109.1,167.5,103.4,167.6,105.6,170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.7,167.9c-4.9,4,3.1,1.3,4.8-0.5C146,167.5,141.8,167,141.7,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175,167.6c1.4,0.4,3.4,0.3,4.9-0.1L175,167.6L175,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.9,167.5c-1.3,2.5,2.5,1.7,2.9-0.1C138.8,167.5,135.7,167.3,135.9,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.2,167.6c-0.3,3.2,3,0.5,4.4,0C37.4,167.6,33.4,167.6,33.2,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.2,168.2c0.5-0.1,1-0.4,1.5-0.7C171,167.3,167,167.7,170.2,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,170.7c1.3-0.1,1.6-2.2,2-3.2C56.3,166.6,53.5,169.9,56.5,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.5,167.5c-1.5-0.2-7,0-5,2.6C128.4,170.1,129.8,168.1,131.5,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.6,171.6c2.2,1.1,3.3-2.9,5.2-3.6c1.2-0.8-3.2-0.2-3.2-0.4C119.2,169,116,170.1,117.6,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.6,170.4c-0.1-0.7-0.5-1.5-0.6-2.2v2.8C0.2,170.9,0.8,170.7,0.6,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.8,167.9c0.6,0.6,1.5,0.7,1.8-0.3h-2C201.6,167.6,201.7,167.7,201.8,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,167.5c-3.1-0.8-2.7,2.2-2.4,4.5C6.8,173.7,6.1,169.2,6.3,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.8,171.1c-0.1-2.3,0.2-4.1-2.7-3.5C12.1,169.4,12.7,174.4,14.8,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73,167.7c1.6,2.6,4.8-1-0.2-0.2L73,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.6,169.4c2.2-2.6-9-2.5-6.6-1C196.3,168.2,199.6,171,200.6,169.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.2,167.6c-1.5-0.5-9.7,0.1-4.4,2.5C115.1,169.1,116.9,168.3,118.2,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,168.2c0.4,1.8,3.6,2.6,2.9,0.2C209.1,167.5,205.4,166.6,206.6,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,167.7c-0.8,2.8,2.1,2,3,0C80.8,167.7,78.2,167.7,78,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,170c0.5-0.7,0.6-1.6,0.7-2.4c-2.7-0.9-3.4,2.5-0.7,2.7C46.1,170.1,46.2,170,46.2,170z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.4,168.7c0.5-0.3,0.9-0.7,1.3-1.1C98.6,167.5,95.5,167.5,98.4,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.3,167.6c0.3-0.1,1,0.8,1.1,0.1C52.6,167.5,51.3,167.6,51.3,167.6L51.3,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87,167.8c0.6,0.2,1.1-0.1,1.7-0.2h-2C86.8,167.6,86.9,167.7,87,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.7,168c1.5,0.5,6,3,4.5-0.4c0,0-5.3,0-5.3,0C263.2,167.7,263.5,167.8,263.7,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.6,169.1c0.7,1.7,2-0.7,2.2-1.6C230.4,167.3,229.8,167.7,229.6,169.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.7,167.6c2,4.6,5.1-1.1-0.2,0L233.7,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.2,170.4c1.3,0,1.4-1.9,1.9-2.8C301.1,166.9,298.1,169.5,301.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.4,171.3c2.5,1.8,2.5-2.3,3.3-3.8C255,166.8,254.4,169.1,254.4,171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.3,169.5c1.5,1.8,2.6-0.9,3.5-1.9C295.6,167.5,292.3,167.3,293.3,169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.6,173.2c2.7,3.6,3.6-7.5,0.2-5.7C278.9,169.3,279.2,171.5,278.6,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.9,168.4c0.9,1.1,2.5-0.1,3.1-1C248.2,167.5,245.8,167,245.9,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.6,168.8c0.2,2.7,2.7,0.4,3.1-1.2C283.5,167.5,282.2,167.4,281.6,168.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5,167.9c5.7,9,5.3-1.2-0.3-0.4C65.3,167.7,65.4,167.8,65.5,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.5,170.2c1.6-1.8-0.1-3.1-2.2-2.6C310.3,169.2,310.5,170.7,312.5,170.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.2,168c0.6,1.3,2,1,2.2-0.4C308.3,167.7,305.4,167.2,306.2,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.6,170.3c-0.3-2.4-1.2-3.1-3.6-2.8C238.5,169.1,240.1,173.6,241.6,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.2,168.1c2.2,4,4.7-1.9-0.6-0.7C272.9,167.8,273,167.9,273.2,168.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.3,168.4c0.4,0.2,0.8-0.4,1-0.7h-5.4C218.3,167.7,219.9,168.4,221.3,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.1,170.4c2,0.7,1.9-1.7,2.7-2.9C250.7,166.9,248.9,168.4,250.1,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.8,170.4c1.6,0.5,1.5-1.8,1.9-2.7C223.9,167.1,222.8,169,223.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.3,171.2c-5.5-1.9,1.3,5.2,1.8,7.2C210,180.8,205.6,172,204.3,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,277c2.6,0.1,5.9-3,1.5-2.9C202.6,274.8,197.1,278.4,205.3,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.6,309.6c5.2,1.4-4.9-7.8-6.2-5.3C202,307,206.3,307.1,207.6,309.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.9,207.2c1.2,0.7,5.6,1.9,4.4-0.7c-2.7-0.5-6.4-1.9-8.7-3.4C134.6,205.2,138.3,206.5,139.9,207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.6,211.1c1.9,0.2,10.9,2,7.3-1.8C146.8,208.6,129.3,208.2,144.6,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.2,202.9c1.1,0.9,2.6,5.6,4.1,3.7C134.7,204.4,127,196.6,130.2,202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,416.1c-2-0.7,0.6-2.1-0.9-3c-3.3-0.6-7.7-1.1-10.6,0.2c-1.5,3.6,6.7,0.4,8.7,1.6c1.3-0.2,0.4,1.2,0.7,2 C85.1,416.7,89.1,417.5,86.8,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.4,310.2c-0.5-0.4-1-0.8-1.7-0.4c0-1.1,0.6-2.4,0.9-3.5c-2.1-5.9-6.6,13-1.4,4.9 C177.6,331.6,184.2,322.5,184.4,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.6,274c7,7.2-2.2-9.4-6.2-9.3c-2.6,1.5,0.8,2.4,1.7,3.5C165.7,270.2,166.5,272.4,168.6,274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.8,221.5c4.3-2.2,2.3,1.6,4.4,1.1c1.6-1.6,7.9-2.7,6.3-5.3c-2.6,0.2-4.6,2.6-6.8,3.2 c-1.3-3.7-5,0.2-7.3,0.3c-2.6-0.8-4.1,1.5-0.9,2c1.3-0.1,1.3-0.3,0.9,0.8c0.5,3.3,7-1.4,2.4-1.4l0,0 C168.1,221.9,168.4,221.7,168.8,221.5z M167.8,222.5c-0.1,0.1-0.5,0.2-0.4,0C167.6,222.4,167.9,222.1,167.8,222.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,316.8c7.1,10.7,4.5-10.1,0.8-12.4c-1.4-0.1-2.5,0.9-1,1.8c1.9,2.8,1.6,6.3,2.4,9.3 c0.6,2.8-3.4-3-2.9,0.7C78.3,316.6,78.6,316.7,78.8,316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.2,178c1.7-0.3,2.6-3.8,0.3-3.1c-2,1.1-3.2,3.4-5.5,4.2c-1.5,0.5-0.5-1.9-2.1-1.6 c-2.5,1.2-6.9-1.2-8.2,1.8c1.1,1.9,6.5,0.2,8.8,0.4C92.5,182.8,97,179.9,98.2,178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.5,215.9c3.1-4-7.1-4-9.5-4.4c5-4.8-7.4-2.1-1.5-0.2C189.4,215.5,198.8,214.1,201.5,215.9z M191.5,211.4 c0-0.2,0.2-0.1,0.3,0C191.7,211.4,191.6,211.4,191.5,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.6,336.5c0.1-3.3-4.2,0.8-5.5,1.4c1.3-2.6,3.1-4.8,4.6-7.2c-2.2-4.4-11.4,11.8-5.1,8 C106.6,341.8,110.3,337.8,111.6,336.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,335.1c3.3-0.2,0-5.5-0.1-7.5c4,0.2,0.2-13.5-1.9-8.4c0.9,3.5,2.2,6.6,0.1,9.4 C5.5,330.6,5.6,333.5,6.6,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.5,316.3c-2.2-1.6-8,8.1-3.8,7.9c-2.2,2.7-0.1,10.5,1.4,3.9c2.2-8.3-1.9-2.2-0.3-6.9 C130.1,319.3,133,318,132.5,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.6,217.3c2.5,1.3,4.1-1.2,6.9-0.6c1.6-0.6,5.4,1.8,4.7-1.3c-3.1-2.8-7.9,0.6-11-0.2 C159.8,212.7,158.8,216.8,164.6,217.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132,278.5c2.3,2,11.1-2.3,5.8-3.3c-6.8,4.7-5.1-3.5-14.6,1.2C124.2,280.7,130.3,274.2,132,278.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.1,268.3c-0.7-1.5-8.3-0.2-6.2,2c-1.9,0.7-9,3.9-3.1,4c4-2.3,3.3-1.7,7.4-0.1c2.6-1.8-3.4-2.2-3.6-3.8 C143.5,270,146.8,270.4,147.1,268.3z M141.3,270.6L141.3,270.6L141.3,270.6L141.3,270.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.6,197.7c2.2-0.3,11.5-3.3,4.1-3.3c-2.5,0.3-5.3,1.7-7.5,1.6C120.8,186.2,107.8,201.1,119.6,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.4,368c3.6-8.3-20.3,9.3-10.3,6C160,371.4,163.4,368.8,167.4,368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.6,178.4c-3.1-5.1-1.6,7.3-6.3,11c4.3,2.5,6.7-7.4,6-10.8C45.6,178.8,45.6,178.6,45.6,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,373.6c-2.2-2.1-2.4,6-4.7,6.3c-3.5-2.2-1.4,5.5-4.6,1.3c-3.6-1.2,1,5.2,2.8,3.4c2.4-1.8,0.2-3.6,4-3.3 C123.4,379.2,125.4,376.1,124.6,373.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,407.2c-2.5,3.5,7.3,12.5,2.4,2.7c3.7,1.6,3-0.6,0.8-2.6c-1-1.2-2.1-6.3-3.7-2.8 C4.5,405.2,5.9,407.5,4.6,407.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.7,364.9c5,0.3,12.5-4.4,2.7-2.7c-2.8,0.4-6.3,1.9-8.9,0.2C164.7,365.2,172.7,365.9,174.7,364.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.6,276.9c2.4-0.9,9.4-2.8,5.7-5.5c1.3-1,6-2.9,3-4.5c-1.5,0.8-8.6,4.8-3.5,5 C17.4,273.6,9.7,274.7,12.6,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.7,286.1c-1.3,0.3-3.1,2.7-1,3c1.3-0.6,2.3-1.9,3.9-1.8c4.6,0.5,2.2-2.8-2.1-2c2.4-6-12.2,1.8-5.5,1.2 C142.6,286,148.9,284.3,146.7,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,195.3c2.3,0.4,9.9-1.3,4.4-2.5c-7.5,1.6-2.7-1-6.8-2c-7.1,0.7-4.2,2.5,0.7,2.4 C142.8,193.6,146.2,195.4,147.4,195.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.1,187.9c1.8-1.3,8.2-1.2,6.5-4.4C91.6,183.1,74.1,191,89.1,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,416c-0.8-3.5-0.4-7.6-2.5-10.6c-3.3,0.4,0.5,9.1,0.3,11.8C192.4,417.1,194.5,417.7,193.6,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.2,316.3c0.6-2.1-2.7-2.7-3.8-3.5c-0.6-5-9.7-5.5-3.8,1.8c1,2,2.2-0.5,1.2-1.6c-0.5-0.2-1.1-0.5-1.1-1.2 C202.7,311.3,203.4,317.6,207.2,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,367.4c1.8,0.2,3.1-2.8,0.9-2.8C-0.3,364.6-1.8,369.2,2.9,367.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.7,415.4c-0.1-1.3-0.3-6.8-2.2-4.1C203.5,413.6,206.3,420,206.7,415.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.9,377.8c4-5.1-12.9-15-5.2-6.3C102.2,372.7,102.7,379,104.9,377.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.6,315c1-1.9-0.6-12.4-2.9-7.3C160.1,311.3,157.7,327.1,161.6,315z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.7,229.6c7.2-3.4,4.1-4.7-1.6-1.5c0,0,0,0-0.1,0c1.1-1.1,4.9-2,3-4.2c-2.6,0.8-10.6,5.3-3.4,4.5 C166.4,230.4,168.5,230.2,169.7,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.8,270c6.1-3.6-3.9-2.2-4.2,0.5c2.3,3-5,2-6.4,3.3c-1.6,3.7,10.9-0.4,8.4-2.7 C124.4,271.1,128.2,270.4,128.8,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.7,196.3c-0.1-2.4-3.5-9.1-5.8-5.8C70.9,193,71.9,207.8,73.7,196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.2,332.5c-3.8-1.7-8.6,19.3-3.1,8.7C133.2,338.3,138.1,335.1,136.2,332.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.8,316.4c2.4-0.2,1.6-4,2.8-5.5C181.2,293.6,169.4,311.2,171.8,316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.3,396.8c11.6-0.6-1.3-5.7-3.1,1.6c-0.7,1.9,3.3,6.9,4.3,3.4C51.6,400.1,46.8,397.9,50.3,396.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.4,226c-3.4-0.8-7.7,1.3-11.5-0.5C65.8,229.3,83.3,230.2,81.4,226z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184,359.3c1.1,1.9,10.2,0.9,7.7-2c-2.1,0.2-5.6,1.5-7.2,0c1.5-2.4-6.6-3.4-4.2-0.6 C182.2,358.1,184.4,356.6,184,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,346c2,4,6.5-8.2,5.1-9.9c-2.7-1.7-3,7.8-5.1,9.8C151.9,345.7,152,345.9,152,346z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.7,341.9c1.7,0.3,5.2,1.2,2.8-1.5c-1.9-1-4.4,0-6-1.3c-2.6-1.5-2.6-4.4-4.2-6.2 C182.7,335.3,189.3,342.9,192.7,341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.5,306.1c4.5,9.4,0.5-7.2-1.9-10.2C160.1,297.1,165.3,303.5,165.5,306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.9,380.7c2,1.3,4,12.5,5.7,9.1C103,387.9,95.5,373.4,95.9,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204,197.8c7.4-1.2-7-4.2-8.9-4.5C192.2,197.4,202,195.8,204,197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.3,272.4c-0.7,3.4,9.2-1.3,5.8-2.7c-1.4,0.6-2.8,1.5-4.4,1.7c1.7-4.7-4.7,1.2-4.6-2.9 C181.9,267.3,183.3,273.4,187.3,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.4,325.4c1.1,2.4,0.1,8.8,4.1,7.6C145.5,330,139.8,313.4,141.4,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,355.4c12.8-0.7-10.8-5.3-7.9-0.5C187.5,355.6,190.7,355.3,193,355.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.7,291.1c0.4-1.7-1.5-15.2-4.7-11.4c2.6,2,2,12.4,4.9,11.4L162.7,291.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.7,359.6c-2.8-2-0.9,4-2.5,4.8c-3.4-3.9-2.8,8.1,0.1,1.1C122,374.8,126.7,362.6,124.7,359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,371.1c0.5,2.4,2.6,9.9,5.8,7.4C89,376.6,84,363.8,84.3,371.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.8,238.7c1.3-2.6-3.6-1.6-4.7-1c-0.7,0.6,0.6,2.2-0.7,1.5c-5.5-1.6,1.6,4.1,3.3,5.1 c2.7-1.8-0.8-3.2-2.1-4.4C169.1,238.7,172.1,240.1,172.8,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.7,322.5c0.3,1.2,0,3.9,1.7,3.8c1.8-0.5-0.7-5.8,0.9-4c2.2,1.1,2.1-5.2,0.8-5.6c-1.6,0-0.9,2.3-1.1,3.3 c-0.1,2.4-0.3,0-0.9-0.9c-1.7-1.9-1.5,2.2-1.5,3.2C185.7,322.2,185.7,322.4,185.7,322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.8,177.3c-3.9-3-1.8,7.2-2.8,9.3c-0.1,0.6-0.2,1.5,0.6,1.5C5.8,186.7,4.2,180.5,4.8,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.2,338c5-13.7-5.8-0.2-1.5,5.1C126.7,344,124.3,339.6,125.2,338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,271.5c2,0.4,3.9,6.2,5.3,3c-0.2-2.8-7.5-5.7-1-4.6C68.4,268.6,53.1,265.2,57.5,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,210.3c2.3-0.1,3.2-2.9,5-3.6c1.8,0.8,9.9,0.3,5-2.1C107.4,204.8,95.1,207.7,99.3,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.2,411c-0.7-2.2-2.6,0.4-3.6,0.2c-4.4-4.4-11.7,10.4-1.2,1.4C167.5,411.2,169.1,416.3,171.2,411z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,254.6c6.2-0.7-6-6.8-8.4-6.5C68.4,250.4,76.7,252.3,78.4,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.8,239c0.8,1.8,3,0.4,1.8-1.3c-1.2-1.2-5.6-1.9-5.3-3.3c1.4-2.5-5.2-4.3-2.4-0.8 C102.9,237,108.3,236.8,110.8,239z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.3,398.4c2.5-1.3-4.2-6.1-4-9.2C63.1,387.9,70,399.5,72.3,398.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.9,256.5c9.1-0.8-6.8-3.9-9.8-2C128.1,257.3,136.9,255.6,138.9,256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.1,308.6c3.3-9-5.6,3-6.9,6.1C127.2,319.2,130.9,309.2,133.1,308.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.7,255.9c1.5,1.2,3.9,4.1,4.9,1.4c0.8,0.6,1.3,3.4,2.6,1.8c1.2-2.8-5.6-9.2-3.1-2.6 C168.7,255.6,163.7,251.7,165.7,255.9z M170.5,257l-0.1-0.1L170.5,257z M170.4,256.9L170.4,256.9z M170.3,256.6 c-0.1,0-0.1,0-0.2-0.1L170.3,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.9,235.8c-2.8,0.9-9.2-1.4-10.7,0.4C74.1,238.6,87.5,239.7,84.9,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.2,415.5c1.2-1.5,1-5.2-0.7-6.2c0.5,4-2.2,5.3-5.2,7.7C127,417.1,130.1,417.2,131.2,415.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156,210.4c1.3,2.6,3.6,0.9,1.9-1.2c-2.4-2-5.2-3.6-8.1-4.7C145.9,206.2,154.8,209,156,210.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.4,374.8c8.4-8.5-5.1,0.7-6.9,4.5C170.6,383.2,176.3,375.8,177.4,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.7,368.6c14-8,9.2-13.5-0.4-0.5C143.4,368,143.4,368.4,143.7,368.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,375.8c-1.2-1.2-8-2.2-5.6,0.7c3.2,0.1,5.7,2.3,7.8,4.4C14.8,379.9,10.4,376.8,9.1,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.7,357.5c1.4,5.1,8.2-8.5,5.7-8.9C145.5,350,145.4,355.2,142.7,357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.3,257.8C179.4,256.9,201.8,264,203.3,257.8L203.3,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.2,211.9c8.4-3.7-4.3-1.9-7.2-1.2C75,214.8,82.2,212,84.2,211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.7,223c3.2-2.9-5.5-2.9-4.8-4.4c1-0.6,2.7,0,3.4-0.9c0.1-3.8-9.1,0.6-4.3,3.3 C94,221.2,96.1,221.9,97.7,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.5,403c4.4,6,1.1-7.5,1.7-9.6C191.5,391.1,194,401.2,193.5,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.4,200.6c4.4-2.6-7.5-4.7-9-3.8C182,200.4,189.2,198.7,191.4,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,177.1c4.5-5.1-15.8-2.7-7.6,0.1C79.6,176.7,81.6,175.4,84.3,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.2,288.4c2-0.5,9.2-4.7,3.6-4c-2,2-9.5,2.6-8.3,5.7C183.9,290.8,185.9,289.1,187.2,288.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.3,241.5c10-3.2-0.1-4-3.6-0.6c-2,3.6,6.8,5.4,2.8,1.5C181.1,242.1,182.2,241.5,182.3,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,175.2c2.8,1.3,4.3-2.9,6.7-2.6c1.2-1.9-2.9-2-3.6-0.4c-0.7,0.6-1.8,1.2-1.4-0.2 C246.1,168.5,245.1,173.8,246.3,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155,295.2c1,1.7,0.4,10,2.5,9.5C160.5,303.4,154.8,285.7,155,295.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,207.5c10.9-4.6-8.1-3.2-4.8,3.7c1.2,0.9,1.7-0.9,1.9-1.8C25,208.8,26.4,208.6,27,207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.9,351c2.4,1.8,18.5-1.9,7.6-2.3C159.2,349.3,154.1,348,153.9,351z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.1,185.6c-9,1.3-3.7,5.3,1,1.3C187.5,177.1,184.6,175.4,183.1,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.6,394c0.9,1.6,4-5.9,6.3-6.5C166.5,379.6,147.6,388.8,150.6,394z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,326.4c1.5,1.2,5.1,5.2,6.1,1.7C49.4,325.8,39.4,318.2,45.5,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,416.6c0.3-1.8,3.5-4.7,0.6-5.8C53.7,412.4,49.4,418,54.3,416.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.4,313.7c-2.9-1.7-2.9,3.4-4.1,5.2C110,329.2,119,317.6,118.4,313.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1,345.9c2.9,1.5,10.8-1.3,7.2-5C92.3,346,85.7,341.4,88.1,345.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,275.3c5.2-1.7-9-17.2-3.8-7.6C8.3,269.9,8.4,273.7,10.1,275.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.9,416.1c-0.8-7.5-2.5-4-2.3,0.9C202.2,416.9,204.4,417.4,203.9,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.4,293.6c-0.6-2-1-4.1-1.6-6.1C153.4,280.7,161.7,308.5,160.4,293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,390.9c3.5-0.8-4.1-17.2-3.1-8.3C78.2,385.1,77.9,389.6,80,390.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,286.5c2.4,1.2,14.2-4.1,8.1-5.1C15.8,284.6,5.7,283.7,8.8,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,406.9c-4.2-9.1-2.4,4.6-0.9,7.1C20.7,416.8,16.4,408.7,17.5,406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,339.8c0.5-1.8-0.9-6.8-2.7-3.7c1.4,2.6-2,9.7,2.1,9.1C140.4,343.8,139.4,341.4,140,339.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.5,350.7c2-0.1,8.2,3.7,8-0.1C191.8,348.8,178.7,347.5,185.5,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.6,275c1.7-0.8,7.7-2.5,4.5-4.6C202.6,271.2,191.2,279.4,201.6,275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.7,273c1.8-0.9,12-3.5,8.3-6.2C203.1,268.4,193.8,269.7,196.7,273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.6,204.4c2.5,0.5,7.6-10.7,2.5-8.3C66.2,198.7,60.8,202.6,63.6,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,301.7c0.6,1.4,3.5,2.9,3.8,0.6c-0.7-1.3-2.8-2.1-3.4-3.9C28.1,298.3,14,291.3,21.2,301.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.2,174c2.9-0.6,5.1,1,7.4,2.5C202.1,174.7,184.2,168.1,188.2,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.3,277.4c5.1,4.3,0.8-5.3-3-4.6c-1.2,0.2-5.2-1.4-4,1.1C48.7,275.1,52.3,274.3,53.3,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.6,391c2.3-1.8,3.8-6.9,6.2-9.3C145.2,377.7,137.9,389.8,140.6,391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.6,315.3c0.4,1.7,3.4,8.1,4.9,4.6C26.9,316.5,20,305.8,23.6,315.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.3,408.8c-2.5-2.1-0.1-8-3.5-9.5c-2,0.7,0.3,2.8,0.1,4.2c0.4,1.9,0.7,9.4,3.5,5.6 C203.1,409.1,203.2,408.9,203.3,408.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.2,397.9c1.8,1,7.3-2.2,5.3-4c-2.4,2.6-5.1,1.4-7.8,0C36.6,395.8,40.4,397.2,42.2,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.1,224.7c1.3-5.1-3.3-12-2.4-2.6c0.8,2.1-0.5,3.3-1.8,4.7C17.7,228.9,20.5,225.8,21.1,224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.1,327.6c-0.5,1.6-3.8,5.9-1.1,5.8C136.6,332.2,136.8,318.3,133.1,327.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171,357.7c10.6-2.3,1.5-4.2-3.3-0.8c-1.1,0.4-2.6,1-2.1,2.4C166.7,360.9,169.4,357.9,171,357.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.4,264.2c1.9-0.9,7.8,1,7.1-1.8C78.5,260.6,63.9,263.4,74.4,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,389c1.3,1.8,8.1,7.7,7.9,3.1c-3.2-0.6-5.2-2.8-7.3-5C0.9,385.3,0,388.4,2,389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,411.8c3.5,6.1,2.2-9,0.6-9.7C35.9,402.3,37.6,409.8,37.5,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.2,237.7c1-0.9,7.2-4.1,4.9-5.2c-2.3-0.2-3.4,2.5-5.1,3.4C173.4,235.7,174.8,239.5,180.2,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,333.1c4.3-1.7-6.2-5-7.4-7.8C20.3,325,31.3,333,32.9,333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.8,319.4c0.2-1.9-0.4-7.5-2.9-4.3C161.9,319.3,162.4,329.7,164.8,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,335.2c3.2-2.2-3.9-2.9-4.7-1.6c-0.5,2,3.8,13.6,3.1,6.1C30,337.1,26.9,334.1,31.5,335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,293.2c5-1.1,2.4,3.7,5.5,5.8c2.1,0.4,1.3-1.2,0.6-2.3C155.4,289.4,143.8,291.6,147.9,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.7,182c2.4,0.5,9.4-7.1,4.8-7.6C128.3,178.2,120.7,180,123.7,182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.7,401c0.8-1.7,0.4-9.4-2-5.7c1.2,3.4-0.6,6.3-0.4,9.7C82.6,406.5,82.6,402.4,82.7,401z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.9,329.6c2.9,1.4,3-14.1,0.1-11.2C173.7,322.2,172.2,326,172.9,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5,264.1c-1.1-1-1.7-2.5-2.4-3.8c0.1,0.3-0.2,4.7,0.3,4.8c0.7,0.6,2.5,1,2.1-0.4 C4.1,265.4,3.5,262.9,2.5,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.9,243.6c8.2,4,2.7-3.8-4.8-3.1C76.7,243.4,83.7,242.7,84.9,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.1,359.3c-4.6,0.6,4,12.7,5.4,7.1C55.9,364.9,54.2,362.1,53.1,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.5,401.4c3.9,0.6,3.4,4.6,4.9,7.2c3.2-0.8-0.6-6.2-0.9-8.3C44,400.3,39.7,398.3,41.5,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.7,216.5c6.3,2.1,6.7-2.4,0.2-2.2c-5.8,0.4-7.7,5.1-0.2,2.5C64.4,216.5,64.5,216.5,64.7,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.1,358.5c3,5.8,2.9-6.3,0.1-7.9C128.8,350.8,134.5,356,133.1,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,413.5c1.9-1,0.3-9.4-0.9-5c0.2,2.5-5.1,7.5-2,7.9C49.9,413.9,49.2,417.1,50.7,413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,392.8c2.3,0.7,1.8-2.8,3.1-3.4c0.3,1.1,0.9,2.8,2.2,3c1.8,0.2-0.4-6.9-2.5-3.5c0.4-2.1-3.1-3.9-2.1-0.9 C59.6,389.6,56.7,391.5,58.6,392.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.6,337.4c5,1.8,6.7-18.5,1.7-5.1C176.4,334.1,173.7,335.7,174.6,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.1,254.7c2.6,3,9.9,2.5,3.2-0.6C142.8,250.9,134.5,252.8,143.1,254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,384.6c1.5-1.6-0.9-1.7-1.5-2.8C0.1,382.8-0.5,385.8,1.5,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.3,386.8c-1.3-1.1-7.8-7.4-6.6-2.8C198.1,386,207.2,394.4,202.3,386.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,338.2c7.6,8.7,0-6.4-3.7-6.6C35.4,332.3,40.2,336.9,41,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139,372.7c0.3-1.8,1.1-3.2,2.6-4.2c0.8-3.1-2.6-1.2-3,0.5C135.2,374.6,138.9,384.4,139,372.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,299.2c-0.1-2-3.2-4.8-4.8-3c3.4,1.2,1.7,5,3.3,7.3C154.5,305.7,151.8,301.3,152,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.4,253.2c4.1,4.6,3.4-3.4-5-4.5C140,249.7,149.1,252.2,150.4,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.7,336.7c-4.1-3.9-7.2,12.3-2.9,8C160.2,341.8,160.9,339,162.7,336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.1,334.2c1.4-2.1,3.3-4.3,3.8-6.9c-0.4-4.7-2.7,0.2-3.2,2.2C121.6,330.9,117.5,336.1,122.1,334.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.5,226.7c7.6,0.3-3.5-5.7-3.9-1c-0.7,1.4-1.1,5.2,1.5,4C91.1,228,91.3,225,93.5,226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.5,373.9c1-1.5,9.1-5.7,3.1-5.1C138.9,371.1,141.9,382.4,143.5,373.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.2,409.3c2.3,0.5,7.1,4.4,8.4,1.7c-0.4-2.6-4.8-1.3-6.5-3.3C116.7,405.8,114.7,405.9,118.2,409.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,298c-1.2-3.9-4.8,2.1-5.9,3.7c-2.1,0.5-2.2,4.1,0.2,2.6C118.7,302.6,120.1,299.9,122.2,298z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.4,232.2c3.1-1.5,7.3-3.2,10.4-4.6C198.2,224.3,183.8,230,187.4,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.5,198.8c0.7-3.2-5.1-2.6-7.2-2.9C140.3,196.6,153.7,199.5,155.5,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,318.8c1.6-1.8-2-3.4-3.1-4.4C20.9,304.6,29.7,320.3,33.4,318.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,179.2c4.3,2.3,7.6-11.6,2.9-4.3C30,176.6,25.5,177.9,27.2,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.9,234.8c1.4,0.3,5.2,3.8,5.6,1.3C68,231.8,52.8,230.4,62.9,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.8,195.5c2.5,5.9,13-0.4,1.8-0.2c-0.9,0.1-0.6-1.2-0.4-1.7C79.3,187.7,75.4,192.2,76.8,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.6,201.5c1.3,1.4,3,7.6,5.3,4.8C11.2,203.8,4.6,194.4,5.6,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.8,370.5c2.6-1.2,10.2-8.3,2.7-4.7C151.3,368.6,151.2,374.9,154.8,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,216c4.1-0.3,14.1-10.8,3.8-4.6C36.9,212.7,32.5,213.7,34.4,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108,393.2c1,1.6,3.6,0.8,3.2-1.1c-2.3-0.6-4.4-6.4-6.7-3.8c-1,1.5,2.4,3.5,3.4,4.6 C107.7,393,107.9,393.1,108,393.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.8,407.4c1.1-0.6,4.1-1.4,3.2-3.1c-2.1-1.6-4.5,2-6.9,1.9C163.5,408.8,169.8,409.3,171.8,407.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.7,193.6c2.8-1.1,0-3.3-2.2-1.8c-4.7,1.5-1-0.6-2-2.6C78.3,190.1,82.5,197.3,87.7,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.5,414.9c4.1,2.4,0.7-7.6,1-9.5C194.4,404.4,197.8,412.5,197.5,414.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.3,386.9c0.8-1.6,3.5-5.5,0-4.7c-1.4,3.2-2.6,5.9-6.5,4.9C115.7,389.7,121.5,389.5,122.3,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,342.8c1.4,2.9,3.4-3,2.6-4.6c-1-2.8-7.5-6.4-3.7-1.2C46.5,338.6,46.9,340.7,45.9,342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.4,384.5c0.5-2.1,3.8-3,3.3-5.1c-0.5-1.4-1.9,0.1-2.5,0.7C135.7,383,135.1,394.1,139.4,384.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.8,319.2c3.1,2.5,2.4-7.6,2.1-8.9c-3.4-1.6-1.7,6.9-2.3,8.9C143.7,319,143.8,319.1,143.8,319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,289.2c1.5,0.5,4.8,2.5,3.9-0.7C37.3,283.9,26.7,289,38,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.8,339.5c-1-3.3,2.1-5.3,1.9-8.4C25.2,325.3,18.5,339.8,23.8,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.2,348.8c0.1-1.5,3.2-11-0.8-8.4C134.3,342.4,131.3,349.5,135.2,348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156,192.8c2.8,0.2,6.9-0.8,9.7-2.1c1-2.7-2.6-1.2-3.9-0.9C160.1,190,154.3,190.1,156,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.4,183.1c13.4,0-6.4-5-6.1-1.5C19.6,183.1,22.5,182.6,24.4,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.8,288.9L5.8,288.9c4-1.2-4.8-5-5.1-7.4C-2.4,283.3,3.4,288.5,5.8,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.1,213.3c2.4-0.1,4.4,1.3,6.8,1.5C192.7,213.7,176.5,207.9,179.1,213.3C179,213.2,179,213.3,179.1,213.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.2,292.1c6.3-4.1-7.1-1.7-8.2,0.8C125,295.7,128.4,291.2,131.2,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.6,342.6c1.2,0.9,3.5,2.2,4.8,1.5c0.1-4.1-6.3-0.7-5-7.8C180.7,331,181.4,341.5,183.6,342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,352.3c1.7,0.7,9.2-7.2,5.1-7.6C28,347,21.5,350.1,24,352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,339.2c3.6-2.2-5.6-5.3-7.1-5.6c-0.9,3.1,4.5,4.2,6.8,5.7C77.5,339.3,77.6,339.2,77.8,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,227.9c0.8,1.7,7.3,5.3,6.6,1.5c-1-1.7-4-0.7-4.9-2.5C57.8,223.6,54.8,225.1,58.1,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126,213.4c-0.1-5.2-15.3,1.8-6.2,1.1C121.6,214.2,124.9,215,126,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.4,344.6c7.4,1.5,4.7-3.3-0.7-2.3C194.9,341.8,197.2,345.5,202.4,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.3,254.4c-0.6,2.6,2.3,0.4,3.5,0.4c1.7-0.2,3.5,0.6,5.3,0.2C53.7,252.3,41.5,251.7,40.3,254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.5,269.9c4.2,7,1-5.5-0.1-7.4C7.7,261.8,11.1,268.1,11.5,269.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.9,186.6c2-0.7,5-5,1.1-4.6c-1,2.5-4.1,3.2-5.7,4.5C28.1,188.8,30.5,187.1,31.9,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.8,204.7c4-5.5,0.3-5.8-2-0.7c-0.7,1.5-4.6,1.6-3.2,3.7C84.2,208.8,87.1,206.2,87.8,204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.5,408.8c2.5,7.7,6,6.7,1.8-1c-0.7-1.7,0.9-2.5,1.3-3.8c-1.6-1.9-3.6,3.3-2.9,4.9 C147.4,408.7,147.4,408.8,147.5,408.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,247.8c2.5,0.5,8.6-3.8,5-5.5c-2.2,0-2.6,3.5-5,3.8C21,246.2,21.1,247.8,24.5,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.5,307.8c-1.3-3.8-4.4,6.2-6,7.2C176.4,318.3,178.7,309.9,179.5,307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.1,307.3c-0.5-4.3-7,4.1-7.2,5.4C114.4,315.1,116.7,308.2,119.1,307.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,266.7c4.1,3.3,9.4-5.9,1.5-1.3c-1.2,0.6-1-1.1-0.9-1.8C15.7,255.5,12.2,264.5,15.2,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,319.4c3.4-0.3-3.5-5.2-3.3-7.9C31.6,309.9,36.2,320.8,38.8,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.2,182.4c0.9-1.8,6.4-4.8,3.6-6.3C155.8,176.7,148.9,188.3,155.2,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.4,221.1c1.4-1.3,6.5-7.6,1.6-5.1C37.4,218.5,30.3,226.8,38.4,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.6,340.6c7.8,0.9-5.6-4.4-5.2-7.4C188.5,330.4,196.4,340.2,198.6,340.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.4,362c2.4,0.6,3.7,2.7,4.3,5c3.3,0.7,1.3-3.8,0.1-5.1C100.8,360.6,95.4,359.8,97.4,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,416.3c-0.2-2.8-4.7,0.1-6,0.8C37.1,416.8,43.7,417.9,42.7,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,251.8c-1.3,2,2.3,1.8,3.5,2.6C80.7,258.4,70.1,249.6,65.7,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160,254c9.5,1.4-6-6-6.6-3.5C153.6,253.3,158.6,252.2,160,254z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9,306.7c0-0.2,0.6-0.3,0.5-0.5c-2.5-9.3-0.5-3.6,3.6-5.9c0.5-2.2-2.5-1.6-3.9-1.8 C186.9,297.8,187.9,305.7,189.9,306.7C189.7,306.8,189.9,306.8,189.9,306.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.2,200.5c4.3,2.6,9.7-11.2,4-4.7C108.1,197.5,103.8,198.4,105.2,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.2,295.4c4.4-4.2-4.8-1-6.9-1.9C186,296.7,193.6,296.3,195.2,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,282.3c7.7,3.2-2.6-6.3-4.8-5.1C69.2,279.6,73.6,280.9,75,282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.1,374.8c1.1,1.5,6,8.9,6.4,4C75.1,377.9,69.9,369.6,70.1,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.3,391.3c3.4,6.5,3.8-1,0.7-3.7C93.7,381.9,94.1,389,96.3,391.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,387c-2-1.1-4.9-2.2-7-3.8C5.7,382.1,18.1,392.5,18.8,387z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,230.1c1.7,6.4,4.2,4.6,1.3-0.8c0.2-2,3-3.2,2.4-5.1C50.2,222.1,47.6,228.4,48.5,230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.7,353.9c0.1-3.7-3.7-0.5-2.7,2.4C1.2,356,2,354.9,2.7,353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2,412.1c3.1,3.7,2.7-7,1.9-8.3C23.9,402.7,25.4,410.1,25.2,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.9,409c1.1,1.4,2.7,6.5,5,5c0.6-2.2-2.5-4.2-3.1-6.4C143.6,402.1,140.1,406.1,140.9,409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,191.8c2.3-1.4,7.5,2.8,7.6-1.2C201.7,188.4,190,189.3,195.6,191.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.2,402.6c3.7,1.1,0.2-7.1-1.3-8.2C184.3,394.1,188.8,400.8,189.2,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.7,188.9c3.2-4.2-7.1-0.4-8.7,0.1C147.9,192.3,156.1,189.1,157.7,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.4,404c4.3-3.5-7.3-1-8.5-0.4C116.1,407,122.3,404.6,124.4,404z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.8,220.2c3.4,4.9,6.4,1.8,0.9-1.8C150.5,215.7,147,219.7,154.8,220.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.6,416.2c-0.1-2.4-3.4-1.2-4.8-2.4C101.6,409.1,116.3,420.3,117.6,416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,212.8c2.1,3.1,4.8-3.1,5.5-5C60.4,203.1,58.4,211.3,57,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173,341.8c0.7,3.2,5.7,4.2,2.6,0.3c-2.8-2-1.7-4.9-2.1-7.7C171.4,331.6,172.1,340.9,173,341.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.3,369.4c1.9-0.1,10.7,2.6,8.5-1.1C201.5,368.1,191.1,366.5,194.3,369.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161,213.1c0.5,1.5,12.1-2.5,8.5-3.9C167.8,210,158.8,210.7,161,213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.2,415.1c5.5-3.2-14.9-3.8-6.6-0.8C121.8,415.2,123.8,415.1,126.2,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.6,185.5c1.7-0.3,11.7-2.5,7.1-4.7C163,181.6,155.5,182.8,157.6,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.4,394.6c0.9,0.6,1.9,1.3,1.6,2.6c2,2.2,3.1-3,0.9-3.4C83.9,388.8,79.7,388.4,84.4,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.1,306.4c3.7-1.4-4.8-5.1-6.1-6.3C52.5,301.9,60.4,305.8,62.1,306.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.4,309.4c1.3,1.4,1.4,5.6,4.2,4.3c0.6-0.1,0.9-0.6,0.3-1C158.1,309.9,151.2,301.5,154.4,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.4,179.5c0.6-3.4-8.1,2.3-9,3.5C105.5,186.6,117,180.5,116.4,179.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.3,244.4c2.3-2.4-11.5-6-9.6-1.9C146,242.2,149.1,244,152.3,244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.8,236.5c1.4,0.9,11.2,0,7.9-2.7C197.5,234.6,191.4,233.3,191.8,236.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.1,259.2c-12.6-5.7-15.7,2-0.3,0C90,259.4,90.1,259.3,90.1,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.7,398.9c1.1-3.6-4.3,2-4.4,3.4c-0.2,1.5-3.2,10.4,0.4,5.7C154.7,404.6,154.5,401.2,157.7,398.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.1,350.8c-1.8-0.5-6.6-6.1-7.3-2.3C172.8,349.3,182.2,356.5,179.1,350.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,302.6c2.5,2.2,0.5-2.7,3.4-1.2c2,0.9,0.6-7.1-1.9-5.5C104.9,302.6,100.9,297.6,102.7,302.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,263c3.7-0.9-3.9-3.4-4.4-6.7C-1.9,255.8,4.4,263.7,7.1,263z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.7,294.5c-3.7,1.7,3.9,4.1,5.2,5.4C50.8,298.6,43.8,294.5,41.7,294.5C41.9,294.5,41.8,294.5,41.7,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.8,383c1.1,1.5,0.7,7.3,3.6,5.2C93.9,384.9,87,376,88.8,383z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.3,414.5c-0.9-1.4-0.2-5-2.7-4.4C27.6,412.2,32.9,421.3,32.3,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145,260.6c7.7,2.2,0.1-3.3-3.4-2.9C134.4,257.8,142.5,260.5,145,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.3,197c-1.5,0.4-5.4-2-4.4,1.1c1.9,2,6.3-0.1,7,3.3C139.8,202.4,136.8,196,134.3,197z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.7,227.7c-3.1,4,5.2,0,1.4-3.8c-0.5-1.3-1.6-5.3-3.1-2.5C3,223.5,5.6,225.7,4.7,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.7,358.6c1.8-0.7,11.3-0.9,7.3-3.6C162.5,355,153.7,356.5,156.7,358.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.2,401.4c2.4-1.4-1.8-6-2.2-8.3C71.5,393.4,75.2,401.9,77.2,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.2,315.8c-2.7-0.4-2.3,4.8-3.7,6.5C148.5,328.7,155.5,317.6,153.2,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.7,180.5c-1.5-1.7-5,2.4-6.8,3C132.5,188,144.8,183.8,144.7,180.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.8,373.3C36.3,376.8,54.8,389.4,41.8,373.3L41.8,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.4,259.6c3.6,3.7,2.4-2-1.6-2.8c-1.5-0.1,1.1-0.8,0-2C48.4,254,52.4,259.3,56.4,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.7,396.4c-1.1-1.5-5.2-11.4-6.4-6.6C199.1,390.6,203.8,402.8,203.7,396.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.9,297.6c-4.8-1.2,3.6,7.4,4.8,7.2C16,302.1,10.1,300,8.9,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.1,280.1c0.1-2.1-4.4,0.8-6,0.5C186.7,282.6,201.9,284,203.1,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.2,242.9c2.8-1.9-4.3-3.4-5.9-6.8c-3.2,1.4,3.5,7,5.6,7.1C124.8,242.8,125,242.8,125.2,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.7,174.5c6,2.4,12.1-11.6,3.6-2.8C163.4,172.5,159.3,172.8,160.7,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98,207.6c-0.6-3.2-3-0.2-4.6,0.6c-1.1,0.8-3.5,0.5-3.7,2C91,212.6,97.1,209.5,98,207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.2,352.7c1.5,0.8,8.6,3.1,6.3-0.5C202.5,351.5,192,348.2,198.2,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.8,396.9c1.3,1.4,4.2,3.9,4.7,0.5c-1.6-1.1-3.8-2.6-4.5-4.6C100,392.8,101.3,395.5,102.8,396.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.4,249.3c2.9,0,4.2,7,6.7,4.2C58.3,251.1,50.6,244,51.4,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126,217.7c0.9,2.6,3.9-1.4,5.7-1.4c4.8-1.5,1.7-4.2-1.8-1.9h0.1C128.8,215.4,125.7,215.8,126,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,290.4c2.7,7.1,6.7,0.7-2.9-4C94.4,285.2,101.5,289.8,103,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188,255.2c0.9,3,3.5,2.5,3.2-0.1c-1.5-0.1-1.6-2.2-3-2.9C182.5,247.9,184.2,252.8,188,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.1,285.3c-1.1-1.6-8.5-3.3-8.6-1.2c1,2.4,4.5,0.7,6.4,1.7C123.4,287,126.5,288.4,124.1,285.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,378c2.8-3.5-11-3-9.9-0.1C185.6,377.3,189.4,377.4,192.4,378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.4,193.7c1.6,0.8,5.3-1.7,2.9-2.9c-2.2,1.1-4.9,0.2-7.3,0.5C175.8,194.2,181.6,193.5,183.4,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,393.8c6.3-3.1,6.3-8.1-0.3-2.1C158,393.7,157.8,399.2,161.9,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,223c-0.7-4.2-2.7-1.3-3,1.4c-0.3,1.3-3,2.8-2.2,4C45.1,229.4,47.9,225.1,48,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.6,390.9c-0.2-2.5-0.8,0.2-0.6,1C0.3,391.6,0.6,391.3,0.6,390.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.8,220.3c3.8,5.1,3.1-2.8-3.7-4C131.6,216.9,140.3,218.9,141.8,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102,414.6c4.7,2.5,6.9,0.8,1.5-1.7C97.5,410.7,95.3,414.4,102,414.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159,389.6c-6.6,4.5,4,1.5,5.7-1.3C167.5,384.2,160.2,388.9,159,389.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180,381.1c1.5,0.5,4.3,2.8,5.5,1.1c0.7-2.2-2.6-1.4-3.8-2.5C177.9,376.7,174.2,378.8,180,381.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,224.2c1.9,0.3,6.7,0.3,3.9-2.3C69.8,221.2,59.9,223.7,69.8,224.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.7,193c6.8-7.5-2.9-2.6-4.5,1.4C30.9,197.6,33.3,193.7,34.7,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.7,251.4c8.7,3.5,3.3-2.8-3.5-2.5C158.5,250.4,163.9,251.8,165.7,251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.8,357.3c-1.9,0-10.5,0.5-7.4,3.3C174.1,359.5,183.2,360.2,179.8,357.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162,178.8c2,0.8,12.5-1.5,7.1-3C167.2,176.7,161.1,175.8,162,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.6,296.8c6.9,1.4-1.6-4.4-4.2-4.4C43.3,294.6,49.1,295.7,50.6,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,177.4c2.1,0.7,11-8.9,6.1-7.7C29.4,173.1,22,175.3,23.9,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.6,395.9c-0.8-3-0.6,0.6-0.6,1.2C0.3,396.8,0.5,396.4,0.6,395.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.7,277.3c0.7-1.3,1.8-4.3-0.7-3.7c-1,2-1.9,5.4-4.1,5.9C20.9,285.4,24.5,278.8,25.7,277.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,367.7c2.7-1.2,2.9-6.6,3.9-9.1C137.9,356.5,134.8,368.3,136.4,367.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,217.5c4.1-6.3-3.5-2.5-4.6,1.4C44.8,222.5,47.5,218.8,48.7,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.1,354.8c3.6,7,0-9.3-2.2-8.9C122.6,347.5,125.3,352.9,126.1,354.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4,202.8c1.9,0.5,11-4.9,5.2-4.8C30.6,199.5,23.1,201.3,26.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.9,325.2c-2.5-0.7-1.3,3.2-2,4.4C177.3,339.4,187.3,329.8,183.9,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202,253.3c-1.9,0.8-10.7-0.5-7.2,3C196.9,256.3,204.1,257,202,253.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,338.1c3.1,0,0.4-7.4-0.6-9C15.5,327.7,17.4,338,18.7,338.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.3,267.6c8.3-0.8-2.2-2.9-5.3-2.7C132.5,267.7,138.8,266.9,140.3,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.1,267.2c-0.5,3.6,6.4,0.8,8.4,2.2C48.5,266.1,38.7,266.8,37.1,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.9,237.5c3.9,4.7,0.2-5.7-0.7-7.3C122,227.2,126.5,236.1,126.9,237.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.3,175.4c3.4,3,4.8-7.9,0.7-7.2C58.9,169.7,62.2,173.2,60.3,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.6,199.4c0.4,1.7,0.5,7,3.3,5.2C14.7,202.4,11.6,192.9,10.6,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,203c2.8,2.1,3.1-4.6,4.4-6.1C58,192.4,54.2,202,55.2,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,326c1.1-1.4,7.3-6.2,2.7-6.3C98.6,321.4,91.6,326.6,97,326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.7,330.3c1.7,1.3,3.4,6,5.5,5.2c0.4-2.1-2.6-3.5-3.5-5.2C192.2,325.8,189.5,323.7,192.7,330.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4,407.7c1.2-1.1,9.1-4.8,5-5.8C137.8,403.4,128.1,407.8,134.4,407.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.6,305.2c-1.3-5.1-10.5,7.2-4.8,5.3c1-2.2,2.5-4.1,4.6-5.3C125.4,305.4,125.5,305.3,125.6,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.3,374c5.8,4.5,1.5-4.9-2-5.1C91.1,370.6,95.8,371.9,96.3,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,324.4c1.7,0.4,6.8,4.4,6.3,0.6C64.3,322.9,52.2,320,60,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.8,346.6c11.3,3.2,1.2-3.2-3.7-2.7C191.3,345.9,194.5,346.5,195.8,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,353.5c1.8-1.6,5.1-7,1.9-8.1c-1.3,0.7-0.5,2.8-1.5,3.9C7.1,351,3.9,353.2,7.5,353.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,223.4c0.9,2.4,8.9,4.4,6.6,0.3C151.6,224.3,146.3,218.6,147.4,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,381c0.4-1.5-2-1.6-2.7-2.6c-1.1-0.9-3.4-4.4-4.6-2.2C35.9,377.8,41.1,383.5,42.9,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.7,389.9c1.1-2.6,6.5-4.5,5.1-7.4C153.4,382.5,144.9,390.5,149.7,389.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.2,305.7c5.8-2.3-8.9-15-2.1-5.9C184.4,301.6,183.2,304.4,185.2,305.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,280.1c5.7,0.4-3.7-4.9-4.5-6.4C0.2,275.2,7.2,278.9,8.6,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.5,261.5c9.3-0.3-3.5-4.3-5.6-1.6C115.1,262.2,119,261.1,120.5,261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123,254.7c-1.3-2.2-4-3.6-5.4-5.8C113.8,249.6,122.5,259.3,123,254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.8,184.3c5.3-3.1-5.8-1.9-7.2-0.1C171.3,186.5,175.9,184.7,177.8,184.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.9,403.6c2.1,0.1,8.2-0.2,8.1-3.1C107.8,399.7,98.4,401.3,100.9,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.8,366.9c-2.9-2.2-14.4,1.1-5.8,1.3c1.9-0.6,5.9,1.8,6.1-1.1C185,367.2,185,367,184.8,366.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.8,287.4c-11.6,7,8,1.4,4.5-2.1C194.8,285.9,193.3,286.6,191.8,287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68,289.8c5.5-0.3-3.2-4.3-4.7-5.7C60,285.5,66.3,289.1,68,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,348.1c2.9-3.1-4.8-4.1-6.7-4.4C160.9,346.8,167.9,347,169.6,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.3,193.4c1.3,4.7,3.9-3.2,5-4.6C63.7,183.9,61.5,191.7,60.3,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,229.6c1.7-0.6,6.1-3.4,2.1-3.9C28,227.4,20.3,232.9,29.5,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,338.8c0-2.3-3.9-3-3.6-5.6C-2.3,328.9,3.1,341.9,6.3,338.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.1,361c1.8,1.7,4.2-1.3,6.3-1.3c3.5-4.1-7.1-1.2-6.5,0.8C7.9,360.5,8,360.8,8.1,361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.4,410.6c1.3-0.2,10.1-3.4,6.8-5C99.7,406.5,92,408.4,94.4,410.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,344.4c-0.1-5.6-8.3,2.8,0.9,5.7C112.9,348.3,105.3,348.2,109.2,344.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,416.5c-1.7-1.3-3.2-3-3.5-5.4C17.9,404.7,22.4,420.7,26.6,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160,279.2c4.6,2.8-5.6-11.1-7.2-9.9C151.4,269.6,159.1,277.2,160,279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.9,243.2c8.8-3-0.7-2.6-4.1-1.5C197.4,244.5,203.2,244.1,204.9,243.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.9,357.7c2.7-1,6.3,5.1,6.8,0.7C104.3,355.1,93.9,354.7,97.9,357.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.5,408.1c4.3,1.6,6.3-7.8,0.6-6.8c3.9,5.1,0.2,2.3-0.8,6.7C182.2,407.8,182.3,407.9,182.5,408.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.8,294.8c1.6-2.2-2.8-5.7-3.7-7.4c2.7-0.9-0.3-3.8-1.9-1.8c-0.6,2.9,2.5,4.2,3.8,6.4 C114.8,293.1,114,294.6,115.8,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.9,412.5c0.8-1.3,3.5-2.2,2.8-3.9C178.3,406.1,171.8,418.3,178.9,412.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.2,239.4c11.8,8.3,6.6-1.2-0.5-2C63.3,238,63.4,239.1,64.2,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.7,204.3c2.4,1,5.2-0.5,7.7-0.5C107.6,200.2,93.4,202.2,97.7,204.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.5,341c-2,4.6,4,3.8,1.8-5.2C144.1,333.5,145.7,339.4,145.5,341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,334.7c-0.4,5.6,10.3-3.3,4.7-3.4C93.2,332.7,91.1,333.4,89.8,334.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.3,333.9c1.7,0.2,5.2-1.7,2.7-3c-2.2,1-5,0.3-7.1,1C81.7,334.8,85.9,333.5,87.3,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.9,216.1c2.7,0.1,6.5,0.5,8.8-0.6C116.4,213,103.5,213.6,105.9,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.7,182.9c0,3.7,3.4-0.5,4.4-1.6C144.5,174.6,135.4,179.1,133.7,182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.8,379.8c-0.4-3.9-6.7,4-7.4,5.1C163,388.5,166.8,380.7,168.8,379.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127,297.8c2.2-5.7-4.8,1.2-6.5,2.5C121.5,304,125.4,298.7,127,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.2,344c1.1,0.8,3.1,4.6,4.4,3C182.8,343.3,172.1,335.6,178.2,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.3,178.7c3.9-5.2-5.5-0.3-6.3,1.9C32.2,183.3,35.5,179.5,37.3,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.2,273.8c0.9-6.3-16.6-5.6,0.2,0.2C56.1,273.8,56.1,273.8,56.2,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.2,286.4c4.6-2.4-9.2-2.9-8.2-0.2C129,288.1,132.6,285.7,135.2,286.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,202.4c-1.4,2.2-1.9,7.7,1.3,3.5C55.3,203.1,53.1,195.8,51.7,202.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.8,237c2.1-2-0.4-2.4-2.1-2.2c-1.9-0.1-4.5-1.4-6-1C148.9,236.8,154.4,237,156.8,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.3,272.7c2.1,0.4,8,4.2,8.1,0.7C96.7,272.6,87.1,269.2,89.3,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.6,193.8c-3,2.3-4,2.8-7.2,2.6C158.6,202,168.7,196.3,165.6,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.9,255.5c0.3,2.1,5.1,7.2,5.6,3.1C129.6,257.3,124.8,248.7,125.9,255.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.2,232.5c1.1,1.8,6-2.9,7-3.9C135.8,225.1,128.3,231.2,129.2,232.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,315.1c3.3,7.1,2.6-4.5-0.6-6.2C191.5,307.5,196.5,313.6,195.6,315.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,338.8c-5.6,0.7,4.7,5.4,5.9,0.2C94.2,335.2,91,340.1,88.7,338.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.5,268.7c-0.2-2.2,0-7.6-2.5-7.8c-1.7,1.7,1,3.8,0.7,5.7C175.1,268.4,176.7,272.1,177.5,268.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.2,274c-0.2,2.2,13.1-0.2,8.4-2C105.1,273.1,100.9,271.7,99.2,274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,258.9c0.5-4.5-9.3,4.8-6,5.6C25,263.2,27.2,260.7,29,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.6,410.9c2.3-3-6.3-2.7-7.9-2.4C101.5,412,107.2,410.5,109.6,410.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.9,351.1c-2-2.7,1.7-7.6-1.3-9.1C114.8,342.9,115,354.1,117.9,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.4,232.3c-0.8-1.3-10.3-3.6-7.5,0.1C76,232.3,81.4,235.7,81.4,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,334.1c2.2-2.5-2.4-2.4-4-1.8c-1.3,0.6-2.6-1.4-3.6-0.6C198.6,335.3,204.6,334.5,206.8,334.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,374c-0.1-1.5,1.6-1.7,2.4-2.6c1.3-2.7-3.2-0.2-3.8,0.8C21,377.1,25.3,382.8,25,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31,257.2c2.3,1.4,2.3-2.9,2.8-4.3C35.5,244.3,29.3,254.2,31,257.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.7,338.5c-1.7-3.5-2.1,1-1.9,2.7c-0.1,1.5-1.9,3.4-0.5,4.8C26.4,347.8,26.9,340,26.7,338.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129,274c1.7-1.5,9.8-1.3,7.8-4.2C135.1,270,126.5,271.5,129,274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.3,277.1c3.4,1.1,5.6,1.9,8.2,4.3c2.9-2.2-9.4-8.4-8.4-4.5C148.1,276.8,148.2,277,148.3,277.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,252.4c1.5,1,4.1,6.3,5.2,2.4C94.2,252.2,85.6,245.9,90,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.6,253.5c1.7,0.2,5.5,5.6,5,1.3C105.9,248.2,99.8,252.4,105.6,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.2,377.6c1.3,1.3,1.7,7,4.1,5.4C63.9,381.5,57.6,371,58.2,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.1,177.5c-0.6-1.2-2.5,1.5-3.6,1.9C162.2,185,177.8,182.5,176.1,177.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,172.7c0.7-4-8.5,1.5-7.6,3C142.3,177.6,145.8,173.6,147.9,172.7C147.9,172.8,147.9,172.7,147.9,172.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.2,246c2,0.1,8.7,2.6,8.3-0.8C134.9,245.1,125,242.2,128.2,246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.3,341c1-1-0.9-2.4-0.6-3.7C60.6,325.9,57.7,341.4,63.3,341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.9,318.7c3.8,0.9,1.6-5.6,1.3-7.7C6.6,309.1,9.2,316.8,8.9,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.9,180.9c2.1,1,3.6-3.3,5.9-2.9C125.7,173.1,116,178.4,117.9,180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.2,173c3.2,1.4,3.8,4.3,5.1,7C301.2,177.9,290.4,166.8,292.2,173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.3,416.1c-0.3-1.1,0-2.1-0.4-3C7.1,412.7,10,419.6,11.3,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.3,206.1c1,1.6,4.6,3.7,5.1,0.9c-0.4-1.7-3.1-0.5-3.4-2.3c-3-4.8-4.3-3.3-1.7,1.2 C71.1,205.9,71.2,206.1,71.3,206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,229.1c8.4,0,3.2-15.4,2-2.8C23.5,227.3,19.7,227.6,21.8,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.1,281.7c2.9,0.1,3.7,5.5,6.7,3.6c0.5-1.6-2.4-3.1-3.4-4.5C151.4,279.6,147.2,279.7,149.1,281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,245.3c5.6,2.4-1.5-5.8-3.3-6.6C111.9,239.8,117.4,243.5,118.1,245.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.1,329.1c1.1,7.5,3.1-0.5,2.4-3.8C137.4,322.6,136.4,327.4,137.1,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.6,368.8c0.7-2.3-4.1-8.3-5.8-5C60.2,364.4,63.8,371.4,64.6,368.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.8,373.1c6.6,2.8,1.6-2.7-1.7-2.9c-1.6-0.4-5,1.8-2.3,2.6C191.3,372.1,192.5,372.4,193.8,373.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,361.1c2.2,6.5,2.9-2.1,2.2-4.8C108.6,354.2,110.1,359.6,109.8,361.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.7,323.3c1.6,1.3,2.8,6.4,5,3.3C43.8,324.3,36.6,317.8,38.7,323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.6,405.5c3.4-3-2.5-1.9-4.2-1.7C99.6,404.7,108.6,407.2,111.6,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.9,289.4c2.2,0.4,6.3,1.9,7.7-0.4C21.7,287.5,9.8,286.2,13.9,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.5,364.3c1.1-0.1,10.5-2.9,7-4.4C166.6,360.6,160.3,361.7,161.5,364.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,260c4.5,2.7,13.3-0.4,3.3-1C39.6,258.8,34.9,257.7,37.5,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.6,292.7c7.9-1.6-2.5-4.1-4.7-0.8C198.8,294.3,202.2,292.9,203.6,292.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,381.2c1,1.5,2.8,7.7,5,5.1C25.7,384.7,20.4,375.4,20.5,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.1,236.3c8.1-1-1.7-5.7-0.7,0.4C136.5,241.7,147.4,237,139.1,236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.8,369.2c1.5,1.6,5.9,6.6,7.6,3.4C57.9,372,51.6,364.8,51.8,369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.1,235.1c2-0.7,2.9-4.6,0.1-4c-0.8,2-2.8,3.1-4.1,4.6C35.5,238.8,39.3,236.5,40.1,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,217.4c5.3-1.8-7.8-5.7-6.2-1.4C84.8,216.4,86.9,217.2,88.9,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.3,275.6c2-3.8-6.4,0.1-8.1,0.2C106.7,279.5,115,276.2,116.3,275.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,351.9c0.2-4.3-4.9,0.9-6,1.8c0.6,4,4.6-0.6,6.2-1.6C96.7,352.1,96.7,352,96.7,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.1,308.1c-1.3-6.1-1.2,1.9-1.1,3.8C3.1,314.4,2.3,309.6,1.1,308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3,343.6c1.6,1.4,3.2,6.3,5,6C73.7,347.7,65,338.9,66.3,343.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,388.8c0.8,0,2.1-1.9,0.8-2c-2.5,0.5-6.1-5.6-7.6-2.3C32.9,386.4,36.2,388,38.5,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,292.4c4-6.4-4,0.3-6.2,1.5C130.4,297.2,135.2,293.6,136.4,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.8,404.1c0.1-1.7,0.3-8.7-2.3-6.2c-0.5,2.3,1.2,5.1,0,7.7C206.3,407.1,207.9,405.5,207.8,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.6,356c2.5-0.9-4-10.3-4.8-5.6C84.7,351.8,84.9,356.1,87.6,356z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.7,233.1c5.6-5.9-2.9-0.9-5.3,0C131.2,236.2,136.6,234.4,137.7,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.5,391.2c-1.9,5.8,7.1-3.2,4.1-6C53.7,384.5,55.6,391.2,52.5,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,349.8c2.6-1.1,3.6-11.4-0.2-8.1C5.9,347.8-1.5,349.5,3.5,349.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,392.3c1.2-0.9-1.6-9.5-3.4-7.1C70.2,387,71.1,393,73.5,392.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.7,207.8c1,1.3,11.5,1.7,6.9-1.4C164.6,206.5,159.1,204.7,159.7,207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.8,191.3c-1.1,3.3,3.1,0.6,4.5,0c1.4-0.1,4.6-1.1,2.6-2.8C172.5,188.9,169.5,189.6,167.8,191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,282c5,3.6,14.3-5.2,2.6-1.2C9.7,281.1,7.3,280.4,8,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.8,251.3c1.9,1,3.5,5.3,5.9,3.4C87.9,252.6,77.6,246.2,80.8,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.4,262.4c8.9,2.5,0.6-3.2-3.4-3C157.5,261.2,162,262.2,163.4,262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.4,228.7c2.2,0,6.6-0.3,7.5-2.6c-0.5-2.4-2.3-0.1-3.7-0.1C128.7,226.6,124.9,226.3,126.4,228.7 C126.2,228.6,126.3,228.7,126.4,228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.8,363.2c0.1,0.2,0.3,0.3,0.5,0.2C174.8,354.1,152.7,359.6,155.8,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.9,388.7c4.4-2.4-5.7-13.3-2-4.4C81.6,385.6,81,388.5,82.9,388.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,188.1c3.8,3.5,5.1-9.2,1.1-6.9C57.5,183.7,55.8,185.9,55.3,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.4,181.9c1.5-4.9-7.2,2-7.1,3.2C126.8,187.3,130.6,182.7,132.4,181.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.3,210.3c-4.7,2.4,7.1,3.8,6.6,0.2C134.7,208.4,131.1,211.7,129.3,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,326.8c3.2,0.5,1.6-6.7,1.3-8.6C168.2,317.6,169.4,325.3,169.6,326.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,348.7c1.6-1.5-0.1-4.5-1.4-1.9c-0.8,1.9-2.9,2.5-4.4,3.4C16.4,353.7,21.2,350.5,22,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68,320c6.2-0.2-3-4-5-4.3C59.8,317,66.9,319.4,68,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.7,311.2c0.5-1.6,4.1-5.7,0.3-4.3C123.6,309.1,123.8,318.5,126.7,311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.8,264.7c8.9-0.7-0.3-3.1-3.7-2.4C109.6,264,114.6,264.9,115.8,264.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,391.8c1.8-0.1,8.7-0.4,2.9-1.9C28.4,388.6,20.8,392.4,29.6,391.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.1,353.9c5.3,1.9,4.4-2.3-0.2-2.3C159.8,350.8,160.7,354.2,166.1,353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.5,357.8c2-0.9,3.7-3.2,6.2-3.7C161.7,349.1,148.4,355.7,152.5,357.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167,329c-0.6-7-3.3-4.2-2,1.1C164.7,336.1,167.7,333.3,167,329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.7,370c0.6,2,4.4,7.3,6.3,4.3C92.6,373.4,88.8,366.8,87.7,370z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,380.4c1.7,0.8,5.4,5.9,6.6,3.2C7.7,381.7,0.4,375.8,1.3,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.9,254c1.1-10.1-1.7-10.7-0.9,0.1C0.3,254.3,0.7,254.2,0.9,254z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.2,410.1c1.2,1.1,9.5-5,5.2-5.5C176.9,405.9,171.7,407.8,173.2,410.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.1,360.9c1.6,2.4,10,0.8,5-1.6c-1.4-0.1-3.4,0.8-4.6-0.2C88,356.3,87.9,359.8,89.1,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,256.3c2.4,0.8,2.8-3.5,4.3-4.7C41.8,245.2,33.9,255,36,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.5,361.5c4.9-4-5.1-0.9-6.4,1.3C187.4,366.6,192.7,361.8,194.5,361.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.5,266.9c1.7,9.4,4.1-6.9-1.1-6.4c0.6-2.6-4.3-2.8-5.8-4.4c-5.6-0.1,3.8,5.4,5.6,4.7 C168.5,262.8,170.7,264.8,170.5,266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.6,389.1c3.3-1.8-9.3-8.7-6.9-4.4C181.8,386.4,184.4,387.7,186.6,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.2,236.3c1.4-0.1,5.8-1.6,3.6-3.3C167.2,233,158.8,236.9,167.2,236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,277.7c-1.2-1.3-0.5,1-0.7,1.5C0.4,278.9,1,278.2,0.7,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.6,399.8c5.9,3.1,0.1-5-2.2-5C93.7,396.5,97.5,398.5,98.6,399.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.6,188.2c2.2,1.1,3.2-3,5.1-3.6C122.9,179.1,114.7,186.9,116.6,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,300.7c5.3,4.8,3-1.8-0.5-2.8C81.7,295.3,84.3,299.9,88,300.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,223.1c-0.3,5.5,4.8-4.1,2.7-6.3C7.5,215.6,10.4,221.4,8.6,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,218.8c2,0.5,1.3-2,1.7-3.2C11,204.9,4,213.7,6,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.1,213.4c-0.5,1.7-4.8,4.8-1.9,5.9c2.5-0.2,7.8-8.3,2.5-8.3l0,0c0.6-1.7,2.8-2.3,3.1-3.5 c-2.2-4.8-9.6,6.5-3.3,3.7C52.2,211.9,52.6,212.9,52.1,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.3,413.3c-3-0.9-2.1-6.3-4.8-7C63.4,408.5,68.6,419.5,69.3,413.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,379.9c9.4-6.5-4-2-4.6,1.8C159.2,383.5,161,380.5,162.3,379.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,371.4c0.4-1.4-2.8-11-3.8-6.2C32.7,366.3,33.6,374.3,35.7,371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,179.6c-0.3-6.9-3.5,1-2.6,4C16.5,186.4,17.1,181.2,17,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.8,282.2c0.8,2.2,10.5-0.7,5.4-2.4C111.8,280.3,106.6,280.2,107.8,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.7,324.4c-2.3-3.7-4.4,2.8-5.7,4.4C114.2,332.4,116.1,325.4,117.7,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,206.6c3.4,0.1,4.6-4.2,0.5-2.4C32.2,204.8,29.8,209.1,36.9,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.8,291.8c1.7,0.6,2.4,2.6,3.6,3.3C19.6,293.5,3.8,283.8,10.8,291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,219.6c-2.1,0.3-5.5-3.5-6.6-1.1C79.4,220.9,90,223.3,86,219.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,202.1c1.3,0,4,2.7,4.5,0.8c0.4-4-13.2-4-5-0.6C149.1,202,149.3,202,149.6,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.3,170.4c3.7-4-4.6-0.7-5.7,1.2C79.3,175.6,85,171.1,86.3,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,318.7c0.8,1.5,4.2,7.7,5.5,4.2C55.1,321.7,48.5,313.9,50,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.3,203.1c2.4,0.2,9.9-1.6,4-2.7C123.5,200.3,117,201.2,121.3,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.4,213c6.8-0.1-2.6-4.1-5.3-2.2C63.7,213.6,69.2,211.8,70.4,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.1,379.7c1.5,0.6,11.6-0.5,6.9-2.3C198.2,377.6,191.4,377.2,193.1,379.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.2,180.4c-0.7-3.8-4.5,2.1-6.4,2.5C143.8,187.5,150.9,181.9,151.2,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.9,290.7c1.9,3.5,6.6,1.1,4.2-0.6c-3.3,1-3-0.7-6.2-2.7C113.9,285.8,117.5,291.2,118.9,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.4,320.1c0.3-0.2,0.6-0.7,0.2-1.1C133,317.6,126.6,331.1,138.4,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.5,366.4c0.7-3-5.4-0.9-7.1-0.5c-3.6-0.5-1.2,2.1,1,1.9C26.4,367.4,28.5,366.8,30.5,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.2,318.9c-1.5,5,4.8-1.3,5.3-3C109.4,312.2,106.5,317.8,105.2,318.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.4,320.2c2-1.1,6.7-7.4,1.6-6.1C113.6,316.4,106.5,320.3,111.4,320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,196.4c1.2-1,6.5-3.5,3-4.7C90.8,192,84.2,198.7,90.5,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,200.4c3.1-3.4-7.2-1.4-7.7,0.1C78.4,203,82.6,200.1,85,200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,240.4c-5.5-1.2,2.8,4.9,4.5,5.3C14.5,243.7,8.8,241.3,7.3,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.4,268.1c2.3-0.4,6.5,3.7,7,0C89.2,266.3,78.6,264.6,83.4,268.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,399.6c0.7,1.1,7.9-6.1,5.8-6.8C146.5,393.8,141.3,397,142.6,399.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.6,395.1c0.9-0.6,0.3-1.6-0.4-2.1C19.6,377.5,20.8,396.1,25.6,395.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,416.8c3.2,1.1,4.2-11.7,1.3-5.9C186.7,412.8,183.3,415.5,185.3,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.5,407.8c3.9-0.6,4.1-4.5-0.1-2.2c-1.4,0.9-3.9-0.5-4.9,0.9C123,408.9,127.1,407.8,128.5,407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.9,212.3c-1-1-7.9-6.3-6.3-2.2C202.4,211.1,209,217.3,206.9,212.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.1,358.3c1.9-0.6,8.2,0.5,6.9-2.6C204.1,355.8,196.4,355.2,199.1,358.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.8,192.2c1.9-0.6,7.4-0.3,6.6-3C130,187.9,121.3,190.6,124.8,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,189c-0.3-2.3-11.1-0.2-6.4,1.8C136.4,190.2,141,191.3,141,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,194.6c2.2,0.5,4.6,0.1,6.8,0.9C138.1,192.2,125.5,191.4,127.8,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,386.6c3.4,6.2,2.7-3.6-3.7-4.7C186.1,384.1,191.7,384.7,192.4,386.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183,175c6.5-9-7.4,1.6-2.9,4.3C181.2,178.5,181.4,175.8,183,175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.8,395.3c1,1.3,1.7,6,3.7,3.4C95.4,396.2,89.1,388.7,90.8,395.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.2,223.8c0.1,0,0.1,0,0.1,0c3.4-4.8-13.8,1.4-6.8,1.9C194.6,224.5,196.9,224.2,199.2,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.6,324.6c2.8,4.2,2.9-5.1,1.4-6.6C153.3,318.1,155.2,322.8,154.6,324.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,214.5c1.8,0.4,6.8-6.5,2.9-6.7C46.6,209.8,42.6,212.7,44.5,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.7,415.3c0.9-1.3-1.5-7.6-1.9-4.2C134.4,413,133.1,420.4,135.7,415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.9,264c0.6,1.6,5.5,7.6,5.8,3.2C111.6,266.5,105.6,259.4,106.9,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,367c4.4-3.2-11.3-3.6-7.2-0.6c2.4-0.5,4.9,0.1,7.2,0.5C206.5,367,206.6,367,206.6,367z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,354.7c5.4-2.6-7.3-1.7-7.8-0.2C23.4,357.3,27.2,354.4,29.7,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.1,257.8c2.5-0.1,6,3.2,7.9,2.1C53.3,257.5,40.6,254,44.1,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.6,378.7c-4.1-6.4-2.4,3.7,0.1,5C105.5,383.2,103.2,380.2,102.6,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.9,231.9c8-3.5-8.8-2.3-4.3,2C32.1,233.7,33.1,231.6,34.9,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,265.9c1.7-0.8,3.6-1.3,5.2,0.1c3.2,0.3-0.4-3.6-2.3-3.2C36.9,262.6,32.9,264.4,35.7,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.5,306.5c0.8-1.7,1.2-4,2.1-5.8C137.3,296.8,133,308.5,137.5,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,363.2c-0.7-1.5-1.7-3.2-0.6-4.8c0.2-3.6-3.1-0.5-2.5,1.7C38.6,362.4,40.3,367,42.4,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.7,375.6c-1.9-2,0.5-8.2-2.6-6.9C128.7,370.4,131.3,380.6,132.7,375.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.8,379.3c1.8-2-3.6-9.6-3.9-4.9C81.9,375.7,83,381,84.8,379.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.5,246.6c1.4,0.5,3.5,2.4,4.9,2c2-2.9-4-3-5-5.1C164.5,242.9,165.2,246.3,166.5,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.1,281.6c0.4-6.3-13.6-5.2-3.3-2C50.1,280.1,50.5,283.4,52.1,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.2,178.1c-0.3-1.8-0.5-3.8-1.3-5.4C0.2,173.2-1,181.5,1.2,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,186.8c3.5-5.2-5-0.6-5.2,2.1C46.2,191.8,47.9,187.3,49.7,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,225.1c2-1.1,3.9-2.6,5.9-3.6C133.8,216.8,122.1,224.6,126.6,225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,233.4c-0.6-2.5-5-0.3-7-0.2C17.2,236.4,27.7,235.1,27.9,233.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.1,399.8c2.7-3.9-4.2-0.8-6.1-2C116.5,400.6,124.3,400.7,126.1,399.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,378.4c4.8,3.3,0-6.8-3.3-4.8C73.4,375.5,78.6,376.1,78.8,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.6,185.1c-0.1-0.7-0.5-1.5-0.6-2.2v2.8C0.3,185.5,0.8,185.4,0.6,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,402.6c-0.4-6.9-3.4,0.6-2.6,3.8C23.5,410.2,24.1,404.3,24.1,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.2,396.2c-1.7-1.3-3.5,1.1-1.5,1.8c2.2-0.1,5.8,4.4,6.2,0.6C13.3,397.2,10.6,396.8,9.2,396.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.8,349.1c-0.8,1.7-2,6.2-0.9,7.6C140.1,357.3,141.9,346.8,138.8,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.1,395.8c2.5,7.3,3.4-0.5,0.3-3.1C17.4,387.9,19,393.8,21.1,395.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.2,376.1c1.5-1.2,4.9-1.7,4.9-3.9C173.7,369.3,163.3,379,170.2,376.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147,401.1c1-1,2.7-1.8,2.8-3.3C147.2,394,138.3,410.4,147,401.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.2,234.9c-1.5-0.7-7-2.1-4.2,1C90.5,237.4,98.1,238.5,92.2,234.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158,204.1c1.6,0.8,8.2-0.3,5.3-2.7C161.3,202.3,152.7,200.8,158,204.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.4,176.3c0.4,1.6,3.7,5.8,3.9,2.3C67.8,176.2,64.8,168,65.4,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,266.8c1.8,0.4,6.9-0.2,3.5-2.4C58.1,264.9,47.9,265.1,57.5,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.9,314.9c7.4,0,5.6-12.3-0.2-0.2C101.7,314.6,101.8,314.7,101.9,314.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.6,330.6c-0.5,1.3,3.7,10.9,4.4,6.3C150.4,335.3,150.7,329.3,147.6,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.4,254.8c0.3,2.3,3.6,5.5,3.1,1.4C7,252.3,1.4,248.9,4.4,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.2,260.8c0.2-3.4-2.3-0.5-2.5,1.2c0.1,1.7,0.3,3.6-0.3,5.3C187.4,268.7,186.7,262.6,187.2,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259,176.9c2.4-0.6,2.9-7.1,1.7-8.5C258.3,169.9,258.7,174.9,259,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.3,297.3c-2.1-1.1-8.5,5.7-3.9,5.5C127.9,300.5,133.2,300,131.3,297.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.7,261.4c6.8,1.9,9.7-2,1.2-2C97.6,258.7,95.6,261,98.7,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,193.9c1.3-1.2,5.5-6.6,1.7-6C15.7,188.9,10.7,196.5,15.1,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.7,384c7.9,9.2-1.9-9.4-3.4-3C203.3,382.1,204.8,382.7,205.7,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,329.2c3,1.5,1.9-5.2,2.3-7.1C144.9,320.5,144.4,327.8,145.3,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,362.2c1.6-0.8,5.7-2,1.9-2.9c-2.1-0.2-3.8,2.2-5.8,1.9C23.5,362.6,30.1,363.6,31.5,362.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.4,344.1c-2.1-2.6-3.7,6.8-3.2,7.8C51.2,352,51.2,346.4,51.4,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.5,291.9c1.3-5.6-8.5,4.6-4.8,4.8C138.5,295.3,139.8,293.4,141.5,291.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132,403c1.9-1,8.8-0.4,6.9-3.7C137.6,400.1,128.7,400.5,132,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,312.1c1.9,0.2,5.6-9.3,1.7-6.6C102.7,307.5,98.8,310.7,101.4,312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.3,302c6.4,1.5,1.1-3.3-2-3.5C23.4,298.3,28.3,301.4,30.3,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,209.8c0.1-2,1-7.2-1.9-6.9C0.3,203.8-1.4,212.9,1.8,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.8,293.6c0.6-1.7,3.6-8-0.2-7.2C168.5,288.2,165.2,294.5,168.8,293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.1,403c1.7-0.4,7.5-1.7,2.9-2.9C164.6,400.1,161.9,405.4,167.1,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,206.8c1.7,0.5,5.6,5.5,5.2,1C197.3,206.1,189.7,201.4,193.6,206.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.5,296c2.3-1.7-2.1-4.3-3.4-5.5C63.5,289.6,69.6,296.9,71.5,296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.9,416.3c-0.7-2-2.7-0.4-3.7,0.6C164.4,416.7,168.8,417.5,167.9,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.7,217.1c1.9,0.3,3.7,5.9,5.6,3.5C162,218.1,153.7,212.4,155.7,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.6,362.8c5.2,0.6-5.9-9.8-4.8-4.5C78.5,359.7,80.1,361.2,81.6,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,373.2c2.6-1,7.8,0.7,9.2-1.3C9.1,370.6-3,370.6,1,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.8,179.1c15.6-5.1,2.8-7.1-0.3-0.2C108.5,178.8,108.6,179,108.8,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.7,415.2c2.2-9.6-5.3,2.7-0.5,1.8C157.3,416.3,157.5,415.9,157.7,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.2,381.4c-3.6-2.6-13.3,5.9-4.2,2.3C174.4,383,177.3,383.5,177.2,381.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,265.6c-1.2,3.2,4.3,1.1,6.1,1.5C159,264.6,149.2,264.2,147.9,265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,309.8c-0.2,3.7,2.8,5.1,2.6,0.8C15,306.2,10,303.5,12.2,309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102,187.8c-6.7,3.2,5.5,2,6-0.7C108,183.9,104,188.2,102,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,172.1c1.6-4.4-7.6,0.4-6.8,3C120,176.4,122,171.9,124.5,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.2,329.6C76.3,334.5,63.4,323.4,61.2,329.6C61.1,329.6,61.2,329.6,61.2,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.9,377.3c3,0.2,4.2-12,1.1-5.9C118.9,373.4,116,375.7,117.9,377.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.9,269.4c1.8-0.9,6.2,3.2,6.1-0.5C80.6,267.1,71.2,266.8,75.9,269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,223.7c2.8,0.5,3.9-5.9,2.1-7.2C12.4,216.4,14.1,221.7,13.2,223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,344.9c0.2,1.2,2.4,5.2,3.3,3.3c-1.9-2.2-1.5-4.4-0.6-6.7C112.6,338.7,110.5,343.2,111.7,344.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.2,248.9c1.2,1.2,6.1,7.3,6.3,3c-0.6-1.2-2.8-1-3.7-2.2C189.1,247.7,184.4,245.5,187.2,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.7,381.9c-2.8-3.8-3,4.6-3.1,6.1C133,389.9,131.5,383.6,132.7,381.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,379.4c0.4,3.6,5,4.6,2.3,0.2C51.7,374,49.5,373.3,49.6,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129,395.8c5.5-4.4-3-1.6-5.5-0.7C123.1,397.4,127.5,396.4,129,395.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,305.9c1.6,0.1,9.6,0.4,6.6-2.4C49.9,303.2,42.6,303.3,44.8,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,377c1.1,2.9,5.4,3.8,2.9-0.2C54.9,373.2,50.7,371.4,54.1,377z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,282.9c5.3-2.2-12.7-4.9-6.2-0.9C135,281.4,137.4,281.9,139.2,282.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,356.2c1.1,1.6,0.3,5.6,2.8,5.7C111.3,361.3,106.2,351.5,105.7,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.8,184.6c2.7-5-10.7-6-4.6-2.5C201.2,181.8,202.1,184.8,203.8,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.3,301.5c2.4,0,3-3.3,5-4.3C145.4,293.3,137.7,301.1,141.3,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,191.5c0.8-1.6,5.4-2.3,3.8-4.4C22.4,187.1,13.4,195.6,21.5,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.3,321.8c3.3-2.4,1.6-6.7-1-2C118.5,322.5,119.7,326.5,123.3,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.8,189c0.8-1.6-2.3-1.6-2.4-3c-0.3-1.5-1.3-2.2-2.8-2.2C67.2,184.8,73.1,191.5,74.8,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99,416.3c-3-2.4-3.8,1.5,0.8,0.6C99.5,416.7,99.3,416.5,99,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.7,214.6c2.4,2,2.2-5.9,3.3-7.4C2.9,205.5,2.3,212.5,2.7,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.9,245.7c10.2-3.7-7.3-2-7.2,1C204.8,247.9,207.7,245.9,209.9,245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,345.5c1.9,3.1,6.2-6.8,2.6-5.9C149.2,340.9,148.2,343.7,147.9,345.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.3,236.7c-4.6-5.3-0.3,5.1,3.1,4.9C57.3,239.7,52.4,238.1,51.3,236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.4,332c0.1,5.6,10,8.5,2,1.9C188.9,331,186.6,324.3,187.4,332z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.1,263.5c1.5,1.4,6,1.6,4.1-1.2C129.6,261.3,121.3,260.3,128.1,263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,191.7c-5.3,3.3,4.5,2,6.1,0.6C29.9,189.6,26,191.5,24.2,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.4,187.4c2.8,1.6,2.6-6.4,1.5-7.1C4.9,180.4,5.9,185.5,6.4,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.6,365.8c2.2,0.2,6.2,2.9,7.7,1.1C81.2,365.3,70,362.6,72.6,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,235.9c-3.4-0.4,3.3,7.5,4.5,7.2C108.9,240.5,104.1,238.1,102.9,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,284.1c7.6-3.1,0.2-3.3-3.6-1.1C25.8,285.7,29.6,284.4,30.9,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.6,318.4c0.7,1.5,5,5.1,4.2,1.4C46.5,317.3,39.4,312.7,43.6,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.7,362c5.3-0.9,2.7-4.1-1.2-1.8C193.6,363.2,194.9,365.4,199.7,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,404.5c0-1.5-2.8-7.2-3.9-4.2C17.1,402.1,19.9,411.1,20.5,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,247.5c1.6,0.8,7.1,0.4,5.1-2C11.9,246.2,1.7,244.2,8.8,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,358.5c4.3,1.5-2.1-6.8-3-7.3C60.5,352.8,64.6,356.8,65.7,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.5,356.4c0.1-1.4,4.4-8.1,1.4-7.1C149.1,350.9,145.4,360.7,149.5,356.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.7,296.8c3.5,0.9,2.1-2.9-0.5-2.4c-2.3-0.9-1.3-3.9-2.7-4.8C171,290.9,175,296.3,176.7,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53,335.2c2.2-1.2-4.3-3.9-5.2-4.1C44.7,332.6,51.7,337,53,335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.7,249c6.4,2.3,1.6-3-1.9-3.5c-2.8,0.7,0.3,3,1.8,3.4C62.5,248.9,62.6,248.9,62.7,249z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.2,328.3c-2.4-0.2-4.8,10.6-0.8,5.9C171,332.9,173,328.5,171.2,328.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7,406.9c4.1,1.8-0.7-8.8-2.3-5.7C71.8,403.1,73.5,405.9,74.7,406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,405.4c4.5,2.6,0.4-10.3-1.3-6C67.7,401.6,70.1,403,69.4,405.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.6,342.7c-2.8-3.1-1.2,6.3-1.6,6.9C1.7,348.1,2,344.8,1.6,342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.9,195.7c3.3,1.2,6.9-9.4,2.5-5.1C108.9,192.4,105.3,193.7,106.9,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.6,416.8c-0.1-3,3.8-6.4,1.9-9.1C60.7,409,56,417.6,59.6,416.8C59.6,416.9,59.6,416.8,59.6,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.2,246.6c2.4-0.6,6.9,3.2,7.3,0.7C49.1,244.8,38.6,243.5,41.2,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,242.2c1.5-0.7,6.9-1,3.4-3C35.4,238.6,28.2,243.3,35,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.4,393.5c1.9,1.7,2.8-2.9,4.2-3.8C150.7,383.4,141.7,390.3,142.4,393.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.9,281.1c-5.4,1-3.1-0.6-6.4-1.6C176.1,283.5,186,286,183.9,281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,274.2c-1.1,1-8.5,2.7-4.8,4.1C190.3,278.4,198.2,273.6,193,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,185.6c-2-5.8-3,1.3-1.9,3.9C14.1,192.2,14.3,187.2,13.6,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.8,270.7c0.5,1.5,3.5,5,3.6,1.6C5.6,267.7-0.9,265,3.8,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,176c0.9,1.9,0.4,7.3,2.5,7.4C76.2,183.1,73.4,175.2,71,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.8,271.9c2.6-0.6,0.3-2.5-0.7-3.5C0.2,269-0.3,271.8,0.8,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.6,261.9c-1.4-6.8-3.8-4.1-1.8,1.3C181,268.5,184.6,265.2,183.6,261.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.2,174.1c-7.5,1.4,2.6,3.4,4.9-0.2C277.2,170,271.7,174.1,270.2,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.5,197.7c3.6-2.5-7.7-5.4-6-1.9c1.4,1.2,4,0.9,5.7,2C179.2,197.7,179.4,197.7,179.5,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73,415.9c-0.6-0.3-0.9,0.6-1,1.1h1.7C73.4,416.7,73.3,416.2,73,415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.4,400.1c-4.4-2.5-2.3,14.3-0.4,6.4C159.6,404.2,159.6,402.2,160.4,400.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.4,242.3c2-0.4,4.3-0.2,6.3-0.6C197.9,237.9,185.9,239.9,189.4,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.1,225.6c7-3.5-1.7-2.4-4.1,0C174.2,228.9,180.7,227.2,182.1,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.1,275c1.7,0.7,3,2.2,4.8,2.7C82.3,277,71.3,270.2,72.1,275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,263.1c2-0.1,7.3,3.3,7.5,0.4C67.3,262.3,58.3,259.4,60.4,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.4,339.7c-0.1,2.2,3.6,5.7,3.2,1.8c-0.5-1.4-1.2-2.7-1.1-4.2c0.1-0.9-0.4-0.7-1.1-0.7 C125.6,336.6,126.4,338.6,126.4,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,234.5c-5.7,2.6,11.6,3.6,5.4,0.1C14.1,234.4,12.3,234.2,10.5,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106,174.4c2.6,2.5,11.2-4.7,4.2-2.9C109.3,172.7,104.9,172.2,106,174.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.3,206.2c1.1,0.2,1.1,1.1,1.5,1.8c2,2,1.6-1.9,0.5-2.8C126.3,201,120.2,204.4,127.3,206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.4,378.6c0.8-1.6,7.8-3,3.7-4.5C159.7,374.3,152.9,380.7,158.4,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,345c-2.4-0.4-1.1,3.8-2.5,5.1C10.7,357.7,17.6,346.8,14.7,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,383.2c1.6-5.2-2.8-3.6-2.4,0.8C106.2,390,107.3,387.5,107.3,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.3,339.9c2.2-0.4,5.3,4.2,6.8,1.5C75.1,339.7,65.1,335.1,69.3,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.6,383.6c-1.7,4,9.4-1.3,7-3.1C151.4,381,148.6,382.5,146.6,383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,394.6c2.3,5.5,3.3,0.4,0.9-2.2C13.6,389.2,12.4,392.3,17.1,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.2,322.8c3,4.6,2.8-8.1-0.6-6.6C192.2,318,193,320.8,193.2,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,187.5c0.6,4.1,6.5-3.4,4.4-4.5C52.7,182.3,52,186.8,50.4,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.3,184.7c-4.7,1.6,3.7,3.1,5.1,3.4C204,185.9,197.8,184.9,196.3,184.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,394.1c3.9-3.3-3.7-12.7-1.5-3.6C44.3,391.3,43.8,394.5,45,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,253.1c1.4,0.3,1.4-1.9,2.1-2.7c0.5-1.3,3.6-3.5,0.6-3.8C29.7,246.5,26.3,252.5,28.4,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.2,370.8c-0.8-1.3-7.9-7.7-5.3-2.3C43.9,370,47.1,374,48.2,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,256.2c5.5-2.7-3.3-2-5.3-0.4C17.3,259.2,22.5,256.4,24,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.5,171.4c-3,2.3,3.8,3.1,5.3,1.6C79.4,168.9,74.4,171.9,72.5,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.7,400.4c-1.9-1.4-5.2-2.3-6.4-4.5C105.7,397.3,115.9,404.3,115.7,400.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3,259.9c2.4-2-2.9-3.7-4.3-4.3c-0.7-0.8-2.6-2.6-2.2-0.3C89.1,257.9,92.2,258.1,94.3,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.2,229.2c1.5,0.9,2.2,2.5,3.9,3.1C158.5,232.6,145.9,222.7,149.2,229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.9,415.9c-0.9-2.1-2.5,0.2-3.5,1.1C171.2,416.9,174.2,417.6,173.9,415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.4,273.7c1.6,0.7,1.9,5.9,4.2,4.3C178.4,275.8,170.1,268,172.4,273.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.8,194.4c-3-2.6-12.1,1.4-3.2,1.6C190.8,195.9,193,196.1,192.8,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,274.3c6.9,0.2,0.6-2.3-2.3-3.2C72.6,270.9,77.5,274.2,79.4,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.8,369.6c-1.3-1.7-9.9,0.2-6.4,2.5C169.1,370.2,173.5,372.3,173.8,369.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,407.1c1.5,0.5,6.7,6.6,5.2,2C56.9,406.4,47.2,403.6,52.8,407.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.8,250.3c1.5,0.3,1.5,2.1,2.4,3c2.1-0.5,0.7-3.2-0.3-4.3C58,246,54.2,247.2,58.8,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.8,184.4c2-6.4-6.2,2.1-3.3,4.4C80.1,188.7,80.5,185.4,81.8,184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91,292.6c3.6-5-12.6-8.8-0.2,0.2C90.8,292.7,90.9,292.7,91,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.9,360c-0.7-1.5,0.7-5.8-2.2-5.1C116.6,357.2,118.8,366.5,119.9,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,260.6c6.5,2.7,0-4.8-2.9-3.7C104.9,258.7,107.9,259.9,109.2,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.4,213.5c5.6,3.1-1.7-7.2-3.9-5C9.1,210.6,13,211.3,13.4,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,325.4c-5.3,3.9,0.8,5,2.4,0.5C104.9,322.9,102,322.4,100.8,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.2,247.5c1.7-0.2,6.6,2.9,6.1-0.5C158.8,245.2,150.1,245.5,154.2,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.5,214.1c-1.9-0.1-4.5-0.3-6,0.7c-0.7,3.2,3.6,0.9,5.3,1.8C79.1,217.2,79.7,214.3,78.5,214.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,203.8c2.7-2.7-5.7-5.8-4.2,2.2C21.5,205.7,18.4,202.3,22.8,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.8,395.5c5.8-2.6-9-4.3-5.2-0.1C31.3,394.7,33,395.1,34.8,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.4,287c3.5-3.3-10.5-7.5-4.1-2.7C70.7,285.1,71.5,287.5,73.4,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,312c2.9,0.3,1.5-4.4,2.2-6.2C169.8,301.3,168.5,311.2,169.6,312z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.5,307.6c-1,4.1,2.8,5.6,2,0.6C91.8,303.5,88.9,301.3,89.5,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.2,386c-5.5,0.2-11.3,5.5-1.8,2.4C176,388.9,178.5,386.7,176.2,386z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.8,240.1c4.3-0.2,4.6-3.5-0.1-2.5c-4.3-3.4-3,1.4-0.1,2.5C132.5,240,132.7,240.1,132.8,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.2,355.2c-1.8,2.3,3.1,1.2,4.1,0.8c1.2,0,5.9,0.9,4.2-1.5C14.5,354.1,12.1,354.6,9.2,355.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.7,176.6c1.8-0.2,3.6-0.3,5.3-0.6C95.5,171.9,82.6,174.3,87.7,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.3,223.5c2.8-1.2-0.6-4.7-0.4-6.9C0.1,216.7-0.5,224,0.3,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1,375c4.7,3.9,1.1-3.7-0.5-5.2C27.9,369.1,31.6,373.7,32.1,375z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.6,283.6c4.8-1.4-3.2-3.4-4.9-3.3C79.8,282.4,85.1,283.7,86.6,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,263.7c3,2,8.3-8,3-4.4C31.6,261,27.8,262.1,29,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.8,204.4c1.8,0.4,3.7,1.4,5.6,1.3C178,203.4,165.5,200.6,168.8,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.1,399.1c5.7-1.4-1.6-3.1-3.9-1.8C168,400.5,172.3,399.4,174.1,399.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,226.1c-0.7-1.8-7.4-5.1-5.7-1C84.3,224.9,88.4,230.3,88,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.3,187.4c1.3-0.9,3.8-1.3,1.8-3.1C110.8,183.6,107,191.7,113.3,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,294.3c4.2,5.6,3.3-1.1-0.2-2.8c-0.8-0.3-0.7-1.3-1.2-1.5C3.8,291.3,5.7,293.5,7.1,294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,177.9c4.7-0.1-5.6-7.4-5.1-3.4C16.3,176.1,18.3,176.7,20.1,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115,202.5c6.6,4.2,1.9-3.6-2-1.9C107.5,201.8,112.6,202.8,115,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,326.7c1.2-0.3,2.5-7,1-7.3C15.6,319.2,13.9,328.7,16.1,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,198c5.4,3.5,13.3-2.6,2-0.7C21.3,196.9,19.8,196.6,20.1,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.8,298.5c6.2-0.2-1.2-4-3.7-2.8C30,297.8,34.4,298.2,35.8,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.4,235.9c1.4,0.6,5.3,4.7,5.7,1.5c-1-1.6-9.1-6.2-5.8-1.5C2.2,235.8,2.3,235.9,2.4,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,398.3c1.4-1.5,2.9-4,4.7-5.6C139.8,387.7,131.1,396.9,134.1,398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.7,246.5c1.4,3.5,11.1-4.1,4.1-2.2C193.6,245,190.1,244.5,190.7,246.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,212.6c5-2.2-5.1-3.7-5.7-1C27.9,214.2,31.7,211.6,33.3,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.8,223.2c-0.5,2.5,5.5,0.1,7.1,0.4C140.2,220.3,132.8,221.7,131.8,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.6,401.5c5.7-2.1-7.6-4.6-4.8,0C177.3,401.9,179,401.4,180.6,401.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.7,221.3c-3.7,4.1,10.1,0.9,5.5-1.3C61.5,220.6,59.3,220.6,57.7,221.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.2,205.6c1.5,0.2,3.8,4.3,4.7,2C205.9,204.3,194.9,201.9,200.2,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,252.4c1.5-1.7-5.6-9.3-4.7-3.9C122,248.8,121.7,253.6,124.2,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.4,357.4c0.3-1.5,3.6-5.1,1.3-5.7C50.5,352.9,46.2,363.1,51.4,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183,220.6c14.3-2.5,1.8-6-0.4-0.1C182.6,220.4,182.8,220.6,183,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.6,205.7c2.6,2.3,7.9-8.4,3.3-4.8C93.5,202.8,89.2,203.6,90.6,205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,219.7c6.1,0.4-5.4-8.9-3.9-3.1C144.2,217.7,146.4,217.6,146.8,219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.4,250.7c0.6,1.1,3.3,5.8,4,2.8C115.3,251.1,108.4,243.9,111.4,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.2,317.6c2,0.8,1.2-1.5,1-2.6c-0.2-1.4,1-3.6-1-4C139.3,311,139.9,316.9,141.2,317.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,415.2c0.1,0.4-0.4,2.1,0.6,1.7C0.3,416.4,0.3,415.7,0,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.2,248.8c5.7,3.5-2.1-9.3-3-5.7C104.2,245.7,108.4,246.4,107.2,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.5,389.4c4.7-0.4,4.9-11.3,0.6-3.1C123.6,387.6,121.4,388.4,123.5,389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34,220c1.7-5.7-8.8,4.1-4.4,3.7C31.1,222.7,32.6,221,34,220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,244.1c1.8,0.1,5.9,3.8,6.3,0.6C70.8,243.4,63.8,240.6,65.3,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,249.1c6.9-0.9-2.4-3.5-4.7-2.1C82.4,250,87.4,248.2,88.7,249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.8,412.8c0.3-1.9-0.6-8.7-2.4-3.8c0.6,1.7-0.2,4.2,0.9,5.6C36.4,415.1,35.9,414.2,35.8,412.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.6,409.4c2.4,3.3,7.7,2.3,2.8-0.9C79.4,406.7,76.8,405.9,78.6,409.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.4,238.9c1.4,0.5,5,2.3,4.9-0.4C59.9,236.4,51,235.3,56.4,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,347.4c2.5,1.7,4.4-2.5,6.2-3.8C102.3,340.9,97,346.2,97.3,347.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,172.3c0.3-1.1,1.5-4.7-0.7-4c-2.1,0.3-0.8,2.7-1.6,4C5.9,176,9.4,175.1,10,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.2,345.1c6.9-0.9-1.7-2.2-3.5-3.3C74.8,342.8,81.5,344.7,83.2,345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,411.4c0.1,1.5,0.6,7.7,2.5,4.2C196.6,413.1,194.2,405.2,193.6,411.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5,395.3c0.3,1.5,1.3,6.3,3,4.6c1.2-1.8-1.7-3.2-1.2-5.2C4.7,391.7,1,393,2.5,395.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.5,244.9c1.6-2-2-2.3-2.9-3.6C168.7,238.7,176.7,246.9,178.5,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.3,246.3c-1-1.1-3-6.3-4.6-3.8C112,244.3,116.9,252.1,116.3,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.8,199.5c2.2-3.9-8.6-1.4-6.3,1.2C37.3,200.4,39.6,199.6,41.8,199.5C41.6,199.7,41.7,199.6,41.8,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.4,235.2c5.6,0.2-5.8-15.4-1.3-5.2C101.1,231.4,99.7,233.5,100.4,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.1,329.9c6.2,4.2,6-11.9,3.4-2.8C85.3,329.2,81.3,327,82.1,329.9C82.1,329.8,82,329.9,82.1,329.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.7,313c-2.5-4.2-4.3,7.9-1,5.7C168.8,317.3,168.4,314.8,168.7,313z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.5,174.7c0.6-1.4,4.7-4.7,1.5-5.2C132.7,170.8,129.3,179.4,133.5,174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,263.9c-4.1,1.1,4.2,3.3,5.3,4.1C53.1,265.7,46.7,264.8,45.2,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.2,302.3c-2.1,4.3,3.4,0.9,4.5-0.8C136.7,296.7,131.6,301.1,130.2,302.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.1,242.9c1.2,1.4,6.4,6,4.4,1.3C52.3,243,46.1,237.8,49.1,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.3,258.9c1.6-0.2,8.2-0.1,5.8-2.7C15.2,256.1,6.5,257.1,10.3,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.9,254.2c1.1,1.6,4.7,1.7,3.3-0.7C174.2,251.7,168.9,247.3,173.9,254.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.6,184.5c0.2-0.2,0.2-0.6-0.1-0.8C203.4,173,208,188.5,210.6,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.3,416.2c0-1.8-2.4-0.8-1.9,0.7C146,416.8,147.5,417.3,147.3,416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,376c1.2-1.9-1.7-4.1-2.3-5.9C103.1,369.7,107.2,378,108.6,376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.2,324.9c3.6,3.4,1.4-10.3-0.9-5.9C176.6,320.9,176.9,323.1,177.2,324.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.6,216.1c-1.8,1.5-4.9,0.7-6.6,1.9C109.4,221.1,121,218.9,117.6,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.9,220.1c3.2-2.8-6.2-2-6.8-1.1C101.1,221.3,106.3,220.4,107.9,220.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.8,331c-0.3-6.6-4.1-4.8-1.7,0.6C151.8,335.2,155.1,333.7,152.8,331z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.1,331.4c-1.9-1.3-2,2.6-3.4,3.3C111,340.4,118.1,333.7,116.1,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.8,219.9c3.7,2.7,10.5-3.2,3.3-1.8C72.7,218.6,70.2,217.5,70.8,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,267.4c-1.1-3.5-5.6,3.1-5.1,4.7C24.7,273.3,26.3,268.6,27.7,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.6,315c0.2-1.8-1.8-6.4-4.1-5.2C44.2,310.9,47.1,317.5,48.6,315z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.9,390.8c1,1.3,5.7,5.1,5.9,1.9C184.5,391.4,176.4,386.3,179.9,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,409c-1.6,0.4-0.5,1.6-0.3,2.6c-0.3,0.8-0.2,1.9,0,2.7C10.7,421.3,17.9,409.9,12.9,409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.3,271.9c0.5-4.4-4.8,0.9-6.1,1.9C30.3,276.3,33.9,272.9,35.3,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.4,319.7c2-0.7,3.2-3.5,0.3-2.9C91.7,319.7,91.2,324.3,96.4,319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.6,247.4c0.5,1.6,2.4,6.9,3.3,2.9C176.8,247.2,170.5,241.1,173.6,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,237.6c-0.1-3.2-4.9-0.8-6.9-0.9C18.9,240,25.5,237.9,27.2,237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.1,171.2c2-3.7-9.2,1.2-5.7,2.6C36.3,173.2,38.3,172,40.1,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4,314.2L134.4,314.2c2.8,0.9,1.3-3.4,2.5-5C134.7,305.3,132.6,313.3,134.4,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,171.9c1.4,0.2,8,4.4,5.7,0.5C198.4,171,191.6,168.4,193.6,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.3,361c2.3-1.2,0.3-4.1,0.1-6.1C127.8,352.8,129.4,360.3,131.3,361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.6,416.4c-3-15.8-4.4,1.5,0.4,0.5C93.8,416.7,93.7,416.5,93.6,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.9,259.2c1.7,0.8,2.7,3.1,4.4,3.3C158.8,260.9,148.9,254.3,150.9,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.1,258.6c5.2,2.5,3.9-1-0.2-2.3C56.1,254.1,57.5,257.6,61.1,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.7,288.8c1.3,0.8,2.4,1.9,3.3,3C53,292.5,42.2,283.1,43.7,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,231.2c3.8,0.5-0.1-3.5-1.4-4.4C0,228.6,0,230,1.5,231.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,186.6c0.7-1.6,3.7-4.5,2.4-6C39,179.1,34.4,188.3,38.2,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.2,204.7c3.9-2.6-8.6-5.1-5.6-1.1C141.6,203.3,143.5,204.1,145.2,204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.3,259.8c-5-4.1-2.5,2.9,1.1,3.1c1,1.1,2.1-0.9,1.7-1.9C139.4,260.8,137.8,260.2,137.3,259.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.8,210.7c1.7,0.4,4,0.8,5.6,0.2C126.9,207.7,116.7,207.8,119.8,210.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,333.3c2,0.1,4,1.3,5.9,0.8C81.9,331.2,70.9,330.1,73.9,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.9,344.5c-1-1.7-3.3-3.8-4.9-4.7C164.8,341.3,171.9,348.3,171.9,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.9,185c1.4-1.1,5.5-6.3,1.7-5.7C78.1,180.8,73.5,184.5,76.9,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.5,268.6c1.2,2.2,8.2,0.1,5.5-2.1C192.4,268.2,185.9,265.2,188.5,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.2,212.6c-0.3-0.9-7.4-1.2-6.8,0.1C90.2,214.9,100.1,214.7,97.2,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.4,174.1c0.9-2.3-2.7-3-4-4.3C15.8,170.9,21.1,175.1,22.4,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.6,205.7c4.4,0.5,0.1-2.9-1.9-3.4C181.5,200.6,185.9,205.5,188.6,205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,328.3c2.6-0.8-1.1-4-0.5-6.1C-0.7,319.2-0.5,328.8,1.8,328.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.6,193.9c0.6,1.4,3.3,5.2,4,2c-0.4-1.5-2.6-2.4-1.9-4.2C2.6,189.8,0.7,192.4,1.6,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.1,416.3c-0.2-1.2-3,1.1,0,0.6C139,416.7,139.1,416.5,139.1,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.7,277.7c-0.6-2.7-4.8,0.6-6.5,1C26.8,281.7,34.5,279.4,34.7,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.4,306.6c5.7,0.2,1.7-13.9-0.2-0.2C107.2,306.4,107.3,306.5,107.4,306.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.3,213c1.6,1.3,3.6,0.2,5.4,0.7C180,211.5,167.7,209.6,170.3,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.5,353.7c-2.8-4.7-3.1,11.9-0.6,5.6C123.5,357.6,123.1,355.4,123.5,353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2,270.4c2.2-2.6-4.2-1.8-5.7-2.1C62.7,270.1,70.9,271.2,72.2,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.7,327.1c1.6,0.9,5.1,1.4,3.6-1.3C53.5,324.4,47.1,323.1,52.7,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,288.8c4.7,1.2-2-8.6-3.4-3.9C47.4,286,49.4,286.8,49.7,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,369.9c5.3-1.1,0-3-2.7-1.6C9.2,369.7,14.7,371.2,17.1,369.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.2,403.6c1.5,0.9,6.1,4.8,6.2,1.1C61.2,404.3,53.1,399.3,56.2,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,253.6c1.4,0.1,9.2,0,5.4-2.3C20.7,251.4,13.6,251.1,16.8,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.5,365.1c0.4,1.4,2.9,4,3.5,1.6C38.9,363.7,35.7,357.6,36.5,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,349.2c1.6,1.4,7.3,0.8,4.3-2C90.5,347.7,85,345.9,88,349.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.9,217.3c-0.6-1.5-10-1.3-6.1,1.3C195.6,217.9,199.8,220.1,199.9,217.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95,365.1c-1.2-0.7-6.3-2.1-5.1,0.5C91.9,366.2,99.1,369.7,95,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.6,385.7c0.4-1.6-0.1-6.4-2.5-5.5c-1.2,1.5,1.2,3.4,0.9,5.1C63.9,387.5,66.3,387.8,66.6,385.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.6,253.1c1.7-0.7,6,0.7,5.5-2C133.8,249.7,123.9,251.2,129.6,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,292.9c4.8-0.3,0.8-3.4-2.3-2.7c-1.5-1-2.5,1.6-0.9,2C24.3,292.4,25.6,292.5,26.5,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,344.6c0.2-3.1-5.3,0.8-6.7,1.5C35.7,349.2,41.8,345.7,42.7,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.7,408.9c1.3,1.5,4.5,2.1,6.2,2.1C118.6,408.6,108.6,406.3,110.7,408.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,274.7c1.2,0.2,7.6-1.6,6.1-3.4C42.4,270,34.4,273.5,37,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.6,393.4c5.4-2.7-5.1-1.3-6.5-2.8C111.9,392.9,118,393.3,119.6,393.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73,362c1.4,0.4,6.2,2.7,4.6-0.5C75.4,360.3,67.1,358.4,73,362z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,407.6c1.5,0.8,7.8-2.7,5-4.3C95,404.5,90.6,405.1,91.6,407.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.2,215.3c4.4-1.5-2.7-3.5-4.4-2.6C146,215.5,150.7,214.8,152.2,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.1,359.6c-2.1-1.7-3.9,5.7-2.3,5.8C114.5,365.8,116.5,360.6,115.1,359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.4,295.4c-0.5,2.2,3.5,5.6,2.7,2.1C112.8,294.2,107.3,289.6,109.4,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.9,275.6c6.7,2.4,0.5-4.1-2.9-3.1C83.2,274.1,87,274.7,87.9,275.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.4,242.6c3-2.4-2.9-3.6-2-7C158.7,236.7,161,241.5,163.4,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.1,308.3c1.6,1.6,1.6-1.4,2.2-1.9c0.6,0.4,1.4,1.5,2.1,1C146.3,303.5,138,303.6,141.1,308.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,210.4c-1.3-0.1-3.8,0.5-2.6,2.2c1.7,0.4,9-1,5.3-3.1C114.5,210.1,114,210.6,112.7,210.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.1,251.5c1.7,1.9,3.2-0.9,1.4-2c-1.6-0.3-3.9-5.2-4.5-1.6C177.9,249.2,178.7,250.6,180.1,251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.6,294.8c4,0.7-0.2-4.9-1.6-5.7C58.7,289.7,61.8,293.9,62.6,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.4,212.8c1.4,0.4,6.5-2,4.6-3.9C105.8,208.5,99.7,211.3,102.4,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.8,283.6c1.8,0,8.2,0.8,5.8-2.3C95.2,281.3,87.9,281.3,90.8,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,356.1c3.6-0.5,5.7-4.3,0.6-2.4C32.1,354.4,32.8,358.1,36.8,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,352.8c5.4-0.9,4.1-13.7,1.1-2.8C43.5,350.7,41.8,352,42.9,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70,309.7c3.9,0.2-1-4.4-1.7-5.9C64.8,303.5,69,308.5,70,309.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.6,285.2c2.1,0.6,4.7,5.8,6.4,3.9C109.2,287.2,100.5,281.7,102.6,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,208.4c-3.5-1.4-2.1,7.5,0.5,6.1C20.9,212.9,20,210.1,19.7,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,337.9c-0.9-1.5-1.5-4-3.1-4.7C9.1,333.8,14.8,342.4,15.2,337.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.8,344.8c2,0.9,1-3,2-4C122.4,333.4,116.1,343.1,118.8,344.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,297.1c1.3,1.1,4.6,6,5.5,2.4C59.7,298.4,56,293.9,55.3,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5,264c6.2-1.4-2.9-3.1-5-2.4C46.9,264.1,52.1,263.2,53.5,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.6,368.5c-0.7-9.4-8.5-3.1-0.1,0.2C109.4,368.7,109.5,368.7,109.6,368.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,310.2c-1.7-0.2-5.8-3.3-6.6-0.6C55.1,310.8,60.6,313.7,60.4,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.3,297.7c1.3,4.9,4.2,4.9,1.8-0.3C4.1,293.1,0.6,293.4,3.3,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,270.6c3-3.1-6.5-2.5-5.9-0.3C94.2,272,97.3,270.2,99.1,270.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.5,176.8c2.6,0.7,8.3-6.9,3.3-4.5C155.2,173.9,150.6,174.9,152.5,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.2,270.2c2-2.7-3.6-3-5.3-3C154.7,269.8,160.9,269.5,162.2,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.6,254.8c3.3,5.6,1.4-3.4-0.9-4.9C97.5,247.8,100.6,253.9,101.6,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,338.9c2.7,2.1,11.3-5,4.2-2.6C99.6,337.1,96.4,337.3,96.7,338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,392.5c1.8-1.2,3.3,0.9,4.8,0.5C45.2,389.4,34.1,388.9,37,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,366.4c4.6,0.4-2.4-5.4-3.6-5.3C64.1,363.4,68.5,364.7,69.6,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.2,228.1c-1.7,1.5,2.2,3.7,2.4,5.4C58.5,240,57.6,228.8,53.2,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,227.1c1.5-0.3,6.3-5.3,3.1-5.8C40.8,223,36.2,225,38.6,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,257.3c1.6,0.1,5.5,5,5.6,2.3C71.3,257.2,62.5,253.7,65.3,257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.1,352.7c2,2.3,4-5,2-5.7C142.9,346.7,143.4,351.2,143.1,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.9,200.7c1.7-0.1,3.7,2.2,5.1,1.2C201.7,199.2,192.6,196.8,194.9,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.1,223.8c1.3,0.9,5.7,4,5.7,0.8c-0.3-1.5-2-0.5-2.8-1.1C108.7,222.2,105,220.7,107.1,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,238.1c3.5-5-2.2-1.3-4,0.5C27.2,241.9,31.4,239.6,32.2,238.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,285.3c1.8-3.1-4.9-0.7-6.2-0.8C17.2,287.8,23.7,286.3,25,285.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.7,225.2c2,0.9,10.3-7.6,3.5-4C176.8,222.1,174,223.2,174.7,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,232.4c4.5-3.1-0.8-2.8-2.8-0.5C199.6,236.1,204.4,234.8,206.6,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43,203.5c2,0.1,8.4-4,4.5-5C46.8,200.1,39.9,203.4,43,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,300.1c-3,1.7,2.8,4.8,4,4.6C42.7,302.4,38.2,301,36.8,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,363.5c0.7,1.5,2.7-1.3,3.8-1.7C152.3,357.1,141,360.3,142.6,363.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.8,279.1c0.8-2.2-6.4-1.5-6.6-0.4C90.7,280.6,97.6,280.2,97.8,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.1,208.7c0.2,2.2,3.6,0.9,5,1C190.9,208,181.5,205.9,181.1,208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.9,415.1c0.1-0.4-0.2-1.7-0.8-1.5C60.9,415.5,65,419,63.9,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,207.4c1.7,0.4,7-2.8,4.1-4.3C46.8,203.4,41.5,206.2,43.9,207.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72,240.4c1.1,1,6.5,3.8,5.1,0.5C75.9,239.6,69.7,236.8,72,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.8,337.3c-1.9-2.8-4.4,2.9-5,3.8C163.8,343.7,165.6,338.7,166.8,337.3 C166.7,337.5,166.8,337.4,166.8,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.8,230.2c5.1-1.3-2.3-2.9-4.3-2.9C154.3,229.7,159.6,229.5,160.8,230.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,195.7c0.1-4.2-4.3,2-4.1,3.8C17.5,201.3,18.6,197.2,19.4,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,276.3c1.5-1.2-1-2.5-1.8-3.4C0,274.2-0.5,277.2,1.8,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.5,393.5c1.4-3-8.4-2.4-6,0.4C173.2,394.3,175.8,393.8,177.5,393.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,289.9c1.6-1.6-1.8-4.9-2.8-6.1C50.7,284.6,54.1,290.6,56,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.5,180c3.5-2.6-4.2-4.7-5-0.4C189.5,182.2,191.1,177.6,193.5,180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.7,174.5c1.7-1.2,2.4-1.7,4.4-0.7c2.4-1.3-0.9-3.2-2.5-3.2C101.5,171.4,98.8,173.2,100.7,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.6,353.2c-0.3-1.8-2.3-4-3.2-1.4C77.7,355.4,83.9,358.5,80.6,353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.7,291.8C1.7,291.8,1.7,291.7,1.7,291.8c0-1.5-1.4-1.8-1.7-3.1C-0.1,289.8-0.2,295,1.7,291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.6,209.6c3.8-3-6.5-2.6-5.5,0.3C173.7,211.1,175.9,209.5,177.6,209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.1,374.5c3.3-1.8,2.6-5.2-0.7-2C179.1,374.9,180.3,379.6,183.1,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.5,232.2c1.3,1.5,4.8,2.1,3.4-0.9C144.3,229.4,139.1,228,143.5,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.4,324.5c0.4,1.1,2.5,4,3.3,1.8c-0.8-1.7-2.9-2.9-3.2-5C197.9,315.5,198.6,322.9,200.4,324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,306.4c2.2-1-2.6-4.6-3.7-5.6C79.4,301.4,84.8,305.9,86.4,306.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185,276.5c5.5-1.9-2.1-2-3.7-2.6C178.8,275.4,183.3,277.2,185,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.3,367.8c2.1-0.3,1.9-6.2,0.2-6.4C131.5,361.4,131.8,367.9,133.3,367.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.2,367.2c1.4,0.4,4,0,2.5-1.9c-1.9-0.4-3.5,0.2-5.2-1.2C79.3,364.5,83.8,367.8,85.2,367.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,393.6c2.4,6.5,3.1-0.2,1.6-3.1C75.8,389.5,74.9,392.3,76,393.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.4,204.4c3.6,1.2,0.7-5.2-0.8-5.9C0.3,199.9,2.6,202.7,3.4,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.6,379.1c1.5-0.3,6.5-2.3,4.6-4.3C151,374.8,144.3,378.1,147.6,379.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.6,410.2c1.4-0.2,5.9-4.4,3-5.1C162.6,405.1,160.6,408.5,161.6,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.7,264.6c3.3-3.4-9.7-3.5-4.7-0.7C144.7,263.9,146.1,264.3,147.7,264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,378.4c3.9,4.3,1.9-3.2-0.1-4.6C25.9,374.2,27.8,377.1,28.6,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,201.6c-0.6,1.5-2.8,6.4,0.5,5.3C60.5,205.4,62.3,200.4,59,201.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.7,370.9c7.7,4.4-2.3-7.1-2.4-2.5C68.5,369.7,69.8,370.1,70.7,370.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.1,288.4c0.1-2.4-4.1-0.7-5.7-0.9C21.5,290,29.8,290.9,30.1,288.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.4,241.9c1.6-9.6-1.2-6.1-0.3,0.4L0.4,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,194.4c1.3-3.2-6.2-0.9-6,0.9C37,197,41.6,195.3,42.5,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.8,238.8c1.4,0.4,2.7,0.7,4.1,1.1C154.6,239,142,233.9,144.8,238.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.8,267.2c3.9-0.5,7.7-3,1.1-2.5C121.7,264.5,119.6,268.7,122.8,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.7,296.7c1.8,0,3.3-2.5,5.1-3.4C146.2,290,137.3,295.2,140.7,296.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,364c3.3-3.3-7.9-0.6-5.3,1.6C18,366.7,20.2,364.3,21.8,364z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.2,222c0.7-3.4-4.3-1.2-6.2-1.6C117.2,223.2,123.9,222.6,125.2,222z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,381.4c1.8,4.3,3-5.4-0.1-5.5C64.9,376.8,68.4,379.5,67.5,381.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.1,281.7c1.5-0.8,7.1-1.5,5.3-3.9C105.2,277.8,97.2,281.2,101.1,281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.3,416.3c-3-10-5.2-8.5-1.4,0.5c0.1-0.1,1.8,0.2,1.5-0.2C141.4,416.6,141.4,416.4,141.3,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.2,182.6c0.5,1.6,0.5,6.4,3.1,3.7c-0.2-1.5,0.1-3.8-1.2-4.6C66.4,181.7,64.4,181.6,65.2,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,190.5c1.1,1.1,3.1-0.9,4.5-0.8C102.3,188.3,90.3,186.1,90.9,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3,170.6c1.9-5.2-10.8,1-5.1,1C90.9,170.8,92.5,170.6,94.3,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,347c-0.4-0.6-1.3-1.9-2.1-2.7C67.8,340.3,75.9,353.1,76,347z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,308.9c3.4,0-0.1-5.3-0.6-7.1C1,302.2,4.1,307.2,4.3,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.5,415.2c0.3-3.1-5.5,0.5-5.7,1.5C179,417.3,182.9,417,183.5,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,242.7c1-0.2-1.2-9.5-2.8-6.8C97.7,237.8,96.8,242.7,99.6,242.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.7,402.6c5.8-2.4-1.7-2.4-3.8-2.3C57.6,402.6,62.2,402.8,63.7,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,304.9c4.8,0.2-3.7-8.2-3.6-3.1C52.1,302.2,52.8,303.8,54.1,304.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,400.5c1.9,0.1,7.9-2.9,4.6-4.3C57.6,398,51.4,397.6,54.1,400.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.9,371.6c3-0.2,1.2-10.2-0.6-5.1C126.8,368.5,124.1,370.8,126.9,371.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,344.6c-0.2-1.8-1.6-3.7-1.9-5.7C55.4,334.5,57.6,349.4,60,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.3,407.7c0.3,1.7,1.8,6.4,3.5,3.4C87.4,409,84.3,400.5,85.3,407.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,278.6c7.7-0.2,5.5-8.5-0.3-0.4C17.6,278.2,17.7,278.4,17.9,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,225.4c1.1,0.7,3.9,5.2,3.8,1.4C143.8,221.3,138,223.1,142.2,225.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,403c10.5,8.7,1.5-6.2-0.1-0.1C7.2,402.8,7.2,402.9,7.3,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.6,313.9c2.4,4.3,2.2-3.1,2.2-4.7C185.6,306.7,187,312.4,186.6,313.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.8,178.2c0.6-2.3,4.5-6.2,1-7.6C41.1,171.7,37.6,182.7,41.8,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.3,241.9c1.4,2.8,3.3,1.2,1.8-1.2C89.9,237.3,85.5,239.5,91.3,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,330.9c1.5,1,3.9,3.8,4.9,0.9C43.5,329.9,37.6,327.5,39,330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.1,277.3c-1.5,0.4-7.3-0.6-5.4,2.1C142.2,280,149.3,280.4,146.1,277.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.4,369.7c0-5.1-3.1,0.9-3.6,2.9C112.4,376.3,113.6,371.1,114.4,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.9,233.9c1.2,0.5,7.8-1.4,5.3-3.2C167,231,159.2,232.2,162.9,233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.2,207.1c6.2,1.7-0.3-3.6-3.1-3.6C113.1,205.3,117.1,206.4,118.2,207.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.3,325.7c2.4-1.3,0.8-4.9-1.2-2.4c-0.5,1.2-1.7,2-2.6,2.8C106,328,108.3,326.7,109.3,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,327.8c2.6,0,1.2-2.6,1.7-4.3C11.2,317.4,8.7,325.9,10.7,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.4,309.1c1.1,0.6,1.2,2.4,2.7,2.5C80.6,309.3,68.1,302.1,74.4,309.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,367.1c3.5,1.9,7-6.2,3.3-3.9C11.3,364.7,8.1,364.7,9,367.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,386.7c-4.8-6.1-5.9-1.8-1.2,2.1C32.4,388.8,33.3,387.5,32.5,386.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82,370.5c0.7-0.4,0.8-1,0.4-1.7C73.8,366.5,72.8,370.3,82,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.6,286.5c1.6,0.2,2.8-2.7,0.8-2.6c-1.3,1.2-5.7,0.2-5.1,2.4C178,287.8,180.4,286.5,181.6,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,309.4c1.8-0.5-1.9-7.6-3.1-5.7C63.3,304.3,66.1,310.6,67.2,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.4,387.5c1.8,0.5,3,2.7,4.9,2.9C13.9,388.7,5.5,383,6.4,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,326.3c3.4-1.1-1.1-3.7-1.8-5.3C30.9,322.1,35.6,325,36.3,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.7,381.2c1.3,0.9,2,4.8,3.6,2.6C37.8,381.1,31.3,374.8,33.7,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.9,190.3C195.7,192.3,196.2,182.2,187.9,190.3C187.9,190.2,187.9,190.2,187.9,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.6,204.9c1.9,0.6,7.7-0.1,3.9-2.3c-2.3,0.9-4.6,1.1-6.3-0.7C74.3,202.7,76.6,204.9,77.6,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.5,250.5c1.6,1.5,6.2,2.3,4.5-1C197.1,249.8,190.5,246,194.5,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,384.7c0.7-1.6-2.1-6.6-3.9-5.2C14.8,381,17.7,385.5,19.2,384.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.6,360.6c2.8,0.1,4.5-10.2,1-5.1C44.9,357.1,41.7,359.7,43.6,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,349.4c3.3-3.5-4.4-0.8-4.9,1C29,353.4,32.3,350.3,33.5,349.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.3,380c3.6,3.8,1-3,1.4-4.9C125.9,372,126.6,378.6,127.3,380z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.6,271.1c6.3-0.3,1.3-2.7-2.1-2.2C113.2,269.5,116.7,271.8,118.6,271.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,318.8c3.5,3.1,2-5.5-0.4-5C0,315,0.2,317.7,0.5,318.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,259.2c-0.9-2.7-6.2,2.9-4.4,4.4C18.3,263.8,22,260,21.8,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.1,349.8c-0.2-1.7-4.1-5.9-5.1-2.9C78.5,348.3,80.2,351.8,82.1,349.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,321.8c0.4-8.8-3.1-0.1-2.3,3.3C21.3,325.8,20.7,322.8,21.5,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.3,322.3c1,0.5,5-6.3,2.4-6.2C119.5,317.2,116.5,320.9,118.3,322.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,196.4c0.4-0.8-0.3-2.7-1.3-1.8C89.8,198.6,92,201.4,97,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.8,232.2c1.2,0,7.6-3.6,4.5-4.9C173.8,228.7,169.6,229.8,170.8,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.1,271.1c1.8-0.2,3.6,2.4,5,1.4C116.5,269.7,106.2,267.3,109.1,271.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.5,230.6c1.5,0.4,9.1-3.1,4.7-3.6C183.7,228,179.5,228.1,180.5,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,373.4c-4.4-1,1.2,5.6,3,4.4C19.6,376,15.7,375,15,373.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.7,409.8c0,0.5,0.4,1.1,1,0.9C45.7,406.7,40.8,396.2,41.7,409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.3,295c3.9,3.2,1.3-4.1-0.7-4.8C70.4,290.3,74.3,293.3,74.3,295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,242.5c6.9,1.7,1.1-2.4-2.3-2.6C16.1,240,20.9,242.4,22.6,242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.8,272.3c1.2,1.2,8.5,5.8,6.1,1.5C152.3,273.8,147.7,269.1,147.8,272.3 C147.7,272.2,147.8,272.2,147.8,272.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.2,173.4c0.6,1.6,7.5-0.1,4.8-2.2C128.9,170.5,124.5,171.4,125.2,173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,232.3c3.7-2.6-3.8-2.4-5.2-1C13.5,234.2,17.5,232.2,19.2,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.4,183c1.9,1.1,2.6-3.1,3.1-4.3C62.9,175.7,59.8,181.9,61.4,183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,307.7c1.8,0,5,1.7,5.5-1C41.2,305.5,32.8,305.4,36.8,307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.7,333.9c1.5,0.5,3.1,2.4,4.6,1.9C72,333.5,63,330.3,64.7,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.9,216.3c0.3,5.3,3.6,1.3,2.2-1.9C24.4,211.5,22,214.2,22.9,216.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.4,382.9c1.8-0.1,0.7-2.1,0.3-3C90.7,373,89.6,381.5,93.4,382.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.1,279.4c-0.7-1.1-4.9-0.3-5.5,0.5C116.8,282.4,125.6,281.9,123.1,279.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,405.5c2-6.7-3.9,1.1-2.4,3.7C33.1,410.4,32.2,406.8,33,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,293.2c2-0.1,4.1,3.4,5.4,1C23.5,292.1,16,289.6,18,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,366.4c1,1.1,2.4,3.6,4.1,2.6C51,366.5,42.2,361.4,45.9,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.4,227.8c1.9,0.4,3.1,2.5,5,2.7C115.2,229.3,105.5,223.5,107.4,227.8 C107.3,227.7,107.3,227.7,107.4,227.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,244.7c-0.2,3.3,3.6,3.1,2.3-0.2C3.6,240,0.2,240.4,1.8,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.5,249.5c1.4,0.1,6.6,1.8,5.2-1c-1.3-1.7-9-0.2-5.4,1.1C135.2,249.5,135.3,249.4,135.5,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.3,403.6c0.8,1.1,3.5,0,2.3-1.1C0.3,401.1-0.7,399.9,0.3,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.9,301.4c1.5,0.7,6.4,1.6,3.9-1.2C44,299.1,37.5,299.5,41.9,301.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,192.7c-1.2-7-4.4,4.5-0.7,3.7C9.7,196,9,193.7,9.1,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,297.6c-1.5-0.2-2.4,0.6-1.2,1.8c0.9,1.2,1.2,5.1,3.3,3.6C71.8,301.2,69.9,299.2,69.1,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99,178.8c0.4,2.5,2.9-0.7,4.4-0.7C109.5,175.2,98.9,175.6,99,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.6,229.8c3-2.9-4.8-1.7-5.7-1C198,231.8,203,229.6,204.6,229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,352c-0.8-1.1-1.6-6.8-3.2-4.8C54.7,348.7,57.5,355.5,58.9,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,240.7c4.3-0.8,2.8-2.9-0.9-2.2C7.8,238.8,10.1,241.1,14.2,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,411.5c1.7-0.6,0.1-1.9-0.2-3C0.1,408.6-0.2,411.8,0.2,411.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.4,340.2c0.3,1.3,1.6,4,3,2.3c0-2.8-5.8-9.8-3.1-2.5C37.3,340,37.4,340.1,37.4,340.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.8,198.2c1.5,0.7,5.7,4.1,4.3,0.2C142.1,196.6,135.7,194.8,138.8,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178,172.3c3.8-2.5,0.9-4.8-1.6-1.2C173.3,175,175.2,175.9,178,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,196.1c1.8,1.4,2.7-2.2,4-3.2C54.3,188.7,47.5,195.1,49.9,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.2,376.6c1.2-0.9,6.1-4.9,2.8-5.5C147.4,371.9,143.6,375.1,146.2,376.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99,277.6c1.7-0.3,6.3,0.9,5.8-2C103.4,275.1,96.7,274.9,99,277.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.1,287.4c0.4-1.8-1-7-3.1-4.6C165.5,283.9,164.4,289.8,167.1,287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.8,336.1c0.3-5.1-2.3-1-3.5,1.3C115.2,340.5,118.7,338,118.8,336.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.1,400.6L151.1,400.6c0.4,0.3,0.8,0.3,1,0C158,389.1,151.6,392.8,151.1,400.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,328.6c4.5,1.3-2.7-9.3-2.7-4C68.9,326,70.1,327.4,71,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.2,391.2c3.1,3.6,2.5-2.1,1-3.9c-1.8-0.9-1.9,1.6-1.8,2.7C84.4,391.1,85.6,390.6,86.2,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.5,313.4c0.6,3.8,4.4-2,4.1-3.4C108.5,308.6,107.1,311.7,106.5,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.7,354.5c-1.2,0.5,1.2,6.1,2.2,6.4C59.1,360.6,56.3,353.7,54.7,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.8,220.2c1.9,0.4,3.6,2.1,5.4,2C209.4,220,200.3,216.6,201.8,220.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,278.6c0.7,1.1,2.5,3.4,3.5,1.5C68.8,277.5,61.2,273.3,65,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,356.7c-2.3,0-6.7,5-1.9,4C26.8,359.4,30.9,357.7,27.9,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.1,248.6c6.4,0.1,0.5-2.6-2.2-3C122.3,246.7,125.5,248.7,127.1,248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4,386.1c1-1.3,2.7-3.3,2.8-5.1C136.3,377.7,131.3,386.5,134.4,386.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.7,416.4c-0.2-2.1-3.9,1.3,0.1,0.6C151.7,416.7,151.7,416.6,151.7,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.6,317c-0.9-0.9-1.8-4.1-3.3-2.9C54.6,316.4,61.9,322.7,59.6,317z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,360c1.4,1.9,4.7-1.7,5.1-3C21.1,355,16,359.1,17,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.4,229.3c1.7-1.7-1.8-5.8-3.4-7.1C99,221.9,103.7,229.6,104.4,229.3C104.4,229.4,104.4,229.4,104.4,229.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,340.5c3.8,3.6,0.8-4.7-1.5-4.7C30,336.6,32.5,339.4,33.3,340.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.4,201.1c5.8,0.4,0.2-3.5-2.8-2.5C171.6,200.2,175.3,200.8,176.4,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.7,398.7c3.5-0.7-4-5.2-4.8-3.1C178.7,397.8,182.2,397.8,183.7,398.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,338.6c0.8,1.2,2,3.3,3.7,3.4C14,340.9,6,334.3,7.3,338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.3,370.7c1.6-2.2-1.1-5.1-1.8-1.7C113.8,372.4,115.5,375.9,117.3,370.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.3,366.8c0.4,0.2,1-0.2,0.8-0.6C127.1,355.1,125.1,361.9,130.3,366.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.7,177.9c1.5-0.5,5.3-5.8,1.9-5.8C137.1,173.8,133.9,176.3,135.7,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67,416.2c-1.6,0.5,0,0.8,0.7,0.7C67.5,416.7,67.4,416.2,67,416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,324.5c-4.3,0.5,6.4,7.4,4.2,2.5c-1.3,0.3-1.4-1.3-2.4-1.8C76.5,324.9,75.6,325.1,75.2,324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.2,224.3c-3.7,0.2-0.6,3.5,3.7,1.9C164.2,223.6,159.7,224.3,158.2,224.3L158.2,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.4,282.6c1.2,0.4,7.3-1.9,5.2-3.7C191.2,279.4,186.3,280.4,187.4,282.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.9,276.6c1.3-1.5-2.2-3.6-3.1-4.8C162.2,271.3,167.1,276.7,167.9,276.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,308.4c0.8,1.2,1.9,5.1,3.7,4.2C32.2,310.9,27.9,304.6,27.5,308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.8,401.6c1.4-0.8,4-2.3,3.6-4.1C131.2,396.8,123.9,402.5,128.8,401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.2,308.1c-1.6,0.5,1.4,5,2.4,5.6C153.8,314.5,149.7,307.7,148.2,308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.3,239.8c3.4-3-3.4-1.8-4.4-0.7C197.8,242.3,201.7,240.5,203.3,239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,292.4c4.5,0.8-1.6-5.3-3.6-4.7C91.6,288.6,96.8,291,97.1,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,295.4c-0.2-1.5-2.1-2-2.3-3.5C54.6,290,60.2,300.3,61.5,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.4,294.4c1.6,0,3.6,2.4,4.5,1.3C187.4,292.4,178.2,290.7,181.4,294.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,360c-0.4,2.3,2.9,5.4,4,2.4C48.6,361.6,47.6,356.2,46.3,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,253.4c0.2,1.5,3,6.1,3.6,3.1C99,254.9,94.8,247.8,96,253.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,203.9c3.5-3.2-11.7-8.9-0.2,0C206.4,203.9,206.5,203.9,206.6,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.4,228.3c5,0.7,11.8-4.1,2.4-1.9C9.7,226.5,7.2,226.8,8.4,228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.1,308.3c2.3,2.2,3.3-2.9,2.5-4.4C109.4,302,111,307,110.1,308.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205,320.5L205,320.5c5-1.3-2.2-2.5-2.9-4.3C200,317.1,203.2,320.9,205,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,194.6c-1.4,0.8-3.6,1.8-3.9,3.5C101,201.4,106.5,195,103.6,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.1,192.5c-0.2-3-4.4-0.4-6-0.2C99.1,195.1,104.1,193.6,105.1,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.9,246.4c6.2,0.8,0.6-3.6-2.3-2.7C75.1,245.3,77.6,245.9,78.9,246.4C78.8,246.3,78.8,246.3,78.9,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.9,244.4c1.3,1.2,1.8,6.9,4,5.3C105.4,248,99.8,240.6,100.9,244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,233.1c2.1-0.7,5.3,0.4,6.3-2.3C11.1,229.6,2.9,231.1,5.2,233.1C5.1,233.1,5.1,233.1,5.2,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,195c1.6,2.2,3.8-1.3,4.5-2.8C48.1,188.8,44.1,193.8,44.2,195z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185,257.5c2-2.2-1.9-3.3-3.2-4.6C178.4,253.2,183.6,257.4,185,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.1,279.1c4.3,0.7-3-4.7-3.7-5.8C159,274.4,164,277.8,165.1,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.3,174.6c1.9-1.3-1.8-2.4-1.7-3.5C288,162.9,286.4,174.2,291.3,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.9,237.1c3.5,0.3,8.4-6.3,2-2.8c-1.1,0.6-2.9,1.1-2.1,2.7C185.8,236.9,185.8,237,185.9,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,398.7c1.9,0.6,2.5-1.5,4.2-2.1c5.9-4.3-4.3-1.2-4.4,2C162.1,398.6,162.2,398.6,162.3,398.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.7,304.3c1.2-1-3-8-4.3-5.4C178.2,300.2,178,305,180.7,304.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.8,400.9c-3.8,0.7,1.8,3.9,4,1.8C98.3,399.6,94.3,401.6,92.8,400.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.5,268.1c4-0.6-4.5-6.5-3.9-3.2C102.3,266.6,104.3,267.2,105.5,268.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.9,206.7c1.5,0.4,2.9,1.7,4.2,2.1C73,206.2,63.2,202.7,65.9,206.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.9,347.5c1.6-0.2,6.1,1.9,5-1.3C188.1,345.6,182.9,344,184.9,347.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,305.5c1.8,0,2.6-6.3-0.3-5.2C99.1,301.5,97.6,305.2,99.8,305.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.5,349.4c0.2,1.6,2.4,2.3,3.1,0.7C130,346.6,125.5,343.7,127.5,349.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,185.1c-1.6,0-3.3-2-4.9-1.1C15.9,186.3,25,188.5,22.8,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.1,300.4c2.3,4.7,3.7-0.5,0-3.1C74.1,295.7,77,299,78.1,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,301.4c1.3-0.8,1.6-6.1-0.9-5.6C168.2,296.8,167.2,302,169.6,301.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.8,352.2c8.4-3.1,3.2-5.8-1.2-1.1C33.9,351.5,34.1,352.1,34.8,352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.6,286c1.1,1.1,6.1,2.7,5.3-0.3C83.3,285.5,78.7,282.3,79.6,286z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.9,311.1c-0.3-5.7-2.9,0.5-2.3,2.7C98.2,316.5,99,312.5,98.9,311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,219.2c-1,0.7-2.1,3.9-0.2,3.6C57.4,220.7,60.1,213.6,55.2,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,250.8c1.8,0.5,7.9-1.4,3.6-2.4C17.3,249.1,11.7,248.8,15,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,297.7c-2.4-5.4-2.6,6.9,0.5,4.1C66.5,300.6,65.1,299.1,65.1,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,416.4c-2.4-3.1-4.3,1.6,0.1,0.6C22.7,416.8,22.7,416.5,22.6,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.2,365.2c-1.4-0.1-3,0.9-4.4,0.6C184.4,369.5,195.8,367.6,192.2,365.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.6,330c1.4,0.3,5.8-5.3,2.2-5C120.2,326.6,116.6,328.4,118.6,330z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,384c1.1,0.8,4,6.4,4.4,2.6C52.3,385,47.4,379.8,48.5,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54,344c2.9,1.5,1.3-4.9,0.8-6.4C52.2,337.6,54.1,342.3,54,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.4,308c2.8,4.8,2.1-1.7,0.7-3.7C160.6,302.1,161.4,306.8,162.4,308z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73,413.7c1.2-1-0.7-7-2.5-6.5C69.6,408.4,71.6,413.5,73,413.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7,384.4c0.8,0.1,2.1-0.9,1.4-1.7C71.3,377.3,69.7,381.7,74.7,384.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.6,416.9c2.1-1.5-1.8-4.1-3.2-4.4C-0.2,413.2,4.2,417.1,5.6,416.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.5,246.6c5.8-0.6-2.2-3.3-3.9-1.7C136.9,247.3,141.4,246.1,142.5,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,358.3c-0.7-1.6-2-5.2-3.3-1.9C82.9,358.7,87.2,362.3,86.4,358.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,396.3c0.3-2.3-7-3.6-4.9-0.8C63.7,395.9,66.2,398.2,67.2,396.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.4,327.2c2.3,1.2,2.7-3.6,1.9-4.8C157.9,321,157.3,326.2,158.4,327.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.9,232.3c4-1.9-4.9-4.4-4-1.5C83.8,232.2,85.4,232,86.9,232.3C86.7,232.3,86.8,232.3,86.9,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.9,181.2c-2-0.2-4.9,4.4-2.9,5.5c1-0.6,0.7-2.7,2.1-3C192.4,183.7,193.8,181,191.9,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.3,400.7c4.4-1.5-4.7-5.2-4.4-1.5C34.9,400.3,37,399.1,38.3,400.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68,233.4c1.5,0.3,5.6,3.5,5-0.1C71.7,232.5,66.8,229.7,68,233.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.7,333.8c-2.5,5.1,7.4-0.9,2.8-2.2C99.5,332.2,98.6,333,97.7,333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.8,347.4c2.8,1.4,1.6-3.3,1.8-4.9C141.2,339.5,141.3,346,141.8,347.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.3,318.6c2.9,5,3.3-6.9-0.1-3.7C147.4,316.2,147.6,317.4,147.3,318.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.1,354.7c1.4,0.7,2.9,1.9,4.3,2.4C75.6,356,65.7,351.1,67.1,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,264.2c1.6,0,3.9,3.2,4.3,0.2C97.9,262,90.5,261.3,94.1,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,333.4c4,0.6,0.1-4.4-2-3.9C53.3,331.4,56.1,332.1,57,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.4,180.7c1.2-2.2-2.9-3-4.5-3.3C198,178.7,204.4,181,205.4,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.7,216.7c4.4-1.5-2-2.2-3.7-2.3C176.1,216.5,181.2,216.7,182.7,216.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.5,309.4c2.4,2.6,2.1-6.4-0.1-6.3C17.1,304.8,19.1,307.3,18.5,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.9,187.2c1.2,0.3,4.9,0.2,4.6-1.8C167.8,183.9,161.3,185.1,163.9,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,345.1c3,4.3,2.8-6,0.1-4.8C15.1,341.6,16.2,344.3,15.9,345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.9,299.1c1.9-5.2-8.7-7.8-0.4,0.3C95.5,299.2,95.7,299.2,95.9,299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,315.8c1.8,0.1-0.1-5.7-1.1-5.7C84.2,310.1,86.9,314.8,88,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,246.5c0.1-2-2.6-5.9-2.2-1.6C96,247.8,101.3,251.5,98.3,246.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,173c1.1-0.6,1.3-3.9-0.3-2.9C216.7,172.9,217.6,179.6,220,173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,300.9c0-1.2-3.7-5.9-4.3-3.5C12.5,298.4,15.7,303.8,16.4,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.8,282c0.6,1.2,0.7,4.7,2.6,3.2C61.7,283.5,56.8,276.2,57.8,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,297.7c1.4-1.2-1.7-6.7-3.5-4.3C78.8,294.8,78.9,298.1,81.2,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.9,200.2c1,1.5,7.7-2.9,3.8-3.3C168.4,197.7,165.3,198.1,165.9,200.2 C165.9,200.1,165.9,200.1,165.9,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.3,238.2c4.3-2.9-1-2.7-3.1-0.8C204.5,240.1,208,239.6,209.3,238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.7,242.7c5.5-2.2-2-2-3.9-0.8C132.2,244.5,136.6,243.5,137.7,242.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,246.6c3.1-0.2,2.7-3.4,0-2.3C32.8,244.7,32.3,248.5,36.2,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,402.3c0-1.8,4-3.3,2.6-4.9C29.7,397.2,25.5,405.7,29.7,402.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.2,301c-1.9,0.2,2.4,5.6,3.8,4.9C149.8,304.7,146.8,301,145.2,301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.1,192.4c1.8,0.4,5.8-5,2.4-4.6C121.1,188.8,116.8,191.8,119.1,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.1,234c1.4,0.2,3,0.2,4.3,0C182,231,171.6,231.4,175.1,234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,299.2c0.9,1.2,1.8,5.5,3.8,3.2C175.8,301.1,171.7,294.4,172.2,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.8,414.8c1.6,0.3,5.8-3.3,2.9-4C44.5,411.9,40.6,412.9,42.8,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.3,258c1.6,0.1,3.3,0,4.9,0.1C120.3,254.8,110.6,255.3,113.3,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.7,304.5c-1.6-0.5-3.6-1.7-5.2-0.8C27,305.7,35.3,307.3,33.7,304.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,190.9c1.7,0.6,3.9-3.4,2.2-4.4C59.8,185.4,58.1,189.9,59.4,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.6,227.2c1-2.3-2.3-2.1-3.7-2.9C59.5,225.4,65.3,228.5,66.6,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,279.1c1.3,1.1,4.5-0.8,5.6-1.7C42.1,274.9,36.5,277.3,36.9,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174,287.6c1,3.9,7.8,4.9,4.7,1.3C176.9,290.8,173.2,285.1,174,287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.3,317.4c2,1.3,2.2-2.7,2.6-3.9C92.4,310,90,315.9,91.3,317.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,313.5c1.4,0.5,1.3,2.1,2.8,2.4C56.8,313.8,46.1,308.7,50.1,313.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,247.7c1.3,0.6,2.8,1.4,4.4,1.4C81,247.4,71.2,244.1,73.2,247.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.2,311c0.7,1,1.5,4.5,3,2.2C193,311.1,188.4,304.6,190.2,311z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,351.8c-1.4-0.6-4.9-3.1-5.4-0.3C170.2,352.2,175,354.8,174.5,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.7,313.1c1.4-0.1,4.4,1.9,4.7-0.2C43.8,310.8,36.1,310.6,39.7,313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.6,278.7c6.3,0.5,1.8-2.3-1.6-2.5C79.4,277.2,82,278.5,83.6,278.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.3,302c1.9-2.1-3.5-2.5-4.8-2.6C193.8,301.4,199.9,301.9,201.3,302C201.2,302.1,201.2,302.1,201.3,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.4,289.9c1,1.1,2.7,2.6,3.4,0.4C78.3,287.7,71.5,286.5,75.4,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.4,350.8c2.3,3.5,2.3-8.1-0.7-4.7C52.5,347.6,53.5,349.3,53.4,350.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,343.3c-0.2-4.1-7.6,2.8-3.1,3.1C34.1,344.8,36.1,344.4,36.9,343.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,308.9c5.2-2.2-4.3-2.7-4.7-0.5C46,310.1,48.4,308.5,49.9,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110,385.1c0.9,0.8,5.2,5.7,4.9,2.6C114.2,386.5,107.6,380.9,110,385.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.2,326.2c-0.8-1.1-2.3-4.1-3.6-1.8C30.3,326.8,34.5,330.8,33.2,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116,357.2c-0.4-1.5-0.9-6.7-3.1-5.1C113.3,353.5,113.7,359.2,116,357.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1,329.3c-2.2,1.7-0.6,4.3,1.3,2.4C107.9,329.8,106.8,326.8,104.1,329.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.5,232.4c1.6,0.7,3.7,2.6,5.3,2.6C116.2,233,107.7,229.4,109.5,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.5,412.3c0.4-1.4,1.1-7.1-1.2-3.8C153.4,410.4,153.5,416.7,155.5,412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,315.4c2.9,3.2,2.3-3.3,1-4.2C2.9,311.5,4.8,313.7,4.5,315.4C4.5,315.3,4.5,315.4,4.5,315.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,325.7c3.1,2.9,1.2-2.6-2.1-4C76.4,323.1,80.2,324.8,81.1,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,397c3.6-2.1-4.2-2.7-5.3-1.9C112.7,397.2,116.7,396.4,118.1,397z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.4,218L98.4,218c1.5,0.1,3.9,0.4,4.9-0.8C104.5,214.5,95.4,216,98.4,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,337.3c0.2-1.9-5.8-1.4-4.4,0.8C82.4,339.3,86.4,339.2,86,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.6,279.5c0.7,1.3,1.7,4.8,3.5,2.6C6.5,280.3,3.6,276.3,2.6,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.5,368.3c1.4-0.1,4.6-1.7,3.9-3.6C154.3,364.2,149.4,366.8,151.5,368.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.1,182.5c2.4,1.3,6.8-4.9,2.5-3.1C104.6,180.4,102,180.7,103.1,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.8,258.1c1.8,3.6,3.6-1.7-0.6-3.3C153.7,255,155.6,257.5,156.8,258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.2,300c-0.5-1.2,0.8-4.5-1.1-4.5C-0.1,296.5,0.2,307.1,1.2,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.1,218.5c1.5-0.2,6.4-2.8,2.9-3.8C29.7,215.6,25.8,216.4,28.1,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.9,305.9c0.5-2.2-3.3-2.4-4.8-3.1C191.8,303.5,199.4,307.1,199.9,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,273.5c0.9-1.3-4.9-3.5-4.9-1.3C65.6,273.4,68.3,275.2,69.6,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,235.5c1.1,4.3,3.2,2.6,1.5-0.8C45.7,229.8,43.5,231.4,45.5,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,358.5c1,0.9,2.1,3.9,3.7,3C65.1,360.4,57.9,354.9,59.4,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.6,376.7c0.4-1.2,0.3-4.4-1.3-4.7C60.5,371.8,62.2,379.4,63.6,376.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.3,303.3c0.3-3.8-7-7.5-2.5-1.8C93.4,302.3,94.1,304.5,95.3,303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,374.7c1.3-1.7-2.1-2.8-3.3-3.3C13.6,372.4,18.6,375.6,20.2,374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,243.9c1.3-0.4,2.4,0.9,3.5,0.3C63.4,240.6,53.5,241.4,58,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,244.3c1.1,0.8,7.8,1,5.4-1.2C19.2,242.8,15,242.1,15.3,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,284.8c1.5,0.6,7.3-1,4.3-2.7C40,282.8,36.1,282.2,37.2,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.3,298.3c1.4-2-6.1-2.5-6.1-0.7C196.6,298.6,201.5,298.7,202.3,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,316.7c2.3,1.1,2.1-4.4,1.3-5.8C17.3,311,18.3,315.2,18.2,316.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,246.3c-1.4-0.1-4.8-1.4-3.8,1.2C147.4,248.5,153.1,248.8,149.6,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,371.3c0.1-0.5-0.7-1.6-1.2-1C132.6,376.2,136.6,380.1,136.1,371.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,179.1c1-0.5,3.7-0.7,2.1-2.3C145.2,175.4,140.3,180,145.8,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.6,290.5c2.6-4.7-7.5,0-3.2,1.4C195.4,291.4,196.4,290.5,197.6,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,252.7c1,1,5.2,2.4,3.6-0.3C11.5,250.8,4.4,250.5,10,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.3,262c-1.2-0.7-4.5-2.7-4,0.1C86.4,263.3,91.5,265.2,89.3,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.9,271.1c0.7-1.4,0.9-7.6-1.4-4.4C179.5,268.3,178.4,272.8,180.9,271.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,265c0.9,0.9,1.5-0.9,2.4-1c1.3,0.1,2.4-1.2,1.4-2.2C195.3,261.7,191.3,263.2,193,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.1,376.6c3.9,0.3-1.7-4.6-3.1-3.6C199.1,374.9,202.2,375.4,203.1,376.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.3,348.5c0.8,0.3,2.5,1.2,3.4,1C209.7,346.5,200.2,344.8,204.3,348.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,297.4c-3.1-2-3,5.5-0.2,4.6C73.5,300.8,73.2,298.8,73.2,297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.5,245.8c1.1,0.9,2.3,3.8,3.4,1.4C164.9,245.1,159.1,241.6,161.5,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.4,279.3c1.1,0.2,2.3-0.7,3.4-0.5C203.4,277,192,275.4,195.4,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,294.5c1.9,0.4,4.5-3,1.5-2.7c-0.4,0.4-0.9,0.5-1.5,0.4C30.6,291.8,30.4,294.9,32.7,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.4,280.4c1,0.8,4.1,4,4.9,2.2C130.7,281.6,121.9,276.4,125.4,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207,225.5c2.5-2.4-5.4-1.2-6.6-0.5C200.2,227.9,205.3,225.4,207,225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.4,175.5c0.6-3.7-5.1,2.9-5.2,4.2C183.8,181.8,186.1,176.6,187.4,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.8,233.1c0.6-1.8-2.2-2-3.1-3.1C89.4,227.7,94.9,235.4,96.8,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,227.2c-0.8-1.6-3.5-2.3-4.9-3.5C118.2,225.1,123.5,229.5,124.6,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176,259.5c0.9,0.6,1.2,2.7,2.4,2.3C181,258.9,172.9,254.7,176,259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.3,390.6c2.5,2.2,3.8-4.4,0.8-4.5C47.1,387,49.5,389.2,48.3,390.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.5,175.2c0,1.3,0.4,4.4,2.2,3.5C57.5,176.9,55.2,171,54.5,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.3,231c-1,0.1-2.7,0-3.5,0.4C191.7,235.1,201.1,233.1,197.3,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.4,262.7c0.9,5.8,2.5-2.1,1.1-4.1C188.3,258.4,190,261.5,189.4,262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.1,397.5c5.4-3-4.5-2.7-2.9,0.7C139.1,399.2,140,397.6,141.1,397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.4,284.1c3.9,4.3-0.1-3-1-4.8C168,277.5,170.2,283.3,171.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.1,233.6c1.3-0.2,1.4-3.1,0-2.3c-0.8,0.9-3.4-0.5-3.5,1.4C155.5,234.9,157.9,233.5,159.1,233.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199,329.8c1.8-0.4,0.1-2.4-0.4-3.3C195.7,317.8,196.5,329.2,199,329.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,352.4c1.1,0.7,3.7,2.8,4.1,0.6C103,351.3,96.2,350.1,99.6,352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,297.9c1,1,2.5,0.1,1.8-1.3C100.9,291.4,96.8,294.6,99.6,297.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.6,293.2c-1.4-4.7-2.4,1.8-1.7,3.6C118.6,299,118.9,294.2,118.6,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.7,266.9c2.2,3.9,3.2,0.6,1.1-2.1C165.9,262.2,165.2,265.4,166.7,266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144,335.4c-1.7-0.2-2.6,3-1.8,4.2C144,340.2,146.3,335.5,144,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.4,223.8c1.1-0.8,2.8-1,3.4-2C191.2,218,183.1,223.8,187.4,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.4,393.1c0.5-1.7-1.5-5.2-3.3-3.4C188.9,390.9,189.5,395.5,191.4,393.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.1,240.9c-0.9-0.1-1.8-2-2.6-1C151.6,242.9,160.1,245.5,156.1,240.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.8,400.4c1,1.1,3.5,5.6,4.6,4C90.7,403.3,85.6,397.4,85.8,400.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.1,351.6c1.8,3.1,2.1-3.4,1.3-4.4C119.1,345.7,120.2,350.4,120.1,351.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,293.8c2.5-1.7-1.2-3.1-2.5-3.4C48.6,291.8,52.1,293.8,53.7,293.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.3,315.7c3.9-0.9-4.3-4.8-4.4-2.2C69.3,314.2,70.7,315.3,72.3,315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.2,245.8c1.1-0.3,2.9-0.3,3.7-1.2C190.3,241.2,182.3,243.6,185.2,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,361.4c2.3,1.6,7.9-8.2,2.4-2.9C3.4,359.4,1.1,359.9,1.8,361.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,370.8c1-0.3,1.8-0.9,2.7-1.3C12,365.3-0.8,369.2,4.3,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.6,348.8c0.6-0.9-3.7-4-3.9-3.1C175.3,347.4,180.1,351.3,180.6,348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.1,211.6c-1.6,1.6,2.2,3.5,3.2,3.3C141.9,213.3,138.5,211.1,137.1,211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.9,360.3c1.2-0.7,1.4-3.1-0.3-1.8c-0.4,0.3-0.3,3-0.3,3.5C0.7,361.5,0.5,360.8,0.9,360.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.6,250.1c-1.2,0.1-3.4-1.5-3.9,0.2C43,252.6,50.8,252.9,46.6,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.8,180.5c0.4,0.5,1.2,1.3,1.9,0.9C52.6,177.2,47.8,173.7,49.8,180.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.8,308.6c4.3,1.1-2.1-6.4-2.6-2.4C22,307.1,22.7,307.8,23.8,308.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.3,321.3c4.1,1.8-0.3-5.5-2.4-2.8C72.1,319.4,73.3,320.8,74.3,321.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.1,392.9c4.6,0.7,9.5-6.3,2.1-1.7C125.4,391.8,123.1,391.5,124.1,392.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.4,233.6c-2.7-5.8-1.4,4.7,0.8,4.8C125.3,237.3,123.3,235,123.4,233.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,318.3c0.7-1.2,0.7-4.6-1.5-3.3c-0.8,0.4-0.2,0.9-0.2,1.5C12.6,318.3,13.3,320.5,15.1,318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.1,175.1c-2.9-4.2-5,8.3-1.5,6.2C13.5,179.5,13.8,177.1,14.1,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.8,307.4c-1.5-7.6-1.3,0.7-1.7,2.8C94.4,312.9,94.9,308.6,94.8,307.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.5,185.6c1.8,0.6,5.8-3,2.5-3.3C86,182.9,83.2,184.4,84.5,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,240.6c-1.6-0.5-4.3,0.1-2.6,2.1C43.4,243.5,47.2,242.6,43.9,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.4,314.2c3,3.1,2.4-0.6,1.2-2.7C73.6,309.4,73.2,313,74.4,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,325.9c2.2,1,1.5-4.1,0.2-4.5C164.8,320.2,166.8,325,167.3,325.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.3,303c-0.1,1.3,2.5,3,2.7,1.1C76.6,301.2,73.9,297.9,74.3,303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.1,221.4c1.2-0.9,4.4,0.3,4.5-1.6C196.6,217.8,191.4,219.2,193.1,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.2,342.2c-0.3-0.9-0.5-5.2-1.8-4.5C49,338.6,50.6,344.8,52.2,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.8,170.8c1.5-5.4-2.8-0.1-1.8,2.6C173.1,175.1,172.7,172,172.8,170.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,347.6c0.4,1.6,2.8,3.5,2.6,0.8C65.2,345.9,61,343.8,63,347.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.2,218.1c0.9-0.4,2.6-0.4,2.8-1.4C124,213.2,117.2,216.9,121.2,218.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.5,186.5c1,0.2,2.6-0.3,3.3-1C103.3,182.2,96.6,184.7,99.5,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.9,173.1c1.3-0.6,4,0,2.5-2.2C96,169.4,92,171.5,94.9,173.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,384.6c2.2-0.8-2.5-4.1-3.8-3C52.9,382.5,56.6,385.2,57.5,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,196.5c1.3-0.9,2.6-3.6,0.2-3.9C54.4,193.4,52.4,197.5,55.3,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,344.1c1.6,1.6,4.7-3,2.7-3.4C98,340.4,95.9,343,96.7,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.7,377.6c0.2,1.1,3.4,6.4,3.8,3.3C112.7,379.5,111.7,376.3,109.7,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,352.9c0.1,1.8,3,1.9,2.1-0.2c0.2-1.6-2.9-3.9-3-1.4C72.6,351.8,73.2,352.3,73.2,352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.7,199c0.9-0.5,3.3-2.3,1.9-3.2C63.2,194,59.7,199.4,62.7,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.2,238.4c1.3,0.7,4,2,2.9-0.7C42.9,235.9,38.4,235.9,41.2,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,317.3c-1.7-1.3-1.5,7.2,0.2,6.4C86.9,321.8,87,319.2,86.4,317.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.4,234.5c4.3,1.2-2.8-6.2-3.1-3.3C116.8,232.6,118.3,233.5,119.4,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.6,280.5c4.5,1.1-2-6.2-2.2-2.4C59.6,279.2,61,279.6,61.6,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,395.4c0.6,5.1,2.9,1.1,2.1-1.8C196.8,391.9,195.3,394.2,195.6,395.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,396.1c1.2,0.2,1.9,1.6,2.8,1.6C17.8,395.5,11.5,392.2,12.4,396.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.7,296.6c1.2,0.5,3.2,1.6,3.6-0.2C29,294.2,23.7,293.8,25.7,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.5,266.5c1.3,0.8,4.8,0.6,3.8-1.7C203.4,264.5,199.1,264.7,200.5,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,339.7c1.4-0.1,0.3-3.6-0.3-4C64.1,335.4,64.8,340.2,66.9,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.3,373.2c2.2,2.6,2.1-3,0.3-3.6C36.6,369.5,37.6,372.3,38.3,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.7,330.8c-1.7-4.2-4.2,6.2-0.6,2.9C162.2,332.7,162.8,331.9,162.7,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.3,274.2c0.2,1.4,2,5,2.6,2.1C178.6,274.8,176.3,268.4,177.3,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.9,351.2c4.7,2.4-1-4.1-3.1-3.4C101,349.6,104.4,349.8,104.9,351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.7,187.2c6.3,3.2,2.2-2.2-1.3-2C140.2,186.1,140.9,186.9,141.7,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.6,205c0-4.3-3.6,2.2-2.8,3.8C15.7,210,15.3,205.9,16.6,205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,306.5c1.2,4.4,3.2-3.9,0.3-4.1C6.4,303.5,8.3,305.3,7.4,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172,279.8c0.6,1.1,2.8,4.7,3.9,3.4C175.9,282,170.3,275.7,172,279.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.5,330.5c0,2,3.1,2.1,2.6,0.1C14.3,327.8,11.5,326.8,12.5,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.4,265.2c1,0.3,2.3,0.7,3.3,0.6C162.5,262.9,154.9,262.4,157.4,265.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1,228.7c2.8-0.5-0.7-4-2.1-3.3C136.5,226.9,139.2,227.8,140.1,228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,374.3c-0.2-1.1-2.5-2.7-3.6-2.3C42.5,373.2,46.7,376.7,47.5,374.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47,386.8c0.6-1.1-1.2-5-2.7-3.4C43.7,384.4,45.8,387.4,47,386.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,382.6c0.9,3.5,3.2-2.8,0.9-3.5C24.6,379.1,26.2,381.3,26,382.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.5,363.1c-5.1-2.1-1.6,2.9,0.9,2.5C188,364.6,187.4,363.6,186.5,363.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.3,397.3c-1.3-4.2-3.1,5-0.2,3.9C27.8,400.1,26.9,398.5,27.3,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.2,281.4c0.6,1.3,5.3,0.9,3.8-1.1C44.7,279.8,42.4,279.5,42.2,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.9,205.8c0.7-0.1,1.3-0.5,2.1-0.4C184.7,201.3,175.4,203.4,178.9,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.9,170.9c0.9-0.1,1.1-2.6,0-2.4C147.4,168.8,146.9,171.8,150.9,170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.4,291.8c0.9,0.4,3.2,2.5,3.5,0.7C85.7,290.6,79.1,289.1,82.4,291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.9,352.4c0.9,1,3.7,1.9,3-0.5C182.6,350.8,178.6,349.5,180.9,352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,311.7c1.2,0.9,3.3,2.2,3.5-0.1C66.2,310,61.1,309.6,63.1,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.9,290.4c-0.9,1-1.3,3.6,0.5,3.9C166.7,293.6,167.3,289.8,164.9,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.4,241c3,0-0.6-5.6-2-2.8C155,239.8,157.1,239.7,157.4,241z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.7,222.1c-1.7-0.7-3.8,1.5-1.6,2.1C79.2,224.7,81.7,222.4,78.7,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,319.5c-2.6,0-0.7,3.1,0.8,3.6C68.4,322.6,66.1,320.4,65.1,319.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.5,329.2c-3.1-8.8-2.8,5.4,0.1,0C22.5,329.3,22.5,329.3,22.5,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,259c1,0.1,3.8,1.4,3.7-0.3C77.3,256.7,71.3,256.8,73.5,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.1,307.9c8,2.1-0.3-4.8-0.7-0.4C56.6,307.8,56.8,307.9,57.1,307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.2,382.2c0.1,1.2,1,2.6,2.3,2.1C89,382.9,85.8,378.4,85.2,382.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.8,330.7c1.3,4.9,4-1.3,0.4-2C154.8,328.6,155.8,329.9,155.8,330.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,343.1c2.4,3.3,2.7-3.4,0.2-3.2C18.9,340.5,19.3,342.2,19.6,343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,370.6c-2.2-0.2-1.5,3.2-0.5,3.9C68.8,374.5,68,371.6,67.3,370.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,392.5c0.4-0.8,1.4-1.1,1.7-2C135.6,384.9,129.3,394.4,133.2,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,258.7c1.4-1.6-3-2.5-3.4-1.6C120.4,258.8,123.8,259.9,124.5,258.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,193.2c1.3-0.7,3.1-3.5,1-4.3C114.6,190.2,111.9,192.1,114.1,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.1,186.8c2.4-3-4.3-1.9-2.7,0.5C148.3,188.2,149.2,187.2,150.1,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.7,304.5c-2.6-1.8-0.9,2.6,0.2,3.2C195.1,308.4,194.1,305,192.7,304.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.1,328.9c0.8,1.6,3.4-1,2.7-2C93.9,324.9,91.2,327.7,92.1,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,293.5c1,0.1,2.9,0.4,3.2-0.9C41.8,290.2,35.7,291.8,38,293.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,309c1.2,3.7,3-1,1.6-2.4C16.2,306.3,15.4,307.8,16,309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.7,352.5c-0.1,1.2,2.8,4,2.3,1.6C111.1,352.3,107.3,348.8,108.7,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.2,266.5c1.2,0.6,3,0.8,4-0.3C73.8,264.6,67.4,264.4,69.2,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,250.8c2.3-1.3-1.8-2.5-3.1-1.9C22.3,250.6,25.6,251.1,26.8,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,324.1c1.1-0.6,0.7-4-0.6-4.3C88.7,320.1,88.9,324.1,90.5,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.1,329.1c1.4,0.7,3.1-3.7,1-3.6C89.2,325.8,87.8,328.5,89.1,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,363.4c-0.5-1.2-1.8-0.3-2.6-0.6C1.3,363.6,8.1,365.9,9,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.6,379.1c1.5,0.1,1.7-4.2-0.4-3.7C114.8,376.4,114,378.7,115.6,379.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.5,268.2c1.2,0.7,3.7,0,2.7-1.8C198.4,265.1,194.3,267.8,196.5,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.8,349.5c-0.4-0.9-0.9-2.5-2-1.5C58.4,349.7,62.2,353.6,61.8,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.9,246.3c-1.5-2.5-3,0.6-1.4,1.9C94.9,249.9,95.8,247.4,94.9,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.3,415.1c-1.4-1.5-2.5,0.4-1.8,1.7C311.3,417.4,311.9,417.2,311.3,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,301.8c-5.8,5.3,1.9,7.3,0.3-0.2L314.8,301.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.9,284.9c-2.9,3.7-2.7,11.2,0.9,3.3c-0.1-0.2,0.9-9-0.6-7.7C314.3,282.1,314.5,283.3,313.9,284.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,291.6c-2.5,1.6-3.1,5.2-4.1,7.5C314,302.6,315.5,293.9,315,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.4,257.4c-8.6,3.7,2.2,5.9,0.7-0.6C314.8,256.9,314.6,257.1,314.4,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,236.3c-0.1-1.2,0.5-2.8-1.3-2.5C311,234.2,313,236.7,315,236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,268.9v-4C314.6,266.2,312.4,268.7,315,268.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,240c-0.8,0.3-0.7,1.4,0,1.8V240z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,335.1c-2-1.2-1.7,2.1,0,2.4V335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,182.9c-0.2,0.5-0.1,1.3,0.4,1.6c0,0,0-2.1,0-2.1C314.8,182.6,314.7,182.7,314.6,182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,394.3c-3.1-0.4-1.3,4.7-3.3,5.8C309.5,404.7,317.5,399.3,314.9,394.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.2,204.6c-2.4,0.1-0.8,2.7,0.9,3.1C315.1,206.8,315.4,204.9,314.2,204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.4,196.6c3.3-1.6-4.8-6.3-5.4-2.5C310,195.4,312.9,195.3,314.4,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,209.5c-3.2,0.7,0.3,3,1.5,4C315.2,212.1,315.3,209.9,313.6,209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,348.6c-1.7,1.4,0.9,4.2,0.3,0C314.9,348.7,314.8,348.7,314.8,348.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.1,360c1.8,1.7,2.5-1.7,3.7-2.5C318.5,351,308.6,357,310.1,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,384.9c-1.7-1.1-7.6-1.8-5,1.5C312.8,386.1,315.5,388.9,315,384.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.3,251.6c-4.9,1.3,1.6,4.9,0.6-0.2C314.8,251.5,314.5,251.6,314.3,251.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,409.6c0-0.7,0.4-11.3-1.7-5.7C313.4,405.5,312.8,409.8,315,409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.1,311.3c2.5,1.7,3.3-1.4,2.9-3.3C314.3,309.5,310.7,309.4,312.1,311.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,215c-2.3-2-1.8,2.3-0.1,2.8C315,217.6,314.8,214.8,315,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,200.1c-1.3,0.1-1.3,2.3,0.2,2.2C315,202.2,315.3,199.8,314.9,200.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,365.9c-2.1-0.9-2.1,1.8-0.1,1.8L315,365.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,243.1c-1.4,0.8-3.7,0.4-4.7,1.8C310.1,247.5,316.1,245.7,315,243.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.5,249.1c2.9-3.3-4.1-1.2-5.2-0.2C309.2,251.9,313,249.4,314.5,249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313,227.9c2.4,0.4,1.9-0.2,1.9-2.1C313.2,224.9,311.8,226.7,313,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,274.5c-0.4,1.1-1.6,3.2,0,3.6C315,277.9,315,274.5,315,274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,171.9c-3.7-4.3-1.1,2.7-0.2,4.5c0.9,1.2,0.2-4,0.4-4C314.9,172.2,314.9,172.1,314.8,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,371.6c-1.5,0.1-2.3,2.3-1.3,3.3C315.6,375.3,314.9,372.7,314.9,371.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,323.8c-1.8,0.4-0.7,2.1,0.1,3L315,323.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,363.5c0.4,0.3,0.1-1.3,0.2-1.4C310.3,360.4,309.8,363.8,314.8,363.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.8,378.5c-1.5-0.3-1.2,2.6,0.1,2.4C314.8,380.7,315,378.3,314.8,378.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9,228.6c-0.7,0-1.8-0.9-2.3-0.2C66.9,231.4,74.3,231,70.9,228.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.6,269c1.2,0.3,3.3,0,2.1-1.6C133.1,266.3,130.2,267.6,132.6,269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.4,242.8c1.2,0.7,3.7-0.1,2.5-1.7C130.6,240.1,128,241.1,129.4,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.1,294c-0.7-0.7-3-1.9-3.1-0.4C87.6,295,92,296.7,90.1,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.2,277.6c0.3,1.6,4.9-0.2,2.7-1.2C118.2,275.7,115.7,276.4,116.2,277.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.3,247c0.3-1.5-3.1-1.2-3.3,0C197.7,248.7,201,248,201.3,247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.8,173.6c1.4-0.1,2.3-1.8,0.9-2.5C230.4,170.5,229,173.5,230.8,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,269.6c-1.1,0-3.7,0.8-2,2C103.6,272.2,106.5,269.9,104.2,269.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.6,381c1-0.1,2,1.2,2.8,0.5C191.4,379,185.2,378.8,187.6,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.6,235.7c-2.2,0.8,1.1,3.2,2.1,2.7C117.6,237.2,115.6,236.1,114.6,235.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.1,193.6c1.4,0.2,1.4-2,0.3-2.2C136.3,191,135.7,193.7,138.1,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.5,298.4c-0.5-0.6-1-3.1-2.1-2C112.1,298.2,115.5,302,114.5,298.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.2,356.1c1,1.1,1.7-0.8,1.8-1.6C141.9,352.8,139.7,354.9,141.2,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.4,279.2c0.8,1.1,3-0.1,2.2-1.4C182,277,179.6,278.1,180.4,279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201,263.1c0.7-0.2,1.8-0.1,1.7-1.1C202.9,259.5,198.5,262.3,201,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.7,362.8c-0.9,0.8,0,2,0.9,1.9C119.2,364.1,117.6,360.9,116.7,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,334.3C96.3,334.3,96.7,334.7,96.6,334.3C96.7,334.4,96.7,334.3,96.6,334.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.9,335c-0.1,0-0.1,0-0.1,0.1L94.9,335z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.8,328.9c2.4,1.7,3.4-1.4,2.8-3.4c-0.1-3,2.7-6.7,0.6-9.4C235.5,316.9,236.4,326.3,234.8,328.9 C234.7,328.9,234.7,328.9,234.8,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.2,335.1c3.3-0.2,0-5.5-0.1-7.5c3.4,0,0.9-8.4-0.7-9.8c-3.3,1,0.7,5.8-0.1,8.4c0.5,1.3-1.7,0.9-1.3,2.4 C249.9,330.6,249.9,333.9,251.2,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.5,296c3.9,8.4,1.8-3.1-0.5-5.7c3.7-1.8-1.8-5.1-3.4-6.9c-5.1-1,1.9,4.8,2.9,6.2 C236.3,291,238.3,294.4,239.5,296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.5,178.1c-3.2-4.9-1.2,6.9-6.1,11.2C288.9,191.5,291.7,181.6,290.5,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.8,411.2c0.1,2,3,5.3,3.3,1.8c-0.5-0.8-1.9-2.4-1.4-3.1c3.6,2.1,2.7-1,0.7-2.5c-1.3-1.1-0.9-3.8-2.7-4 c-2.1,0.5-0.1,2.5,0.1,3.8C247.5,407.9,249.2,409.5,249.8,411.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.2,276.9c2.4-0.9,9.4-2.8,5.7-5.5c1.3-1,6-2.9,3-4.5c-1.5,0.8-8.4,4.8-3.4,5 C262.1,273.6,254.6,274.6,257.2,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.9,369.3c3.5,0.1,7-1.5,10.5-2.1C254.3,362.4,234.8,366.8,237.9,369.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212,315.4c4.5,4.7,0.1-8.1-2.2-2.6C208.9,320.1,212.9,327.2,212,315.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295,396.8c11.7-0.6-1.1-5.8-3,1.6c-0.7,2,3.1,6.8,4.3,3.4C296.5,400.2,291.5,397.8,295,396.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.1,326c2.7-4.4-0.8-11.6-1.6-2.2c-2.2,0.4-3.4,9.6-0.2,5.9C206.9,328.4,205.9,325.6,208.1,326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.4,177.3c-3.9-3.2-2,8-3,10.1C249.9,190.8,249.2,179.3,249.4,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308,268.5c-10.4-2.1-6.3,2.5-1.6,6.8c4.7-1.2-5.9-6.3-1.1-5.8C306.3,269.7,308.8,270.3,308,268.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.1,261.1c1.8-0.1,6.3,1.4,6.1-1.5c-1.3-2-7.9,1.9-6.5-3C225.8,250.3,222.6,261.8,227.1,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.7,375.8c-1.2-1.2-8-2.1-5.6,0.7c3.3,0.1,5.8,2.2,7.9,4.4C259.4,379.9,255.3,376.6,253.7,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271,208c9.3-4.5,0-4.1-4-0.5C265.8,214.7,268.1,209.7,271,208z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.9,281.4c1.6,0.5,4.9,3.2,5.4,0.2c-1.8-1.3-4.9-1.1-6.2-3.3C231.8,270.1,230.4,280.6,235.9,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.1,326.4c1.6,1.3,5.1,5.2,6.2,1.7C294.1,325.9,284.7,318.2,290.1,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.9,416.6c0.2-1.9,2.8-3.5,1.3-5.4C298.7,409.8,294.1,418.7,298.9,416.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.1,403.3c-3.5-3.7-4.9,10-1.4,9C229.9,410.3,227.3,405.8,229.1,403.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,335.4c8.4,0,2.9-18.5,2.1-3.7C239.8,333.2,234.5,334.3,237.6,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.7,275.3c5.3-1.7-9-17.1-3.9-7.6C252.8,269.8,252.9,273.8,254.7,275.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,205.1c-1.1-5.4-5.1-3.6-1.4-9.7c-1.9-1.5-3.3,3.2-3.8,4.6C213.2,201.5,215.7,206.5,217.6,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.4,375.7c1.6,2,4.4-2.2,6.5-2.3C248.6,369,231.3,371.1,231.4,375.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.4,286.5c2.6,0.3,11.9-1.9,9.1-5.2C258,284.8,250.3,284.2,253.4,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.5,412.1c4.2,9.3,2.1-7.7-0.6-8.4C257.7,405.3,261,409.5,260.5,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.3,319.7c0.7-1.3-1.7-13.9-4.2-8.3C241,313.6,239.1,321.1,243.3,319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313,196.7c-1.5-3.8-5.8,6.2-5.4,7.4C309.9,205.9,313.3,198.7,313,196.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.3,298.3c4.9,1.2-2.4-5.3-2.5-0.7C265.4,304.7,273.1,306,266.3,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.4,253.5c2.9,0.2,1.4-4.7,1.9-6.6C235.9,236.7,232.2,250.9,234.4,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.9,277.4c3.8,4.6,3.9-4.8-5.9-5C286.9,274.5,297.8,274.4,297.9,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.7,320.1c6,3.9-2.1-6.8-2.3-8.6c-3.9-3,0.9,7.3,1.9,8.6C270.4,319.9,270.5,320,270.7,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.8,407.2c-1.2-2,1.4-9.9-2.5-8C208,401.1,209.5,412.2,211.8,407.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.8,397.9c1.8,1.1,7.6-2.4,5.2-4c-2.2,2.9-5.1,1.1-7.6,0C281.4,395.8,285,397.1,286.8,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.7,224.7c1.3-7.3-4.1-10.9-2.2-1c0.4,1.5-1.5,2-2,3.1C262.3,228.9,265.1,225.8,265.7,224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.6,389c1.3,1.8,8.1,7.7,7.9,3.1c-3.2-0.6-5.3-2.8-7.4-5C245.4,385.3,244.4,388.5,246.6,389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.1,411.8c3.5,6.1,2.1-9,0.5-9.7C280.3,402.2,281.9,409.9,282.1,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.5,333.1c4.3-1.7-6.2-5-7.4-7.8C265,324.8,276.1,332.9,277.5,333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.1,335.2c3-2.5-2.6-2.4-4.2-2.2c-1.5,1.6,1,3.9,0.7,5.8c-0.5,1.3,2.1,4.9,2.2,2.2 C274.9,338.3,271,333.2,276.1,335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230,299.5c1.9,2,0.4,4.3,0.8,7c1.1,3.5,2.3-0.6,1.7-2.4C232.9,294.4,224.2,294.3,230,299.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.5,341.8c1.8,1.3,3,6.5,5.5,4.9C214.8,343.3,203.9,334,208.5,341.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.1,264.1c-1.8-1.6-2.3-4-3-6.1c0.6-2.4-2.3-2.3-2.2-0.1C241.3,260.4,246.4,269.3,247.1,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.7,359.3c-4.6,0.6,4,12.7,5.4,7.1C300.5,364.9,298.8,362.1,297.7,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.1,401.4c3.9,0.6,3.3,4.6,4.8,7.2c3.1-0.4-0.3-6.6-0.8-8.3C288.6,400.4,284.6,398.2,286.1,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7,238.6c-6.8,5.2,7.2,1.2,6.3-3C231.4,232.9,229.2,238.6,226.7,238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.4,218.5c1.6-6.5-16.1-2-7-1.4C308.9,216.3,311.2,219.1,313.4,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.2,413.5c2-1.4,0.3-9.6-1.2-4.6c0.1,3.5-5,6.9-1.6,7.5C294.5,414,293.6,417,295.2,413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.2,390.7c-0.5-1.6-1.2-4.1-3-1.8c0.4-2.1-3-3.9-1.9-0.9c0.4,1.5-2.9,4-0.5,4.7c2.1,0.1,1.5-3,2.8-3.5 C306.8,392.9,311.3,392.5,309.2,390.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.5,384c7.8,3.3-2.4-7.3-5.7-5.5C235.9,380.1,242.7,381.7,243.5,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.6,338.2c7.5,8.5-0.2-6.5-3.8-6.6C280,332.6,284.9,336.7,285.6,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.9,344.3c2.4,0.9,5.9-4.6,8.3-5.9C243.9,332.9,230.4,343.2,231.9,344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.9,240.3c0.6,0.7,1.6,0.5,1.7-0.4c0.2-2.1,9.4-6.5,4.3-7.1C215.5,235,209.3,237.3,210.9,240.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.2,412c-0.1-1.6-1.2-6.2-3.2-3.4C229.9,412.9,232.4,422.2,233.2,412z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278,318.8c1.6-1.7-2-3.4-3.1-4.4C265.9,304.9,274,320.1,278,318.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.2,179.6c6.4,1.9,11.4-9.3,4.9-3.7C274.2,177.6,268.5,177.2,270.2,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.5,235.5c-1.6-1.1-7.3-6.7-8-3.2C305.1,233.4,315,240.7,312.5,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.2,201.5c1.3,1.4,2.9,7.6,5.3,4.8C255.8,203.8,249.3,194.4,250.2,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.3,415.9c-0.9-4.7-3-3.1-2.5,0.8C208.5,416.6,210.5,417.1,210.3,415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279,216c3.4-0.2,13.8-9.8,4.5-5.2C282.3,212.5,277,213.4,279,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.5,342.8c1.3,2.9,3.5-3,2.6-4.6c-1-2.8-7.5-6.4-3.7-1.2C291.1,338.6,291.5,340.7,290.5,342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.6,289.2c7.6,3.6,3.1-3.7-1.9-2.5C273.7,287.4,278.9,289.1,282.6,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.2,337.3c1.5,6.9,4.2-5.2,4.2-7.2c-1.6-1.5-2.1-0.1-1.8,1.5C267.5,333.5,265.9,335,266.2,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.9,253.8c0.5-1.5,1.3-2.6,2.7-3.3c0.5-2.8-3.4-0.7-4,0.8C212,255.4,214.2,261.4,216.9,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269,183.1c11.2-0.7-1.5-2.6-5.1-2.7C260.2,182.2,267.5,183.4,269,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.4,288.9c4-1.2-4.9-5-5.1-7.4C240.4,282.1,248.4,288.2,250.4,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6,240.7c1.1-5-6.5,3-9.1,1.4C214,247.3,220.4,242.1,222.6,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.6,352.3c1.9,0.6,9.1-6.9,5.2-7.6C272.7,347,266.3,350,268.6,352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243,340.8c1.5-1.5,1.6-10.1-1.2-6.5C242.9,337.4,237,346.6,243,340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.2,230.2c10.4,2.4-0.9-3.3-3.2-5.4C299.4,225.3,304,230,305.2,230.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.9,254.4c-0.6,2.6,2.3,0.4,3.5,0.4C302.8,256.1,289.7,249.6,284.9,254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.1,269.9c4.5,8.6,0.6-12.6-1.9-6.3C255,265.6,255.1,268,256.1,269.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.1,186.2c-1.7,5.1,11.7-2.5,6.1-4.4C276.4,183.2,274.7,185.7,272.1,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.1,247.8c2.3,0.4,8.2-3.5,5.1-5.4c-2.3-0.5-2.7,3.5-5.2,3.7C265.3,246.2,265.7,247.8,269.1,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.8,266.7c4,3.4,9.6-5.9,1.6-1.3c-1.3,0.6-0.9-1.1-0.9-1.8C260.4,255.5,257,264.5,259.8,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.4,319.4c3.3-0.2-3.4-5.4-3.4-7.9C276,309.9,280.8,320.7,283.4,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283,221.1c0.8-1.7,5.8-4.7,2.7-5.9C283,217.1,274,227.2,283,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.3,416.3c-0.2-2.8-4.8,0.1-6.1,0.8C281.6,416.8,288.3,417.9,287.3,416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.5,321.7c0.6-0.3-0.2-1.4,0.3-1.5c2.9,5.2,2.1-6.3,0.2-6.3c-2,1.1-0.2,3.8-0.4,5.6 C213.7,317.4,214.2,323.3,216.5,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.3,192.4c1,1.6,1.3,5.6,3.5,5.6C243,196.3,234.7,184.3,236.3,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258,386.9c1.5,1,5.1,3.2,5.4,0.1C260.6,385.2,248.6,379.4,258,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.1,230.1c0.7,1.3,1.1,6.1,3.1,3.3c-2.6-3.8-1.8-5,0.8-8.4C296,220.8,291.9,228.3,293.1,230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.1,358.5c1.8-0.4,10.1-4.2,6.2-6.1C245.5,353.4,236.1,357.9,240.1,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.5,249.2c1-1.7,9.3-3.3,4.9-5.1c-2,1.7-4.8,1.4-6.5,3.5C209.8,249.1,212,251.5,213.5,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.8,412.1c2.8,3.9,3.2-7.8,1.5-8.6C268.6,404.6,270.3,409.6,269.8,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.7,212.4c0.9-1.9,4.1-6.2,0-6.1C304.1,208.8,298,216.7,304.7,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.7,306.4c3.7-1.4-4.9-5.1-6.1-6.3C297.1,301.9,305,305.8,306.7,306.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234,306.6c0.5,1.6,2.2,9.6,4.6,6.6C237.8,311.5,234.4,300.5,234,306.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.5,282.2c1.3-1.4,3.1-7.4-0.3-4c-0.4,2.4-6.8,6.7-2.1,7.3C210.6,284.3,211.7,283.3,212.5,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.8,263c2.8-0.8,0.1-2-1.3-2.7c-1.8-0.9-2.3-5.4-4.5-3.8C245.7,259.2,248.9,262.9,251.8,263z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.6,297c-2.1-5.5-2.1,4.9-3.7,6.2C218.1,307.3,220.2,299,219.6,297z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.7,202.2c2.3,3.7,5.9,2.8,1.8-0.8C208.5,198.1,204.6,199.5,208.7,202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.3,294.5c-3.7,1.7,4,4,5.3,5.4C295.6,298.7,288.2,294.1,286.3,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.9,414.5c-0.6-1.4-1.2-6.4-3.3-3.8C273.3,413.5,277.1,420.9,276.9,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,383.3c2.5-1.6-8.8-9.5-7.5-4.3C231.5,378.8,232.5,383.9,235.6,383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.4,262c2,4,7.7,1.9,1.7-0.4c-2.9-1.5,2.9-6.2-0.7-6.6C221.1,257.2,219.9,259.5,221.4,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.3,227.7c-3.5,3.1,5.8,2.2,0.4-6.6C244.8,218.7,250.3,226.1,249.3,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.4,390.5c1.6,0.8,11.8-0.7,7.4-2.9C228.5,388.6,222.9,387,223.4,390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.2,225c-5.6-6.5-19.8,9.6-5.6,1C215.1,225,219.4,227.6,219.2,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.4,373.3c-3,1.2,0.5,5.5,2.1,6.8c4.7,3,2.9-1.2,0.1-3C287.5,376.2,287.6,373.9,286.4,373.3L286.4,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301,259.6c3.8,3.8,2.3-2.1-1.6-2.8c-1.5-0.1,1.1-0.8,0-2C293.1,254,297.1,259.6,301,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.8,301.6c-1.8-0.5-4.3-6.3-5.6-3.6C251.9,301.2,262.3,307.9,257.8,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.8,222.1c9.5,6.2,1.1-6.6-7.1,0.5C230.8,223.6,233.4,221.3,235.8,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296,249.3c2.9,0.5,3.4,4.4,6,5.1C305.3,252.3,295,243.7,296,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.6,223c-1.6-6.1-3.2,3.7-5.4,4.9C288.9,230.5,293,224.9,292.6,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.4,390.4c1.9,0,7.1,3.3,6.8-0.3c-2.1-0.1-10.7-4.2-8.8,0.4C237,390.3,237.8,390.3,238.4,390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.3,193c0.7-1.2,2.8-1.9,2.3-3.4C277.7,186.8,269.9,201.3,279.3,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.2,296.8c6.9,1.5-1.6-4.4-4.2-4.4C287.9,294.6,293.7,295.7,295.2,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.5,172.8c2.1,0.5,11.6,0.2,9.7-3.2C270.1,171.6,259.8,169.3,262.5,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238,394.6c2.2,0.7,4.8,1.2,6.3,2.7C248.6,394.2,235.1,390,238,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.7,273.8c-0.3,3.1-6.4,6.8-3.2,8.2c1.7-0.2,7.2-9,3.2-8.3C269.8,273.7,269.7,273.7,269.7,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.5,250.3c-1.1,8.7,5.5-4,1.8-5.9C224.5,244.1,227,248.7,225.5,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.3,217.5c5.3-8.1-7.4,0.1-3.6,2.8c1.7,0.8,2.2-1.9,3.6-2.6C293.2,217.7,293.2,217.6,293.3,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.2,200.6c-0.5,0.3-1.5,0.3-1.1,1.2c1.1,2.8,6.6-1.2,8-2.6C277.2,195.3,273.4,201.1,271.2,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.6,235L208.6,235c3.2,0.7,9.2-12,2.7-5.2C210.7,231.5,207.1,233.2,208.6,235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.3,336.7c3.4,6.3,2.2-8.5-0.5-7.6C260,330.9,262.7,334.3,262.3,336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.8,267.2c-0.5,3.6,6.5,0.8,8.5,2.2C293.4,266.1,283.3,266.8,281.8,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.3,174.7c2.3-4.8-2.6-1.8-4.1,0.4C300.3,177.7,309.4,178.4,310.3,174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.2,199.4c0.3,1.7,0.4,7,3.1,5.2C259.2,202.2,255.6,192.9,255.2,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.1,369c5.2-2-7.7-4-7.6-1.9C222,369,227.2,369,229.1,369z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303,199.7c2.8-7.5-2.8-2.8-3.3,1.5C298.2,205.7,303.1,202.3,303,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.3,244.9c-0.2-7.1-5.3,5.5-1.7,6.5C224.9,250.5,223.4,246.8,224.3,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.4,302.5c0.1-2.8-2-6.3-2.4-8.9C209.5,291.7,213,304.6,215.4,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.2,271.9c0.8,1.5,0.8,6.7,3.5,4.4C239.1,273.5,232.9,264.4,234.2,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.6,286.5c2.7,1.3,2.4-3.8,3.5-5.3C224.9,273.5,217.9,284.1,219.6,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.6,324.4c1.6,0.3,6.8,4.4,6,0.6C308.4,322.6,295.9,320.2,304.6,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.3,197.2c-1.7-1.4,0.9-4.4-0.6-5.7c-1.1-0.1-1.9,0.9-2,1.9C217.1,200.9,225,200.5,221.3,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.1,353.5c1.8-1.2,5.3-8.6,1.5-7.9C253.7,350.1,247.8,352.9,252.1,353.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.7,239.8c1.3,0.5,1.3-1.4,2.1-1.9c1.3-1.1,6.1-2.4,4.5-4.6C221.1,233,215.5,237,216.7,239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.3,324.3c0.3,1.6,1.8,5.2,3.5,2.7C224.9,322.5,219.9,314.4,222.3,324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.5,381c0.3-1.2-8.9-8.7-6.7-3.6c2.1,1.1,3.8,5.2,6.6,4C287.3,381.4,287.4,381.2,287.5,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.2,280.1c5.8,0.3-3.5-4.8-4.4-6.4C244.8,275.2,251.8,278.8,253.2,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,354.5c9.3-0.9-0.7-14.8,2.7-3.7C208.1,351.7,204.3,352.5,206.6,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.6,289c-1.2-1.9-1.2-4.4-1.8-6.6C304.2,278.1,309.4,295.6,310.6,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.5,194.9c1-2.1,5.3-6.5,1.9-7.7C307.3,188.7,302.7,194.7,306.5,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.5,231c1.5-0.2,10.1-3.5,6.3-5.3C275.3,226.7,267.7,228.8,270.5,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.9,338.8c0-2.3-4-2.9-3.7-5.6C242.2,328.9,247.5,341.9,250.9,338.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.9,272.2c3.4-0.4-2.2-4.8-1-7.1C204.9,261.4,207.1,272.2,209.9,272.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.8,361c1.7,2.1,11.1-3.6,5.2-3.4C256.4,358.5,251.9,358.7,252.8,361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215,284.6c2.1,3.5,3.5-7.9,2.2-8.5C215.4,274.9,214.5,283.4,215,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.2,416.5c-1.7-1.3-3.2-3-3.5-5.4C262.5,404.7,267,420.7,271.2,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.7,241.8c4.2,0.7-3.2-4.8-4.6-4C306.6,240,310.2,240.6,311.7,241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229,213.5c5.7-0.4-3-3.3-4.2-4.7C220,209.4,227.2,213.2,229,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.9,173.9c0.6,1.5,3.5,7.3,4.6,3.6c-1.2-1.9-2.3-3.9-2.9-6C226,169.8,224.3,172.6,225.9,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.9,178.7c1.9-0.7,0.9-3.5-0.8-2.5c-0.9,1.8-8.3,3.7-4.4,5.5C278.5,181.1,280.3,179.9,281.9,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.8,273.8c0.6-6.6-17-5.8,0.2,0.1C300.7,273.8,300.7,273.8,300.8,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.9,185.7c-1-1.6-3.4-7.5-5.4-4.4C221.5,182.7,226.5,191.7,225.9,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.3,202.4c-2.3,4-0.8,8.1,1.7,2.2C299.9,201.5,296.9,196.7,296.3,202.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.7,331.7c6.2,4.8,0.6-4.8-1.6-5.9C208,326.5,212.3,330.1,212.7,331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.8,395.8c8.8-2.6-0.2-3.9-3.5-0.9C204.1,398.1,208.3,396.5,209.8,395.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.5,271.5c0.7-1.5-3.4-4.4-2.4-1.6c0.9,2.1-5.3,7.1-0.1,6C213.8,274.5,215.6,273.3,215.5,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.6,258.9c0.4-4.2-7.8,3.7-6.6,5.2C268.6,265.4,272.1,260,273.6,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.9,230.6c-0.5,1.4,1.4,2.9,2.2,1.2c0.2-2.2-0.2-4.5,0.5-6.6C233.6,222.9,233,228.8,233.9,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.3,393.5c2.5,0.5,5.5-1.9,8-1.4C236.4,388.9,225.3,390.6,227.3,393.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.6,374c6.5-6.7-2.1-3.4-1.9,0C266.3,379.8,270.5,380.1,269.6,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.6,257.2c2.1,1.4,2.1-2.6,2.6-3.9C280.4,244,273.5,254,275.6,257.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.3,338.5c-1.6-3.5-2.1,1-1.9,2.7c0,1.5-1.9,3.5-0.5,4.8C271.2,347.3,271.4,340.3,271.3,338.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.8,377.6c1,1.5,2.7,8.9,4.5,4.3C306.5,380,302.7,371.5,302.8,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.1,191.1c2.6-1-1.3-4.4-2.8-4.6c-1.8,0-4.4,4.2-2.4,4.9c1.6-0.4,1.1-4.5,3.3-2 C230.7,190.1,231,191.2,232.1,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305,338.2c-0.1,1.6,1.9,4.4,3.1,2.2c-0.7-2.1-1.9-4.4-1.7-6.8C303.2,331.7,304.6,336.7,305,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,318.7c3.5,2.1,2.4-10.5-0.4-7.6C252.6,313.3,253.4,316.3,253.5,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.8,339.2c-1.8-0.7-6-6.4-7.1-4.8C210.7,336.1,218.3,342.8,218.8,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.9,416.1c0.2-7.4-5,1.8,0.3,0.8C255.9,416.7,255.9,416.4,255.9,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.5,229.1c8.4-0.1,3.1-15.4,2-2.8C268.2,227.2,264.4,227.7,266.5,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.2,368.8c1-2.5-5.4-8.9-5.8-4.5C305.9,364.8,307.1,371.5,309.2,368.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.3,323.3c1.1,1.6,4.4,7.1,4.8,2.4C287.1,323.6,281.2,317.8,283.3,323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.3,290c7.6-1.3-2.2-2.4-4.5-2.8C255.4,289.2,261.4,290.6,263.3,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.1,260c2.2,0.4,6.1,2.1,7.8,0.8c0.6-2.6-3.1-1.4-4.6-1.8C284,258.7,279.3,257.7,282.1,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.1,381.2c0.9,1.5,2.9,7.7,4.9,5.1C270.3,384.7,264.6,375.3,265.1,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.6,416.4c0.1-2.2,1.1-4.6,2-6.7C220.6,407.3,217.1,418.4,221.6,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.6,229.2c-0.2,2.1,0.7,7.4,2.4,3.2C232.9,228.3,230.5,220.8,229.6,229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.4,369.2c1.7,1.8,4.5,5,7.1,4.3c1.5-2-3.1-2.6-4.2-4.2C298.7,367.7,295.6,366.8,296.4,369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.7,235.1c2.1-0.8,3-4.6,0.1-4c-0.8,2-2.8,3.1-4.1,4.6C280.1,238.8,284,236.6,284.7,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.3,307.6c0.2,1.9,2.6,7.7,3.6,3.3C246.4,308.4,242.6,301,243.3,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.4,344.9c1,2,4,6.5,3.4,1.2C312.5,342,305.9,337.3,310.4,344.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.1,388.8c0.7-0.1,1.8-1.8,0.8-2c-2.8,0.4-5-4.6-7.5-2.8C275.9,385.8,281.4,388.3,283.1,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.4,385.1c-1.5-0.9-6.7-6.2-6.3-1.7C229.8,384.1,236.7,390.4,234.4,385.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.2,391.2c-2.2,6.3,7.9-4.5,3.5-6.1C298.6,385.4,299.9,391,297.2,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.8,349.9c3.2-0.8,3.9-12,0.4-8.3C250.7,347.2,243.8,349.3,247.8,349.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.4,408.7c1.8,0.5,2.4-1.4,3-2.7C222,395.6,212,405.3,213.4,408.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.6,282c1.3,2.3,12.5-0.8,6.7-2.8C258,281.7,252.4,279.6,252.6,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.6,186.2c-2.2,2.9-0.5,6.9,1.6,2.3C304.4,183.9,299.6,179.2,300.6,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.8,245.4c4.9,2.8-0.9-5.9-2.3-6.3C235.1,239.9,240.1,243.8,240.8,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.1,379.8c1.9-0.5,10.4-0.9,7-3.8C211.4,377.9,204.1,375.5,206.1,379.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.4,351.5c4.3,2.5,8.9-10.3,2.9-3.3C263.6,349.8,259.1,349.9,261.4,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.7,320.1c3.8-1.6-4.7-3.9-6.2-4.4C304.2,317.1,312.5,320.1,313.7,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.4,361.6c1.7-0.4,6.2-1.8,4.3-3.9c-2.1-0.1-4,2.8-6.4,2.5C218.7,361.3,222.1,362.8,223.4,361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.2,391.8c1.8-0.1,8.7-0.4,2.9-1.9C273,388.6,265.4,392.4,274.2,391.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.4,381.9c4.2-3.2-10-4-6.7-0.5C213.7,381.6,216.3,381,218.4,381.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.9,380.4c1.9,1.1,4,4.3,6.2,3.9C254.2,382.4,244.6,375.6,245.9,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.6,253.2c3.7,5.2,2.6-11.5-0.1-6.1C243.4,249.1,243.9,251.3,243.6,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.6,256.3c2.4,0.8,2.7-3.6,4.4-4.7C286.5,245.2,278.5,255,280.6,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.1,392c2-0.5,9,0.1,5.9-3.3C209.3,389.5,202.6,388.8,205.1,392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.1,278.9c5.7,1.3-1.7-4.1-2.4-6.1C236.8,273.5,241.6,277.8,243.1,278.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.5,415c-0.9-2.1-3.1,0.2-2.5,1.9C236.6,417,235.9,417.1,236.5,415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.4,222.7c-1.3,6.3,4.8-3.3,2.5-5.9C252.2,215.6,255,221.1,253.4,222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.2,217.4c1.6,5,2.9-4.8,3.3-6.3C250.7,208.4,250.7,215.7,250.2,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.5,217.4c-1.6-5.1-4.9,8.1-1.9,7.1C301,223,300.9,219.6,301.5,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.9,229.2c2.3-0.7,0.3-2.4-0.3-3.7C113.4,215.2,113.4,225.9,117.9,229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.7,213.4c-0.7,1.7-5.4,5.9-1.1,5.9c1.9-1.7,7.1-7.7,1.9-8.4l0,0l0,0c0.9-2,5.8-4.1,1-4.7 c-2.6,0.9-6.1,6.9-1.1,4.8C297.3,211.8,297.3,212.8,296.7,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,412.5c-3-0.9-2.1-6.3-4.8-7C308.6,407.1,313.9,418.8,314.6,412.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.7,416.4c-0.1-9.1-4.5-7.2-2.2,0.6C212.8,416.9,215.6,417.4,214.7,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.3,371.4c0-1.6-1.6-9.7-3.9-6.7C277.2,366.1,278.1,374.2,280.3,371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.6,179.6c-0.2-7.3-4.2,2.1-2.2,4.6C262,184.9,261.1,181.1,261.6,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.6,234c1.6-0.8,7.7-5.3,4.4-6.6C217.1,229.2,210.1,232.7,213.6,234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.5,206.6c5.4-1,2.2-4.3-1.6-1.8C273.9,206.2,277.7,208.6,281.5,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.6,293.4c0.5,0.5,0.6,1.6,1.3,1.7c3.6-1.6-2.9-5-4.2-6.6C251.2,289.2,256.3,292.5,257.6,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.6,318.7c1,1.8,2.4,4.8,4.5,5.3C303,324,292.4,313.3,294.6,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,366.4c0.6-2.9-5.5-0.8-7.2-0.4c-3.6-0.5-0.8,2.3,1.2,1.9C271,367.4,273.3,367,275.1,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,240.4c-5.4-1.1,2.8,4.9,4.5,5.3C259.1,243.7,253.4,241.4,251.9,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.2,395.1c1-1.1-0.4-1.8-1.1-2.6c-1.4-1.5-0.8-4.9-2.4-5.7C264.6,388,267.3,396.6,270.2,395.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.2,213.8c1.9,1,4.2,6.5,6.1,4.7C240.3,216.2,231.7,208.2,234.2,213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.1,214.5c1.9,0.6,6.6-6.5,2.8-6.7C291.1,209.8,287,212.8,289.1,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.2,292.6c2.6,5.7,3-4.2,1.3-6.1C224.5,284.8,226.7,291.2,226.2,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7,178.2c-3.3-7.1-8.6,0.1-6.3,0.1C223.9,174.2,224.1,182,226.7,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,354.7c4.8-2.7-5.2-1.3-6.6-0.9C263.6,356.7,272.8,355,274.3,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.8,257.8c2.5-0.1,6,3.2,7.9,2.1C298,257.5,285.3,254,288.8,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.5,231.9c6.8-2.7-4.9-3.1-5.2,1C275.4,235.7,277.5,231.2,279.5,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.3,265.9c2.9-2.2,4.9,1,6.4-0.2C287.6,261.4,276.6,262.5,280.3,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.2,234.1c-1.1-3.7-2.1-2-1.9,0.7c-0.8,1.2-3.5,1.2-2.8,3C224.9,240.2,229.4,236.2,228.2,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287,363.2c-2.1-2.5,0.6-5.3-1.1-6.5C282.2,357,284,368.5,287,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7,386.2c3.9-2-4.4-3.8-5.8-4C219.6,385.3,224.7,385.6,226.7,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.9,383.8c0.8,1.4,4.6,5.4,4.8,1.8C241.1,383.5,233.8,377.6,237.9,383.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.7,281.6c1-5.9-13.4-5.4-3.3-2C294.7,280,295.2,283.4,296.7,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.1,172.6c-0.7-8-2.8-0.3-2.8,3C244.3,178.8,244.8,174.2,245.1,172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.1,187.3c3.5-5.3-5.1-0.7-5.2,2.1C290.6,192.3,292.2,187.6,294.1,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.7,368.4c4-0.9,4.8-5.4,0.1-2.3C212.4,367.1,211,372.2,216.7,368.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.1,228.2c-1.6,1.1-5.9,1-6.1,3.2C220.6,233.9,229.6,230,226.1,228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.5,233.4c-0.6-2.5-5.1-0.3-7-0.2C261.8,236.4,272.3,235.1,272.5,233.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.8,294.2c-0.7-2-2.4-4.2-0.9-6.5C212.6,281.6,212.8,298.4,216.8,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,184.3c-0.9-1.7-0.7-7.2-3.4-6.2C240.5,179,242.7,187.8,244.9,184.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,217.9c3-1.9-4.4-2.9-5.6-4C209.2,214,218.2,218.5,220,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.7,402.6c-0.6-7.6-3.6,1.8-2.3,4.5C269.4,408.8,268.2,404.1,268.7,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.7,397.9c2.2,0.1,4.5,2.6,6.1,2.2C260.9,397.6,249.8,393.7,251.7,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.3,395.1c1.1,3.6,3.8,6.3,2.5,0.4C266.4,391,260.9,388.5,265.3,395.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.3,393.2c1.9-4.3-8.1,0.6-6.2,3.1C216.1,396.2,218.4,394,220.3,393.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.6,206.7c2.6,4.8,6.1,3.6,2.1-1C226.8,202.3,222.8,203.8,226.6,206.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.1,266.8c1.5,0.2,6.4,0.3,4-2.1C303.1,264.2,292.5,265.4,302.1,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.2,255.8c2.5-4.6-1.7-4.3-2.5-0.1C208.6,260.7,211.8,260.6,212.2,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.7,175.2c0.2-2-1.6-6.8-2.8-2.8C235.9,175.9,237.6,182.2,238.7,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249,254.8c0.8,1.2,1.3,5.1,3.2,2.8C253.4,254,245.9,247.8,249,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.3,178.7c0.6,4.2,4.4,4.2,2.6-0.1C234.4,173.9,230,173.5,232.3,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.2,190.5c0.9-1.3,1.8-3-0.7-2.6c-1.9,1.2-1.6,4.2-3.7,5.3C257.7,196.5,262.2,192.2,262.2,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.1,362.2c7.1-2.5,1.4-4.1-2.3-1.3C267.6,361.8,273.3,364.1,276.1,362.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296,344.1c-3.2-1.6-2.4,5.4-3.5,7.4C295.5,353.5,295.7,346.1,296,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.9,186.3c1.3-2.9-2.4-1.4-2.5,0.7c0,1.5-1.1,5.1,0.7,5.6C218.5,191.6,216.6,188,217.9,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.2,409.9c1.3,1.9,1.7,5.1,3.3,6.4C243.8,415.7,237.2,404.6,237.2,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.9,302c6.5,1.5,1-3.2-2.1-3.5C267.8,298.3,272.9,301.4,274.9,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.4,209.8c0.1-1.9,1-7.7-2.1-6.8C243.5,203.9,244.2,213.3,246.4,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.2,292.9c2.9,7.4,2.5-2.7,1.1-5.6C220.5,285.8,222.5,291.4,222.2,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.9,394.1c0.7-3.9-7.6,1.9-5.9,4.3C220.3,399.1,226.1,394.8,225.9,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.2,352.1c1.9,2.3,5.4-1.8,6.5-3.5C237.2,345.4,231.9,351,231.2,352.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.8,373.1c1.7-0.2,9.7,0.5,9.8-1.1c-0.5-1.1-12-1.4-10,0.9C244.5,372.9,244.6,373,244.8,373.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.4,310.2c-0.4-1.3-0.7-3.7-2-4.2C253.7,306.7,260.1,318.7,259.4,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.7,236.4c-0.8-1.3-3.1-5.7-4.2-2.7C238.2,236.5,245,243.5,241.7,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.8,329.6c14.8,4.9,2.7-6.2,0.1,0.1C305.7,329.6,305.8,329.6,305.8,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.9,273.3c1.5-7.8-3.8,0.4-3.2,3.4C222,278.6,222.3,274.6,222.9,273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.8,223.7c2.7,0.6,4.4-7.2,1.5-7.2C257.3,217.4,258.6,221.7,257.8,223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,379.4c3.6,7.6,2.7-0.8,1.6-4.3C293.5,374.1,294.5,378.1,294.2,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,305.9c1.6,0.1,9.6,0.4,6.6-2.4C294.5,303.2,287.2,303.3,289.4,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.7,377c0.8,2,4.6,4.4,3.4,0.5C300.4,374.2,295.3,370.5,298.7,377z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.8,294.3c-0.1-1.5,0.8-8-1.8-7C207.4,288.9,206.7,297.2,209.8,294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.8,192.4c1.1-1.3,6.9-3.7,5.1-5.3C268.2,187.1,258.8,193.5,264.8,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.5,306.3c-0.4-1.5,0.3-5.4-1.5-5.6C219.7,302.9,223.2,314.1,223.5,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.1,358.2c1.6-0.4,9-2.9,5.3-4.3C236.1,354.5,228.3,356.6,232.1,358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.8,268.8c0.6-0.2,1.1-1.6,0.2-1.5c-1.1-0.5-1.5-2.2-1.9-3.3C234.9,257.3,233.3,270.1,238.8,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.3,214.6c2.2,2,2-6,3.1-7.4C247.4,205.5,246.5,212.6,247.3,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.9,236.7c-4.4-5.1-0.8,4,2.1,4.6C302.5,241.7,297.3,237.7,295.9,236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.8,191.7c-4.9,3.6,3.7,1.4,5.8,1.1C276.2,189.6,270.3,191.3,268.8,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.2,181.6c-1.5-0.2-3.7,6.3-2.2,6.8c2.1,0.3,1.6-1.9,2.3-3.2C253.6,184,255.7,181.4,253.2,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.7,378.1c2,1,4.2,1.9,6.1,3.1C229.2,378.7,217.5,373.5,219.7,378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.5,284.1c1.2-0.4,5-1.7,2.9-3.2C274.9,281.4,266.5,285.7,275.5,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.2,318.4c0.7,1.5,5,5.1,4.2,1.4C291.1,317.3,283.8,312.8,288.2,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.1,407.2c3.6-1.3-3.1-12-3-5.9C262.9,402.8,262.6,406.6,264.1,407.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.4,247.5c3.2,2.1,8.5-2.8,3.7-1.5c-0.6,0.3-1.7-0.4-2.3-0.3C251.9,243.9,248.7,246.6,253.4,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.6,355.8c-0.1-1.1-4.7-9.7-5.4-6C305.3,351.6,306.8,357.2,309.6,355.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.1,289.6c-1.3-1.7-2.6-3.6-3.7-5.4C225.8,280.6,236.9,297,235.1,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.6,335.2c2.2-1.2-4.3-3.9-5.2-4.1C289.4,332.6,296.1,337,297.6,335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,247.7c5.1,1.2,0.5-2.6-2.1-2.5C302.5,245.9,306.4,247.4,307.4,247.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.2,351.8c2.5-4.3-8.9-1-6.2,1.3C218.9,353.3,221.1,351.6,223.2,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.2,342.7c-2.3-2.5-1.9,4.9-3.3,6.2C245.8,352,246.9,344.6,246.2,342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.6,275.2c2.1-2,0-8.2-2.7-6.7C219,271.6,214.3,275.7,218.6,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.2,416.8c-0.1-3,3.8-6.4,1.9-9.1c-0.8,1.3-5.5,9.9-1.8,9.1C304.2,416.9,304.2,416.8,304.2,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,246.6c2.3-0.7,6.5,3.2,7.4,0.7C293.7,244.9,283.8,243.4,285.8,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.6,242.2c1.9-0.3,7.2-1.9,2.8-3C279.3,239.1,273.1,243.2,279.6,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.5,315.8c2.7,6.6,3.3-5.4,0.6-5.9C224.1,310.2,226.1,314.2,225.5,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.3,183.6c-3.3-1-0.8,4.3-1.1,6C259.4,192.4,258.9,184.7,257.3,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.4,270.7c0.4,1.9,4.3,4.9,3.4,1.2C250.5,268,243.9,264.7,248.4,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.1,268c1.5,1.1,3.4,4.8,5.4,3.4C247.9,269.8,239.5,263.3,241.1,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.9,213c3.8,1.4-1.6-7.9-3.3-6.6C205.4,208.7,209.3,210.6,209.9,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229,218.9c8.7,0.4,1.3-3.5-2.9-2.3C224.6,220,227.5,218.1,229,218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.4,264.4c6.1,0.2-2.6-3.5-4.8-3.3C302.2,263.1,309.3,263.6,310.4,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.1,234.5c-4.5,2.2,5.2,2.7,6.2,2.1C263.1,233.8,256.7,234.3,255.1,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.8,352.6c2.2,0.3,2.3-4.2,3-5.9c-0.5-5.7-4,4.6-3.1,5.8C256.6,352.5,256.7,352.5,256.8,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.7,304.1c-1.2-1.5-2.4-4.7-4.3-4.9C202.8,300,208.7,307.6,209.7,304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.9,277.1c4.3,0.4,2.7-14.2-0.1-2.7C224.6,275.3,223.6,276.5,224.9,277.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.4,393.8c-0.2-2.2-6-4.3-4.3-0.9c2.2,0.6,3.3,2.4,4,4.4C264.9,397.6,264.5,394.5,263.4,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.3,236.8c-1.3-7-3.6,3.7-1.8,5C237,242.4,236.1,238.3,236.3,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295,187.5c0.6,4.1,6.6-3.3,4.5-4.5C297.3,182.2,296.7,186.6,295,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.3,222c1.7-0.2,7.9,1.6,6.6-1.7C215.2,220.1,207.4,218.7,210.3,222z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.1,398.2c4.4-5.9-8,0.3-4,2.9C227.4,400.2,228.4,398.7,230.1,398.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.6,394.1c2-1.8,0.6-4.3,0.1-6.4C286.6,382.8,287.9,394.1,289.6,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273,253.1c1.4,0.2,1.4-1.8,2.1-2.7C281.1,241.6,269.3,250,273,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.8,370.8c-0.8-0.9-6.7-7.2-5.7-3C288,369.5,291.4,374.2,292.8,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.6,256.2c0.5-0.5,2-0.1,1.9-1c-0.9-2.8-5.2,0.3-7.2,0.6C262.1,259.2,267,256.3,268.6,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,399.5c4-4.5-9.4-2.3-4.7,0.7C234.4,399.1,235.9,399.6,237.6,399.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.4,177.6c-0.9-1.6-1.3-7.3-3.8-5.8C206.8,173.1,209.9,181.6,211.4,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.1,203.1c-2-5.5-3.7,0.6-1.1,3C223.1,210.1,223,205.2,221.1,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.4,407.1c0.8,0.9,1.9,1,2.8,1.7c1,0.6,1.8,3.7,2.8,1.4C303.1,406.7,291.5,403.4,297.4,407.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.4,250.3c1.6,0.3,1.3,2.6,2.6,3c1.3-0.6,0.9-2.1,0.3-3.1C304.8,246.6,298,246,303.4,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224,300.9c1.3,1.9,4.8,2.1,2.3-0.2c-2.5-1-2.6-4.7-4.8-5.4C219.7,296.6,223.2,299.5,224,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258,213.5c6.1,3.2-3.3-8.9-4-4.3C255.3,210.6,257.3,211.6,258,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.4,203.8c2.7-2.7-5.7-5.9-4.2,2.2C266,205.7,263,202.3,267.4,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.4,395.5c4.6-1.8-4.2-4.1-5.5-1.7C272.2,396.6,277.8,394.4,279.4,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,307.6c-1.2-4.5-3.1,2.3-2.6,4.2C219.6,315.9,219.2,309.4,219.5,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.4,260.4c0.6,1.7,2.6,0.9,1.9-0.8c-0.2-1.7,1.9-3.4,0.6-4.8C217.7,253.3,216.4,258.9,217.4,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,205.9c3.7,2.9,1-5.2-0.6-6.2C236.6,199.4,240.1,204.3,240.5,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.2,356.2c6.6-4-15.2-0.3-5.2,0.6C257.8,356.2,259.2,356,261.2,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.1,255.3c3.1,4.7,3.9-9.3,0.4-5.5C229.5,251.6,229.9,253.6,229.1,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244,223c3.8,3.3,1.1-9.5-1.2-6.1C242,219,244.7,221,244,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.7,375c4.4,3.8,1.3-3.7-0.4-5.2C272.5,369.1,276.6,373.8,276.7,375z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.9,259.7c1-1.4-2.1-1.9-2.4-0.5c-0.4,1.7-4.2,2.8-3,4.4C275.6,264.7,277.7,261.2,278.9,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.7,294.3c4.4,5.7,3.4-1-0.9-3.4C248.8,288,248.7,293.8,251.7,294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.2,176.4c1.4,1.1,6.7,4.6,5.1,0.7C266.9,176,259.5,172,263.2,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.9,400.3c-1.7,5.7,9.4-3.5,4.5-3.1C222.2,398.5,220.3,399.2,218.9,400.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,326.7c1.3-0.3,2.6-7,1.1-7.3C260.3,319.1,258.6,328.6,260.7,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.7,198c4.8,3.7,13.2-2.7,2.5-0.6C266.3,197.3,264.4,196.2,264.7,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224,196.3c2-1.2,0.4-11.5-1.6-5.7C223.2,192.4,221.8,195.6,224,196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.4,298.5c6.2-0.2-1.3-4-3.8-2.8C274.5,297.8,279,298.2,280.4,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227,355.2c1.3-0.5,5-4.6,2.8-5.5C228.6,348.9,223.4,355.4,227,355.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247,235.9c1.4,0.6,5.3,4.7,5.7,1.5C251.7,235.8,243.7,231.2,247,235.9C246.8,235.8,246.9,235.9,247,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.9,212.6c5-2.1-5.3-3.7-5.8-1C272.4,214.2,276.2,211.6,277.9,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.8,220c-1.8,1-6.5-0.1-6,3C302.7,223.7,311.7,222.1,307.8,220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296,357.4c0.3-1.5,3.6-5.1,1.3-5.7C295.1,352.9,290.9,363.1,296,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.7,317.1c2.2,0.3,4.2-7.2,1.2-7C221.3,310.5,219.1,317.3,220.7,317.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.2,178.7c-0.1-1.3,0.1-2.8-1.4-3.1c-1.8,1.1,0.1,5-0.7,6.9C215.4,185.1,215.5,180.3,215.2,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.1,416.8C243.7,409.6,239.4,417.9,245.1,416.8C245.1,416.9,245.1,416.8,245.1,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.6,220c1.8-5.1-7.3,2.4-5,3.7c1.8,0,3.4-2.3,4.9-3.6C278.4,220.2,278.5,220.1,278.6,220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.4,256.3c6.4,0.7-3-5.7-4.2-2.6C307.2,255.3,310.2,255.2,311.4,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.4,412.8c0.3-1.9-0.6-8.7-2.4-3.8c0.7,1.7-0.2,4.3,0.9,5.6C280.8,415.2,280.7,414.2,280.4,412.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.7,237.8c-2.4-0.9-8.9-2.5-3.7,1.3C302.6,240.6,308.4,240.4,304.7,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.9,175.3c1.5-4.8-3.2-0.6-3.7,1.7C248.4,181.1,254.7,177.7,254.9,175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.2,399c4.3,4.2,0.5-4,0.6-5.9C245.6,392,247.7,397.5,248.2,399z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.1,414.5c-2.6-2-2.1,0.5-2.2,2.4C226.9,417.2,228.1,416.8,227.1,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.4,199.5c2.2-3.9-8.5-1.4-6.3,1.2C281.9,200.4,284.5,199.5,286.4,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.8,219.8c-1.4-0.5-9.3-0.6-6,2.2C221.6,221.5,226.3,222.7,225.8,219.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225,364.6c2-0.1,6.3,1.5,7-1C230.8,362.9,222,361.6,225,364.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.6,364.9L213.6,364.9c1.3-2-6.9-1.2-7.9-2.5C201.3,364.4,212.2,365.8,213.6,364.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.8,263.9c-4.1,1.1,4.2,3.4,5.4,4.1C297.8,265.6,291.3,264.7,289.8,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.4,346.3c-1.8,0.1-0.8,2.8-1.6,3.8C238.6,358,245.5,347.7,241.4,346.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.7,242.9c1.7,0.8,2.6,3.8,4.6,3.4C300.7,244.3,290.1,237.4,293.7,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.9,258.9c1.6-0.2,8.2-0.1,5.8-2.7C259.8,256.1,251.1,257.1,254.9,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.3,267.4c-0.9-4.1-7.9,5.6-3.9,5C269.7,270.8,271.2,269,272.3,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.2,315c0.2-1.8-1.8-6.4-4.1-5.2C288.8,310.9,291.7,317.5,293.2,315z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.5,415.3c1.3,4.7,4.9-7,0.8-6.3C255.6,410.1,258.5,413.7,256.5,415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.9,271.9c1.5-4.7-8.2,2.1-5.3,2.7C276.6,274.9,278.4,273,279.9,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.9,271.1c1.7,0.3,8.4-5.3,3.5-4.7C275.5,267.8,270.9,269.2,272.9,271.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.8,237.6c1-2.8-9.1-1.7-6.8,0.8C267.1,238.4,269.7,238.3,271.8,237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.7,258.6c6.6,2.6,1.2-2.8-2.3-3.1C300.1,256.4,304.5,257.8,305.7,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.3,288.8c1.4,0.8,2.4,2.2,3.6,3.2C297.2,291.5,286.6,283.6,288.3,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.4,228.5c1.1,1.2,4.5,5.2,4.1,1.1C246.2,227.3,240,223.5,243.4,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.8,186.6c0.8-1.6,3.7-4.4,2.4-6C283.6,179.1,278.7,188.4,282.8,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.1,344.7c-0.9-1.2-3.4-7.2-5.1-4.8C213.3,341.5,215.9,346.6,218.1,344.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,363.3c0.8,0,2,1.3,2-0.3c-1-2.4-5.4-1-7.6-2.3C230.3,362.1,237.9,363.6,239.1,363.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.4,208.4c1.8,0.5,3.4,2.9,5.2,2.6C219.2,208.8,209.2,204,211.4,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.7,342c4.5-0.5-2.9-4.4-4-5.4C216.6,338.1,222.5,341.1,223.7,342z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.1,323.8c-0.1,1.7,2.1,6.6,3.5,3.5C246.6,325.5,244.5,317.5,244.1,323.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.1,197.8c0.9,1.2,2.7-0.1,2.8-1.3c4.1,1.7,0.8-10.2-0.6-3.8c0.1,1-1,2.1-1.5,3.1 C245.5,186.8,244.3,194.9,249.1,197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.3,277.7c-0.6-2.7-4.8,0.6-6.5,1C271.4,281.7,279.1,279.3,279.3,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.6,187.3c4.6,6.8,5.5,2.8,1-1.7C206.6,181.1,203.5,185.4,205.6,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.7,388.2c4-1.8-6.7-6.4-4.9-2.2C218.2,386.9,220.2,387.4,221.7,388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.3,327.1c1.5,0.8,4.7,1.6,3.8-1.2C298.4,324.5,291.6,323,297.3,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.3,288.8c4.7,1.2-2-8.6-3.4-3.9C291.9,286,294,286.8,294.3,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.1,370.5c1.9-0.8,7.1-0.5,3.5-3.2C260.8,367.9,253,369.7,259.1,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.8,403.6c1.5,0.9,6.1,4.9,6.2,1.1C305.8,404.3,297.7,399.3,300.8,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.4,267.9c3.7-1.8-4.4-3-5.4-4.7C217.7,265.5,222.6,267.6,224.4,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.5,253.6c1.4,0.5,2.6-0.6,4-0.3C274.6,251.6,257.3,249.8,261.5,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.1,365.1c0.3,1.5,3.3,4.1,3.5,1.3C283.2,363.5,280.4,357.7,281.1,365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.8,382.8c0.8-1.3-0.4-6.7-1.7-3.5C308.8,381.3,306.3,388,309.8,382.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.4,338.5c3.6-1.2,1-3.9-1.6-2.4C219.7,335,223.2,339.2,226.4,338.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.1,292.9c1.5,0.8,3.3-1.5,1.4-2.3C268.2,289,263.8,291.8,271.1,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.3,344.6c0.3-2.9-2.6-0.2-3.9,0.2c-0.9,0.3-3.1,0.6-2.8,2C282.2,348.3,286,345.8,287.3,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.6,274.7c1.4,0.1,7.9-1.6,5.8-3.6C286.3,270.4,278.9,273.4,281.6,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.5,358.9c10.2-3.6-2.8-2.5-4.3,0.3C215.2,360.8,217.3,359.5,218.5,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.2,294.8c4,0.7-0.2-5-1.6-5.7C303.2,289.7,306.3,294,307.2,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.1,207.2c-0.3,1.7,4.5,8.6,4.7,4.3C237.8,210.5,237.3,205,235.1,207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.4,356.1c8.3-3.1,1.1-3.6-2.9-1.2C277.1,356.6,280.4,357.4,281.4,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.5,352.8c5.5-0.9,4-13.6,1.1-2.8C288.1,350.7,286.4,352,287.5,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.4,208.4c-3.4-1.4-2.1,7,0.3,6.2C265.9,213.3,264.6,210.1,264.4,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.5,264.9c0.7-3.4-4.3-1.2-6-0.8C226.8,267.2,232.4,265.7,233.5,264.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.9,202c-1.4-1.2-2-4.8-4.1-3.6C224.5,200.1,230.7,206.7,229.9,202z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.8,337.9c-0.8-1.6-1.5-3.4-2.7-4.6C253.1,332.6,259.2,342.8,259.8,337.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300,297.1c1.4,1.1,2.9,4.3,4.7,3.6C307.1,299,299.2,293.9,300,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.1,264c7.4-1.1-6.4-4.4-5.3-1.3C294.1,263.7,296.5,263.2,298.1,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.9,191.9c-2.6-2-2.7,4.9-1.9,6.2C231.7,198.5,231,193.6,230.9,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305,310.2c-1.5-0.6-3.5-1.3-5.2-1.8C294.9,309.5,306.6,314.3,305,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.9,297.7c0.5,2.3,3.5,6.4,2.5,1.5C249.7,294.9,244.7,291.2,247.9,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.7,392.5c1.7-1.4,3.3,0.8,4.7,0.4C290,388.9,277.8,389.1,281.7,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.8,229.6c-5.2-4.1,0.4,3.6,1,5.7C303.7,236.1,300.8,230.5,299.8,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.2,227.1c1.5-0.3,6.3-5.3,3.1-5.8C285.4,223,280.6,225,283.2,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,246.5c0.2-1.6,2.5-6.4-0.6-5.8C230.4,242,228.4,248.8,232,246.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.4,172.2c-0.6-1.2-2-4.4-3.6-4.1C210.1,169.2,215.2,175.9,216.4,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.9,240c3.1,2,7.9-8,2.7-3.3C275,237.8,271.6,238.5,272.9,240z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.5,286.1c1.4,1.3,9.1-0.6,5.6-2.5C267.5,284.5,262.1,283.2,263.5,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.6,203.5c1.9,0.2,8.6-4.2,4.5-5C291.5,200.1,284.4,203.3,287.6,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.4,300.1c-3,1.7,2.8,4.8,4,4.6C287.3,302.4,282.8,301,281.4,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.1,251.4c-0.5-1.2,0.7-6.1-1.7-4.3C236.7,249.5,239.7,257.6,240.1,251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.5,415.1c0.1-0.4-0.2-1.7-0.8-1.5C305.5,415.5,309.6,419,308.5,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.5,207.4c1.7,0.4,7-2.8,4.2-4.3C291.7,203.1,285.9,206.6,288.5,207.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.6,174c2.3-4.4-5.1,0.1-5.4,1.5C148.7,177.4,151.3,175.1,152.6,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210,358.4c1.2,1,6.9-4.7,4.1-4.9C212.8,353.9,207.7,357.1,210,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.9,272.9c1.2,1,3.2,4.5,4.9,2.9C247.8,274,239.4,268.1,241.9,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.6,289.9c1.6-1.6-1.8-4.9-2.8-6.1C295.4,284.6,298.7,290.6,300.6,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.2,415.3c2.4,0.1,3.5-4.8,3-6.7C217.8,407,214.9,415.1,216.2,415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.4,287.8c-0.2,1.7,2.6,7.2,4,4C245.5,290.5,242.7,282.4,242.4,287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.2,281.1c1.9,2.4,2.5,0.3,1.5-1.8c-0.5-1.4,1.1-4.8-1.5-4.6C228.2,276.6,229.4,279.3,229.2,281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.8,231.4c-1.7-1.1-2.8-5.4-5.1-3.3C237.5,229.3,243.2,235.5,242.8,231.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.2,342.2c4,2.4,6.9-9.4,3-3.9C230,339.9,226.2,340.6,227.2,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248,204.4c3.7,1.2,0.6-5-0.7-5.9C245,199.9,247.3,202.6,248,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.3,378.4c3.8,4.1,1.9-2.6,0.3-4.3C270.9,373.4,272.4,377.2,273.3,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.5,206.6c1.7,2.3,3.8-3.6,2.7-4.6C303.2,199.5,301.7,205.3,302.5,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.1,362.1c1.8,0.7,3-2.3,5-2.3C213.1,356.4,200.1,359,203.1,362.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.7,288.4c0.1-2.4-4.1-0.7-5.7-0.9C266,290,274.5,290.9,274.7,288.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.6,242.2c1.7,0.6,2.2-2.6,2-3.9C245.5,231.5,242.1,239.8,243.6,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.2,194.4c1.5-4.1-9.1,0.4-5.1,1.6C283.8,195.6,285.9,195.6,287.2,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.8,323.9c4.6-2.2-1.2-12-0.5-2C229.6,322.9,229.3,323.9,230.8,323.9L230.8,323.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.8,264.1c3.9-0.6-0.7-11.6-0.8-3.6c0.4,1.5-1,2.7,0.7,3.5C239.6,264,239.7,264.1,239.8,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.3,365.7c0.6,1.1,5.9-1.7,5.8-2.7C266.2,361.2,259.1,364,261.3,365.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.3,407.5c1.1-1.6,4.5-2.9,4.5-4.7C223.1,401.7,215.2,408.2,220.3,407.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.2,191.5c0.1,4,3.5,4.3,2.2,0c0-1.2,1.9-3.4-0.6-3.2C241.5,188.6,242,190.5,241.2,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,378.8c0.7,1.3,0.6,2.8,1,4C317.2,382.9,310.1,371,311,378.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.6,263.7c2.8,6.3,2.1,0,1.8-3C213.6,257,212.6,262,213.6,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.2,184.2c-0.4,1.8,1.3,4.1,2.7,2.1C314.1,182.4,308.7,179.2,310.2,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.9,308.9c3.3,0,0-5.3-0.5-7C245.8,302,248.6,307.4,248.9,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.8,401.9c1.7-2.8-3.6-0.9-5.1-1.7C301.2,402.5,308.8,403.6,309.8,401.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.7,304.9c4.8,0.2-3.8-8.2-3.7-3.1C296.5,302.2,297.5,303.8,298.7,304.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.7,400.5c1.8,0,8-2.6,4.9-4.3C302.2,398.1,297.2,397.2,298.7,400.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.6,344c-1.4-1.4-1.1-4.8-2.5-5.8C299.4,339.3,304,349.1,304.6,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.5,278.6c7.7-0.2,5.5-8.5-0.3-0.4C262.2,278.2,262.3,278.4,262.5,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,403c1.9,0.4,2.8,3.2,4.2,3c3.3-2-4.7-6.9-4.3-3.1C251.8,402.8,251.8,402.9,251.9,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.9,296.3c-0.5-1.3-2.3-6-4-4.1C230.1,293.4,234.4,300.2,234.9,296.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.6,178.8c0.5-1.7,2.3-6.2-0.9-5.8C285,174.2,283.9,180.6,286.6,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.6,330.9c1.5,1,3.9,3.8,4.9,0.9C288.1,329.9,282.2,327.5,283.6,330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.4,327.8c2.6,0,1.2-2.6,1.7-4.3C256,317.4,253.4,326,255.4,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.6,367.1c4.2,2.1,7.3-7.7,2.6-3.1C254.9,364.7,253.1,365.2,253.6,367.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.1,386.7c-1-0.8-2-2.1-2.9-3C269.1,382.8,278.6,392.9,277.1,386.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.7,348c4.4,3.4,4-10,1.3-2.9C219.6,346.1,217.7,346.8,218.7,348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.8,309.4c1.4-0.7,0.6-1.9-0.1-2.9c-0.8-1-1.2-4.2-3.1-2.8C307.7,304.3,310.6,310.6,311.8,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251,387.5c1.7,0.7,2.8,2.2,4.5,2.9C259.5,389.5,249.7,382.5,251,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.9,326.3c3.5-1.1-1.1-3.1-1.4-4.8c-0.1-0.5-0.7-0.5-1.1-0.3C275.9,322.6,280,325.2,280.9,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.3,381.2c1.2,0.7,1.8,4,3.3,3.1C283.4,381.7,276.6,374.8,278.3,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.6,248.1c-0.9-0.4-8.7,1.2-5.6,3.1C203.6,250.9,208.7,250.7,207.6,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.2,217.5c1.1,1.4,7.2,3.6,4.6,0.2C212.2,217,206.5,213.4,209.2,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,372.3c1.4,0.8,3.3-1.7,4.8-2.2c1.5-0.9,0.3-3.6-1.1-1.7C207.7,369.4,204.8,370.3,205.3,372.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.1,267.6c2.7,1.1-0.5-4.9-0.6-6.1C208.6,260,210.5,267.3,212.1,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.9,380.9c1.2,1.1,2,4.5,3.9,3.9C265.2,382.6,259.5,376.4,259.9,380.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,392.1c-0.3-1.1-1.9-4.2-3.2-3.1C309.6,389.8,314.2,395.7,313.6,392.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.2,360.6c3.5-0.3,3.8-11.4,0.9-4.3C288.9,357.5,286.5,360,288.2,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.2,349.4c2.7-3.4-3.4-0.9-4.6,0.3C272.1,353.4,277,350.7,278.2,349.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.8,215.3c4.8,2.8,1.6-2.4-1.2-2.9C216.6,211.3,219.6,215.1,221.8,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.2,316.3c0.7,4.7,4.8,3.4,2.3-0.7C246,312.6,242.1,313.7,244.2,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.4,259.2c-0.8-2.8-4.7,2.2-4.8,3.5C262.2,265.5,266.4,260.2,266.4,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.1,321.8c0.8-1.7-0.4-5.9-1.8-2.6C263.9,322.6,263.7,329.9,266.1,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.7,182.5c1.2,1.6,5.2,2.7,3.7-0.2C228.9,179.4,224.1,179.7,227.7,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.5,283.8c1.9,1.3,2.7-3.4,2.4-4.8C226.4,275.3,224.2,282.9,225.5,283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.1,375.9c1.1,1.2,4.6,3.7,3.6,0.3C261.1,373.5,254.5,371.5,259.1,375.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.3,409.8c0,0.4,0.4,1.1,0.9,0.9C290.2,406.6,285.4,396.3,286.3,409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.2,242.5c6.8,1.7,1.2-2.4-2.2-2.6C260.8,240,265.5,242.3,267.2,242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.8,232.3c4.1-2.4-5.1-2.4-5.4-0.5C258.7,234.3,262.2,232.2,263.8,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.5,180.7c2.1-1.9-7.1-8.9-3.4-2.6C301.1,178.9,301.9,182.3,303.5,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.2,183.7c0.2-1.5,2.7-3.9,0.2-4.5C304.9,179.4,304.4,187.8,307.2,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.4,307.7c1.6,0.2,6.4,1.5,5.3-1.3C285.2,305.8,277.7,305.3,281.4,307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.4,333.2c1.2,0.7,2.5,1.5,3.8,2.1C316.9,333.7,305.8,329,308.4,333.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.6,214.3c-2.1-4.7-3.2,4.1-1,4.7C270.8,218.6,269.8,215.7,269.6,214.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.6,405.5c1.9-6.5-3.3,0.5-2.6,3.4C277.4,410.9,277,406.8,277.6,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.6,293.2c2,0,3.4,2.6,5,1.6C269.7,292.5,260.3,289.3,262.6,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.5,366.4c0.7,1.1,3.7,4.5,4.3,2C294.7,366.3,287.3,361.5,290.5,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.4,244.7c1.8,6.2,3.1-0.1,1.6-3.1C246.2,240,245.6,243.4,246.4,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.5,402.2c1.9,0.3,3.5,2.2,5.5,1.9C249.7,402.3,239.8,398.4,241.5,402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.2,352.2c6.2,0,5.4-7.7,2.4-3.1C214.2,350.5,210.7,350.6,212.2,352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.5,301.4c1.6,0.7,6.4,1.6,3.9-1.2C288.6,299.1,282.1,299.4,286.5,301.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.5,352c-0.2-1.4-1.4-2.4-1.6-3.7C298.9,341.9,300.9,357.1,303.5,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.2,181.6c-3-0.2-0.4,3.9,0.4,5.2C241.7,187.8,239.7,182.1,238.2,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.8,240.7c7.5-2-2.5-3.6-4.2-1C255,241.1,257.6,240.3,258.8,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.1,409.9c4,5.2,2-3.5-1.2-4.1C239,406.5,242.8,408.5,243.1,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282,340.2c-0.2,2,3.4,4.4,2.6,1.4C283.7,337.8,278.8,333.7,282,340.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.5,196.1c1.8,1.4,2.7-2.2,4-3.2C298.9,188.4,292.1,195.1,294.5,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.7,406.9c2.6-0.7-1.8-4.9-3.1-4.8C229.2,403.3,233.2,406.4,234.7,406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,255.7c-2.3-3-2.5,2.7-2.4,4.3C237.8,263.2,237.5,257.4,237.6,255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.3,354.5c-1.4,0.7,1.2,5.9,2.1,6.4C303.6,360.7,300.8,353.8,299.3,354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.5,282.3c4.4,1.2-0.3-4-1.8-4.7C307.2,278.4,310.4,281.3,311.5,282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.5,356.7c-2.3,0-6.7,5-1.9,4C271.3,359.4,275.5,357.6,272.5,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.6,402c1.2-0.9,5.6-4.4,2.8-5.5C214,397.4,210,400.8,212.6,402z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.2,317c-0.9-0.9-1.9-4.1-3.4-2.9C299.2,316.4,306.2,322.7,304.2,317z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.4,359.3c0.6,3.3,5.1-0.8,5.4-2.3C265,355.1,262.8,358.4,261.4,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.2,329.6c-0.9-1.6-1.4-3.3-2.2-5C216.6,324.2,220,332.3,222.2,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.9,340.5c4,3.1,0.7-2.9-0.4-4.3C274.2,334.5,276.6,339.5,277.9,340.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252,338.6c0.4,1.4,4.4,5.5,4.4,2C255.9,339.7,251.1,334.4,252,338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.1,308.4c0.7,1.5,1.6,3.1,2.6,4.3C278.4,313.5,273.2,303.9,272.1,308.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.1,295.4c-0.2-1.5-2.1-2-2.3-3.5C299.2,290,304.8,300.3,306.1,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.4,209.5c1.2,1.1,1.9,6,3.8,3.4C244.3,210.8,239.4,205.5,240.4,209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.9,360c-0.5,2.2,2.9,5.5,4,2.4c-0.2-0.9-2.1-1.2-2.1-2.3C293.1,358.1,291.1,358.3,290.9,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.1,228.3c1.9,0.5,10.9-2,5.6-2.6C257.2,226.7,252.1,225.6,253.1,228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.6,331.6c7.8,10.3,4.2-3.6-0.4-0.3C216.4,331.3,216.5,331.5,216.6,331.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.8,233.1c2.1-0.7,5.3,0.4,6.3-2.3C255.6,229.6,247.4,231,249.8,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.1,195.8c6.6-4,1.6-7.5-1.1-1C289.4,195.2,289.6,195.7,290.1,195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.8,208c-2.4-0.5-5.2,6.8-1.5,4.6C309.4,211,313.4,208.6,310.8,208z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.8,194.9c4.4,0.8-0.8-4.2-2.7-3.6C203.5,193.4,206.2,194.2,207.8,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.4,185.1c-1.6-0.1-3.4-2-4.9-1.1C260.4,186.4,269.8,188.4,267.4,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.4,352.2c1.1-0.6,6-2.1,3.9-3.6C282.1,348,275.8,351.1,279.4,352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.8,174.3c0.1,0.3,0.6,0.7,0.8,0.3C310.2,166.1,301.2,168.5,301.8,174.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.6,250.8c1.8,0.5,7.9-1.4,3.6-2.4C261.9,249.1,256.3,248.8,259.6,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308,299.3c-0.1,3.1,3.6,3.9,2.3,0.4C310,296.1,306.9,294.9,308,299.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.4,416.8c-0.2-1.8-3.6-2-2.6,0.2C264.9,416.9,267.6,417.2,267.4,416.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.2,384c1.2,0.8,3.9,6.4,4.4,2.6C297,385,292.1,379.8,293.2,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.1,281.2c1.1-1.3,2.9-5.4-0.3-3.5C205.7,278.9,205.5,284.5,208.1,281.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.6,344c2.8,1.7,1.4-5.1,0.7-6.4C296.7,337.6,298.6,342.4,298.6,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.1,257c0.3-1.5,1.5-2.6,2-4.1C207.4,247.7,202.2,258.2,206.1,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.8,285.5c-1.2-5.3-5.3,3.6-1,3.4C203.1,288.6,201.4,286.7,202.8,285.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.2,416.9c2.1-1.5-1.9-4.1-3.2-4.4C244.4,413.2,248.8,417.1,250.2,416.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.6,322.5c0.7-6.6-3.4,0.5-2.2,3C228.5,326.9,228.1,323.8,228.6,322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.4,394.3c-4.2-1.5-3.7,1.5-0.1,2.5C312.6,397.8,312.3,395,309.4,394.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.6,370.5c-3,3.5,6.1,0.8,4.8-1.2C232.1,367.8,230.2,370.3,228.6,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.6,376.9c1.5-0.2,3,0.3,4.4,0.5C247.5,374.1,236,374.4,239.6,376.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.9,400.7c4.4-1.5-4.7-5.2-4.4-1.5C279.5,400.3,281.6,399.1,282.9,400.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.4,178.2c-1.7-4.8-4.7,7.1-1,4.5C217.7,181.1,218,179.7,218.4,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.5,334.5c0.8-0.9,3.1-5.3,0.8-5.6C232.3,329.2,229.3,335.8,232.5,334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.4,372.2c1.4,1.2,7.7-0.8,4.3-2.5C219.1,370,215.6,369.9,216.4,372.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.2,351.1c5.9,4,0.8-4.4-2.5-2.2C307.1,350.3,309.3,350.9,310.2,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.6,306.1c1,4.6,2.6-1,1.9-3C239.7,300.9,238.7,304.4,239.6,306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.2,269.7c-4.1-6.1-2,1.1-0.7,3.4C234.1,274.6,232.8,270.8,232.2,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.5,181c2.9-0.2-2.2-5.5-3.9-3.7C309.9,178.6,311.7,181.4,313.5,181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.6,333.4c3.9,0.4,0.1-4.3-2.1-3.9C297.7,331.4,300.7,332,301.6,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.2,262.6c0.2-1.4,2.4-5.5-0.4-4.9C205.7,258.6,204.5,265.7,207.2,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.9,305.6c0.1,10.7,4.2-0.9,0.3-2.4C262.4,303.8,262.6,304.8,262.9,305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.8,362.8c0.5-2.6-4.8-0.1-5.9-2C208.1,363,216.4,363.9,217.8,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.5,345.1c3.2,4.3,2.8-5.9,0.1-4.8C259.8,341.6,260.7,343.8,260.5,345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261,300.9c0-1.2-3.6-5.9-4.2-3.5C257.2,298.3,260.4,303.8,261,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.8,282.8c-0.9-0.8-1.2-4.7-2.7-2.2C301.4,283.7,306.3,288.2,304.8,282.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.4,331.4c0.8-1.3,2-6.7-1-4.9C228.8,328.3,225.8,332.5,229.4,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.8,246.6c2.2-0.2,3.4-2.4,0.5-2.6C277.8,244.6,276,248.4,280.8,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.4,402.3c-0.1-1.6,4.6-4,2.3-4.9C274.3,397.6,270.2,405.7,274.4,402.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.3,349.1c1.5,0.2,3.9-4.4,2-4.8C225.2,344.5,221.5,349.4,224.3,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.4,414.8c1.5,0.3,5.8-3.2,2.9-4C289.1,411.9,285.5,412.8,287.4,414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.3,304.5c-1.6-0.5-3.6-1.7-5.2-0.8C271.6,305.6,279.9,307.3,278.3,304.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304,190.9c1.7,0.6,3-2.6,2.7-3.9C304.9,184.5,302.5,189.7,304,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.2,227.2c1-2.3-2.3-2.1-3.7-2.9C304.1,225.4,309.7,228.5,311.2,227.2 C311.2,227.3,311.2,227.2,311.2,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.5,279.1c0.8,1.1,7.3-1.2,5-2.8C284.9,276.3,281.3,277.1,281.5,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.7,313.5c1.4,0.5,1.3,2.2,2.9,2.4C301.2,313.5,290.7,308.8,294.7,313.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.3,313.1c1.6,0,3.3,1.5,4.7,0.3C289.4,310.7,280.4,310.6,284.3,313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298,350.8c2,3,2.1-4.4,0.6-5.3C295.8,345.6,298.6,349.2,298,350.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231,313.3c0.4,2.5,4.2,2.3,2.2-0.4C233,308.8,229.5,309.1,231,313.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.5,343.3c-0.3-4.1-7.4,2.8-3,3.1C278.7,344.8,280.8,344.5,281.5,343.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.5,308.9c4.5-2.4-2.3-2-3.9-1.5C287.4,309.8,293.3,308.8,294.5,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.8,326.2c-0.8-1.1-2.3-4.1-3.6-1.8c0.9,2,4,6.7,3.9,1.9C278,326.5,277.9,326.4,277.8,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.8,337.6c-2.1-5.6-3,0.8-1,3.1C205.7,341.8,205.7,338.7,204.8,337.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.1,315.4c0.1,0.8,1.5,0.9,2,0.7C252.3,311.5,247.9,308.5,249.1,315.4 C249.2,315.3,249.1,315.4,249.1,315.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.2,279.5c0.8,1.3,1.7,4.8,3.5,2.6C251.1,280.4,248.1,276.2,247.2,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.8,300c-0.5-1,0.7-5.2-1.2-4.3C243.1,297.6,245.1,306.6,245.8,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.5,395.6c0.8,0.8,4.9,1.6,4.6-0.7C236.7,393.1,231.7,393,232.5,395.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.7,218.5c1.5-0.2,6.2-2.9,2.8-3.8C274.2,215.6,270.2,216.5,272.7,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211,308.9c0.9,4.4,3.7-4.3,2-4.9C211.3,304.5,211.4,307.4,211,308.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.3,272.8c-8.3-5.3-3.5,4,0.1,0.5C314.3,273.3,314.3,273,314.3,272.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.1,235.5c1.1,4.3,3.1,2.6,1.4-0.8C290.2,229.7,288.1,231.5,290.1,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,358.1c0.8,1.3,1.8,2.6,3,3.6C310.9,362,303.8,354.6,303.8,358.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.1,193.1c0-2.1-0.2-4.8-0.9-6.8C209.7,185.4,211.4,194.6,213.1,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.2,376.7c0.5-1.2,0.2-5.5-1.8-4.5C305.5,372.6,306.8,379.3,308.2,376.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.8,372c-4.5-1.5-1.2,2.8,1.3,3.1C266.5,374.2,264,372.6,262.8,372z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.6,243.9c1.2-0.3,2.4,0.8,3.4,0.3C307.9,240.6,297.9,241.5,302.6,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260,244.3c1,0.8,7.9,0.9,5.4-1.2C264,242.8,259.7,242.1,260,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.8,284.8c1.5,0.3,6.6-0.3,4.8-2.6C285.1,282.4,280.6,282.3,281.8,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.6,316.2c0.1,0.7,0.8,0.7,1.2,0.8C266.2,311.4,262.9,306.9,262.6,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.7,337.8c0.4,1.6,3.5,2.2,2.8,0.2C210.3,334.9,205.9,333.3,208.7,337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.6,252.7c1.1,1,5.1,2.4,3.6-0.3C256.2,251.1,248.8,250.4,254.6,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.9,204.2c2.5,0.5,0.6-3.9,0-4.9C231,199.4,232.9,203,233.9,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.3,294.5c1.9,0.4,4.5-3,1.5-2.7c-0.4,0.4-0.9,0.5-1.5,0.4C275.1,291.8,275.1,295,277.3,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.9,390.6c3.8,2.8,2.6-7.8,0-3.4C293.1,388.4,293.8,389.5,292.9,390.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.1,170.7c-0.1,1.3,0.7,4.7,2.2,3.4C300.2,172.2,297.7,166.3,297.1,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.2,343.2c-1.3-1.3-2.5,1.4-3.8,0.9C231,347.2,240.2,346,239.2,343.2L239.2,343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.3,374.7c0-2.5-6.9-1.9-4.1,0.6C224.5,374.7,226.9,376.8,227.3,374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,385.8c3.3-1.9-4.5-4.3-3.9-1C210.7,385.8,213,385.4,214,385.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.3,309.3c-0.1-1.6,0.3-4.8-1.6-5.2C226.8,304.9,227.5,312,229.3,309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.4,299.4c1.4,10.2,4.4,1.8,0.3-1C235.6,298.6,235,299.2,235.4,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.3,293.8c2.5-1.7-1.2-3.2-2.6-3.4C293.1,291.8,296.8,293.9,298.3,293.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.4,361.4c1.1,1.9,7.4-6.1,3.6-4.1C249.2,359,246,359.4,246.4,361.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.9,370.8c1.1-0.4,5.1-1.9,3.4-3.2C250.8,367.1,245.2,370,248.9,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.8,372.4c-1.5,0.2-5,1.4-3.2,3.3C209.3,375.5,212.9,374.3,210.8,372.4L210.8,372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243,363.1c1.3,0.1,5.4-6.3,2.1-4.7C244.7,359.7,241.6,361.8,243,363.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.2,250.1c-1.2,0.1-3.4-1.5-3.9,0.2C287.6,252.6,295.4,252.8,291.2,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.6,223.4c-3-0.8-8.2,6.2-2.2,2.6C225,225.2,227.8,224.8,226.6,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216,326c-0.7-1.6-2.9-4.2-3.4-1.2C213.3,326.4,215.8,329.4,216,326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.4,324c2,3.2,3.1-4.8,0.3-3C239.9,321.6,240.5,323.1,240.4,324z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.7,181.1c0.5,0.5,1.2,1.4,1.9,0.8C296.4,177.7,292.3,174,293.7,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.4,308.6c5.4,0.7-4.2-6.9-2.1-1.8C267.1,307.4,267.6,308,268.4,308.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.7,318.3c0.4-1.1,0.8-2.3,0-3.4C256.8,313.5,257.1,322,259.7,318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.1,180.1c2.1,0.6,1.8-2,2.7-3.1C256.4,174.1,253.7,178.6,255.1,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.5,240.6c-1.6-0.5-4.3,0.1-2.6,2.1C288,243.5,291.8,242.5,288.5,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.2,197c2.9,1.2,2-2.8,0.1-3.6C231.8,193.5,233.1,195.9,234.2,197z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.8,342.2c-0.3-0.9-0.3-5.2-1.7-4.5C293.7,338.6,295.3,344.7,296.8,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.5,389.7c0.7,1.2,4.7,0.4,3.8-1.5C217,387.3,213.5,387.2,214.5,389.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.5,345.3c0.4,1.6,2.8,3.5,2.6,0.8C308.7,343.6,304.6,341.4,306.5,345.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.1,384.6c2.5-0.8-3.6-5.1-3.9-2.3C299.3,383,300.7,385,302.1,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.9,196.5c1.3-0.9,2.6-3.6,0.2-3.9C299.1,193.4,297,197.5,299.9,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.1,198.5c1.1-1,2.5-2.3,0.4-3.1C306.6,195.3,304.6,200.5,308.1,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,238.4c1,0.3,1.6,0.9,2.6,1.1C291.3,236.8,282.2,234.7,285.8,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.2,280.5c4.5,1.1-1.9-6.2-2.2-2.4C304.2,279.2,305.6,279.6,306.2,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.7,321.8c0.3-1.1,1.7-5.4-0.9-4.6C232.9,318.2,232.2,323,234.7,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,332.9c0.5,0.5,1.1,2,2,1.5C230.2,333.1,222,327.7,224.8,332.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.4,186.2c1.1,1.2,3.1,2.2,3.3-0.1C236.1,184,232.1,183.7,233.4,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.5,397.8c3.8-1.6-3.7-6.1-2.4-1.7C258.1,396.5,259,396.9,259.5,397.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.3,296.6c0.9,0.3,2.6,1.3,3.3,0.5C275.1,294.5,268,293.4,270.3,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,339.9c2.1,3.6,2.8-1.5,1.2-2.8C310.4,337,310.5,338.6,311,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.9,373.2c2.2,2.6,2.1-3,0.3-3.6C281.2,369.5,282.2,372.2,282.9,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.2,205c0-4.3-3.6,2.1-2.8,3.8C260.2,209.9,260,205.9,261.2,205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.1,174.5c-0.1-1.5,1.6-2.6,1.2-4C283.5,167.5,280.8,179.3,284.1,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252,306.5c1.1,4,2.9-2.7,0.8-4C250.7,302.2,252.7,305.5,252,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.9,297.8c2.6,1.9,1.1-3.9,0-4.6C234.8,293.7,236.7,296.4,236.9,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219,282.1c1.5,0.2,0.9-1.2,1.4-2.1C221.7,275,215.9,280,219,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,330.5c1.4,3.6,3.6,0.5,1.7-1.9C257.3,327,256.4,329.3,257.1,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.2,292.4c-0.2-1.3-0.7-2.3-0.9-3.7C216,286.9,218.3,295.4,220.2,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.4,296.8c-0.8-0.7-0.6-4.6-2.3-2.6C204,296.4,207.5,300.7,207.4,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.8,404.1c1,1.4,3.9,1.4,2.8-0.6C238.5,401.8,234.4,401.9,236.8,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.3,197.3c-1.9-2.6-2.8,1.9-1.6,3.3C244.7,202.2,244.6,198.4,244.3,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.6,218c2.7,2.6,1.4-2.3-0.1-3.3C203.5,214,204.2,217.5,205.6,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.1,374.3c-0.1-1.2-1.9-1.8-2.8-2.4C285.9,371.7,291.4,377.3,292.1,374.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.6,386.8c0.6-1.1-1.4-4.9-2.8-3.4C288.2,384.5,290.2,387.7,291.6,386.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.6,382.6c0.9,3.4,2.9-2.2,1.2-3.4C269.3,378.6,270.7,381.3,270.6,382.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.9,397.3c-1.3-3.5-2.5,2.8-1,3.9C272.9,401.8,271.6,398.4,271.9,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.8,281.4c0.7,1.2,4.7,1.2,4-0.9C289.8,279.6,287,279.5,286.8,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.7,311.7c1.2,0.9,3.3,2.2,3.5-0.1C310.8,310.1,306,309.5,307.7,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.5,322.4c1.4,1.8,3.2-0.6,1.4-1.7C309.4,318.1,307.3,320.9,309.5,322.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.1,329.2c-0.4-0.9-0.4-2.5-1.6-2.9c-2.3,0.4,0.8,6.8,1.7,2.9C267.1,329.3,267.1,329.3,267.1,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.1,285.5c-0.1-1.1-1.5-4-2.3-1.8C204.3,285.8,207.1,289,207.1,285.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,322.9c2.5,4.8,2.8-4.5-0.1-2.5C267.4,321.3,268.2,322,267.9,322.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.7,307.9c1.3,0.6,4.5,0.9,2.9-1.3C303.4,305.7,299.2,306.3,301.7,307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,343.1c2.8,3.8,2.3-5-0.1-2.8C264,341.2,263.9,342.3,264.3,343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.7,372.9c0.6,3.6,3.1-0.3,1.5-1.9C311.4,369.4,309.4,372.1,310.7,372.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.6,293.5c1,0.1,2.1,0.3,2.9-0.3C287.6,290.3,280.2,291.4,282.6,293.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.6,309c1.2,4.2,3.4-2.3,1.1-2.4C260.5,306.7,260.3,308.1,260.6,309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.8,267.5c1.1,0.7,4.1,0.9,3.9-0.9C312.1,265.9,306.7,265.3,308.8,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.1,197.8c1,0.3,2.5,0.5,3.3-0.1C213.2,195.2,206.2,195.4,209.1,197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.6,363.4c-0.7-1.3-3.1-0.5-4.4-0.3C248,365.4,253.1,364.6,253.6,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.9,374.8c-0.7-1.3-3.1-0.3-4.4-0.2C214.2,376.9,219.6,376.2,219.9,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.4,185.5c-1.6-0.4-2.7,2.8-1.8,3.9C221.2,189.5,221.8,186.5,221.4,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.9,365.4c1.3-0.6-0.3-4.5-1.7-3.3C308.2,362.8,309.7,366.4,310.9,365.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.3,367.6c1.1,0.6,4.1-1,4-2.1C235.3,365.2,231.3,366.2,232.3,367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.7,346.4c-0.4-2.3-3.3,0.5-3.3,1.5C229.6,349.3,231.1,347.6,231.7,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.5,377.3c2.8-3.5-2.4-1.2-1.7,1.2C235.5,380.3,236.1,378,236.5,377.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.3,371.1c-1.3-0.7-2.1,1.3-0.8,1.8C214.6,373.1,215.1,371.7,214.3,371.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.1,366.5C310.4,367.7,313.8,367.8,312.1,366.5C312.2,366.5,312.2,366.5,312.1,366.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsGraphTextureYellowSimple);
export default __webpack_public_path__ + "static/media/Results-Graph_TextureYellow-simple.svg";
export { ForwardRef as ReactComponent };